import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Inline translations to avoid Vite JSON import issues
const enCommon = {
  "app": { "name": "TALKwAI Admin", "version": "v1.0.0" },
  "navigation": {
    "infrastructure": "Infrastructure",
    "configuration": "Configuration",
    "analytics": "Analytics",
    "administration": "Administration",
    "logs": "Logs",
    "media_servers": "Media Servers",
    "tool_runners": "Tool Runners",
    "virtual_interfaces": "Virtual Interfaces",
    "tools_list": "Tools List",
    "webhook_tester": "Webhook Tester",
    "agents": "Agents",
    "tools": "Tools",
    "knowledgeBases": "Knowledge Bases",
    "vocabulary": "Vocabulary",
    "groups": "Groups",
    "agent_groups": "Agent Groups",
    "tool_groups": "Tool Groups",
    "channel_groups": "Channel Groups",
    "user_groups": "User Groups",
    "tool_tester": "Tool Tester",
    "dashboard": "Dashboard",
    "call_logs": "Call Logs",
    "tool_logs": "Tool Run Logs",
    "tenants": "Tenants",
    "audit_logs": "Audit Logs",
    "administrators": "Administrators",
    "settings": "Settings",
    "email_templates": "Email Templates",
    "upstreamProviders": "Upstream Providers",
    "billing": "Billing",
    "billing_report": "Billing Report",
    "billing_rates": "Billing Rates",
    "outboundDialers": "Outbound Dialers"
  },
  "auth": {
    "sign_in": "Sign In",
    "sign_out": "Sign Out",
    "username": "Username",
    "password": "Password",
    "totp_code": "TOTP Code",
    "otp_code": "OTP Code",
    "verify": "Verify",
    "verify_otp": "Verify OTP",
    "send_otp": "Send OTP",
    "back_to_password": "Back to Password Login",
    "use_otp_instead": "Use OTP instead",
    "two_factor_auth": "Two-Factor Authentication",
    "otp_login": "OTP Login",
    "otp_description": "Choose how you want to receive your one-time password.",
    "delivery_method": "Delivery Method",
    "email": "Email",
    "sms": "SMS",
    "enter_totp": "Enter the 6-digit code from your authenticator app.",
    "enter_otp": "Enter the 6-digit code sent to your {{method}}."
  },
  "errors": {
    "invalid_credentials": "Invalid credentials. Please try again.",
    "account_locked": "Account temporarily locked. Please try again later.",
    "not_found": "{{resource}} not found."
  },
  "forms": {
    "agents": {
      "tabs": {
        "details": "Details",
        "configuration": "Configuration",
        "upstreamProviders": "Upstream Providers"
      },
      "labels": {
        "name": "Name",
        "description": "Description",
        "agentGroup": "Agent Group"
      },
      "placeholders": {
        "noGroup": "No Group"
      },
      "errors": {
        "nameRequired": "Agent name is required"
      },
      "loading": {
        "tools": "Loading tools...",
        "agents": "Loading agents..."
      },
      "empty": {
        "noTools": "No tools available",
        "noDelegateAgents": "No other agents in this tenant"
      },
      "badge": {
        "builtin": "Built-in"
      },
      "alerts": {
        "saveFirst": "Save the agent first to configure upstream providers."
      },
      "otherConfiguration": "Other Configuration"
    },
    "auth": {
      "login": { "title": "Password Login" }
    },
    "outboundDialers": {
      "name": "Name",
      "originatingMediaServer": "Originating Media Server",
      "virtualInterface": "Virtual Interface",
      "activitySchedule": "Activity Schedule",
      "activitySchedule.enabled": "Active",
      "activitySchedule.start": "Open",
      "activitySchedule.end": "Close",
      "activitySchedule.day": "Day",
      "activitySchedule.invalidRange": "Start must be before end",
      "timezone": "Timezone",
      "anyCloudMediaServer": "Any available cloud media server",
      "weekday": {
        "sun": "Sun",
        "mon": "Mon",
        "tue": "Tue",
        "wed": "Wed",
        "thu": "Thu",
        "fri": "Fri",
        "sat": "Sat"
      }
    },
    "tables": {
      "headers": {
        "attribute": "Attribute",
        "value": "Value",
        "level": "Level",
        "action": "Action"
      }
    }
  },
  "common": {
    "create": "Create",
    "edit": "Edit",
    "configure": "Configure",
    "delete": "Delete",
    "save": "Save",
    "saving": "Saving...",
    "cancel": "Cancel",
    "loading": "Loading...",
    "search": "Search",
    "filter": "Filter",
    "actions": "Actions",
    "export": "Export",
    "view": "View",
    "deleting": "Deleting...",
    "dismiss": "Dismiss",
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "suspended": "Suspended",
    "deleted": "Deleted",
    "created_at": "Created At",
    "updated_at": "Updated At",
    "reset": "Reset",
    "refresh": "Refresh",
    "update": "Update",
    "select_tenant": "Please select a tenant to continue",
    "seconds": "seconds",
    "creating_in_tenant": "Creating in tenant",
    "no_tenant_selected_warning": "No tenant selected. Please select a tenant from the top bar dropdown before proceeding.",
    "online": "Online",
    "offline": "Offline",
    "degraded": "Degraded",
    "no_group": "No group",
    "time": "Time",
    "tool": "Tool",
    "tools": "Tools",
    "agent": "Agent",
    "agents": "Agents",
    "group": "Group",
    "no_description": "No description",
    "confirm_delete": "Are you sure you want to delete this item?",
    "delete_failed": "Failed to delete item",
    "agent_delete_blocked": "Cannot delete: {{count}} virtual interface(s) still use this agent. Delete or reassign them first.",
    "load_failed": "Failed to load data",
    "create_failed": "Failed to create item",
    "update_failed": "Failed to update item",
    "view_all": "View All",
    "view_infrastructure": "View Infrastructure",
    "none": "None",
    "enabled": "Enabled",
    "disabled": "Disabled",
    "close": "Close",
    "save_failed": "Failed to save changes",
    "modified": "modified",
    "previous": "Previous",
    "next": "Next",
    "back": "Back",
    "items": "Items"
  },
  "dashboard": {
    "title": "Dashboard",
    "time_series": "Time-Series Analytics",
    "today": "Today",
    "last_7_days": "Last 7 Days",
    "last_30_days": "Last 30 Days",
    "this_month": "This Month",
    "last_month": "Last Month",
    "processed_calls": "Processed Calls",
    "tools_run": "Tools Run",
    "total_call_time": "Total Call Time",
    "tool_processing_time": "Tool Processing Time",
    "updated": "Updated",
    "tenant_scope": "Tenant scope",
    "current_tenant": "Current",
    "all_tenants": "All",
    "system_health": "System Health",
    "no_infrastructure": "No infrastructure configured.",
    "recent_tool_logs": "Recent Tool Executions",
    "no_recent_tool_logs": "No recent tool executions."
  },
  "call_logs": {
    "title": "Call Logs",
    "filters": "Filters",
    "from_date": "From Date",
    "to_date": "To Date",
    "status": "Status",
    "agent": "Agent",
    "gender": "Gender",
    "all_statuses": "All Statuses",
    "started": "Started",
    "phone": "Phone",
    "channel": "Channel",
    "duration": "Duration",
    "medium": "Medium",
    "no_logs": "No call logs found",
    "previous": "Previous",
    "next": "Next",
    "message": "Message",
    "search_messages": "Search messages...",
    "conversation": "Conversation",
    "view_conversation": "View conversation",
    "system_prompt": "System Prompt",
    "tool_result": "Tool Result",
    "no_messages": "No conversation messages",
    "search": "Search",
    "regenerate_feedback": "Regenerate Feedback",
    "insights_filter": "Insight Filters",
    "insight_any": "any",
    "insight_yes": "yes",
    "insight_no": "no",
    "feedback_title": "Title",
    "feedback_summary": "Summary",
    "subagent_activity": "Subagent activity",
    "subagent_badge": "Subagent",
    "subagent_count_title": "Subagent consultations",
    "exporting": "Exporting…",
    "export_failed": "Failed to export call logs",
    "export_empty": "No calls match the current filters — nothing to export",
    "direction": {
      "inbound": "Inbound",
      "outbound": "Outbound",
      "internal": "Internal",
      "all": "All"
    },
    "attachments": {
      "title": "Attachments",
      "expired": "Attachment expired",
      "download_failed": "Download failed",
      "kind": {
        "photo": "Photo",
        "video": "Video",
        "voice": "Voice message",
        "audio": "Audio",
        "document": "Document"
      }
    }
  },
  "tool_logs": {
    "title": "Tool Run Logs",
    "filters": "Filters",
    "from_date": "From Date",
    "to_date": "To Date",
    "search": "Search",
    "search_placeholder": "Search tool name, input, output, error",
    "all": "All",
    "tool_name": "Tool Name",
    "input": "Input",
    "output": "Output",
    "timestamp": "Timestamp",
    "duration": "Duration",
    "call_id": "Call ID",
    "error": "Error",
    "actions": "Actions",
    "view_details": "View details",
    "details": "Tool Run Details",
    "no_logs": "No tool logs found",
    "load_failed": "Failed to load tool logs",
    "tenant_scope": "Tenant Scope",
    "showing": "Showing {{start}} to {{end}} of {{total}} results",
    "previous": "Previous",
    "next": "Next",
    "copy": "Copy",
    "copied": "Copied",
    "no_output": "No output",
    "success": "Success",
    "failed": "Failed",
    "expand": "Show more",
    "collapse": "Show less",
    "csv_timestamp": "Timestamp",
    "csv_tool_name": "Tool Name",
    "csv_input": "Input",
    "csv_success": "Success",
    "csv_duration": "Duration (ms)",
    "csv_error": "Error",
    "csv_call_id": "Call ID"
  },
  "outboundDialers": {
    "pause": "Pause",
    "play": "Play",
    "configure": "Configure",
    "load_error": "Failed to load outbound dialers",
    "status": {
      "pending": "Pending",
      "dialing": "Dialing",
      "answered": "Answered",
      "completed": "Completed",
      "no_answer": "No Answer",
      "busy": "Busy",
      "failed": "Failed",
      "invalid_number": "Invalid Number",
      "retry_scheduled": "Retry Scheduled",
      "paused": "Paused",
      "playing": "Playing"
    },
    "queue": {
      "title": "Queue",
      "empty": "The queue is empty",
      "showing": "Showing {{start}}-{{end}} of {{total}}",
      "number": "Number",
      "name": "Name",
      "status": "Status",
      "context": "Context",
      "actions": "Actions"
    },
    "upload": {
      "title": "Upload File",
      "chooseFile": "Choose a file (.csv or .json)",
      "upload": "Upload",
      "sampleCsv": "Download sample CSV",
      "sampleJson": "Download sample JSON",
      "valid": "Valid",
      "summary": "{{valid}} valid, {{invalid}} invalid",
      "added": "Added: {{added}}, Skipped: {{skipped}}",
      "approve": "Approve",
      "cancel": "Cancel"
    },
    "list": {
      "empty": "No outbound dialers found"
    }
  },
  "recent_calls": {
    "title": "Recent Calls",
    "time": "Time",
    "type": "Type",
    "duration": "Duration",
    "agent": "Agent",
    "status": "Status",
    "no_recent_calls": "No recent calls.",
    "view_all": "View All",
    "just_now": "Just now",
    "minutes_ago": "{{minutes}}m ago",
    "hours_ago": "{{hours}}h ago",
    "seconds": "seconds",
    "minutes": "minutes"
  },
  "voice_analysis": {
    "summary_label": "Voice Analysis",
    "male": "Male",
    "female": "Female",
    "angry": "Angry",
    "happy": "Happy",
    "sad": "Sad",
    "neutral": "Neutral",
    "low": "Low",
    "normal": "Normal",
    "high": "High",
    "gender": "Gender",
    "mood": "Mood",
    "energy": "Energy",
    "carried": "carried from earlier detection"
  },
  "tool_tester": {
    "title": "Tool Tester",
    "tool_runner": "Tool Runner",
    "tool": "Tool",
    "parameters": "Parameters",
    "timeout": "Timeout",
    "populate": "Populate",
    "run_tool": "Run Tool",
    "running": "Running...",
    "result": "Result",
    "select_runner": "Select Tool Runner...",
    "select_tool": "Select Tool...",
    "select_runner_first": "Select runner first",
    "parameters_placeholder": '{"key": "value"}',
    "parameters_help": "Enter parameters as JSON object",
    "help_title": "How to Use",
    "help_text": "Test tool execution without running a full conversation session.",
    "step1_title": "1. Select Runner",
    "step1_desc": "Choose an online tool runner.",
    "step2_title": "2. Select Tool",
    "step2_desc": "Choose the tool to test.",
    "step3_title": "3. Set Parameters",
    "step3_desc": "Click 'Populate' for sample parameters.",
    "step4_title": "4. Configure Timeout",
    "step4_desc": "Set timeout (default: 60 seconds).",
    "step5_title": "5. Run Test",
    "step5_desc": "Click 'Run Tool' to execute."
  },
  "tools": {
    "new": "New Tool",
    "no_tools": "No tools found",
    "error_name_required": "Tool name is required",
    "tab_details": "Details",
    "tab_attributes": "Attributes",
    "effective_value": "Effective: {{value}} — from {{source}}",
    "effective_source_default": "Registry default"
  },
  "toolRunner": {
    "status_online": "Online",
    "status_offline": "Offline",
    "status_pending": "Pending",
    "status_error": "Error"
  },
  "virtual_interface": {
    "title": "Virtual Interfaces",
    "new": "New Virtual Interface",
    "edit": "Edit Virtual Interface",
    "info_text": "Virtual interfaces connect external channels (Telegram, WhatsApp, RocketChat, Voice) to your agents. Each interface defines matching criteria to route incoming messages to the correct agent",
    "technology": "Technology",
    "voice_sip": "Voice (SIP)",
    "active": "Active",
    "inactive": "Inactive",
    "match_criteria": "Match Criteria",
    "information": "Information",
    "save_first_attributes": "Save the virtual interface first to configure attributes.",
    "waba_required": "WABA ID is required for WhatsApp interfaces.",
    "workspace_url_required": "Workspace URL is required for RocketChat",
    "bot_username_required": "Bot username is required for RocketChat",
    "bot_password_required": "Bot password is required for RocketChat",
    "invalid_rocketchat_config": "Invalid configuration for RocketChat",
    "step1_basic": "Step 1: Basic Information",
    "step2_config": "Step 2: Configuration",
    "configure_tech": "Configure the integration settings for {{technology}}.",
    "match_criteria_desc": "Configure how incoming messages will be matched to this interface.",
    "step3_agent": "Step 3: Agent Assignment",
    "select_agent": "Select an agent...",
    "no_agents_available": "No agents available. Please create an agent first.",
    "save_changes": "Save changes",
    "saving": "Saving...",
    "details": "Details",
    "configuration": "Configuration",
    "progress": "Progress",
    "basic_information": "Basic Information",
    "agent_assignment": "Agent Assignment",
    "configuration_attributes": "Configuration Attributes",
    "review_create": "Review & Create",
    "review": "Review",
    "configured": "Configured",
    "edit_desc": "Edit the virtual interface configuration. Changes will be synchronized to Channel Gateways automatically.",
    "telegram_chat_id": "Telegram Chat ID",
    "whatsapp_phone": "WhatsApp Phone Number",
    "caller_id": "Caller ID",
    "did_number": "DID Number",
    "multi_value_help": "Press Enter, comma, or Tab to add each value. Click a value to edit it.",
    "telegram_chat_id_help": "When set, only chats in this list can interact with this interface; leave empty to allow everyone.",
    "whatsapp_caller_id_help": "When set, only these phone numbers can interact with this interface; leave empty to allow everyone. Numbers may be entered with or without a leading +.",
    "multi_value_remove": "Remove",
    "sip_domain": "SIP Domain",
    "webchat_info": "Webchat interfaces are matched by session ID automatically",
    "rocketchat_info": "RocketChat interfaces are matched by their webhook route automatically. No manual match criteria needed",
    "agent_select": "Select an agent...",
    "agent_label": "Agent",
    "status_label": "Status",
    "hook_parameters": "Hook Parameters (JSON)",
    "rocketchat_config": "RocketChat Configuration",
    "workspace_url": "Workspace URL",
    "workspace_url_label": "Workspace URL",
    "workspace_url_help": "The URL of your RocketChat workspace",
    "bot_username": "Bot Username",
    "bot_username_label": "Bot Username",
    "bot_password": "Bot Password",
    "bot_password_label": "Bot Password",
    "bot_password_help": "The password for the bot account",
    "webhook_url": "Webhook URL",
    "last_incoming_request": "Last Incoming Request",
    "last_outbound_call": "Last Outbound Call",
    "last_webhook_register": "Last Webhook Register",
    "error_details": "Error details",
    "warning_change_tech": "Changing the technology will reset match criteria",
    "never": "Never",
    "success": "Success",
    "fail": "Fail",
    "whatsapp_phone_number_id": "Phone Number ID",
    "whatsapp_phone_number_id_help": "The Phone Number ID from your WhatsApp registration service onboarding.",
    "whatsapp_registration_section": "WhatsApp Registration",
    "display_phone_number": "Display Phone Number",
    "registration_id": "Registration ID",
    "last_refreshed": "Last refreshed",
    "refresh_registration": "Refresh Registration",
    "refreshing_registration": "Refreshing...",
    "registration_refreshed": "Registration refreshed",
    "registration_refresh_failed": "Registration refresh failed",
    "whatsapp_phone_number": "WhatsApp Number",
    "whatsapp_number_help": "Choose a number onboarded in the WhatsApp registration service for this tenant.",
    "select_whatsapp_number": "Select a number...",
    "loading_numbers": "Loading numbers...",
    "whatsapp_numbers_load_failed": "Failed to load WhatsApp numbers.",
    "no_whatsapp_numbers": "No WhatsApp numbers are available for this tenant. Onboard numbers in the WhatsApp registration service first.",
    "in_use": "in use",
    "number_in_use_warning": "This number is already connected to another interface. Connecting it here will move it to this interface; the other interface will stop receiving messages for this number.",
    "change_number": "Change Number",
    "change_number_title": "Change WhatsApp Number",
    "changing_number": "Changing...",
    "change_number_failed": "Failed to change the number.",
    "change_number_success": "Number changed.",
    "not_registered_hint": "This number is not registered yet. Click Refresh Registration to register it."
  },
  "virtual_interface_create": {
    "step4_title": "Step 4: Configuration Attributes",
    "step4_desc": "Configure additional settings for this virtual interface. These settings can be changed later.",
    "step4_info": "Attributes will be saved after the virtual interface is created.",
    "step5_title": "Step 5: Review & Create",
    "review_label": "Review",
    "review_name": "Name",
    "review_technology": "Technology",
    "review_agent": "Agent",
    "review_attributes": "Attributes",
    "review_attributes_configured": "{{count}} configured",
    "creating": "Creating...",
    "create_interface": "Create Interface",
    "webhook_failed_title": "Webhook Registration Failed",
    "webhook_failed_desc": "Failed to register the WhatsApp webhook override with Meta. The virtual interface was not created.",
    "error_details_card": "Error Details",
    "error_endpoint": "Endpoint",
    "error_response_status": "Response Status",
    "error_response_body": "Response Body",
    "close": "Close",
    "telegram_bot_token": "Telegram Bot Token",
    "telegram_bot_token_help": "Get this from @BotFather on Telegram. Format: 123456789:ABCdef...",
    "whatsapp_api_token": "WhatsApp API Token",
    "whatsapp_phone_number_id": "Phone Number ID",
    "whatsapp_waba_id": "WABA ID",
    "whatsapp_waba_id_help": "Your WhatsApp Business Account ID from Meta Business settings.",
    "rocketchat_workspace_url_help": "The URL of your RocketChat workspace (e.g., https://mycompany.rocket.chat)",
    "rocketchat_bot_username_help": "The username of the bot account created in RocketChat",
    "rocketchat_bot_password_help": "The password for the bot account. The webhook will be automatically registered on creation.",
    "rocketchat_info_create": "A webhook integration will be automatically registered with your RocketChat workspace when this interface is created. The bot will respond to @mentions in channels and direct messages.",
    "match_chat_id_optional": "Telegram Chat ID (Optional)",
    "match_chat_id_help": "Leave empty to match all chats. Use for private groups/channels. Get from @userinfobot.",
    "match_whatsapp_help": "The WhatsApp phone number to match (with country code).",
    "match_caller_id_optional": "Caller ID (Optional)",
    "match_did_optional": "DID Number (Optional)",
    "match_sip_optional": "SIP Domain (Optional)"
  },
  "createFromJson": {
    "title": "Create Tools from JSON",
    "button": "Create from JSON",
    "executionMethod": "Execution Method",
    "pathPrefix": "Path / URL Prefix",
    "pathPrefixHelp": "This prefix will be prepended to each tool name to form the tool path",
    "jsonInput": "JSON Input",
    "toolCount": "Tool count impact: {{count}} tool(s) will be created/updated",
    "quotaExceeded": "This would create {{new}} tool(s) but you only have {{available}} quota remaining",
    "processing": "Processing...",
    "creating": "Creating: {{name}}",
    "updating": "Updating: {{name}}",
    "create": "Create",
    "success": "Created: {{created}}, Updated: {{updated}}",
    "http_rest": "HTTP REST",
    "local_script": "Local Script",
    "builtin": "Built-in"
  },
  "sections": {
    "chat_agent": "Chat Agent",
    "user_preferences": "User Preferences",
    "user_permissions": "User Permissions",
    "media_server": "Media Server",
    "upstream_providers": "Upstream Providers",
    "knowledge_base": "Knowledge Base"
  },
  "attributes": {
    "title": "Configuration Attributes",
    "search_placeholder": "Search attributes...",
    "level_default": "Default",
    "level_set": "Set",
    "level_force": "Force",
    "level_forced": "Forced (inherit)",
    "modified_count": "{{count}} modified",
    "stt_provider_id": "STT provider",
    "tts_provider_id": "TTS provider",
    "llm_provider_id": "LLM model",
    "kb_embedding_provider": "KB Embedding Provider",
    "kb_embedding_base_url": "KB Embedding Base URL",
    "kb_embedding_model": "KB Embedding Model",
    "kb_embedding_api_key": "KB Embedding API Key",
    "kb_embedding_dimensions": "KB Embedding Dimensions",
    "kb_image_llm_provider": "KB Image LLM Provider",
    "kb_image_llm_base_url": "KB Image LLM Base URL",
    "kb_image_llm_model": "KB Image LLM Model",
    "kb_image_llm_api_key": "KB Image LLM API Key",
    "kb_image_instructions": "KB Image Instructions",
    "system_default": "System default",
    "product_default": "Product default",
    "inherited_tenant": "Inherited from Tenant",
    "inherited_group": "Inherited from Agent Group",
    "inherited_agent": "Inherited from Agent",
    "tool_timeout": "Tool Run Timeout (seconds)",
    "tool_timeout_error_message": "Tool Timeout Error Message",
    "level": {
      "title": "Attribute level",
      "default": "Default",
      "set": "Set",
      "force": "Force"
    }
  },
  "attributeLabels": {
    "attachment_retention_seconds": "Attachment retention (seconds)",
    "attachment_max_size_bytes": "Max attachment size (bytes)",
    "consult_delegate_agents": "Delegate agents",
    "consult_timeout_seconds": "Consult timeout (seconds)",
    "consult_max_iterations": "Consult max iterations",
    "stt_provider": "STT Provider",
    "stt_api_base_url": "STT API Base URL",
    "stt_api_key": "STT API Key",
    "stt_model": "STT Model",
    "stt_language": "STT Language",
    "stt_provider_params": "STT Provider Params",
    "stt_protocol": "STT Protocol",
    "tts_provider": "TTS Provider",
    "tts_api_base_url": "TTS API Base URL",
    "tts_api_key": "TTS API Key",
    "tts_voice_id": "TTS Voice ID",
    "tts_model": "TTS Model",
    "tts_provider_params": "TTS Provider Params",
    "tts_style_instructions": "TTS Style Instructions",
    "s2s_greeting_instructions": "S2S Greeting Instructions",
    "s2s_temperature": "Temperature",
    "s2s_top_p": "Top P",
    "s2s_top_k": "Top K",
    "tool_timeout": "Tool Run Timeout (seconds)",
    "tool_timeout_error_message": "Tool Timeout Error Message",
    "stt_vocabulary_book": "Vocabulary Book",
    "tts_language": "TTS Language",
    "tts_speed": "TTS Speed",
    "tts_protocol": "TTS Protocol",
    "tts_audio_format": "TTS Audio Format",
    "tts_sample_rate": "TTS Sample Rate",
    "tts_bitrate": "TTS Bitrate",
    "llm_provider": "LLM Provider",
    "llm_api_base_url": "LLM API Base URL",
    "llm_api_key": "LLM API Key",
    "llm_model": "LLM Model",
    "llm_temperature": "LLM Temperature",
    "llm_max_tokens": "LLM Max Tokens",
    "llm_provider_params": "LLM Provider Params",
    "llm_api_response_timeout": "LLM API Response Timeout",
    "llm_retry_count": "LLM Retry Count",
    "stt_audio_format": "STT Audio Format",
    "stt_sample_rate": "STT Sample Rate",
    "stt_num_channels": "STT Channels",
    "stt_enable_endpoint_detection": "STT Endpoint Detection",
    "llm_vertex_ai_project_id": "Vertex AI Project ID",
    "llm_vertex_ai_location": "Vertex AI Location",
    "llm_vertex_ai_key": "Vertex AI Service Account JSON",
    "system_prompt": "System Prompt",
    "system_prompt_prepend": "System Prompt Prepend",
    "system_prompt_append": "System Prompt Append",
    "available_tools": "Available Tools",
    "no_available_tools": "All tools are assigned",
    "additional_tools": "Additional Tools",
    "tool_calling_behavior": "Tool Calling Behavior",
    "interim_message_enabled": "Interim Message Enabled",
    "interim_message_enabled_help": "Show a message while processing tool results",
    "session_timeout_enabled": "Session Timeout Enabled",
    "session_timeout_seconds": "Session Timeout (seconds)",
    "session_timeout_goodbye_message": "Session Timeout Goodbye Message",
    "single_channel_session_timeout": "Single Channel Session Timeout",
    "language": "Language",
    "tool_calling_attempts": "Tool Calling Attempts",
    "barge_in_enabled": "Barge-in Enabled",
    "g729_transcoding": "G.729 Transcoding",
    "llm_streaming_enabled": "LLM Streaming Enabled",
    "tool_runner_ping_interval": "Tool Runner Ping Interval",
    "tool_runner_absence_timeout": "Tool Runner Absence Timeout",
    "welcome_message": "Welcome Message",
    "goodbye_message": "Goodbye Message",
    "telegram_enable_polling": "Telegram Enable Polling",
    "telegram_polling_interval": "Telegram Polling Interval",
    "whatsapp_messaging_instructions": "WhatsApp Messaging Instructions",
    "telegram_messaging_instructions": "Telegram Messaging Instructions",
    "voice_tts_timeout": "Voice TTS Timeout",
    "voice_analysis_enabled": "Voice Analysis Enabled",
    "speaker_gated_barge_in_enabled": "Enable Speaker-Gated Barge-In",
    "speaker_similarity_threshold": "Similarity Threshold",
    "speaker_ema_alpha": "EMA Alpha",
    "voice_analysis_min_frames": "Voice Analysis Min Frames",
    "voice_gender_threshold_hz": "Voice Gender Threshold (Hz)",
    "voice_gender_ambiguous_zone_hz": "Voice Gender Ambiguous Zone (Hz)",
    "voice_analysis_window_ms": "Voice Analysis Window (ms)",
    "voice_analysis_update_interval_ms": "Voice Analysis Update Interval (ms)",
    "voice_gender_reset_threshold_hz": "Voice Gender Reset Threshold (Hz)",
    "tool_processing_prompt": "Tool Processing Prompt",
    "tool_processing_delay": "Tool Processing Delay",
    "tool_processing_message": "Tool Processing Message",
    "session_idle_timeout_voice": "Session Idle Timeout (Voice, seconds)",
    "session_absolute_timeout_voice": "Session Absolute Timeout (Voice, minutes)",
    "session_idle_timeout_text": "Session Idle Timeout (Text, seconds)",
    "session_absolute_timeout_text": "Session Absolute Timeout (Text, minutes)",
    "session_pre_expire_message": "Pre-Expire Message",
    "session_pre_expire_message_help": "Sent once before the idle timeout closes the session. Empty = disabled.",
    "session_pre_expire_timeout_text": "Pre-Expire Lead Time (seconds)",
    "session_pre_expire_timeout_text_help": "Seconds before the idle timeout to send the pre-expire message. 0 = disabled.",
    "perm_tenant_wide": "Tenant-wide Permissions",
    "page_tenant_wide": "Page Access",
    "audio_chunk_size": "Audio Chunk Size",
    "audio_chunk_transfer_encoding": "Audio Chunk Transfer Encoding",
    "audio_tts_queue_size": "TTS Queue Size",
    "audio_energy_threshold": "Audio Energy Threshold",
    "audio_silence_duration": "Audio Silence Duration",
    "audio_min_speech_duration": "Audio Min Speech Duration",
    "audio_vad_hysteresis": "VAD Hysteresis Enabled",
    "audio_barge_in_enabled": "Audio Barge-in Enabled",
    "audio_barge_in_threshold": "Audio Barge-in Threshold",
    "audio_barge_in_min_speech": "Audio Barge-in Min Speech",
    "barge_in_grace_time": "Barge-in Grace Time",
    "barge_in_auto_raise_energy": "Barge-in Auto Raise Energy",
    "barge_in_auto_raise_margin": "Barge-in Auto Raise Margin",
    "barge_in_auto_raise_max": "Barge-in Auto Raise Max Energy",
    "audio_jitter_buffer_ms": "Audio Jitter Buffer (ms)",
    "audio_max_buffer_frames": "Audio Max Buffer Frames",
    "audio_packet_loss_concealment": "Audio Packet Loss Concealment",
    "utility_extensions_enable": "Utility Extensions Enable",
    "utility_extension_local_echo": "Local Echo Extension",
    "media_server_utility_agent_id": "Utility Agent ID",
    "utility_extension_dictation": "Dictation Extension",
    "utility_extension_dictation_announcement": "Dictation Announcement",
    "utility_extension_dictation_stt_error": "Dictation STT Error Message",
    "audio_enhance_enabled": "Audio Enhancement Enabled",
    "audio_enhance_noise_suppression": "Audio Enhancement Noise Suppression",
    "audio_enhance_agc_target": "Audio Enhancement AGC Target",
    "audio_enhance_highpass_hz": "Audio Enhancement Highpass (Hz)",
    "audio_enhance_aec_enabled": "Audio Enhancement AEC Enabled",
    "smtp_host": "SMTP Host",
    "smtp_port": "SMTP Port",
    "smtp_encryption": "SMTP Encryption",
    "smtp_ignore_certificates": "Ignore SMTP Certificate Errors",
    "smtp_username": "SMTP Username",
    "smtp_password": "SMTP Password",
    "smtp_from_email": "SMTP From Email",
    "smtp_from_name": "SMTP From Name",
    "smtp_verify_peer": "Verify SMTP Peer Certificate",
    "smtp_verify_peer_name": "Verify SMTP Peer Name",
    "smtp_allow_self_signed": "Allow Self-Signed SMTP Certificates",
    "email_tag_wrapper": "Tag Wrapper",
    "chat_bridge_virtual_interface": "Chat Bridge Virtual Interface",
    "chat_bridge_auto_add_users": "Auto-Add Users",
    "chat_bridge_activation": "Activation",
    "chat_bridge_include_context": "Include Conversation Context",
    "chat_bridge_agent_entity": "Agent Entity",
    "chat_bridge_caller_entity": "Caller Entity",
    "chat_bridge_service_person_entity": "Service Person Entity",
    "chat_bridge_handoff_silence_timeout_seconds": "Handoff Silence Timeout (seconds)",
    "chat_bridge_handoff_return_message": "Handoff Return Message",
    "agent_training_llm": "Agent Training LLM",
    "agent_training_llm_help": "The LLM used by the Edit-with-AI feature. Configurable at tenant/system level by global admins.",
    "agent_training_llm_timeout_seconds": "Training LLM Timeout (seconds)",
    "agent_training_llm_timeout_seconds_help": "Per-LLM-call timeout for the training/Edit-with-AI agent.",
    "agent_training_loop_timeout_seconds": "Training Loop Timeout (seconds)",
    "agent_training_loop_timeout_seconds_help": "Overall timeout for a training/Edit-with-AI run (all LLM calls and tools combined).",
    "session_feedback_llm_provider": "Session Feedback LLM",
    "session_feedback_llm_provider_help": "The LLM used to summarize calls and evaluate insights after a session ends. Leave empty to disable feedback for this agent.",
    "session_feedback_prompt": "Session Feedback Prompt",
    "session_feedback_prompt_help": "Static prompt head (up to 'Trait Definitions:'). Trait definitions, schema and transcript are appended dynamically. Leave empty for the built-in default.",
    "non_productive_min_call_seconds": "Non-Productive Min Call Seconds (0 = off)",
    "session_feedback_timeout_seconds": "Session Feedback Timeout (seconds)",
    "session_feedback_timeout_seconds_help": "Timeout for the background feedback LLM call that writes the title, summary and insights. 10s is too short for long transcripts; default 90s.",
    "performance_assessment_prompt": "Performance Assessment Prompt",
    "performance_assessment_prompt_help": "System prompt for the autonomous performance-assessment agent. Pre-filled with the built-in default; edit to customize.",
    "performance_assessment_history_hours": "History Hours",
    "performance_assessment_history_hours_help": "Hours of recent calls the assessment agent reviews.",
    "performance_assessment_stale_min_gap_minutes": "Stale Auto-Trigger Min Gap (minutes)",
    "performance_assessment_stale_min_gap_minutes_help": "Minimum minutes between automatic stale assessment runs for this agent. 0 disables on-load auto-trigger (cron and the manual Run button still work).",
    "performance_assessment_ttl_minutes": "Stale After (minutes)",
    "performance_assessment_ttl_minutes_help": "A stored assessment older than this is considered stale.",
    "performance_assessment_manual_quota": "Manual Quota",
    "performance_assessment_manual_quota_help": "Per-agent cap on manual AI-Assessment clicks (resets when an automated run completes).",
    "performance_assessment_cron_enabled": "Cron Enabled",
    "performance_assessment_cron_enabled_help": "Run a daily assessment automatically.",
    "performance_assessment_cron_hour": "Cron Hour",
    "performance_assessment_cron_hour_help": "Daily cron hour (0-23).",
    "performance_assessment_cron_min": "Cron Minute",
    "performance_assessment_cron_min_help": "Daily cron minute (0-59).",
    "performance_assessment_cron_random": "Cron Random Jitter (sec)",
    "performance_assessment_cron_random_help": "Max seconds of random delay before the cron run begins.",
    "consumer_api_enabled": "Consumer API Enabled",
    "consumer_api_agents_enabled": "Agents Endpoint Enabled",
    "consumer_api_call_logs_enabled": "Call Logs Endpoint Enabled",
    "consumer_api_tools_enabled": "Tools Endpoint Enabled",
    "consumer_api_knowledge_bases_enabled": "Knowledge Bases Endpoint Enabled",
    "consumer_api_tool_calls_enabled": "Tool Calls Endpoint Enabled",
    "consumer_api_dial_queue_enabled": "Dial Queue — Load via API",
    "outbound_dialer_active": "Active",
    "simultaneous_outbound_calls": "Simultaneous Outbound Calls",
    "answer_timeout_seconds": "Answer Timeout (seconds)",
    "call_attempts": "Call Attempts",
    "call_retry_interval_seconds": "Call Retry Interval (seconds)",
    "call_retry_interval_randomization_seconds": "Call Retry Interval Randomization (seconds)",
    "caller_id_number": "Caller ID Number",
    "caller_id_name": "Caller ID Name",
    "outbound_sip_proxy_host": "Outbound SIP Proxy Host",
    "outbound_sip_proxy_port": "Outbound SIP Proxy Port",
    "outbound_sip_proxy_transport": "Outbound SIP Proxy Transport",
    "outbound_sip_username": "Outbound SIP Username",
    "outbound_sip_password": "Outbound SIP Password",
    "consumer_api_calls_include_transcripts": "Calls Include Transcripts",
    "consumer_api_rate_limit_window_seconds": "Rate Limit Window (seconds)",
    "consumer_api_rate_limit_max_requests": "Max Requests per Window",
    "consumer_api_rate_limit_concurrent": "Max Concurrent Requests",
    "consumer_api_unauth_rate_limit_window_seconds": "Unauthenticated Rate Limit Window (seconds)",
    "consumer_api_unauth_rate_limit_max_requests": "Unauthenticated Max Requests per Window",
  },
  "attributeGroups": {
    "attachments": "Attachments",
    "agent_collaboration": "Agent Collaboration",
    "stt_provider": "STT Provider Configuration",
    "tts_provider": "TTS Provider Configuration",
    "llm_provider": "LLM Provider Configuration",
    "vertex_ai": "Vertex AI System Account",
    "tts_advanced": "TTS Advanced Settings",
    "tts_google": "Google TTS Settings",
    "tts_openai": "OpenAI Settings",
    "core_agent": "Core Agent Configuration",
    "tool_runner_health": "Tool Runner Health Tracking",
    "virtual_interface": "Virtual Interface Configuration",
    "voice_analysis": "Voice Analysis",
    "speaker_barge_in": "Speaker-Gated Barge-In",
    "tool_processing": "Tool Processing UX",
    "session_timeout": "Session Timeout",
    "messaging_instructions": "Messaging Instructions",
    "admin_permissions": "Administrator Permissions",
    "audio_streaming": "Audio Streaming",
    "vad": "End-of-Speech Detection (VAD)",
    "barge_in": "TTS Interruption (Barge-in)",
    "rtp": "RTP Configuration",
    "utility_extensions": "Utility Extensions",
    "audio_enhancement": "Audio Enhancement (APM)",
    "smtp_provider": "SMTP Provider Configuration",
    "email_template": "Email Template Configuration",
    "chat_bridging": "Chat Bridging",
    "training": "Agent Training",
    "training_desc": "Edit-with-AI LLM selection (tenant/system level)",
    "session_feedback": "Session Feedback",
    "session_feedback_desc": "LLM + prompt for post-call session feedback summarization & insights",
    "performance_assessment": "Performance Assessment",
    "performance_assessment_desc": "Configuration for the AI performance-assessment agent.",
    "consumer_api": "Consumer API",
    "kb_embedding": "KB Embedding",
    "kb_image_llm": "KB Image LLM (Vision)",
    "outboundDialer": "Outbound Dialer Configuration",
    "execution_settings": "Execution Settings"
  },
  "pages": {
    "agents": {
      "list": {
        "title": "Agents",
        "new": "New Agent",
        "no_agents": "No agents found",
        "open": "Open",
        "advanced_properties": "Advanced Properties"
      },
      "page": {
        "back": "Back to Agents",
        "advanced_properties": "Advanced Properties",
        "tab_stats": "Stats",
        "tab_training": "Agent Training",
        "tab_call_logs": "Call Logs",
        "tab_session_feedback": "Session Feedback",
        "session_feedback": {
          "title": "Session Feedback",
          "custom_insights": "Custom Insights",
          "no_custom": "No custom insights configured. Built-in insights are always evaluated.",
          "add": "Add Insight",
          "edit": "Edit",
          "delete": "Delete",
          "quota_exceeded": "Custom insight quota reached ({{quota}}). Remove an insight or contact your admin to increase the quota.",
          "quota_reached": "Custom insight quota reached. Delete an insight to add a new one.",
          "built_in": "Built-in Insights",
          "read_only": "(read-only)",
          "variable": "Variable",
          "label": "Label",
          "description": "Description",
          "description_placeholder": "Describe how to capture this insight (used in the feedback LLM prompt)",
          "description_help": "Shown to the feedback LLM as the capture instruction for this insight.",
          "data_type": "Data Type",
          "enum_values": "Enum Values (comma-separated)",
          "number_kind": "Number Kind",
          "save": "Save",
          "cancel": "Cancel",
          "data_type_boolean": "Boolean (yes/no)",
          "data_type_number": "Number",
          "data_type_enum": "Enum",
          "values": "values"
        }
      },
      "stats": {
        "sessions_chart": "Sessions (24h)",
        "minutes_chart": "Minutes (24h)",
        "kpi_vis": "Virtual Interfaces",
        "kpi_sessions": "Sessions (24h)",
        "kpi_tool_calls": "Tool Calls (24h)",
        "no_data": "No data available",
        "load_failed": "Failed to load stats",
        "insight": {
          "title": "Insight Performance",
          "load_failed": "Failed to load insight stats",
          "positives": "Positives",
          "calls": "Calls",
          "percentage": "Percentage",
          "timeframe": {
            "current_hour": "Current Hour",
            "last_60_minutes": "60 Minutes",
            "today": "Today",
            "last_24_hours": "24 Hours",
            "this_week": "This Week",
            "last_7_days": "7 Days",
            "current_month": "Current Month",
            "last_30_days": "30 Days"
          },
          "customerNeedWasAttended": "Customer need was attended",
          "customerUnderstoodAgent": "Customer understood agent",
          "agentUnderstoodCustomer": "Agent understood customer",
          "nonProductiveCall": "Non Productive Call"
        }
      },
      "training": {
        "title": "Agent Training",
        "agent_prompt": "Agent System Prompt",
        "interface_instructions": "Interface Instructions",
        "edit_with_ai": "Edit with AI",
        "restore": "Restore",
        "no_llm": "No training LLM configured",
        "no_vis": "No virtual interfaces linked to this agent",
        "no_history": "No prompt history",
        "saved": "Saved successfully",
        "restored": "Prompt restored",
        "confirm_restore": "Restore this prompt version?",
        "load_failed": "Failed to load training data",
        "history_title": "Prompt History",
        "assessment": {
          "title": "AI Assessment",
          "run": "AI Assessment",
          "empty": "No assessment yet. Click AI Assessment.",
          "analyzing": "Analyzing recent calls…",
          "no_recommendations": "No recommendations.",
          "recommendations_count": "{{count}} Recommendations",
          "stale": "The last assessment is stale. A new one is being generated.",
          "quota_exceeded": "Manual assessment quota reached ({{quota}} per agent).",
          "quota_reached": "Manual assessment quota reached",
          "running": "Assessment running…",
          "applied": "Applied",
          "dismissed": "Dismissed",
          "accept": "Accept",
          "dismiss": "Dismiss",
          "apply": "Apply",
          "reject": "Reject",
          "retry": "Retry",
          "failed": "Assessment failed",
          "load_failed": "Failed to load assessment",
          "severity_high": "High",
          "severity_medium": "Medium",
          "severity_low": "Low",
          "category_system_prompt": "System Prompt",
          "category_vi": "Interface",
          "category_service": "Service",
          "summary": "Summary",
          "satisfaction": "Satisfaction",
          "efficiency": "Efficiency"
        },
        "chat": {
          "title": "Edit with AI",
          "placeholder": "Describe a problem or request an edit…",
          "send": "Send",
          "pending": "Thinking…",
          "applied_to": "Applied to {{target}}",
          "target_agent": "Agent system prompt",
          "calling_tool": "Calling {{tool}}…",
          "tools_done": "Done: {{tools}}",
          "target_vi": "Interface prompt: {{name}}",
          "failed": "Request failed",
          "empty": "Ask the agent to review logs and propose prompt edits.",
          "drafting": "Drafting the full edit…",
          "apply_error_prompt_changed": "The prompt has changed since this proposal was made — it cannot be applied. Try again."
        }
      },
      "edit_ai": {
        "step_scope": "Choose scope",
        "scope_agent": "Agent prompt only",
        "scope_vis": "Virtual interfaces",
        "scope_all": "Agent + all virtual interfaces",
        "step_instruction": "Describe the change",
        "instruction_placeholder": "Describe what to change in the prompt...",
        "step_review": "Review changes",
        "target_agent": "Agent",
        "invalid_response": "The model returned an invalid response",
        "finish": "Finish",
        "approve": "Approve & Finish"
      },
      "create": { "title": "Create New Agent" },
      "edit": {
        "title": "Edit Agent",
        "back_to_agents": "Back to Agents",
        "not_found_or_no_permission": "Agent not found or you don't have permission to edit this agent."
      }
    },
    "tools": {
      "create": { "title": "Create New Tool" },
      "edit": {
        "title": "Edit Tool",
        "back_to_tools": "Back to Tools",
        "tool_not_found": "Tool not found"
      }
    },
    "outboundDialers": {
      "list": {
        "title": "Outbound Dialers",
        "new": "New Outbound Dialer",
        "empty": "No outbound dialers found"
      },
      "create": { "title": "Create New Outbound Dialer" },
      "edit": { "title": "Edit Outbound Dialer" },
      "view": { "title": "Outbound Dialer" }
    }
  },
  "groups": {
    "new_group": "New Group",
    "delete_failed": "Failed to delete group",
    "confirm_delete": "Are you sure you want to delete this group?",
    "agent": {
      "title": "Agent Groups",
      "create_title": "Create New Agent Group",
      "edit_title": "Edit Agent Group",
      "empty": "No agent groups found",
      "load_failed": "Failed to load agent groups",
      "create_failed": "Failed to create agent group",
      "update_failed": "Failed to update agent group",
      "manage": "Manage Agents"
    },
    "tool": {
      "title": "Tool Groups",
      "create_title": "Create New Tool Group",
      "edit_title": "Edit Tool Group",
      "empty": "No tool groups found",
      "load_failed": "Failed to load tool groups",
      "create_failed": "Failed to create tool group",
      "update_failed": "Failed to update tool group",
      "manage": "Manage Tools",
      "tab_details": "Details",
      "tab_attributes": "Attributes"
    },
    "channel": {
      "title": "Channel Groups",
      "create_title": "Create New Channel Group",
      "edit_title": "Edit Channel Group",
      "empty": "No channel groups found",
      "load_failed": "Failed to load channel groups",
      "create_failed": "Failed to create channel group",
      "update_failed": "Failed to update channel group",
      "type_label": "Channel Type",
      "channel_type_voice": "Voice",
      "channel_type_chat": "Chat",
      "channel_type_email": "Email",
      "channel_type_sms": "SMS"
    },
    "user": {
      "title": "User Groups",
      "create_title": "Create New User Group",
      "edit_title": "Edit User Group",
      "empty": "No user groups found",
      "load_failed": "Failed to load user groups",
      "create_failed": "Failed to create user group",
      "update_failed": "Failed to update user group"
    },
    "delete_group_confirm": "Are you sure you want to delete this group?",
    "delete_type_confirm": "Are you sure you want to delete this {{type}} group?",
    "delete_type_failed": "Failed to delete {{type}} group",
    "modal": {
      "manage_title": "Manage {{itemType}} - {{name}}",
      "available_items": "Available {{itemType}}",
      "group_members": "Group Members",
      "no_available": "No available {{itemType}}",
      "no_members": "No {{itemType}} in this group",
      "count_available": "{{count}} available",
      "count_members": "{{count}} members",
      "add_selected": "Add selected",
      "add_all": "Add all",
      "remove_selected": "Remove selected",
      "remove_all": "Remove all",
      "load_failed": "Failed to load {{itemType}}",
      "add_failed": "Failed to add {{itemType}}",
      "remove_failed": "Failed to remove {{itemType}}",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "close": "Close"
    }
  },
  "tenants": {
    "title": "Tenants",
    "new_tenant": "New Tenant",
    "create_title": "Create New Tenant",
    "edit_title": "Edit Tenant",
    "empty": "No tenants found",
    "load_failed": "Failed to load tenants",
    "create_failed": "Failed to create tenant",
    "update_failed": "Failed to update tenant",
    "delete_failed": "Failed to delete tenant",
    "delete_confirm": "Are you sure you want to delete this tenant? This cannot be undone.",
    "no_expiration": "No expiration",
    "expiration_date": "Expiration Date",
    "quotas": "Quotas",
    "agent_quota": "Agent Quota",
    "knowledge_base_quota": "Knowledge Base Quota",
    "custom_tool_quota": "Custom Tool Quota",
    "onprem_tool_quota": "On-Prem Tool Quota",
    "onprem_media_server_quota": "On-Prem Media Server Quota",
    "create_tenant": "Create Tenant",
    "config_saved": "Configuration saved successfully.",
    "config_save_failed": "Failed to save configuration",
    "not_found": "Tenant not found",
    "tab_details": "Details",
    "tab_configuration": "Configuration",
    "updating": "Updating...",
    "update_tenant": "Update Tenant",
    "tenant_attributes": "Tenant Attributes",
    "default_obj_permission": "Default Tenant Object Permission",
    "default_obj_perm_help": "Default permission level for new tenant objects.",
    "default_form_permission": "Default Tenant Form Permission",
    "default_form_perm_help": "Default permission level for tenant forms/pages.",
    "upstream_providers": "Upstream Providers"
  },
  "administrators": {
    "title": "Administrators",
    "add_new": "Add New",
    "search_placeholder": "Search by username...",
    "all_status": "All Status",
    "empty": "No administrators found",
    "login_required": "Please log in to view administrators.",
    "loading_permissions": "Loading permissions...",
    "permission_error": "Error loading permissions: {{error}}",
    "no_view_permission": "You do not have permission to view administrators.",
    "no_create_permission": "You do not have permission to create administrators.",
    "back_to_list": "Back to Administrators",
    "create_title": "Create Administrator",
    "edit_title": "Edit Administrator",
    "load_failed": "Failed to fetch administrator",
    "save_failed": "Failed to save administrator",
    "delete_failed": "Failed to delete administrator",
    "delete_confirm": "Are you sure you want to delete this administrator?",
    "username": "Username",
    "display_name": "Display Name",
    "role": "Role",
    "totp": "TOTP",
    "totp_enrolled": "Enrolled",
    "totp_not_enrolled": "Not Enrolled",
    "role_global_admin": "Global Admin",
    "role_tenant_admin": "Tenant Admin",
    "role_read_only": "Read-Only",
    "tab_details": "Details",
    "tab_configuration": "Configuration",
    "tab_permissions": "Permissions",
    "basic_info": "Basic Information",
    "password": "Password",
    "password_help": "Min 12 chars, uppercase, lowercase, number, special char",
    "role_status": "Role & Status",
    "tenant": "Tenant",
    "tenant_unselected": "No tenant selected",
    "tenant_hint": "The administrator is created on the tenant selected in the tenant selector at the top.",
    "tenant_required": "Select a tenant using the tenant selector at the top before creating a tenant administrator.",
    "global_admin_hint": "Global Admin option only visible to global admins",
    "security_settings": "Security Settings",
    "require_password_change": "Require password change on first login",
    "force_totp_enrollment": "Force TOTP enrollment",
    "create_admin": "Create Administrator",
    "update_admin": "Update Administrator",
    "resetting": "Resetting...",
    "reset_password": "Reset Password",
    "regenerating": "Regenerating...",
    "regenerate_totp": "Regenerate TOTP",
    "confirm_reset_password": "Are you sure you want to reset this administrator's password?",
    "confirm_regenerate_totp": "Are you sure you want to regenerate TOTP for this administrator?",
    "password_reset_success": "Password has been reset. The administrator will need to set a new password on next login.",
    "temporary_password": "Temporary Password",
    "temporary_password_info": "Give this temporary password to the administrator. They can log in and change it from their profile.",
    "reset_password_failed": "Failed to reset password",
    "regenerate_totp_failed": "Failed to regenerate TOTP",
    "totp_regenerated": "TOTP Secret Regenerated",
    "secret": "Secret",
    "qr_code_url": "QR Code URL",
    "view_qr_code": "View QR Code",
    "validation_username_length": "Username must be at least 3 characters",
    "validation_password_required": "Password is required",
    "validation_password_length": "Password must be at least 12 characters",
    "validation_password_complexity": "Password must contain uppercase, lowercase, number, and special character",
    "validation_email_format": "Invalid email format"
  },
  "emailTemplates": {
    "title": "Email Templates",
    "create": "Create Template",
    "createTemplate": "Create Email Template",
    "editTemplate": "Edit Email Template",
    "internalName": "Internal Name",
    "displayName": "Display Name",
    "format": "Format",
    "subject": "Subject",
    "template": "Template Body",
    "tagWrapper": "Tag Wrapper",
    "availableTags": "Available Tags",
    "updated": "Updated",
    "actions": "Actions",
    "noTemplates": "No email templates found. Create one to get started.",
    "permissionDenied": "You do not have permission to view email templates",
    "confirmDelete": "Are you sure you want to delete template \"{{name}}\"?",
    "invalidInternalName": "Internal name must contain only letters, numbers, dashes, and underscores"
  },
  "smtp": {
    "title": "SMTP Configuration",
    "host": "SMTP Host",
    "port": "SMTP Port",
    "encryption": "Encryption",
    "encryption_none": "None",
    "encryption_tls": "TLS",
    "encryption_starttls": "STARTTLS",
    "ignore_certificates": "Ignore Certificate Errors",
    "username": "SMTP Username",
    "password": "SMTP Password",
    "from_email": "From Email",
    "from_name": "From Name"
  },
  "settings": {
    "title": "Settings",
    "login_required": "Please log in to access settings.",
    "access_denied_title": "Access Denied",
    "access_denied_message": "Settings are only available to global administrators. Please contact your system administrator if you need access to system-level configuration.",
    "session_info": "Session Information",
    "authentication": "Authentication",
    "access_level": "Access Level",
    "authenticated": "Authenticated",
    "not_authenticated": "Not Authenticated",
    "global_admin": "Global Administrator",
    "standard_user": "Standard User",
    "tool_runner_config": "Tool Runner Configuration",
    "tool_runner_config_desc": "Configure global settings for tool runner connectivity and health monitoring.",
    "ping_interval": "Ping Interval (seconds)",
    "absence_timeout": "Absence Timeout (seconds)",
    "ping_help": "Time between ping messages from tool runner (1-300 seconds)",
    "absence_help": "Time before tool runner is marked as offline (1-300 seconds)",
    "config_modified": "Configuration has been modified. Click \"Save Changes\" to apply.",
    "saving": "Saving...",
    "save_changes": "Save Changes",
    "reset_defaults": "Reset to Defaults",
    "current_settings": "Current Settings",
    "ping_current": "Ping Interval: {{interval}} seconds",
    "absence_current": "Absence Timeout: {{timeout}} seconds",
    "config_saved": "Tool Runner configuration saved successfully",
    "config_save_failed": "Failed to save tool runner configuration",
    "system_attributes": "System Attributes",
    "tab_api": "API",
    "api_key": "API Key",
    "api_reissue_key": "Re-issue Key",
    "api_reissue_confirm": "Re-issuing the API key will immediately invalidate the current key. Any system using the current key will stop working. Are you sure?",
    "api_generate_key": "Generate Key",
    "api_key_reissued": "API key re-issued successfully",
    "api_save_permissions": "Save Permissions",
    "api_rate_limits": "Rate Limits",
    "api_rate_limits_managed_globally": "Rate limits are managed globally by the system administrator.",
    "api_loading": "Loading...",
    "api_load_error": "Failed to load consumer API settings.",
    "consumer_api_section": "Consumer API",
    "upstream_attr_defaults_subheading": "Provider Attribute Defaults — inherited by provider rows unless they set their own"
  },
  "webhook_tester": {
    "title": "Webhook Tester",
    "description": "Test webhook endpoints for Virtual Interfaces",
    "request": "Request",
    "response": "Response",
    "webhook_url": "Webhook URL",
    "webhook_url_help": "Enter the full webhook URL including the virtual interface ID",
    "sample_payloads": "Sample Payloads",
    "payload_json": "Payload (JSON)",
    "sending": "Sending...",
    "send_webhook": "Send Webhook",
    "status_label": "Status",
    "response_body": "Response Body",
    "response_headers": "Response Headers",
    "empty_state": "Send a request to see the response",
    "tips_title": "Tips",
    "tip1": "Make sure the Channel Gateway is running on port 3002",
    "tip2": "Use a valid virtual interface ID in the URL",
    "tip3": "Check the browser console for CORS errors if the request fails",
    "tip4": "View Channel Gateway logs with: docker logs sophia-channel-gateway-1"
  },
  "infrastructure": {
    "media_servers": "Media Servers",
    "tool_runners": "Tool Runners",
    "new_server": "New Server",
    "new_runner": "New Runner",
    "new_media_server": "New Media Server",
    "new_tool_runner": "New Tool Runner",
    "edit_media_server": "Edit Media Server",
    "edit_tool_runner": "Edit Tool Runner",
    "api_key": "API Key",
    "type": "Type",
    "last_seen": "Last Seen",
    "never": "Never",
    "on_prem": "On-Prem",
    "cloud": "Cloud",
    "copy_api_key": "Copy API Key",
    "api_key_copied": "API Key copied to clipboard",
    "api_key_copy_failed": "Failed to copy API Key",
    "no_media_servers": "No media servers found",
    "no_tool_runners": "No tool runners found",
    "connection_config": "Connection Configuration",
    "deployment_type": "Deployment Type",
    "on_premises_deployment": "On-Premises Deployment",
    "on_prem_help": "Check if the server will be deployed in your infrastructure.",
    "runner_on_prem_help": "Check if the tool runner will be deployed in your infrastructure.",
    "create_server": "Create Server",
    "create_runner": "Create Runner",
    "creating": "Creating...",
    "saving": "Saving...",
    "save_changes": "Save Changes",
    "details": "Details",
    "configuration": "Configuration",
    "regenerate_key": "Regenerate Key",
    "regenerating": "Regenerating...",
    "regenerate_warning": "Regenerating API Key will immediately invalidate the old key.",
    "regenerate_confirm": "Are you sure you want to regenerate the API Key? The old key will stop working immediately.",
    "key_regenerated": "API Key regenerated successfully",
    "key_regenerate_failed": "Failed to regenerate API Key",
    "server_created_title": "Media Server Created",
    "runner_created_title": "Tool Runner Created",
    "success": "Success!",
    "server_created_desc": "Media server created. Please save the API Key below - it will not be shown again.",
    "runner_created_desc": "Tool runner created. Please save the API Key below - it will not be shown again.",
    "server_id": "Server ID",
    "runner_id": "Runner ID",
    "key_shown_once": "This API Key will only be shown once. Please save it securely.",
    "config_title": "Configuration",
    "config_env_vars": "Configure your server with the following environment variables:",
    "runner_config_env_vars": "Configure your tool runner with the following environment variables:",
    "done": "Done",
    "auth_required": "Authentication required. Please login again.",
    "save_first_attributes": "Save the media server first to configure attributes.",
    "load_failed_media_server": "Failed to load media server",
    "create_failed_media_server": "Failed to create media server",
    "update_failed_media_server": "Failed to update media server",
    "load_failed_tool_runner": "Failed to load tool runner",
    "create_failed_tool_runner": "Failed to create tool runner",
    "update_failed_tool_runner": "Failed to update tool runner",
    "delete_failed_runner": "Failed to delete runner",
    "delete_runner_confirm": "Are you sure you want to delete the runner \"{{name}}\"?",
    "media_server_connect": "Media servers connect to AI Orchestrator using the API Key shown above. Configure the connection URL on the media server via",
    "tool_runner_connect": "Tool runners connect to AI Orchestrator using the API Key shown above. Configure the connection URL on the tool runner via",
    "env_var": "environment variable.",
    "media_server_env_help": "The media server will connect to AI Orchestrator using environment variables. The API Key will be created and shown after creation.",
    "runner_env_help": "The tool runner will connect to AI Orchestrator using environment variables. The API Key will be created and shown after creation.",
    "example": "Example",
    "copy": "Copy"
  },
  "session": {
    "timeouts_title": "Session Timeouts",
    "timeouts_desc": "Configure session timeout behavior for voice and text channels",
    "attribute": "Attribute",
    "value": "Value",
    "level": "Level",
    "action": "Action",
    "idle_timeout_voice": "Idle Timeout (Voice)",
    "idle_timeout_voice_desc": "Time of inactivity before voice session ends",
    "idle_timeout_text": "Idle Timeout (Text)",
    "idle_timeout_text_desc": "Time of inactivity before text session ends",
    "absolute_timeout_voice": "Absolute Timeout (Voice)",
    "absolute_timeout_voice_desc": "Maximum duration of voice session",
    "absolute_timeout_text": "Absolute Timeout (Text)",
    "absolute_timeout_text_desc": "Maximum duration of text session (0 = infinite)",
    "seconds": "seconds",
    "minutes": "minutes",
    "timeout_behavior": "Timeout Behavior",
    "idle_timeout": "Idle Timeout",
    "idle_timeout_explanation": "Session ends if user is inactive for the specified duration.",
    "absolute_timeout": "Absolute Timeout",
    "absolute_timeout_explanation": "Session ends after the maximum duration regardless of activity.",
    "channel_types": "Channel Types",
    "channel_types_explanation": "Voice channels (SIP, WebRTC) use voice timeouts. Text channels (Telegram, WhatsApp, Webchat) use text timeouts.",
    "30_minutes": "30 minutes",
    "1_hour": "1 hour",
    "2_hours": "2 hours",
    "3_hours": "3 hours",
    "4_hours": "4 hours",
    "5_hours": "5 hours",
    "6_hours": "6 hours",
    "12_hours": "12 hours",
    "18_hours": "18 hours",
    "24_hours": "24 hours",
    "36_hours": "36 hours",
    "48_hours": "48 hours",
    "72_hours": "72 hours",
    "infinite_no_timeout": "Infinite (no timeout)",
    "96_hours_4_days": "96 hours (4 days)",
    "168_hours_7_days": "168 hours (7 days)"
  },
  "system_attributes": {
    "loading": "Loading system attributes...",
    "fetch_failed": "Failed to fetch system attributes",
    "save_failed": "Failed to save system attributes",
    "chat_agent_title": "Chat Agent Defaults",
    "chat_agent_desc": "Default chat agent configuration for the system",
    "tool_runner_title": "Tool Runner Configuration",
    "tool_runner_desc": "Global tool runner connectivity settings",
    "vertex_ai_title": "Google Vertex AI Configuration",
    "vertex_ai_desc": "Service account credentials for Vertex AI (LLM and TTS)",
    "system_prompt": "System Prompt",
    "barge_in_enabled": "Barge In Enabled",
    "ping_interval": "Ping Interval (seconds)",
    "absence_timeout": "Absence Timeout (seconds)",
    "project_id": "Project ID",
    "location": "Location",
    "sa_json": "Service Account JSON",
    "paste_sa_json": "Paste service account JSON here"
  },
  "upstreamProviders": {
    "title": "Upstream Providers",
    "forbiddenDescription": "Only global administrators can manage upstream providers.",
    "tabs": {
      "stt": "Speech to Text",
      "tts": "Text to Speech",
      "llm": "LLM"
    },
    "addStt": "Add STT Provider",
    "addTts": "Add TTS Provider",
    "addLlm": "Add LLM Model",
    "createStt": "New STT Provider",
    "createTts": "New TTS Provider",
    "createLlm": "New LLM Model",
    "editStt": "Edit STT Provider",
    "editTts": "Edit TTS Provider",
    "editLlm": "Edit LLM Model",
    "name": "Name",
    "providerColumn": "Provider",
    "model": "Model",
    "actions": "Actions",
    "searchPlaceholder": "Search by name…",
    "noStt": "No STT providers configured.",
    "noTts": "No TTS providers configured.",
    "noLlm": "No LLM models configured.",
    "deleteConfirm": "Delete this provider?",
    "deleteBlocked": "Cannot delete: this provider is used by {{count}} agent(s).",
    "failedToLoad": "Failed to load providers.",
    "failedToSave": "Failed to save provider.",
    "failedToDelete": "Failed to delete provider.",
    "manageProviders": "Manage providers",
    "selectStt": "STT provider",
    "selectTts": "TTS provider",
    "selectLlm": "LLM model",
    "createStep1Hint": "After creating the provider, you will configure its settings.",
    "stt_ignored_badge": "STT ignored",
    "stt_ignored_hint": "OpenAI Realtime Speech-to-Speech is active for this agent. The selected STT provider is ignored — OpenAI Realtime handles speech-to-text using the TTS API key.",
    "provider": {
      "soniox": "Soniox",
      "faster_whisper": "Faster Whisper",
      "google": "Google",
      "google_vertex_ai": "Google Vertex AI",
      "elevenlabs": "ElevenLabs",
      "openai": "OpenAI",
      "anthropic": "Anthropic",
      "azure_openai": "Azure OpenAI",
      "self_hosted": "Self-hosted"
    },
    "stt": "Speech-to-Text (STT)",
    "tts": "Text-to-Speech (TTS)",
    "llm": "LLM Provider",
    "optionalDefault": "Optional, uses provider default",
    "language": "Language",
    "vocabulary_book": "Vocabulary Book",
    "encrypted": "Encrypted",
    "smtp": "SMTP Configuration"
  },
  "billing": {
    "title": "Billing Report",
    "rates_title": "Billing Rates",
    "tenant": "Tenant",
    "transcription_minutes": "Transcription Minutes",
    "transcribed_files": "Transcribed Files",
    "voice_analysis_minutes": "Voice Analysis Minutes",
    "stt_minutes": "STT Minutes",
    "tts_minutes": "TTS Minutes",
    "sts_minutes": "STS Minutes",
    "llm_tokens": "LLM Tokens",
    "cost": "Cost",
    "no_data": "No billing data for this period",
    "no_rates": "No billing rates configured",
    "load_error": "Failed to load billing data",
    "rate_saved": "Rate saved",
    "rate_deleted": "Rate deleted",
    "scope_system": "System Default",
    "scope_tenant": "Tenant Override",
    "service_type": "Service Type",
    "service_type_llm": "LLM",
    "service_type_stt": "Speech to Text",
    "service_type_tts": "Text to Speech",
    "service_type_s2s": "Speech to Speech",
    "service_type_voice_analysis": "Voice Analysis",
    "model": "Model",
    "model_default": "Default (all models)",
    "model_placeholder": "Select model",
    "no_providers": "No providers configured",
    "per_1": "Per 1",
    "per_1000": "Per 1,000",
    "per_1000000": "Per 1,000,000",
    "unit": "Unit",
    "unit_token": "Token",
    "unit_word": "Word",
    "unit_char": "Character",
    "unit_minute": "Minute",
    "unit_hour": "Hour",
    "unit_token_s": "token",
    "unit_token_p": "tokens",
    "unit_word_s": "word",
    "unit_word_p": "words",
    "unit_char_s": "char",
    "unit_char_p": "chars",
    "unit_minute_s": "min",
    "unit_minute_p": "min",
    "unit_hour_s": "hour",
    "unit_hour_p": "hours",
    "used_amount": "Used Amount",
    "price_rate": "Price",
    "tier": "Tier",
    "tier_default": "Default",
    "tier_input": "Input",
    "tier_cached": "Cached",
    "tier_output": "Output",
    "tier_audio_input": "Audio Input",
    "tier_text_input": "Text Input",
    "tier_image_input": "Image Input",
    "tier_audio_cached_input": "Audio Cached Input",
    "tier_text_cached_input": "Text Cached Input",
    "tier_image_cached_input": "Image Cached Input",
    "tier_audio_output": "Audio Output",
    "tier_text_output": "Text Output",
    "no_breakdown": "No model breakdown for this tenant",
    "add_override": "Add Override",
    "unit_price": "Unit Price",
    "currency": "Currency",
    "scope": "Scope",
    "period_custom": "Custom",
    "from_date": "From",
    "to_date": "To"
  },
  "knowledgeBases": {
    "title": "Knowledge Bases",
    "new": "New Knowledge Base",
    "create_title": "Create Knowledge Base",
    "edit_title": "Edit Knowledge Base",
    "processing_title": "Processing",
    "loading": "Loading knowledge bases...",
    "empty": "No knowledge bases found",
    "name": "Name",
    "description": "Description",
    "store_type": "Store Type",
    "documents": "Documents",
    "status": "Status",
    "created": "Created",
    "actions": "Actions",
    "delete_confirm": "Are you sure you want to delete this knowledge base?",
    "quota_used": "{{used}} / {{quota}}",
    "stub_notice": "This page is under construction.",
    "tabs": {
      "general": "General",
      "data_source": "Data Source",
      "embedding": "Embedding",
      "chunking": "Chunking",
      "documents": "Documents"
    }
  },
  "vocabulary": {
    "title": "Vocabulary Books",
    "add_book": "Add Vocabulary Book",
    "create": "Create",
    "items": "Items",
    "phrase": "Phrase",
    "created": "Created",
    "updated": "Updated",
    "empty": "No vocabulary books yet",
    "delete_book_confirm": "Delete this vocabulary book? All its phrases will be removed.",
    "search_placeholder": "Search phrases...",
    "new_phrase": "New phrase...",
    "add_phrase": "Add",
    "import": "Import",
    "export": "Export CSV",
    "import_result": "{added} added, {duplicates} duplicates, {dropped} dropped",
    "delete_selected": "Delete Selected",
    "delete_selected_confirm": "Delete the selected phrases?",
    "load_failed": "Failed to load",
    "save_failed": "Save failed",
    "no_book": "(none)"
  }
};

const heCommon = {
  ...enCommon,
  "navigation": {
    ...enCommon.navigation,
    "infrastructure": "תשתית",
    "configuration": "תצורה",
    "analytics": "אנליטיקס",
    "administration": "ניהול",
    "logs": "לוגים",
    "media_servers": "שרתי מדיה",
    "tool_runners": "מריצי כלים",
    "virtual_interfaces": "ממשקים וירטואליים",
    "tools_list": "רשימת כלים",
    "webhook_tester": "בודק Webhook",
    "agents": "סוכנים",
    "tools": "כלים",
    "knowledgeBases": "בסיסי ידע",
    "vocabulary": "אוצר מילים",
    "groups": "קבוצות",
    "agent_groups": "קבוצות סוכנים",
    "tool_groups": "קבוצות כלים",
    "channel_groups": "קבוצות ערוצים",
    "user_groups": "קבוצות משתמשים",
    "tool_tester": "בודק כלים",
    "dashboard": "לוח בקרה",
    "call_logs": "יומן שיחות",
    "tool_logs": "יומן כלים",
    "tenants": "שוכרים",
    "audit_logs": "לוגי ביקורת",
    "administrators": "מנהלים",
    "settings": "הגדרות",
    "email_templates": "תבניות דואר",
    "upstreamProviders": "ספקים חיצוניים",
    "billing": "חיוב",
    "billing_report": "דוח חיוב",
    "billing_rates": "תעריפי חיוב",
    "outboundDialers": "חיוג יוצא"
  },
  "groups": {
    "new_group": "קבוצה חדשה",
    "delete_failed": "נכשלה מחיקת קבוצה",
    "confirm_delete": "האם אתה בטוח שברצונך למחוק קבוצה זו?",
    "agent": {
      "title": "קבוצות סוכנים",
      "create_title": "יצירת קבוצת סוכנים חדשה",
      "edit_title": "עריכת קבוצת סוכנים",
      "empty": "לא נמצאו קבוצות סוכנים",
      "load_failed": "נכשלה טעינת קבוצות סוכנים",
      "create_failed": "נכשלה יצירת קבוצת סוכנים",
      "update_failed": "נכשל עדכון קבוצת סוכנים",
      "manage": "ניהול סוכנים"
    },
    "tool": {
      "title": "קבוצות כלים",
      "create_title": "יצירת קבוצת כלים חדשה",
      "edit_title": "עריכת קבוצת כלים",
      "empty": "לא נמצאו קבוצות כלים",
      "load_failed": "נכשלה טעינת קבוצות כלים",
      "create_failed": "נכשלה יצירת קבוצת כלים",
      "update_failed": "נכשל עדכון קבוצת כלים",
      "manage": "ניהול כלים",
      "tab_details": "פרטים",
      "tab_attributes": "מאפיינים"
    },
    "channel": {
      "title": "קבוצות ערוצים",
      "create_title": "יצירת קבוצת ערוצים חדשה",
      "edit_title": "עריכת קבוצת ערוצים",
      "empty": "לא נמצאו קבוצות ערוצים",
      "load_failed": "נכשלה טעינת קבוצות ערוצים",
      "create_failed": "נכשלה יצירת קבוצת ערוצים",
      "update_failed": "נכשל עדכון קבוצת ערוצים",
      "type_label": "סוג ערוץ",
      "channel_type_voice": "קול",
      "channel_type_chat": "צ'אט",
      "channel_type_email": "דואר",
      "channel_type_sms": "SMS"
    },
    "user": {
      "title": "קבוצות משתמשים",
      "create_title": "יצירת קבוצת משתמשים חדשה",
      "edit_title": "עריכת קבוצת משתמשים",
      "empty": "לא נמצאו קבוצות משתמשים",
      "load_failed": "נכשלה טעינת קבוצות משתמשים",
      "create_failed": "נכשלה יצירת קבוצת משתמשים",
      "update_failed": "נכשל עדכון קבוצת משתמשים"
    },
    "delete_group_confirm": "האם אתה בטוח שברצונך למחוק קבוצה זו?",
    "delete_type_confirm": "האם אתה בטוח שברצונך למחוק קבוצת {{type}}?",
    "delete_type_failed": "נכשלה מחיקת קבוצת {{type}}",
    "modal": {
      "manage_title": "ניהול {{itemType}} - {{name}}",
      "available_items": "{{itemType}} זמינים",
      "group_members": "חברי קבוצה",
      "no_available": "אין {{itemType}} זמינים",
      "no_members": "אין {{itemType}} בקבוצה זו",
      "count_available": "{{count}} זמינים",
      "count_members": "{{count}} חברים",
      "add_selected": "הוסף נבחרים",
      "add_all": "הוסף הכל",
      "remove_selected": "הסר נבחרים",
      "remove_all": "הסר הכל",
      "load_failed": "נכשלה טעינת {{itemType}}",
      "add_failed": "נכשלה הוספת {{itemType}}",
      "remove_failed": "נכשלה הסרת {{itemType}}",
      "enabled": "מופעל",
      "disabled": "מושבת",
      "close": "סגור"
    }
  },
  "infrastructure": {
    ...enCommon.infrastructure,
    "media_servers": "שרתי מדיה",
    "tool_runners": "מריצי כלים",
    "new_server": "שרת חדש",
    "new_runner": "מריץ חדש",
    "new_media_server": "שרת מדיה חדש",
    "new_tool_runner": "מריץ כלים חדש",
    "edit_media_server": "עריכת שרת מדיה",
    "edit_tool_runner": "עריכת מריץ כלים",
    "api_key": "מפתח API",
    "type": "סוג",
    "last_seen": "נראה לאחרונה",
    "never": "לעולם לא",
    "on_prem": "On-Prem",
    "cloud": "Cloud",
    "copy_api_key": "העתק מפתח API",
    "api_key_copied": "מפתח API הועתק ללוח",
    "api_key_copy_failed": "נכשלה העתקת מפתח API",
    "no_media_servers": "לא נמצאו שרתי מדיה",
    "no_tool_runners": "לא נמצאו מריצי כלים",
    "connection_config": "תצורת חיבור",
    "deployment_type": "סוג פריסה",
    "on_premises_deployment": "פריסה מקומית (On-Premises)",
    "on_prem_help": "סמן אם השרת יופרס בתשתית שלך.",
    "runner_on_prem_help": "סמן אם מריץ הכלים יופרס בתשתית שלך.",
    "create_server": "צור שרת",
    "create_runner": "צור מריץ",
    "creating": "יוצר...",
    "saving": "שומר...",
    "save_changes": "שמור שינויים",
    "details": "פרטים",
    "configuration": "תצורה",
    "regenerate_key": "צור מפתח מחדש",
    "regenerating": "מחדש...",
    "regenerate_warning": "יצירת מפתח API מחדש תבטל את המפתח הישן באופן מיידי.",
    "regenerate_confirm": "האם אתה בטוח שברצונך לחדש את מפתח ה-API? המפתח הישן יפסיק לעבוד מיידית.",
    "key_regenerated": "מפתח API חודש בהצלחה",
    "key_regenerate_failed": "נכשלה יצירת מפתח API מחדש",
    "server_created_title": "שרת מדיה נוצר",
    "runner_created_title": "מריץ כלים נוצר",
    "success": "הצלחה!",
    "server_created_desc": "שרת המדיה נוצר. אנא שמור את מפתח ה-API למטה - הוא לא יוצג שוב.",
    "runner_created_desc": "מריץ הכלים נוצר. אנא שמור את מפתח ה-API למטה - הוא לא יוצג שוב.",
    "server_id": "מזהה שרת",
    "runner_id": "מזהה מריץ",
    "key_shown_once": "מפתח API זה יוצג רק פעם אחת. אנא שמור אותו בבטחה.",
    "config_title": "תצורה",
    "config_env_vars": "הגדר את השרת שלך עם משתני הסביבה הבאים:",
    "runner_config_env_vars": "הגדר את מריץ הכלים שלך עם משתני הסביבה הבאים:",
    "done": "בוצע",
    "auth_required": "אימות נדרש. אנא התחבר שוב.",
    "save_first_attributes": "יש לשמור את שרת המדיה תחילה כדי להגדיר תכונות.",
    "load_failed_media_server": "נכשלה טעינת שרת מדיה",
    "create_failed_media_server": "נכשלה יצירת שרת מדיה",
    "update_failed_media_server": "נכשל עדכון שרת מדיה",
    "load_failed_tool_runner": "נכשלה טעינת מריץ כלים",
    "create_failed_tool_runner": "נכשלה יצירת מריץ כלים",
    "update_failed_tool_runner": "נכשל עדכון מריץ כלים",
    "delete_failed_media_server": "נכשלה מחיקת שרת מדיה",
    "delete_failed_tool_runner": "נכשלה מחיקת מריץ כלים",
    "delete_failed_runner": "נכשלה מחיקת מריץ",
    "delete_runner_confirm": "האם אתה בטוח שברצונך למחוק את המריץ \"{{name}}\"?",
    "server_deleted": "שרת המדיה נמחק בהצלחה",
    "runner_deleted": "מריץ הכלים נמחק בהצלחה",
    "media_server_connect": "שרתי מדיה מתחברים ל-AI Orchestrator באמצעות מפתח ה-API המוצג למעלה. הגדר את כתובת החיבור בשרת המדיה דרך",
    "tool_runner_connect": "מריצי כלים מתחברים ל-AI Orchestrator באמצעות מפתח ה-API המוצג למעלה. הגדר את כתובת החיבור במריץ הכלים דרך",
    "env_var": "משתנה סביבה.",
    "media_server_env_help": "שרת המדיה יתחבר ל-AI Orchestrator באמצעות משתני סביבה. מפתח ה-API ייווצר ויוצג לאחר היצירה.",
    "runner_env_help": "מריץ הכלים יתחבר ל-AI Orchestrator באמצעות משתני סביבה. מפתח ה-API ייווצר ויוצג לאחר היצירה.",
    "example": "דוגמה",
    "copy": "העתק",
    "no_name": "ללא שם",
    "health_check_url": "כתובת URL לבדיקת תקינות",
    "websocket_url": "כתובת WebSocket",
    "actions": "פעולות",
    "edit": "ערוך",
    "delete": "מחק",
    "confirm_delete_server": "האם אתה בטוח שברצונך למחוק את שרת המדיה?",
    "confirm_delete_runner": "האם אתה בטוח שברצונך למחוק את מריץ הכלים?",
    "delete_server": "מחק שרת",
    "delete_runner": "מחק מריץ",
    "server_name": "שם שרת",
    "runner_name": "שם מריץ",
    "server_url": "כתובת שרת",
    "runner_url": "כתובת מריץ",
    "status": "סטטוס",
    "online": "מחובר",
    "offline": "מנותק",
    "version": "גרסה",
    "active_calls": "שיחות פעילות",
    "cpu_usage": "שימוש במעבד",
    "memory_usage": "שימוש בזיכרון",
    "uptime": "זמן פעילות",
    "last_heartbeat": "פעימת לב אחרונה",
    "no_data": "אין נתונים",
    "refresh": "רענון",
    "auto_refresh": "רענון אוטומטי",
    "auto_refresh_enabled": "רענון אוטומטי מופעל",
    "auto_refresh_disabled": "רענון אוטומטי מושבת",
    "refresh_interval": "מרווח רענון",
    "seconds": "שניות",
    "minutes": "דקות",
    "hours": "שעות",
    "days": "ימים"
  },
  "toolRunner": {
    ...enCommon.toolRunner,
    "title": "מריצי כלים",
    "new": "מריץ כלים חדש",
    "edit": "עריכת מריץ כלים",
    "edit_title": "עריכת מריץ כלים",
    "basic_info": "מידע בסיסי",
    "api_key": "מפתח API",
    "copy": "העתק",
    "copy_success": "מפתח API הועתק ללוח",
    "copy_failed": "נכשלה העתקת מפתח API",
    "regenerate_key": "צור מפתח מחדש",
    "regenerating": "מחדש...",
    "regenerate_warning": "יצירת מפתח API מחדש תבטל את המפתח הישן באופן מיידי.",
    "status_online": "מחובר",
    "status_offline": "מנותק",
    "status_pending": "ממתין",
    "status_error": "שגיאה",
    "status_readonly": "הסטטוס מתעדכן אוטומטית בהתאם לקישוריות המריץ",
    "acceptConnections": "קבל חיבורים",
    "acceptConnections_help": "אפשר למריץ זה לקבל חיבורי הרצת כלים חדשים",
    "deployment_type": "סוג פריסה",
    "on_premises": "פריסה מקומית (On-Premises)",
    "save_changes": "שמור שינויים",
    "saving": "שומר...",
    "cancel": "ביטול",
    "tools_panel_title": "כלים זמינים במריץ זה",
    "no_tools": "אין כלים במריץ זה",
    "load_failed": "נכשלה טעינת מריץ הכלים",
    "create_failed": "נכשלה יצירת מריץ כלים",
    "update_failed": "נכשל עדכון מריץ כלים",
    "delete_failed": "נכשלה מחיקת מריץ כלים",
    "runner_deleted": "מריץ הכלים נמחק בהצלחה",
    "confirm_delete": "האם אתה בטוח שברצונך למחוק את מריץ הכלים?",
    "delete": "מחק",
    "back_to_runners": "חזרה למריצי כלים",
    "regenerate_confirm": "האם אתה בטוח שברצונך לחדש את מפתח ה-API? המפתח הישן יפסיק לעבוד מיידית.",
    "key_regenerated": "מפתח API חודש בהצלחה",
    "key_regenerate_failed": "נכשלה יצירת מפתח API מחדש",
    "api_key_copied": "מפתח API הועתק ללוח",
    "api_key_copy_failed": "נכשלה העתקת מפתח API",
    "associated_tools": "כלים משויכים",
    "runner_tools": "כלי המריץ",
    "available_tools": "כלים זמינים",
    "items_count": "{{count}} פריטים",
    "built_in": "מובנה",
    "no_available_tools": "כל הכלים משויכים",
    "no_associated_tools": "אין כלים משויכים",
    "add_selected": "הוסף כלים נבחרים",
    "remove_selected": "הסר כלים נבחרים",
    "selection_hint": "החזק Ctrl/Cmd כדי לבחור מספר פריטים",
    "tools_updated": "הגדרות הכלים עודכנו בהצלחה",
    "error_load_tools": "נכשלה טעינת הכלים",
    "error_save_tools": "נכשלה שמירת הגדרות הכלים"
  },
  "common": {
    ...enCommon.common,
    "filter": "סנן",
    "export": "ייצוא",
    "actions": "פעולות",
    "modified": "משונה",
    "creating_in_tenant": "יוצר בשוכר",
    "cancel": "ביטול",
    "create": "צור",
    "configure": "הגדר",
    "update": "עדכן",
    "save": "שמור",
    "saving": "שומר...",
    "loading": "טוען...",
    "search": "חפש",
    "name": "שם",
    "description": "תיאור",
    "status": "סטטוס",
    "group": "קבוצה",
    "created_at": "תאריך יצירה",
    "updated_at": "תאריך עדכון",
    "edit": "ערוך",
    "delete": "מחק",
    "confirm_delete": "האם אתה בטוח שברצונך למחוק פריט זה?",
    "delete_failed": "מחיקת הפריט נכשלה",
    "agent_delete_blocked": "לא ניתן למחוק: {{count}} ממשק(ים) וירטואלי(ים) עדיין משתמש(ים) בסוכן זה. מחק או הקצה אותם מחדש תחילה.",
    "load_failed": "טעינת הנתונים נכשלה",
    "online": "מחובר",
    "offline": "מנותק",
    "no_group": "ללא קבוצה",
    "view_all": "צפה בהכל",
    "view_infrastructure": "צפה בתשתית",
    "no_tenant_selected_warning": "לא נבחר שוכר. אנא בחר שוכר מהתפריט העליון לפני המשך.",
    "active": "פעיל",
    "inactive": "לא פעיל",
    "reset": "איפוס",
    "refresh": "רענון",
    "dismiss": "סגור",
    "view": "צפה",
    "deleting": "מוחק...",
    "time": "זמן",
    "tool": "כלי",
    "tools": "כלים",
    "agent": "סוכן",
    "agents": "סוכנים",
    "no_description": "אין תיאור",
    "next": "הבא",
    "previous": "הקודם",
    "back": "חזרה",
    "items": "פריטים",
    "none": "ללא",
    "enabled": "מופעל",
    "disabled": "מושבת",
    "close": "סגור",
    "save_failed": "שמירה נכשלה"
  },
  "forms": {
    "tables": {
      "headers": {
        "attribute": "תכונה",
        "value": "ערך",
        "level": "רמה",
        "action": "פעולה"
      }
    },
    "agents": {
      "tabs": {
        "details": "פרטים",
        "configuration": "תצורה",
        "upstreamProviders": "ספקים חיצוניים"
      },
      "labels": {
        "name": "שם",
        "description": "תיאור",
        "agentGroup": "קבוצת סוכנים"
      },
      "placeholders": {
        "noGroup": "אין קבוצה"
      },
      "errors": {
        "nameRequired": "שם הסוכן נדרש"
      },
      "loading": {
        "tools": "טוען כלים...",
        "agents": "טוען סוכנים..."
      },
      "empty": {
        "noTools": "אין כלים זמינים",
        "noDelegateAgents": "אין סוכנים אחרים בדייר זה"
      },
      "badge": {
        "builtin": "מובנה"
      },
      "alerts": {
        "saveFirst": "יש לשמור את הסוכן תחילה כדי להגדיר ספקים חיצוניים."
      },
      "otherConfiguration": "תצורה אחרת"
    },
    "auth": {
      "login": { "title": "התחברות עם סיסמה" }
    },
    "outboundDialers": {
      "name": "שם",
      "originatingMediaServer": "שרת מדיה מתחיל",
      "virtualInterface": "ממשק וירטואלי",
      "activitySchedule": "לוח זמנים",
      "activitySchedule.enabled": "פעיל",
      "activitySchedule.start": "פתיחה",
      "activitySchedule.end": "סגירה",
      "activitySchedule.day": "יום",
      "activitySchedule.invalidRange": "שעת ההתחלה חייבת להיות לפני שעת הסיום",
      "timezone": "אזור זמן",
      "anyCloudMediaServer": "כל שרת מדיה ענני זמין",
      "weekday": {
        "sun": "ראשון",
        "mon": "שני",
        "tue": "שלישי",
        "wed": "רביעי",
        "thu": "חמישי",
        "fri": "שישי",
        "sat": "שבת"
      }
    }
  },
  "dashboard": {
    ...enCommon.dashboard,
    "title": "לוח בקרה",
    "time_series": "אנליטיקס סדרת זמן",
    "today": "היום",
    "last_7_days": "7 ימים אחרונים",
    "last_30_days": "30 יום אחרונים",
    "this_month": "החודש",
    "last_month": "חודש שעבר",
    "processed_calls": "שיחות שעובדו",
    "tools_run": "כלים שהופעלו",
    "total_call_time": "זמן שיחה כולל",
    "tool_processing_time": "זמן עיבוד כלים",
    "updated": "עודכן",
    "tenant_scope": "טווח שוכר",
    "current_tenant": "נוכחי",
    "all_tenants": "הכל",
    "system_health": "תקין מערכת",
    "no_infrastructure": "אין תשתית מוגדרת.",
    "recent_tool_logs": "הפעלות כלים אחרונות",
    "no_recent_tool_logs": "אין הפעלות כלים אחרונות."
  },
  "upstreamProviders": {
    "title": "ספקים חיצוניים",
    "forbiddenDescription": "רק מנהלי מערכת גלובליים יכולים לנהל ספקים חיצוניים.",
    "tabs": {
      "stt": "דיבור לטקסט",
      "tts": "טקסט לדיבור",
      "llm": "LLM"
    },
    "addStt": "הוסף ספק STT",
    "addTts": "הוסף ספק TTS",
    "addLlm": "הוסף מודל LLM",
    "createStt": "ספק STT חדש",
    "createTts": "ספק TTS חדש",
    "createLlm": "מודל LLM חדש",
    "editStt": "ערוך ספק STT",
    "editTts": "ערוך ספק TTS",
    "editLlm": "ערוך מודל LLM",
    "name": "שם",
    "providerColumn": "ספק",
    "model": "מודל",
    "actions": "פעולות",
    "searchPlaceholder": "חפש לפי שם…",
    "noStt": "אין ספקי STT מוגדרים.",
    "noTts": "אין ספקי TTS מוגדרים.",
    "noLlm": "אין מודלי LLM מוגדרים.",
    "deleteConfirm": "למחוק ספק זה?",
    "deleteBlocked": "לא ניתן למחוק: ספק זה בשימוש על ידי {{count}} סוכן(ים).",
    "failedToLoad": "נכשלה טעינת ספקים.",
    "failedToSave": "נכשלה שמירת ספק.",
    "failedToDelete": "נכשלה מחיקת ספק.",
    "manageProviders": "ניהול ספקים",
    "selectStt": "ספק STT",
    "selectTts": "ספק TTS",
    "selectLlm": "מודל LLM",
    "createStep1Hint": "לאחר יצירת הספק, תגדיר את הגדרותיו.",
    "stt_ignored_badge": "STT מתעלם",
    "stt_ignored_hint": "מצב Speech-to-Speech של OpenAI Realtime פעיל לסוכן זה. ספק ה-STT שנבחר אינו בשימוש — OpenAI Realtime מבצע זיהוי דיבור באמצעות מפתח ה-API של ה-TTS.",
    "provider": {
      "soniox": "Soniox",
      "faster_whisper": "Faster Whisper",
      "google": "Google",
      "google_vertex_ai": "Google Vertex AI",
      "elevenlabs": "ElevenLabs",
      "openai": "OpenAI",
      "anthropic": "Anthropic",
      "azure_openai": "Azure OpenAI",
      "self_hosted": "מארח עצמי"
    },
    "stt": "דיבור לטקסט (STT)",
    "tts": "טקסט לדיבור (TTS)",
    "llm": "ספק LLM",
    "optionalDefault": "אופציונלי, משתמש בברירת המחדל של הספק",
    "language": "שפה",
    "vocabulary_book": "ספר אוצר מילים",
    "encrypted": "מוצפן",
    "smtp": "תצורת SMTP"
  },
  "billing": {
    ...enCommon.billing,
    "title": "דוח חיוב",
    "rates_title": "תעריפי חיוב",
    "tenant": "טננט",
    "transcription_minutes": "דקות תמלול",
    "transcribed_files": "קבצים מתומללים",
    "voice_analysis_minutes": "דקות ניתוח קול",
    "stt_minutes": "דקות STT",
    "tts_minutes": "דקות TTS",
    "sts_minutes": "דקות STS",
    "llm_tokens": "טוקנים LLM",
    "cost": "עלות",
    "no_data": "אין נתוני חיוב לתקופה זו",
    "no_rates": "לא הוגדרו תעריפי חיוב",
    "load_error": "טעינת נתוני החיוב נכשלה",
    "rate_saved": "התעריף נשמר",
    "rate_deleted": "התעריף נמחק",
    "scope_system": "ברירת מחדל מערכת",
    "scope_tenant": "דריסת טננט",
    "service_type": "סוג שירות",
    "service_type_llm": "LLM",
    "service_type_stt": "תעתוק לטקסט",
    "service_type_tts": "טקסט לדיבור",
    "service_type_s2s": "דיבור לדיבור",
    "service_type_voice_analysis": "ניתוח קולי",
    "model": "מודל",
    "model_default": "ברירת מחדל (כל המודלים)",
    "model_placeholder": "בחר מודל",
    "no_providers": "אין ספקים מוגדרים",
    "per_1": "לכל 1",
    "per_1000": "לכל 1,000",
    "per_1000000": "לכל 1,000,000",
    "unit": "יחידה",
    "unit_token": "טוקן",
    "unit_word": "מילה",
    "unit_char": "תו",
    "unit_minute": "דקה",
    "unit_hour": "שעה",
    "unit_token_s": "טוקן",
    "unit_token_p": "טוקנים",
    "unit_word_s": "מילה",
    "unit_word_p": "מילים",
    "unit_char_s": "תו",
    "unit_char_p": "תווים",
    "unit_minute_s": "דקה",
    "unit_minute_p": "דקות",
    "unit_hour_s": "שעה",
    "unit_hour_p": "שעות",
    "used_amount": "כמות בשימוש",
    "price_rate": "מחיר",
    "tier": "שכבה",
    "tier_default": "ברירת מחדל",
    "tier_input": "קלט",
    "tier_cached": "מטמון",
    "tier_output": "פלט",
    "tier_audio_input": "קלט שמע",
    "tier_text_input": "קלט טקסט",
    "tier_image_input": "קלט תמונה",
    "tier_audio_cached_input": "קלט שמע במטמון",
    "tier_text_cached_input": "קלט טקסט במטמון",
    "tier_image_cached_input": "קלט תמונה במטמון",
    "tier_audio_output": "פלט שמע",
    "tier_text_output": "פלט טקסט",
    "no_breakdown": "אין פירוט מודלים לדייר זה",
    "add_override": "הוסף דריסה",
    "unit_price": "מחיר ליחידה",
    "currency": "מטבע",
    "scope": "היקף",
    "period_custom": "מותאם אישית",
    "from_date": "מתאריך",
    "to_date": "עד תאריך"
  },
  "attributes": {
    ...enCommon.attributes,
    "title": "תכונות תצורה",
    "search_placeholder": "חפש תכונות...",
    "level_default": "ברירת מחדל",
    "level_set": "מוגדר",
    "level_force": "כפה",
    "level_forced": "מוכפה (ירושה)",
    "modified_count": "{{count}} שונו",
    "system_default": "ברירת מחדל של המערכת",
    "product_default": "ברירת מחדל של המוצר",
    "inherited_tenant": "יורש מהשוכר",
    "inherited_group": "יורש מקבוצת סוכנים",
    "inherited_agent": "בירושה מהסוכן",
    "collapse_all": "כווץ הכל",
    "expand_all": "הרחב הכל",
    "level_locked": "נעול",
    "paste_sa_json": "הדבק JSON חשבון שירות כאן",
    "stt_provider_id": "ספק STT",
    "tts_provider_id": "ספק TTS",
    "llm_provider_id": "מודל LLM",
    "tool_timeout": "פסק זמן הרצת כלי (שניות)",
    "tool_timeout_error_message": "הודעת שגיאה לפסק זמן כלי",
    "level": {
      "title": "רמת תכונה",
      "default": "ברירת מחדל",
      "set": "מוגדר",
      "force": "כפה",
    },
  },
  "sections": {
    "chat_agent": "סוכן צ'אט",
    "user_preferences": "העדפות משתמש",
    "user_permissions": "הרשאות משתמש",
    "media_server": "שרת מדיה",
    "upstream_providers": "ספקים חיצוניים",
    "knowledge_base": "בסיס ידע"
  },
  "session": {
    "timeouts_title": "פסקי זמן של שיחה",
    "timeouts_desc": "הגדר התנהגות פסק זמן של שיחה לערוצי קול וטקסט",
    "attribute": "תכונה",
    "value": "ערך",
    "level": "רמה",
    "action": "פעולה",
    "idle_timeout_voice": "פסק זמן השבתה (קול)",
    "idle_timeout_voice_desc": "זמן חוסר פעילות לפני סיום שיחת קול",
    "idle_timeout_text": "פסק זמן השבתה (טקסט)",
    "idle_timeout_text_desc": "זמן חוסר פעילות לפני סיום שיחת טקסט",
    "absolute_timeout_voice": "פסק זמן מוחלט (קול)",
    "absolute_timeout_voice_desc": "משך מרבי של שיחת קול",
    "absolute_timeout_text": "פסק זמן מוחלט (טקסט)",
    "absolute_timeout_text_desc": "משך מרבי של שיחת טקסט (0 = אינסופי)",
    "seconds": "שניות",
    "minutes": "דקות",
    "timeout_behavior": "התנהגות פסק זמן",
    "idle_timeout": "פסק זמן השבתה",
    "idle_timeout_explanation": "השיחה מסתיימת אם המשתמש לא פעיל למשך הזמן שצוין.",
    "absolute_timeout": "פסק זמן מוחלט",
    "absolute_timeout_explanation": "השיחה מסתיימת לאחר המשך המרבי ללא קשר לפעילות.",
    "channel_types": "סוגי ערוצים",
    "channel_types_explanation": "ערוצי קול (SIP, WebRTC) משתמשים בפסקי זמן קול. ערוצי טקסט (Telegram, WhatsApp, Webchat) משתמשים בפסקי זמן טקסט.",
    "30_minutes": "30 דקות",
    "1_hour": "שעה אחת",
    "2_hours": "שעתיים",
    "3_hours": "3 שעות",
    "4_hours": "4 שעות",
    "5_hours": "5 שעות",
    "6_hours": "6 שעות",
    "12_hours": "12 שעות",
    "18_hours": "18 שעות",
    "24_hours": "24 שעות",
    "36_hours": "36 שעות",
    "48_hours": "48 שעות",
    "72_hours": "72 שעות",
    "infinite_no_timeout": "אינסופי (ללא פסק זמן)",
    "96_hours_4_days": "96 שעות (4 ימים)",
    "168_hours_7_days": "168 שעות (7 ימים)"
  },
  "system_attributes": {
    "loading": "טוען תכונות מערכת...",
    "fetch_failed": "נכשלה טעינת תכונות מערכת",
    "save_failed": "נכשל שמירת תכונות מערכת",
    "chat_agent_title": "ברירות מחדל של סוכן צ'אט",
    "chat_agent_desc": "תצורת סוכן צ'אט ברירת מחדל למערכת",
    "tool_runner_title": "תצורת מריץ כלים",
    "tool_runner_desc": "הגדרות חיבור כלליות של מריץ כלים",
    "vertex_ai_title": "תצורת Google Vertex AI",
    "vertex_ai_desc": "אישורי חשבון שירות עבור Vertex AI (LLM ו-TTS)",
    "system_prompt": "הנחיית מערכת",
    "barge_in_enabled": "הפרעה מופעלת",
    "ping_interval": "מרווח Ping (שניות)",
    "absence_timeout": "פסק זמן היעדרות (שניות)",
    "project_id": "מזהה פרויקט",
    "location": "מיקום",
    "sa_json": "JSON חשבון שירות",
    "paste_sa_json": "הדבק JSON חשבון שירות כאן"
  },
  "call_logs": {
    "title": "יומן שיחות",
    "filters": "מסננים",
    "from_date": "מתאריך",
    "to_date": "עד תאריך",
    "status": "סטטוס",
    "agent": "סוכן",
    "gender": "מגדר",
    "all_statuses": "כל הסטטוסים",
    "started": "התחלה",
    "phone": "טלפון",
    "channel": "ערוץ",
    "duration": "משך",
    "medium": "מדיום",
    "no_logs": "לא נמצאו שיחות",
    "previous": "הקודם",
    "next": "הבא",
    "message": "הודעה",
    "search_messages": "חפש הודעות...",
    "conversation": "שיחה",
    "view_conversation": "צפה בשיחה",
    "system_prompt": "הנחיית מערכת",
    "tool_result": "תוצאת כלי",
    "no_messages": "אין הודעות שיחה",
    "search": "חיפוש",
    "regenerate_feedback": "יצירת משוב מחדש",
    "insights_filter": "סינון תובנות",
    "insight_any": "הכל",
    "insight_yes": "כן",
    "insight_no": "לא",
    "feedback_title": "כותרת",
    "feedback_summary": "תקציר",
    "subagent_activity": "פעילות סוכן-משנה",
    "subagent_badge": "סוכן-משנה",
    "subagent_count_title": "התייעצויות סוכן-משנה",
    "exporting": "מייצא…",
    "export_failed": "ייצוא יומן השיחות נכשל",
    "export_empty": "אין שיחות שתואמות למסננים הנוכחיים — אין מה לייצא",
    "direction": {
      "inbound": "נכנס",
      "outbound": "יוצא",
      "internal": "פנימי",
      "all": "הכל"
    },
    "attachments": {
      "title": "קבצים מצורפים",
      "expired": "פג תוקף הקובץ המצורף",
      "download_failed": "הורדת הקובץ נכשלה",
      "kind": {
        "photo": "תמונה",
        "video": "וידאו",
        "voice": "הודעה קולית",
        "audio": "שמע",
        "document": "מסמך"
      }
    }
  },
  "tool_logs": {
    "title": "יומן כלים",
    "filters": "מסננים",
    "from_date": "מתאריך",
    "to_date": "עד תאריך",
    "search": "חיפוש",
    "search_placeholder": "חפש שם כלי, קלט, פלט, שגיאה",
    "all": "הכל",
    "tool_name": "שם הכלי",
    "input": "קלט",
    "output": "פלט",
    "timestamp": "חותמת זמן",
    "duration": "משך",
    "call_id": "מזהה שיחה",
    "error": "שגיאה",
    "actions": "פעולות",
    "view_details": "הצג פרטים",
    "details": "פרטי הפעלת כלי",
    "no_logs": "לא נמצאו יומני כלים",
    "load_failed": "נכשלה טעינת יומני הכלים",
    "tenant_scope": "היקף שוכרים",
    "showing": "מציג {{start}} עד {{end}} מתוך {{total}} תוצאות",
    "previous": "הקודם",
    "next": "הבא",
    "copy": "העתק",
    "copied": "הועתק",
    "no_output": "אין פלט",
    "success": "הצלחה",
    "failed": "נכשל",
    "expand": "הצג עוד",
    "collapse": "הצג פחות",
    "csv_timestamp": "חותמת זמן",
    "csv_tool_name": "שם הכלי",
    "csv_input": "קלט",
    "csv_success": "הצלחה",
    "csv_duration": "משך (מילישניות)",
    "csv_error": "שגיאה",
    "csv_call_id": "מזהה שיחה"
  },
  "outboundDialers": {
    "pause": "השהה",
    "play": "הפעל",
    "configure": "הגדר",
    "load_error": "נכשלה טעינת חיוגים יוצאים",
    "status": {
      "pending": "ממתין",
      "dialing": "מחייג",
      "answered": "נענה",
      "completed": "הושלם",
      "no_answer": "לא נענה",
      "busy": "עסוק",
      "failed": "נכשל",
      "invalid_number": "מספר לא תקין",
      "retry_scheduled": "מתוזמן לניסיון חוזר",
      "paused": "מושהה",
      "playing": "מנגן"
    },
    "queue": {
      "title": "תור",
      "empty": "התור ריק",
      "showing": "מוצג {{start}}-{{end}} מתוך {{total}}",
      "number": "מספר",
      "name": "שם",
      "status": "סטטוס",
      "context": "הקשר",
      "actions": "פעולות"
    },
    "upload": {
      "title": "העלאת קובץ",
      "chooseFile": "בחר קובץ (.csv או .json)",
      "upload": "העלה",
      "sampleCsv": "הורד דוגמת CSV",
      "sampleJson": "הורד דוגמת JSON",
      "valid": "תקין",
      "summary": "{{valid}} תקינים, {{invalid}} לא תקינים",
      "added": "נוספו: {{added}}, נדלגו: {{skipped}}",
      "approve": "אשר",
      "cancel": "ביטול"
    },
    "list": {
      "empty": "לא נמצאו חיוגים יוצאים"
    }
  },
  "recent_calls": {
    "title": "שיחות אחרונות",
    "time": "זמן",
    "type": "סוג",
    "duration": "משך",
    "agent": "סוכן",
    "status": "סטטוס",
    "no_recent_calls": "אין שיחות אחרונות.",
    "view_all": "צפה בהכל",
    "just_now": "זה עתה",
    "minutes_ago": "לפני {{minutes}} דקות",
    "hours_ago": "לפני {{hours}} שעות",
    "seconds": "שניות",
    "minutes": "דקות"
  },
  "voice_analysis": {
    "summary_label": "ניתוח קול",
    "male": "זכר",
    "female": "נקבה",
    "angry": "כועס",
    "happy": "שמח",
    "sad": "עצוב",
    "neutral": "ניטרלי",
    "low": "נמוך",
    "normal": "רגיל",
    "high": "גבוה",
    "gender": "מגדר",
    "mood": "מצב רוח",
    "energy": "אנרגיה",
    "carried": "הובא מזיהוי קודם"
  },
  "createFromJson": {
    "title": "יצירת כלים מ-JSON",
    "button": "יצירה מ-JSON",
    "executionMethod": "שיטת הרצה",
    "pathPrefix": "קידומת נתיב / URL",
    "jsonInput": "קלט JSON",
    "toolCount": "{{count}} כלים ייווצרו/יעודכנו",
    "quotaExceeded": "פעולה זו תיצור {{new}} כלים אך נותרו רק {{available}} מכסות",
    "processing": "מעבד...",
    "creating": "יוצר: {{name}}",
    "updating": "מעדכן: {{name}}",
    "create": "צור",
    "success": "נוצרו: {{created}}, עודכנו: {{updated}}",
    "http_rest": "HTTP REST",
    "local_script": "סקריפט מקומי",
    "builtin": "מובנה"
  },
  "pages": {
    "agents": {
      "list": {
        "title": "סוכנים",
        "new": "סוכן חדש",
        "no_agents": "לא נמצאו סוכנים",
        "open": "פתיחה",
        "advanced_properties": "מאפיינים מתקדמים"
      },
      "page": {
        "back": "חזרה לסוכנים",
        "advanced_properties": "מאפיינים מתקדמים",
        "tab_stats": "סטטיסטיקות",
        "tab_training": "אימון הסוכן",
        "tab_call_logs": "יומני שיחות",
        "tab_session_feedback": "משוב שיחה",
        "session_feedback": {
          "title": "משוב שיחה",
          "custom_insights": "תובנות מותאמות",
          "no_custom": "אין תובנות מותאמות. תובנות מוערכות תמיד.",
          "add": "הוסף תובנה",
          "edit": "ערוך",
          "delete": "מחק",
          "quota_exceeded": "מכסת התובנות המותאמות התמלאה ({{quota}}). הסר תובנה או פנה למנהל להגדלת המכסה.",
          "quota_reached": "מכסת התובנות התמלאה. מחק תובנה כדי להוסיף חדשה.",
          "built_in": "תובנות מובנות",
          "read_only": "(קריאה בלבד)",
          "variable": "משתנה",
          "label": "תווית",
          "description": "תיאור",
          "description_placeholder": "תאר כיצד ללכוד תובנה זו (בשימוש בפרומפט ה-LLM למשוב)",
          "description_help": "מוצג ל-LLM המשוב כהוראת לכידה לתובנה זו.",
          "data_type": "סוג נתונים",
          "enum_values": "ערכי enum (מופרדים בפסיקים)",
          "number_kind": "סוג מספר",
          "save": "שמור",
          "cancel": "ביטול",
          "data_type_boolean": "בוליאני (כן/לא)",
          "data_type_number": "מספר",
          "data_type_enum": "Enum",
          "values": "ערכים"
        }
      },
      "stats": {
        "sessions_chart": "שיחות (24 שעות)",
        "minutes_chart": "דקות (24 שעות)",
        "kpi_vis": "ממשקים וירטואליים",
        "kpi_sessions": "שיחות (24 שעות)",
        "kpi_tool_calls": "קריאות לכלים (24 שעות)",
        "no_data": "אין נתונים זמינים",
        "load_failed": "נכשלה טעינת הסטטיסטיקות",
        "insight": {
          "title": "ביצועי תובנות",
          "load_failed": "טעינת סטטיסטיקות התובנות נכשלה",
          "positives": "חיוביים",
          "calls": "שיחות",
          "percentage": "אחוז",
          "timeframe": {
            "current_hour": "שעה נוכחית",
            "last_60_minutes": "60 דקות",
            "today": "היום",
            "last_24_hours": "24 שעות",
            "this_week": "השבוע",
            "last_7_days": "7 ימים",
            "current_month": "חודש נוכחי",
            "last_30_days": "30 ימים"
          },
          "customerNeedWasAttended": "צורך הלקוח טופל",
          "customerUnderstoodAgent": "הלקוח הבין את הסוכן",
          "agentUnderstoodCustomer": "הסוכן הבין את הלקוח",
          "nonProductiveCall": "שיחה לא פרודוקטיבית"
        }
      },
      "training": {
        "title": "אימון הסוכן",
        "agent_prompt": "הנחיית המערכת של הסוכן",
        "interface_instructions": "הוראות ממשק",
        "edit_with_ai": "עריכה עם AI",
        "restore": "שחזור",
        "no_llm": "לא הוגדר LLM לאימון",
        "no_vis": "אין ממשקים וירטואליים מקושרים לסוכן זה",
        "no_history": "אין היסטוריית הנחיות",
        "saved": "נשמר בהצלחה",
        "restored": "ההנחיה שוחזרה",
        "confirm_restore": "לשחזר גרסת הנחיה זו?",
        "load_failed": "נכשלה טעינת נתוני האימון",
        "history_title": "היסטוריית הנחיות",
        "assessment": {
          "title": "הערכת AI",
          "run": "הערכת AI",
          "empty": "אין עדיין הערכה. לחץ על הערכת AI.",
          "analyzing": "מנתח שיחות אחרונות…",
          "no_recommendations": "אין המלצות.",
          "recommendations_count": "{{count}} המלצות",
          "stale": "ההערכה האחרונה ישנה. מופקת הערכה חדשה.",
          "quota_exceeded": "מכסת הערכות ידניות הושגה ({{quota}} לכל סוכן).",
          "quota_reached": "מכסת הערכות הידניות הושגה",
          "running": "הערכה פועלת…",
          "applied": "יושם",
          "dismissed": "נדחה",
          "accept": "קבל",
          "dismiss": "דחה",
          "apply": "החל",
          "reject": "דחה",
          "retry": "נסה שוב",
          "failed": "ההערכה נכשלה",
          "load_failed": "טעינת ההערכה נכשלה",
          "severity_high": "גבוה",
          "severity_medium": "בינוני",
          "severity_low": "נמוך",
          "category_system_prompt": "הנחיית מערכת",
          "category_vi": "ממשק",
          "category_service": "שירות",
          "summary": "סיכום",
          "satisfaction": "שביעות רצון",
          "efficiency": "יעילות"
        },
        "chat": {
          "title": "עריכה עם AI",
          "placeholder": "תאר בעיה או בקש עריכה…",
          "send": "שלח",
          "pending": "חושב…",
          "applied_to": "יושם על {{target}}",
          "target_agent": "הנחיית המערכת של הסוכן",
          "calling_tool": "מריץ כלי: {{tool}}…",
          "tools_done": "הושלמו: {{tools}}",
          "target_vi": "הנחיית ממשק: {{name}}",
          "failed": "הבקשה נכשלה",
          "empty": "בקש מהסוכן לסקור לוגים ולהציע עריכות הנחיות.",
          "drafting": "מנסח את השינוי המלא…",
          "apply_error_prompt_changed": "הפרומפט שונה מאז ההצעה — לא ניתן להחיל. נסה שוב."
        }
      },
      "edit_ai": {
        "step_scope": "בחר היקף",
        "scope_agent": "הנחיית הסוכן בלבד",
        "scope_vis": "ממשקים וירטואליים",
        "scope_all": "הסוכן + כל הממשקים הווירטואליים",
        "step_instruction": "תאר את השינוי",
        "instruction_placeholder": "תאר מה לשנות בהנחיה...",
        "step_review": "סקירת שינויים",
        "target_agent": "סוכן",
        "invalid_response": "המודל החזיר תגובה לא תקינה",
        "finish": "סיום",
        "approve": "אשר וסיים"
      },
      "create": { "title": "יצירת סוכן חדש" },
      "edit": {
        "title": "עריכת סוכן",
        "back_to_agents": "חזרה לסוכנים",
        "not_found_or_no_permission": "הסוכן לא נמצא או שאין לך הרשאה לערוך סוכן זה."
      }
    },
    "tools": {
      "create": { "title": "יצירת כלי חדש" },
      "edit": {
        "title": "עריכת כלי",
        "back_to_tools": "חזרה לכלים",
        "tool_not_found": "הכלי לא נמצא"
      }
    },
    "outboundDialers": {
      "list": {
        "title": "חיוג יוצא",
        "new": "חייגן יוצא חדש",
        "empty": "לא נמצאו חיוגים יוצאים"
      },
      "create": { "title": "יצירת חיוג יוצא חדש" },
      "edit": { "title": "עריכת חיוג יוצא" },
      "view": { "title": "חיוג יוצא" }
    }
  },
  "tools": {
    "new": "כלי חדש",
    "no_tools": "לא נמצאו כלים",
    "error_name_required": "שם הכלי נדרש",
    "is_builtin_short": "מובנה",
    "tab_details": "פרטים",
    "tab_attributes": "מאפיינים",
    "effective_value": "בתוקף: {{value}} — מ-{{source}}",
    "effective_source_default": "ברירת מחדל של הרישום"
  },
  "agent": {
    "new": "סוכן חדש",
    "no_agents": "לא נמצאו סוכנים",
    "status": {
      "active": "פעיל",
      "inactive": "לא פעיל"
    }
  },
  "webhook_tester": {
    "title": "בודק Webhook",
    "description": "בדיקת נקודות קצה של Webhook לממשקים וירטואליים",
    "request": "בקשה",
    "response": "תגובה",
    "webhook_url": "כתובת Webhook",
    "webhook_url_help": "הזן את כתובת ה-Webhook המלאה כולל מזהה הממשק הווירטואלי",
    "sample_payloads": "מטענים לדוגמה",
    "payload_json": "מטען (JSON)",
    "sending": "שולח...",
    "send_webhook": "שלח Webhook",
    "status_label": "סטטוס",
    "response_body": "גוף התגובה",
    "response_headers": "כותרות התגובה",
    "empty_state": "שלח בקשה כדי לראות את התגובה",
    "tips_title": "טיפים",
    "tip1": "ודא שה-Channel Gateway רץ על פורט 3002",
    "tip2": "השתמש במזהה ממשק וירטואלי תקין בכתובת",
    "tip3": "בדוק את קונסולת הדפדפן לשגיאות CORS אם הבקשה נכשלת",
    "tip4": "צפה בלוגים של Channel Gateway עם: docker logs sophia-channel-gateway-1"
  },
  "tool_tester": {
    "title": "בודק כלים",
    "tool_runner": "מריץ כלים",
    "tool": "כלי",
    "parameters": "פרמטרים",
    "timeout": "זמן קצוב",
    "populate": "מילוי",
    "run_tool": "הפעל כלי",
    "running": "מפעיל...",
    "result": "תוצאה",
    "select_runner": "בחר מריץ כלים...",
    "select_tool": "בחר כלי...",
    "select_runner_first": "בחר מריץ תחילה",
    "parameters_placeholder": '{"key": "value"}',
    "parameters_help": "הזן פרמטרים כאובייקט JSON",
    "help_title": "איך להשתמש",
    "help_text": "בדוק הפעלת כלי ללא הרצת שיחה מלאה.",
    "step1_title": "1. בחר מריץ",
    "step1_desc": "בחר מריץ כלים מקוון.",
    "step2_title": "2. בחר כלי",
    "step2_desc": "בחר את הכלי לבדיקה.",
    "step3_title": "3. הגדר פרמטרים",
    "step3_desc": "לחץ על 'מילוי' לקבלת פרמטרים לדוגמה.",
    "step4_title": "4. הגדר זמן קצוב",
    "step4_desc": "הגדר זמן קצוב (ברירת מחדל: 60 שניות).",
    "step5_title": "5. הרץ בדיקה",
    "step5_desc": "לחץ על 'הפעל כלי' לביצוע."
  },
  "attributeLabels": {
    "attachment_retention_seconds": "שמירת קבצים מצורפים (שניות)",
    "attachment_max_size_bytes": "גודל קובץ מצורף מרבי (בתים)",
    "consult_delegate_agents": "סוכנים מורשים ליעוץ",
    "consult_timeout_seconds": "זמן קצוב ליעוץ (שניות)",
    "consult_max_iterations": "מספר איטרציות מרבי ליעוץ",
    "stt_provider": "ספק STT",
    "stt_api_base_url": "כתובת בסיס API של STT",
    "stt_api_key": "מפתח API של STT",
    "stt_model": "מודל STT",
    "stt_language": "שפת STT",
    "stt_provider_params": "פרמטרי ספק STT",
    "stt_protocol": "פרוטוקול STT",
    "tts_provider": "ספק TTS",
    "tts_api_base_url": "כתובת בסיס API של TTS",
    "tts_api_key": "מפתח API של TTS",
    "tts_voice_id": "מזהה קול TTS",
    "tts_model": "מודל TTS",
    "tts_provider_params": "פרמטרי ספק TTS",
    "tts_style_instructions": "הוראות סגנון TTS",
    "s2s_greeting_instructions": "הוראות ברכת פתיחה S2S",
    "s2s_temperature": "טמפרטורה",
    "s2s_top_p": "Top P",
    "s2s_top_k": "Top K",
    "tool_timeout": "פסק זמן הרצת כלי (שניות)",
    "tool_timeout_error_message": "הודעת שגיאה לפסק זמן כלי",
    "stt_vocabulary_book": "ספר אוצר מילים",
    "tts_language": "שפת TTS",
    "tts_speed": "מהירות TTS",
    "tts_protocol": "פרוטוקול TTS",
    "tts_audio_format": "פורמט שמע TTS",
    "tts_sample_rate": "קצב דגימת TTS",
    "tts_bitrate": "קצב סיביות TTS",
    "llm_provider": "ספק LLM",
    "llm_api_base_url": "כתובת בסיס API של LLM",
    "llm_api_key": "מפתח API של LLM",
    "llm_model": "מודל LLM",
    "llm_temperature": "טמפרטורת LLM",
    "llm_max_tokens": "מקסימום אסימוני LLM",
    "llm_provider_params": "פרמטרי ספק LLM",
    "llm_api_response_timeout": "זמן המתנה לתגובת API של LLM",
    "llm_retry_count": "מספר ניסיונות חוזרים ל-LLM",
    "stt_audio_format": "פורמט שמע STT",
    "stt_sample_rate": "קצב דגימת STT",
    "stt_num_channels": "ערוצי STT",
    "stt_enable_endpoint_detection": "זיהוי נקודת סיום STT",
    "llm_vertex_ai_project_id": "מזהה פרויקט Vertex AI",
    "llm_vertex_ai_location": "מיקום Vertex AI",
    "llm_vertex_ai_key": "קובץ JSON של חשבון שירות Vertex AI",
    "system_prompt": "הנחיית מערכת",
    "system_prompt_prepend": "הוספה לפני הנחיית מערכת",
    "system_prompt_append": "הוספה אחרי הנחיית מערכת",
    "available_tools": "כלים זמינים",
    "additional_tools": "כלים נוספים",
    "tool_calling_behavior": "התנהגות קריאה לכלים",
    "interim_message_enabled": "הודעת ביניים מופעלת",
    "session_timeout_enabled": "פסק זמן שיחה מופעל",
    "session_timeout_seconds": "פסק זמן שיחה (שניות)",
    "session_timeout_goodbye_message": "הודעת פרידה לפסק זמן שיחה",
    "single_channel_session_timeout_enabled": "פסק זמן שיחה לערוץ בודד מופעל",
    "language": "שפה",
    "tool_calling_attempts": "ניסיונות קריאה לכלים",
    "barge_in_enabled": "הפרעה מופעלת",
    "g729_transcoding": "המרת G.729",
    "llm_streaming_enabled": "הזרמת תגובות LLM",
    "tool_runner_ping_interval": "מרווח ping ל-Tool Runner",
    "tool_runner_absence_timeout": "זמן היעדרות Tool Runner",
    "welcome_message": "הודעת קבלת פנים",
    "goodbye_message": "הודעת פרידה",
    "telegram_enable_polling": "הפעלת סקר Telegram",
    "telegram_polling_interval": "מרווח סקר Telegram",
    "whatsapp_messaging_instructions": "הוראות העברת הודעות WhatsApp",
    "telegram_messaging_instructions": "הוראות העברת הודעות Telegram",
    "voice_tts_timeout": "זמן קצוב TTS קולי",
    "voice_analysis_enabled": "ניתוח קול מופעל",
    "speaker_gated_barge_in_enabled": "אפשר השתלטות מותנית דובר",
    "speaker_similarity_threshold": "סף דמיון",
    "speaker_ema_alpha": "מקדם EMA",
    "voice_analysis_min_frames": "מינימום פריימים לניתוח קול",
    "voice_gender_threshold_hz": "סף מגדר קולי (הרץ)",
    "voice_gender_ambiguous_zone_hz": "אזור עמום מגדר קולי (הרץ)",
    "voice_analysis_window_ms": "חלון ניתוח קול (אלפיות שנייה)",
    "voice_analysis_update_interval_ms": "מרווח עדכון ניתוח קול (אלפיות שנייה)",
    "voice_gender_reset_threshold_hz": "סף איפוס מגדר קולי (הרץ)",
    "tool_processing_prompt": "בקשת עיבוד כלי",
    "tool_processing_delay": "השהיית עיבוד כלי",
    "tool_processing_message": "הודעת עיבוד כלי",
    "session_idle_timeout_voice": "פסק זמן השבתה קולי (שניות)",
    "session_absolute_timeout_voice": "פסק זמן מוחלט קולי (דקות)",
    "session_idle_timeout_text": "פסק זמן השבתה בטקסט (שניות)",
    "session_absolute_timeout_text": "פסק זמן מוחלט בטקסט (דקות)",
    "session_pre_expire_message": "הודעת התראה לפני סגירת השיחה",
    "session_pre_expire_message_help": "נשלחת פעם אחת לפני שפסק זמן חוסר הפעילות סוגר את השיחה. ריק = מושבת.",
    "session_pre_expire_timeout_text": "זמן התראה לפני סגירה (שניות)",
    "session_pre_expire_timeout_text_help": "כמה שניות לפני פסק זמן חוסר הפעילות לשלוח את הודעת ההתראה. 0 = מושבת.",
    "perm_tenant_wide": "הרשאות בין-מחוכר",
    "page_tenant_wide": "גישה לדפים",
    "audio_chunk_size": "גודל מקטע שמע",
    "audio_chunk_transfer_encoding": "קידוד העברת מקטעי שמע",
    "audio_tts_queue_size": "גודל תור TTS",
    "audio_energy_threshold": "סף אנרגיית שמע",
    "audio_silence_duration": "משך שתיקה",
    "audio_min_speech_duration": "משך דיבור מינימלי",
    "audio_vad_hysteresis": "היסטרזיס VAD מופעל",
    "audio_barge_in_enabled": "הפרעת שמע מופעלת",
    "audio_barge_in_threshold": "סף הפרעת שמע",
    "audio_barge_in_min_speech": "מינימום דיבור להפרעה",
    "barge_in_grace_time": "זמן חסד להפרעה",
    "barge_in_auto_raise_energy": "העלאת אנרגיה אוטומטית בהפרעה",
    "barge_in_auto_raise_margin": "מרווח העלאת אנרגיה אוטומטית",
    "barge_in_auto_raise_max": "סף מקסימום העלאת אנרגיה אוטומטית",
    "audio_jitter_buffer_ms": "חוצץ רעידת שמע (אלפיות שנייה)",
    "audio_max_buffer_frames": "מקסימום פריימי חוצץ שמע",
    "audio_packet_loss_concealment": "הסתרת אובדן מנות שמע",
    "utility_extensions_enable": "הפעלת הרחבות עזר",
    "utility_extension_local_echo": "הרחבת הד מקומי",
    "media_server_utility_agent_id": "מזהה סוכן עזר",
    "utility_extension_dictation": "הרחבת הכתבה",
    "utility_extension_dictation_announcement": "הודעת הכתבה",
    "utility_extension_dictation_stt_error": "הודעת שגיאת STT בהכתבה",
    "audio_enhance_enabled": "שיפור שמע מופעל",
    "audio_enhance_noise_suppression": "דיכוי רעשי שמע",
    "audio_enhance_agc_target": "יעד AGC לשיפור שמע",
    "audio_enhance_highpass_hz": "מסנן מעביר גבוהים (הרץ)",
    "audio_enhance_aec_enabled": "ביטול הד אקוסטי מופעל",
    "smtp_host": "מארח SMTP",
    "smtp_port": "יציאת SMTP",
    "smtp_encryption": "הצפנת SMTP",
    "smtp_ignore_certificates": "התעלם משגיאות אישור SMTP",
    "smtp_username": "שם משתמש SMTP",
    "smtp_password": "סיסמת SMTP",
    "smtp_from_email": "אימייל שולח SMTP",
    "smtp_from_name": "שם שולח SMTP",
    "smtp_verify_peer": "אמת אישור עמית SMTP",
    "smtp_verify_peer_name": "אמת שם עמית SMTP",
    "smtp_allow_self_signed": "אפשר אישורים חתומים עצמית",
    "email_tag_wrapper": "תג מעטפת",
    "chat_bridge_virtual_interface": "ממשק וירטואלי לגשר צ'אט",
    "chat_bridge_auto_add_users": "משתמשים להוספה אוטומטית",
    "chat_bridge_activation": "הפעלה",
    "chat_bridge_include_context": "כלול הקשר שיחה",
    "chat_bridge_agent_entity": "יישות סוכן",
    "chat_bridge_caller_entity": "יישות מתקשר",
    "chat_bridge_service_person_entity": "יישות נציג שירות",
    "chat_bridge_handoff_silence_timeout_seconds": "זמן המתנה להחזרת בוט (שניות)",
    "chat_bridge_handoff_return_message": "הודעת חזרה לבוט",
    "auto_reply_enabled": "הפעלת מענה אוטומטי",
    "session_timeout": "פסק זמן שיחה (דקות)",
    "telegram_parse_mode": "מצב ניתוח טלגרם",
    "telegram_disable_notification": "ביטול התראות טלגרם",
    "telegram_protect_content": "הגנה על תוכן טלגרם",
    "whatsapp_template_namespace": "מרחב שמות תבנית WhatsApp",
    "whatsapp_message_type": "סוג הודעת WhatsApp",
    "voice_greeting": "ברכת קול",
    "voice_timeout": "פסק זמן קול (שניות)",
    "webhook_url": "כתובת Webhook",
    "webhook_secret": "סוד Webhook",
    "webhook_events": "אירועי Webhook",
    "rocketchat_hook_register_interval": "מרווח רישום Webhook (שניות)",
    "rocketchat_integration_channel": "ערוץ אינטגרציה",
    "agent_training_llm": "LLM לאימון הסוכן",
    "agent_training_llm_help": "ה-LLM המשמש את תכונת העריכה עם AI. ניתן להגדרה ברמת מחוכר/מערכת על ידי מנהלי מערכת.",
    "agent_training_llm_timeout_seconds": "פסק זמן LLM לאימון (שניות)",
    "agent_training_llm_timeout_seconds_help": "פסק זמן לכל קריאת LLM של סוכן האימון/עריכה עם AI.",
    "agent_training_loop_timeout_seconds": "פסק זמן כולל לאימון (שניות)",
    "agent_training_loop_timeout_seconds_help": "פסק זמן כולל לריצת סוכן האימון/עריכה עם AI (כל קריאות ה-LLM והכלים יחד).",
    "session_feedback_llm_provider": "LLM לסיכום שיחות",
    "session_feedback_llm_provider_help": "ה-LLM המשמש לסיכום שיחות והערכת insights לאחר סיום שיחה. השאר ריק כדי לבטל את הפידבק לסוכן זה.",
    "session_feedback_prompt": "פרומפט סיכום שיחות",
    "session_feedback_prompt_help": "חלק הפרומפט הסטטי (עד 'Trait Definitions:'). הגדרות התכונות, הסכמה והתמליל מצורפים דינמית. השאר ריק לברירת המחדל המובנית.",
    "non_productive_min_call_seconds": "שניות מינימום לשיחה לא פרודוקטיבית (0 = כבוי)",
    "session_feedback_timeout_seconds": "פסק זמן לקריאת משוב השיחה (שניות)",
    "session_feedback_timeout_seconds_help": "פסק זמן לקריאת ה-LLM הרקע שכותבת את הכותרת, הסיכום וה-insights. 10 שניות קצרות מדי לתמלילים ארוכים; ברירת מחדל 90.",
    "performance_assessment_prompt": "פרומפט הערכת ביצועים",
    "performance_assessment_prompt_help": "הנחיית מערכת לסוכן הערכת הביצועים האוטונומי. מאוכלס מראש בברירת המחדל המובנית; ערוך כדי להתאים אישית.",
    "performance_assessment_history_hours": "שעות היסטוריה",
    "performance_assessment_history_hours_help": "שעות של שיחות אחרונות שסוכן ההערכה סוקר.",
    "performance_assessment_stale_min_gap_minutes": "מרווח מינימלי בין הרצות אוטומטיות (דקות)",
    "performance_assessment_stale_min_gap_minutes_help": "מספר דקות מינימלי בין הרצות הערכה אוטומטיות שמתבצעות בטעינת הדף. 0 מבטל הפעלה אוטומטית בטעינה (ה-cron וכפתור ההרצה הידני עדיין עובדים).",
    "performance_assessment_ttl_minutes": "פג תוקף אחרי (דקות)",
    "performance_assessment_ttl_minutes_help": "הערכה שמורה ישנה יותר מזה נחשבת למיושנת.",
    "performance_assessment_manual_quota": "מכסת הערכה ידנית",
    "performance_assessment_manual_quota_help": "מכסה לכל סוכן על לחיצות הערכת ביצועים ידניות (מתאפסת כשהרצה אוטומטית מסתיימת).",
    "performance_assessment_cron_enabled": "הפעלת Cron",
    "performance_assessment_cron_enabled_help": "הרץ הערכה יומית אוטומטית.",
    "performance_assessment_cron_hour": "שעת Cron",
    "performance_assessment_cron_hour_help": "שעה יומית ל-Cron (0-23).",
    "performance_assessment_cron_min": "דקת Cron",
    "performance_assessment_cron_min_help": "דקה יומית ל-Cron (0-59).",
    "performance_assessment_cron_random": "שיהוי אקראי של Cron (שניות)",
    "performance_assessment_cron_random_help": "מקסימום שניות של עיכוב אקראי לפני תחילת הרצת ה-Cron.",
    "consumer_api_enabled": "API לצרכן מופעל",
    "consumer_api_agents_enabled": "נקודת קצה סוכנים מופעלת",
    "consumer_api_call_logs_enabled": "נקודת קצה יומן שיחות מופעלת",
    "consumer_api_tools_enabled": "נקודת קצה כלים מופעלת",
    "consumer_api_knowledge_bases_enabled": "נקודת קצה בסיסי ידע מופעלת",
    "consumer_api_tool_calls_enabled": "נקודת קצה קריאות לכלים מופעלת",
    "consumer_api_dial_queue_enabled": "תור חיוג — טעינה דרך API",
    "outbound_dialer_active": "פעיל",
    "simultaneous_outbound_calls": "שיחות יוצאות במקביל",
    "answer_timeout_seconds": "פסק זמן לתשובה (שניות)",
    "call_attempts": "ניסיונות חיוג",
    "call_retry_interval_seconds": "מרווח ניסיון חוזר (שניות)",
    "call_retry_interval_randomization_seconds": "אקראיות במרווח ניסיון חוזר (שניות)",
    "caller_id_number": "מספר מזהה מתקשר",
    "caller_id_name": "שם מזהה מתקשר",
    "outbound_sip_proxy_host": "מארח פרוקסי SIP יוצא",
    "outbound_sip_proxy_port": "יציאת פרוקסי SIP יוצא",
    "outbound_sip_proxy_transport": "תעבורת פרוקסי SIP יוצא",
    "outbound_sip_username": "שם משתמש SIP יוצא",
    "outbound_sip_password": "סיסמת SIP יוצא",
    "consumer_api_calls_include_transcripts": "שיחות כוללות תמלילים",
    "consumer_api_rate_limit_window_seconds": "חלון מגבלת קצב (שניות)",
    "consumer_api_rate_limit_max_requests": "מקסימום בקשות בחלון",
    "consumer_api_rate_limit_concurrent": "מקסימום בקשות מקבילות",
    "consumer_api_unauth_rate_limit_window_seconds": "חלון מגבלת קצב ללא אימות (שניות)",
    "consumer_api_unauth_rate_limit_max_requests": "מקסימום בקשות בחלון ללא אימות"
  },
  "attributeGroups": {
    "attachments": "קבצים מצורפים",
    "agent_collaboration": "שיתוף פעולה בין סוכנים",
    "general": "תצורה כללית",
    "session-timeout": "פסק זמן שיחה",
    "bargein-config": "הפרעת TTS (Barge-in)",
    "tool-processing": "עיבוד כלים",
    "vertex-ai": "Google Vertex AI",
    "codec": "המרת קודק",
    "tool-runner": "תצורת Tool Runner",
    "smtp": "תצורת SMTP (דואר)",
    "email_template": "תצורת תבנית דואר",
    "chat-bridging": "גשר צ'אט",
    "audio-streaming": "הזרמת שמע",
    "vad-config": "זיהוי סוף דיבור (VAD)",
    "rtp-config": "תצורת RTP",
    "utility-functions": "פונקציות עזר",
    "audio-enhancement": "שיפור שמע",
    "telegram": "הגדרות Telegram",
    "whatsapp": "הגדרות WhatsApp",
    "voice": "הגדרות קול",
    "voice-analysis": "ניתוח קול",
    "webhook": "תצורת Webhook",
    "rocketchat": "הגדרות RocketChat",
    "permissions": "הרשאות ברירת מחדל",
    "stt_provider": "תצורת ספק STT",
    "tts_provider": "תצורת ספק TTS",
    "llm_provider": "תצורת ספק LLM",
    "vertex_ai": "חשבון מערכת Vertex AI",
    "tts_advanced": "הגדרות TTS מתקדמות",
    "tts_google": "הגדרות TTS של Google",
    "tts_openai": "הגדרות OpenAI",
    "core_agent": "תצורת סוכן ראשי",
    "tool_runner_health": "מעקב תקינות Tool Runner",
    "virtual_interface": "תצורת ממשק וירטואלי",
    "voice_analysis": "ניתוח קול",
    "speaker_barge_in": "השתלטות מותנית דובר",
    "tool_processing": "חוויית משתמש בעיבוד כלים",
    "session_timeout": "פסק זמן שיחה",
    "messaging_instructions": "הוראות העברת הודעות",
    "admin_permissions": "הרשאות מנהל",
    "audio_streaming": "הזרמת שמע",
    "vad": "זיהוי סוף דיבור (VAD)",
    "barge_in": "הפרעת TTS (Barge-in)",
    "rtp": "תצורת RTP",
    "utility_extensions": "הרחבות עזר",
    "audio_enhancement": "שיפור שמע (APM)",
    "smtp_provider": "תצורת ספק SMTP",
    "chat_bridging": "גשר צ'אט",
    "training": "אימון הסוכן",
    "training_desc": "בחירת LLM לעריכה עם AI (רמת מחוכר/מערכת)",
    "session_feedback": "פידבק שיחות",
    "session_feedback_desc": "LLM ופרומפט לסיכום ופידבק שיחות לאחר סיום שיחה",
    "performance_assessment": "הערכת ביצועים",
    "performance_assessment_desc": "תצורה עבור סוכן הערכת הביצועים של ה-AI.",
    "consumer_api": "API לצרכן",
    "kb_embedding": "הטמעת בסיס ידע (Embedding)",
    "kb_image_llm": "LLM חזותי לתמונות בסיס ידע",
    "outboundDialer": "תצורת חיוג יוצא",
    "execution_settings": "הגדרות הרצה"
  },
  "virtual_interface": {
    "title": "ממשקים וירטואליים",
    "new": "ממשק וירטואלי חדש",
    "edit": "עריכת ממשק וירטואלי",
    "info_text": "ממשקים וירטואליים מחברים ערוצים חיצוניים (טלגרם, ווטסאפ, RocketChat, קול) לסוכנים שלך. כל ממשק מגדיר קריטריוני התאמה כדי לנתב הודעות נכנסות לסוכן הנכון.",
    "technology": "טכנולוגיה",
    "voice_sip": "קול (SIP)",
    "active": "פעיל",
    "inactive": "לא פעיל",
    "match_criteria": "קריטריוני התאמה",
    "information": "מידע",
    "save_first_attributes": "יש לשמור את הממשק הווירטואלי תחילה כדי להגדיר תכונות.",
    "waba_required": "מזהה WABA נדרש לממשקי WhatsApp.",
    "workspace_url_required": "כתובת Workspace נדרשת ל-RocketChat",
    "bot_username_required": "שם משתמש בוט נדרש ל-RocketChat",
    "bot_password_required": "סיסמת בוט נדרשת ל-RocketChat",
    "invalid_rocketchat_config": "תצורה לא תקינה ל-RocketChat",
    "step1_basic": "שלב 1: מידע בסיסי",
    "step2_config": "שלב 2: תצורה",
    "configure_tech": "הגדר את הגדרות האינטגרציה של {{technology}}.",
    "match_criteria_desc": "הגדר כיצד הודעות נכנסות יותאמו לממשק זה.",
    "step3_agent": "שלב 3: הקצאת סוכן",
    "select_agent": "בחר סוכן...",
    "no_agents_available": "אין סוכנים זמינים. אנא צור סוכן תחילה.",
    "save_changes": "שמור שינויים",
    "saving": "שומר...",
    "details": "פרטים",
    "configuration": "תצורה",
    "progress": "התקדמות",
    "basic_information": "מידע בסיסי",
    "agent_assignment": "הקצאת סוכן",
    "configuration_attributes": "תכונות תצורה",
    "review_create": "סקירה ויצירה",
    "review": "סקירה",
    "configured": "הוגדרו",
    "edit_desc": "ערוך את תצורת הממשק הווירטואלי. שינויים יסונכרנו ל-Channel Gateways באופן אוטומטי.",
    "telegram_chat_id": "מזהה צ'אט טלגרם",
    "whatsapp_phone": "מספר טלפון ווטסאפ",
    "caller_id": "מזהה מתקשר",
    "did_number": "מספר DID",
    "multi_value_help": "הקישו Enter, פסיק או Tab כדי להוסיף כל ערך. לחצו על ערך כדי לערוך אותו.",
    "telegram_chat_id_help": "כאשר מוגדר, רק צ'אטים ברשימה זו יוכלו לתקשר עם ממשק זה; השאירו ריק לאפשר לכולם.",
    "whatsapp_caller_id_help": "כאשר מוגדר, רק מספרי הטלפון ברשימה זו יוכלו לתקשר עם ממשק זה; השאירו ריק לאפשר לכולם. ניתן להזין מספרים עם או בלי + בהתחלה.",
    "multi_value_remove": "הסר",
    "sip_domain": "דומיין SIP",
    "webchat_info": "ממשקי Webchat מזוהים לפי מזהה הפעלה באופן אוטומטי",
    "rocketchat_info": "ממשקי RocketChat מזוהים לפי נתיב ה-webhook שלהם באופן אוטומטי. אין צורך בקריטריוני התאמה ידניים",
    "agent_select": "בחר סוכן...",
    "agent_label": "סוכן",
    "status_label": "סטטוס",
    "hook_parameters": "פרמטרי Hook (JSON)",
    "rocketchat_config": "תצורת RocketChat",
    "workspace_url": "כתובת Workspace",
    "workspace_url_label": "כתובת Workspace",
    "workspace_url_help": "הכתובת של ה-Workspace שלך ב-RocketChat",
    "bot_username": "שם משתמש בוט",
    "bot_username_label": "שם משתמש בוט",
    "bot_password": "סיסמת בוט",
    "bot_password_label": "סיסמת בוט",
    "bot_password_help": "הסיסמה לחשבון הבוט",
    "webhook_url": "כתובת Webhook",
    "last_incoming_request": "בקשה נכנסת אחרונה",
    "last_outbound_call": "שיחה יוצאת אחרונה",
    "last_webhook_register": "רישום Webhook אחרון",
    "error_details": "פרטי שגיאה",
    "warning_change_tech": "שינוי הטכנולוגיה יאפס את קריטריוני ההתאמה",
    "never": "לעולם לא",
    "success": "הצלחה",
    "fail": "נכשל",
    "whatsapp_phone_number_id": "מזהה מספר טלפון",
    "whatsapp_phone_number_id_help": "מזהה מספר הטלפון מתהליך ההרשמה של שירות ה-WhatsApp.",
    "whatsapp_registration_section": "רישום WhatsApp",
    "display_phone_number": "מספר טלפון מוצג",
    "registration_id": "מזהה רישום",
    "last_refreshed": "רענון אחרון",
    "refresh_registration": "רענן רישום",
    "refreshing_registration": "מרענן...",
    "registration_refreshed": "הרישום רוענן",
    "registration_refresh_failed": "רענון הרישום נכשל",
    "whatsapp_phone_number": "מספר WhatsApp",
    "whatsapp_number_help": "בחר מספר שהועלה לרישום בשירות ה-WhatsApp עבור דייר זה.",
    "select_whatsapp_number": "בחר מספר...",
    "loading_numbers": "טוען מספרים...",
    "whatsapp_numbers_load_failed": "טעינת מספרי WhatsApp נכשלה.",
    "no_whatsapp_numbers": "אין מספרי WhatsApp זמינים לדייר זה. יש להעלות מספרים לרישום בשירות ה-WhatsApp תחילה.",
    "in_use": "בשימוש",
    "number_in_use_warning": "מספר זה כבר מחובר לממשק אחר. חיבורו כאן יעביר אותו לממשק זה; הממשק האחר יפסיק לקבל הודעות למספר זה.",
    "change_number": "החלף מספר",
    "change_number_title": "החלפת מספר WhatsApp",
    "changing_number": "מחליף...",
    "change_number_failed": "החלפת המספר נכשלה.",
    "change_number_success": "המספר הוחלף.",
    "not_registered_hint": "מספר זה עדיין אינו רשום. לחץ על רענן רישום כדי לרשום אותו."
  },
  "virtual_interface_create": {
    "step4_title": "שלב 4: תכונות תצורה",
    "step4_desc": "הגדר הגדרות נוספות עבור ממשק וירטואלי זה. ניתן לשנות הגדרות אלו מאוחר יותר.",
    "step4_info": "התכונות יישמרו לאחר יצירת הממשק הווירטואלי.",
    "step5_title": "שלב 5: סקירה ויצירה",
    "review_label": "סקירה",
    "review_name": "שם",
    "review_technology": "טכנולוגיה",
    "review_agent": "סוכן",
    "review_attributes": "תכונות",
    "review_attributes_configured": "{{count}} הוגדרו",
    "creating": "יוצר...",
    "create_interface": "צור ממשק",
    "webhook_failed_title": "רישום Webhook נכשל",
    "webhook_failed_desc": "נכשל ברישום webhook ה-WhatsApp ב-Meta. הממשק הווירטואלי לא נוצר.",
    "error_details_card": "פרטי שגיאה",
    "error_endpoint": "נקודת קצה",
    "error_response_status": "סטטוס תגובה",
    "error_response_body": "גוף תגובה",
    "close": "סגור",
    "telegram_bot_token": "אסימון בוט טלגרם",
    "telegram_bot_token_help": "קבל זאת מ-@BotFather בטלגרם. תבנית: 123456789:ABCdef...",
    "whatsapp_api_token": "אסימון API של WhatsApp",
    "whatsapp_phone_number_id": "מזהה מספר טלפון",
    "whatsapp_waba_id": "מזהה WABA",
    "whatsapp_waba_id_help": "מזהה חשבון WhatsApp Business מ-Meta Business settings.",
    "rocketchat_workspace_url_help": "הכתובת של ה-RocketChat workspace שלך (למשל https://mycompany.rocket.chat)",
    "rocketchat_bot_username_help": "שם המשתמש של חשבון הבוט שנוצר ב-RocketChat",
    "rocketchat_bot_password_help": "הסיסמה לחשבון הבוט. ה-webhook יירשם באופן אוטומטי בעת היצירה.",
    "rocketchat_info_create": "אינטגרציית webhook תירשם באופן אוטומטי ב-RocketChat workspace בעת יצירת ממשק זה. הבוט יגיב ל-@mentions בערוצים ובהודעות פרטיות.",
    "match_chat_id_optional": "מזהה צ'אט טלגרם (אופציונלי)",
    "match_chat_id_help": "השאר ריק כדי להתאים לכל הצ'אטים. שימוש לקבוצות/ערוצים פרטיים. קבל מ-@userinfobot.",
    "match_whatsapp_help": "מספר הטלפון של WhatsApp להתאמה (עם קידומת בינלאומית).",
    "match_caller_id_optional": "מזהה מתקשר (אופציונלי)",
    "match_did_optional": "מספר DID (אופציונלי)",
    "match_sip_optional": "דומיין SIP (אופציונלי)"
  },
  "knowledgeBases": {
    ...enCommon.knowledgeBases,
    "title": "בסיסי ידע"
  },
  "vocabulary": {
    "title": "ספרי אוצר מילים",
    "add_book": "הוסף ספר אוצר מילים",
    "create": "צור",
    "items": "פריטים",
    "phrase": "ביטוי",
    "created": "נוצר",
    "updated": "עודכן",
    "empty": "אין ספרי אוצר מילים",
    "delete_book_confirm": "למחוק את ספר אוצר המילים? כל הביטויים יוסרו.",
    "search_placeholder": "חיפוש ביטויים...",
    "new_phrase": "ביטוי חדש...",
    "add_phrase": "הוסף",
    "import": "ייבוא",
    "export": "ייצוא CSV",
    "import_result": "נוספו {added}, כפולים {duplicates}, הושמטו {dropped}",
    "delete_selected": "מחק נבחרים",
    "delete_selected_confirm": "למחוק את הביטויים שנבחרו?",
    "load_failed": "הטעינה נכשלה",
    "save_failed": "השמירה נכשלה",
    "no_book": "(ללא)"
  },
  "settings": {
    ...enCommon.settings,
    "upstream_attr_defaults_subheading": "ברירות מחדל של מאפייני ספק — יורשות על ידי שורות הספק אלא אם כן הן מגדירות ערכים משלהן"
  }
};

const deCommon = {
  ...enCommon,
  "navigation": {
    ...enCommon.navigation,
    "infrastructure": "Infrastruktur",
    "configuration": "Konfiguration",
    "analytics": "Analyse",
    "administration": "Verwaltung",
    "logs": "Protokolle",
    "media_servers": "Medienserver",
    "tool_runners": "Tool-Runner",
    "virtual_interfaces": "Virtuelle Schnittstellen",
    "tools_list": "Werkzeugliste",
    "webhook_tester": "Webhook-Tester",
    "agents": "Agenten",
    "tools": "Werkzeuge",
    "knowledgeBases": "Wissensdatenbanken",
    "vocabulary": "Vokabular",
    "groups": "Gruppen",
    "agent_groups": "Agentengruppen",
    "tool_groups": "Werkzeuggruppen",
    "channel_groups": "Kanalgruppen",
    "user_groups": "Benutzergruppen",
    "tool_tester": "Werkzeugtester",
    "dashboard": "Dashboard",
    "call_logs": "Anrufprotokolle",
    "tool_logs": "Werkzeugprotokolle",
    "tenants": "Mandanten",
    "audit_logs": "Audit-Protokolle",
    "administrators": "Administratoren",
    "settings": "Einstellungen",
    "email_templates": "E-Mail-Vorlagen",
    "upstreamProviders": "Externe Anbieter",
    "outboundDialers": "Outbound-Dialer"
  },
  "groups": {
    "new_group": "Neue Gruppe",
    "delete_failed": "Löschen der Gruppe fehlgeschlagen",
    "confirm_delete": "Möchten Sie diese Gruppe wirklich löschen?",
    "agent": {
      "title": "Agentengruppen",
      "create_title": "Neue Agentengruppe erstellen",
      "edit_title": "Agentengruppe bearbeiten",
      "empty": "Keine Agentengruppen gefunden",
      "load_failed": "Agentengruppen konnten nicht geladen werden",
      "create_failed": "Erstellen der Agentengruppe fehlgeschlagen",
      "update_failed": "Aktualisieren der Agentengruppe fehlgeschlagen",
      "manage": "Agenten verwalten"
    },
    "tool": {
      "title": "Werkzeuggruppen",
      "create_title": "Neue Werkzeuggruppe erstellen",
      "edit_title": "Werkzeuggruppe bearbeiten",
      "empty": "Keine Werkzeuggruppen gefunden",
      "load_failed": "Werkzeuggruppen konnten nicht geladen werden",
      "create_failed": "Erstellen der Werkzeuggruppe fehlgeschlagen",
      "update_failed": "Aktualisieren der Werkzeuggruppe fehlgeschlagen",
      "manage": "Werkzeuge verwalten",
      "tab_details": "Details",
      "tab_attributes": "Attribute"
    },
    "channel": {
      "title": "Kanalgruppen",
      "create_title": "Neue Kanalgruppe erstellen",
      "edit_title": "Kanalgruppe bearbeiten",
      "empty": "Keine Kanalgruppen gefunden",
      "load_failed": "Kanalgruppen konnten nicht geladen werden",
      "create_failed": "Erstellen der Kanalgruppe fehlgeschlagen",
      "update_failed": "Aktualisieren der Kanalgruppe fehlgeschlagen",
      "type_label": "Kanaltyp",
      "channel_type_voice": "Sprache",
      "channel_type_chat": "Chat",
      "channel_type_email": "E-Mail",
      "channel_type_sms": "SMS"
    },
    "user": {
      "title": "Benutzergruppen",
      "create_title": "Neue Benutzergruppe erstellen",
      "edit_title": "Benutzergruppe bearbeiten",
      "empty": "Keine Benutzergruppen gefunden",
      "load_failed": "Benutzergruppen konnten nicht geladen werden",
      "create_failed": "Erstellen der Benutzergruppe fehlgeschlagen",
      "update_failed": "Aktualisieren der Benutzergruppe fehlgeschlagen"
    },
    "delete_group_confirm": "Möchten Sie diese Gruppe wirklich löschen?",
    "delete_type_confirm": "Möchten Sie diese {{type}}-Gruppe wirklich löschen?",
    "delete_type_failed": "Löschen der {{type}}-Gruppe fehlgeschlagen",
    "modal": {
      "manage_title": "{{itemType}} verwalten - {{name}}",
      "available_items": "Verfügbare {{itemType}}",
      "group_members": "Gruppenmitglieder",
      "no_available": "Keine verfügbaren {{itemType}}",
      "no_members": "Keine {{itemType}} in dieser Gruppe",
      "count_available": "{{count}} verfügbar",
      "count_members": "{{count}} Mitglieder",
      "add_selected": "Ausgewählte hinzufügen",
      "add_all": "Alle hinzufügen",
      "remove_selected": "Ausgewählte entfernen",
      "remove_all": "Alle entfernen",
      "load_failed": "Laden von {{itemType}} fehlgeschlagen",
      "add_failed": "Hinzufügen von {{itemType}} fehlgeschlagen",
      "remove_failed": "Entfernen von {{itemType}} fehlgeschlagen",
      "enabled": "Aktiviert",
      "disabled": "Deaktiviert",
      "close": "Schließen"
    }
  },
  "auth": {
    "sign_in": "Anmelden",
    "sign_out": "Abmelden",
    "username": "Benutzername",
    "password": "Passwort",
    "totp_code": "TOTP-Code",
    "otp_code": "OTP-Code",
    "verify": "Bestätigen",
    "send_otp": "OTP senden",
    "back_to_password": "Zurück zur Passwort-Anmeldung",
    "use_otp_instead": "Stattdessen OTP verwenden",
    "two_factor_auth": "Zwei-Faktor-Authentifizierung",
    "otp_login": "OTP-Anmeldung",
    "enter_totp": "Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein.",
    "enter_otp": "Geben Sie den 6-stelligen Code ein, der an Ihre E-Mail gesendet wurde."
  },
  "common": {
    ...enCommon.common,
    "create": "Erstellen",
    "edit": "Bearbeiten",
    "configure": "Konfigurieren",
    "delete": "Löschen",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "loading": "Laden...",
    "search": "Suchen",
    "filter": "Filtern",
    "actions": "Aktionen",
    "export": "Exportieren",
    "name": "Name",
    "description": "Beschreibung",
    "status": "Status",
    "created_at": "Erstellt am",
    "updated_at": "Aktualisiert am",
    "reset": "Zurücksetzen",
    "update": "Aktualisieren",
    "select_tenant": "Bitte wählen Sie einen Mandanten aus",
    "seconds": "Sekunden",
    "saving": "Speichern...",
    "deleting": "Löschen...",
    "dismiss": "Schließen",
    "view": "Anzeigen",
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "suspended": "Suspendiert",
    "deleted": "Gelöscht",
    "refresh": "Aktualisieren",
    "creating_in_tenant": "Erstellen in Mandant",
    "no_tenant_selected_warning": "Kein Mandant ausgewählt. Bitte wählen Sie einen Mandanten aus der Dropdown-Liste oben.",
    "online": "Online",
    "offline": "Offline",
    "degraded": "Eingeschränkt",
    "no_group": "Keine Gruppe",
    "time": "Zeit",
    "tool": "Werkzeug",
    "tools": "Werkzeuge",
    "agent": "Agent",
    "agents": "Agenten",
    "no_description": "Keine Beschreibung",
    "group": "Gruppe",
    "confirm_delete": "Möchten Sie dieses Element wirklich löschen?",
    "delete_failed": "Löschen fehlgeschlagen",
    "agent_delete_blocked": "Löschen nicht möglich: {{count}} virtuelle Schnittstelle(n) verwenden diesen Agenten noch. Löschen oder weisen Sie sie zuerst neu zu.",
    "load_failed": "Laden fehlgeschlagen",
    "create_failed": "Erstellen fehlgeschlagen",
    "update_failed": "Aktualisieren fehlgeschlagen",
    "view_all": "Alle anzeigen",
    "view_infrastructure": "Infrastruktur anzeigen",
    "modified": "Geändert",
    "next": "Weiter",
    "previous": "Vorherige",
    "back": "Zurück",
    "items": "Elemente",
    "none": "Keine",
    "enabled": "Aktiviert",
    "disabled": "Deaktiviert",
    "close": "Schließen",
    "save_failed": "Speichern fehlgeschlagen"
  },
  "call_logs": {
    "title": "Anrufprotokolle",
    "filters": "Filter",
    "from_date": "Von Datum",
    "to_date": "Bis Datum",
    "status": "Status",
    "agent": "Agent",
    "gender": "Geschlecht",
    "all_statuses": "Alle Status",
    "started": "Gestartet",
    "phone": "Telefon",
    "channel": "Kanal",
    "duration": "Dauer",
    "medium": "Medium",
    "no_logs": "Keine Anrufprotokolle gefunden",
    "previous": "Zurück",
    "next": "Weiter",
    "message": "Nachricht",
    "search_messages": "Nachrichten suchen...",
    "conversation": "Konversation",
    "view_conversation": "Konversation anzeigen",
    "system_prompt": "System-Prompt",
    "tool_result": "Werkzeug-Ergebnis",
    "no_messages": "Keine Konversationsnachrichten",
    "subagent_activity": "Unteragenten-Aktivität",
    "subagent_badge": "Unteragent",
    "subagent_count_title": "Unteragenten-Konsultationen",
    "direction": {
      "inbound": "Eingehend",
      "outbound": "Ausgehend",
      "internal": "Intern",
      "all": "Alle"
    },
    "attachments": {
      "title": "Anhänge",
      "expired": "Anhang abgelaufen",
      "download_failed": "Download fehlgeschlagen",
      "kind": {
        "photo": "Foto",
        "video": "Video",
        "voice": "Sprachnachricht",
        "audio": "Audio",
        "document": "Dokument"
      }
    }
  },
  "tool_logs": {
    "input": "Eingabe",
    "csv_input": "Eingabe",
  },
  "outboundDialers": {
    "pause": "Pause",
    "play": "Starten",
    "configure": "Konfigurieren",
    "load_error": "Outbound-Dialer konnten nicht geladen werden",
    "status": {
      "pending": "Ausstehend",
      "dialing": "Wählt",
      "answered": "Beantwortet",
      "completed": "Abgeschlossen",
      "no_answer": "Keine Antwort",
      "busy": "Besetzt",
      "failed": "Fehlgeschlagen",
      "invalid_number": "Ungültige Nummer",
      "retry_scheduled": "Wiederholung geplant",
      "paused": "Pausiert",
      "playing": "Aktiv"
    },
    "queue": {
      "title": "Warteschlange",
      "empty": "Die Warteschlange ist leer",
      "showing": "{{start}}-{{end}} von {{total}} angezeigt",
      "number": "Nummer",
      "name": "Name",
      "status": "Status",
      "context": "Kontext",
      "actions": "Aktionen"
    },
    "upload": {
      "title": "Datei hochladen",
      "chooseFile": "Datei auswählen (.csv oder .json)",
      "upload": "Hochladen",
      "sampleCsv": "Beispiel-CSV herunterladen",
      "sampleJson": "Beispiel-JSON herunterladen",
      "valid": "Gültig",
      "summary": "{{valid}} gültig, {{invalid}} ungültig",
      "added": "Hinzugefügt: {{added}}, Übersprungen: {{skipped}}",
      "approve": "Genehmigen",
      "cancel": "Abbrechen"
    },
    "list": {
      "empty": "Keine Outbound-Dialer gefunden"
    }
  },
  "recent_calls": {
    "title": "Letzte Anrufe",
    "time": "Zeit",
    "type": "Typ",
    "duration": "Dauer",
    "agent": "Agent",
    "status": "Status",
    "no_recent_calls": "Keine letzten Anrufe.",
    "view_all": "Alle anzeigen",
    "just_now": "Gerade eben",
    "minutes_ago": "Vor {{minutes}} Minuten",
    "hours_ago": "Vor {{hours}} Stunden",
    "seconds": "Sekunden",
    "minutes": "Minuten"
  },
  "voice_analysis": {
    "summary_label": "Sprachanalyse",
    "male": "Männlich",
    "female": "Weiblich",
    "angry": "Wütend",
    "happy": "Fröhlich",
    "sad": "Traurig",
    "neutral": "Neutral",
    "low": "Niedrig",
    "normal": "Normal",
    "high": "Hoch",
    "gender": "Geschlecht",
    "mood": "Stimmung",
    "energy": "Energie",
    "carried": "aus früherer Erkennung übernommen"
  },
  "attributes": {
    "title": "Konfigurationsattribute",
    "search_placeholder": "Attribute suchen...",
    "level_default": "Standard",
    "level_set": "Gesetzt",
    "level_force": "Erzwingen",
    "level_forced": "Erzwungen (Vererbung)",
    "modified_count": "{{count}} geändert",
    "system_default": "Systemstandard",
    "product_default": "Produktstandard",
    "inherited_tenant": "Vom Mandanten geerbt",
    "inherited_group": "Von der Gruppe geerbt",
    "collapse_all": "Alle einklappen",
    "expand_all": "Alle ausklappen",
    "level_locked": "Gesperrt",
    "paste_sa_json": "Service-Account-JSON hier einfügen",
    "stt_provider_id": "STT-Provider",
    "tts_provider_id": "TTS-Provider",
    "llm_provider_id": "LLM-Modell",
    "kb_embedding_provider": "KB Embedding Provider",
    "kb_embedding_base_url": "KB Embedding Base URL",
    "kb_embedding_model": "KB Embedding Model",
    "kb_embedding_api_key": "KB Embedding API Key",
    "kb_embedding_dimensions": "KB Embedding Dimensions",
    "kb_image_llm_provider": "KB Image LLM Provider",
    "kb_image_llm_base_url": "KB Image LLM Base URL",
    "kb_image_llm_model": "KB Image LLM Model",
    "kb_image_llm_api_key": "KB Image LLM API Key",
    "kb_image_instructions": "KB Image Instructions",
    "tool_timeout": "Tool-Run-Timeout (Sekunden)",
    "tool_timeout_error_message": "Tool-Timeout-Fehlermeldung",
    "level": {
      "title": "Attribut-Ebene",
      "default": "Standard",
      "set": "Gesetzt",
      "force": "Erzwingen"
    }
  },
  "createFromJson": {
    "title": "Werkzeuge aus JSON erstellen",
    "button": "Aus JSON erstellen",
    "executionMethod": "Ausführungsmethode",
    "pathPrefix": "Pfad / URL-Präfix",
    "pathPrefixHelp": "Dieses Präfix wird jedem Werkzeugnamen vorangestellt",
    "jsonInput": "JSON-Eingabe",
    "toolCount": "{{count}} Werkzeug(e) werden erstellt/aktualisiert",
    "quotaExceeded": "Dies würde {{new}} Werkzeug(e) erstellen, aber Sie haben nur {{available}} Kontingent übrig",
    "processing": "Verarbeite...",
    "creating": "Erstelle: {{name}}",
    "updating": "Aktualisiere: {{name}}",
    "create": "Erstellen",
    "success": "Erstellt: {{created}}, Aktualisiert: {{updated}}",
    "http_rest": "HTTP REST",
    "local_script": "Lokales Skript",
    "builtin": "Integriert"
  },
  "errors": {
    ...enCommon.errors,
    "fetch_runners_failed": "Fehler beim Abrufen der Tool-Runner",
    "fetch_tools_failed": "Fehler beim Abrufen der Werkzeuge",
    "select_runner_and_tool": "Bitte wählen Sie einen Runner und ein Werkzeug",
    "invalid_json_parameters": "Ungültiges JSON in Parametern",
    "tool_execution_failed": "Werkzeugausführung fehlgeschlagen"
  },
  "tools": {
    ...enCommon.tools,
    "new": "Neues Werkzeug",
    "no_tools": "Keine Werkzeuge gefunden",
    "error_name_required": "Werkzeugname ist erforderlich",
    "is_builtin_short": "Integriert",
    "tab_details": "Details",
    "tab_attributes": "Attribute",
    "effective_value": "Wirksam: {{value}} — von {{source}}",
    "effective_source_default": "Registrierungsstandard"
  },
  "pages": {
    "agents": {
      "page": {
        "back": "Zurück zu Agenten",
        "advanced_properties": "Erweiterte Eigenschaften",
        "tab_stats": "Statistiken",
        "tab_training": "Agenten-Training",
        "tab_call_logs": "Anrufprotokolle",
        "tab_session_feedback": "Sitzungs-Feedback"
      },
      "training": {
        "title": "Agent-Training",
        "agent_prompt": "Agenten-System-Prompt",
        "interface_instructions": "Schnittstellen-Anweisungen",
        "edit_with_ai": "Mit AI bearbeiten",
        "restore": "Wiederherstellen",
        "no_llm": "Kein Trainings-LLM konfiguriert",
        "no_vis": "Keine virtuellen Schnittstellen mit diesem Agenten verknüpft",
        "no_history": "Kein Prompt-Verlauf",
        "saved": "Erfolgreich gespeichert",
        "restored": "Prompt wiederhergestellt",
        "confirm_restore": "Diese Prompt-Version wiederherstellen?",
        "load_failed": "Trainingsdaten konnten nicht geladen werden",
        "history_title": "Prompt-Verlauf",
        "assessment": {
          "title": "KI-Assessment",
          "run": "KI-Assessment",
          "empty": "Noch kein Assessment. Auf „KI-Assessment“ klicken.",
          "analyzing": "Letzte Anrufe werden analysiert…",
          "no_recommendations": "Keine Empfehlungen.",
          "recommendations_count": "{{count}} Empfehlungen",
          "stale": "Das letzte Assessment ist veraltet. Ein neues wird erstellt.",
          "quota_exceeded": "Kontingent für manuelle Assessments erreicht ({{quota}} pro Agent).",
          "quota_reached": "Kontingent für manuelle Assessments erreicht",
          "running": "Assessment läuft…",
          "applied": "Angewendet",
          "dismissed": "Verworfen",
          "accept": "Akzeptieren",
          "dismiss": "Verwerfen",
          "apply": "Anwenden",
          "reject": "Ablehnen",
          "retry": "Erneut versuchen",
          "failed": "Assessment fehlgeschlagen",
          "load_failed": "Assessment konnte nicht geladen werden",
          "severity_high": "Hoch",
          "severity_medium": "Mittel",
          "severity_low": "Niedrig",
          "category_system_prompt": "System-Prompt",
          "category_vi": "Schnittstelle",
          "category_service": "Service",
          "summary": "Zusammenfassung",
          "satisfaction": "Zufriedenheit",
          "efficiency": "Effizienz"
        },
        "chat": {
          "title": "Mit AI bearbeiten",
          "placeholder": "Problem beschreiben oder Änderung anfordern…",
          "send": "Senden",
          "pending": "Denke nach…",
          "applied_to": "Angewendet auf {{target}}",
          "target_agent": "Agenten-System-Prompt",
          "calling_tool": "Rufe {{tool}} auf…",
          "tools_done": "Fertig: {{tools}}",
          "target_vi": "Schnittstellen-Prompt: {{name}}",
          "failed": "Anfrage fehlgeschlagen",
          "empty": "Den Agenten bitten, Protokolle zu prüfen und Prompt-Änderungen vorzuschlagen."
        }
      },
      "create": { "title": "Neuen Agenten erstellen" },
      "edit": {
        "title": "Agent bearbeiten",
        "back_to_agents": "Zurück zu Agenten",
        "not_found_or_no_permission": "Agent nicht gefunden oder keine Berechtigung zum Bearbeiten."
      }
    },
    "tools": {
      "create": { "title": "Neues Werkzeug erstellen" },
      "edit": {
        "title": "Werkzeug bearbeiten",
        "back_to_tools": "Zurück zu Werkzeugen",
        "tool_not_found": "Werkzeug nicht gefunden"
      }
    },
    "outboundDialers": {
      "list": {
        "title": "Outbound-Dialer",
        "new": "Neuer Outbound-Dialer",
        "empty": "Keine Outbound-Dialer gefunden"
      },
      "create": { "title": "Neuen Outbound-Dialer erstellen" },
      "edit": { "title": "Outbound-Dialer bearbeiten" },
      "view": { "title": "Outbound-Dialer" }
    }
  },
  "upstreamProviders": {
    "title": "Externe Anbieter",
    "forbiddenDescription": "Nur globale Administratoren können externe Anbieter verwalten.",
    "tabs": {
      "stt": "Spracherkennung",
      "tts": "Text-zu-Sprache",
      "llm": "LLM"
    },
    "addStt": "STT-Provider hinzufügen",
    "addTts": "TTS-Provider hinzufügen",
    "addLlm": "LLM-Modell hinzufügen",
    "createStt": "Neuer STT-Provider",
    "createTts": "Neuer TTS-Provider",
    "createLlm": "Neues LLM-Modell",
    "editStt": "STT-Provider bearbeiten",
    "editTts": "TTS-Provider bearbeiten",
    "editLlm": "LLM-Modell bearbeiten",
    "name": "Name",
    "providerColumn": "Provider",
    "model": "Modell",
    "actions": "Aktionen",
    "searchPlaceholder": "Nach Name suchen…",
    "noStt": "Keine STT-Provider konfiguriert.",
    "noTts": "Keine TTS-Provider konfiguriert.",
    "noLlm": "Keine LLM-Modelle konfiguriert.",
    "deleteConfirm": "Diesen Provider löschen?",
    "deleteBlocked": "Löschen nicht möglich: dieser Provider wird von {{count}} Agent(en) verwendet.",
    "failedToLoad": "Provider konnten nicht geladen werden.",
    "failedToSave": "Provider konnte nicht gespeichert werden.",
    "failedToDelete": "Provider konnte nicht gelöscht werden.",
    "manageProviders": "Provider verwalten",
    "selectStt": "STT-Provider",
    "selectTts": "TTS-Provider",
    "selectLlm": "LLM-Modell",
    "createStep1Hint": "Nach dem Erstellen des Providers konfigurieren Sie dessen Einstellungen.",
    "stt_ignored_badge": "STT ignored",
    "stt_ignored_hint": "OpenAI Realtime Speech-to-Speech is active for this agent. The selected STT provider is ignored — OpenAI Realtime handles speech-to-text using the TTS API key.",
    "provider": {
      "soniox": "Soniox",
      "faster_whisper": "Faster Whisper",
      "google": "Google",
      "google_vertex_ai": "Google Vertex AI",
      "elevenlabs": "ElevenLabs",
      "openai": "OpenAI",
      "anthropic": "Anthropic",
      "azure_openai": "Azure OpenAI",
      "self_hosted": "Selbst gehostet"
    },
    "stt": "Sprache-zu-Text (STT)",
    "tts": "Text-zu-Sprache (TTS)",
    "llm": "LLM-Anbieter",
    "optionalDefault": "Optional, verwendet Anbieter-Standard",
    "language": "Sprache",
    "vocabulary_book": "Vokabularbuch",
    "encrypted": "Verschlüsselt",
    "smtp": "SMTP-Konfiguration"
  },
  "billing": { ...enCommon.billing },
  "webhook_tester": {
    "title": "Webhook-Tester",
    "description": "Testen Sie Webhook-Endpunkte für virtuelle Schnittstellen",
    "request": "Anfrage",
    "response": "Antwort",
    "webhook_url": "Webhook-URL",
    "webhook_url_help": "Geben Sie die vollständige Webhook-URL einschließlich der virtuellen Schnittstellen-ID ein",
    "sample_payloads": "Beispiel-Payloads",
    "payload_json": "Payload (JSON)",
    "sending": "Senden...",
    "send_webhook": "Webhook senden",
    "status_label": "Status",
    "response_body": "Antworttext",
    "response_headers": "Antwort-Header",
    "empty_state": "Senden Sie eine Anfrage, um die Antwort zu sehen",
    "tips_title": "Tipps",
    "tip1": "Stellen Sie sicher, dass das Channel Gateway auf Port 3002 läuft",
    "tip2": "Verwenden Sie eine gültige virtuelle Schnittstellen-ID in der URL",
    "tip3": "Überprüfen Sie die Browser-Konsole auf CORS-Fehler, wenn die Anfrage fehlschlägt",
    "tip4": "Channel Gateway Logs anzeigen mit: docker logs sophia-channel-gateway-1"
  },
  "sections": {
    "chat_agent": "Chat-Agent",
    "user_preferences": "Benutzereinstellungen",
    "user_permissions": "Benutzerberechtigungen",
    "media_server": "Medienserver",
    "upstream_providers": "Externe Anbieter",
    "knowledge_base": "Wissensdatenbank"
  },
  "attributeLabels": {
    "attachment_retention_seconds": "Aufbewahrung von Anhängen (Sekunden)",
    "attachment_max_size_bytes": "Maximale Anhangsgröße (Bytes)",
    "consult_delegate_agents": "Delegierte Agenten",
    "consult_timeout_seconds": "Konsultations-Timeout (Sekunden)",
    "consult_max_iterations": "Max. Konsultations-Iterationen",
    "stt_provider": "STT-Anbieter",
    "stt_api_base_url": "STT-API-Basis-URL",
    "stt_api_key": "STT-API-Schlüssel",
    "stt_model": "STT-Modell",
    "stt_language": "STT-Sprache",
    "stt_provider_params": "STT-Anbieterparameter",
    "stt_protocol": "STT Protocol",
    "tts_provider": "TTS-Anbieter",
    "tts_api_base_url": "TTS-API-Basis-URL",
    "tts_api_key": "TTS-API-Schlüssel",
    "tts_voice_id": "TTS-Stimm-ID",
    "tts_model": "TTS-Modell",
    "tts_provider_params": "TTS-Anbieterparameter",
    "tts_style_instructions": "TTS-Stilanweisungen",
    "s2s_greeting_instructions": "S2S-Begrüßungsanweisungen",
    "s2s_temperature": "Temperatur",
    "s2s_top_p": "Top P",
    "s2s_top_k": "Top K",
    "tool_timeout": "Tool-Run-Timeout (Sekunden)",
    "tool_timeout_error_message": "Tool-Timeout-Fehlermeldung",
    "stt_vocabulary_book": "Vokabularbuch",
    "tts_language": "TTS-Sprache",
    "tts_speed": "TTS-Geschwindigkeit",
    "tts_protocol": "TTS-Protokoll",
    "tts_audio_format": "TTS-Audioformat",
    "tts_sample_rate": "TTS-Abtastrate",
    "tts_bitrate": "TTS-Bitrate",
    "llm_provider": "LLM-Anbieter",
    "llm_api_base_url": "LLM-API-Basis-URL",
    "llm_api_key": "LLM-API-Schlüssel",
    "llm_model": "LLM-Modell",
    "llm_temperature": "LLM-Temperatur",
    "llm_max_tokens": "LLM-Max-Token",
    "llm_provider_params": "LLM-Anbieterparameter",
    "llm_api_response_timeout": "LLM-API-Antwortzeitlimit",
    "llm_retry_count": "LLM-Wiederholungsanzahl",
    "stt_audio_format": "STT-Audioformat",
    "stt_sample_rate": "STT-Abtastrate",
    "stt_num_channels": "STT-Kanäle",
    "stt_enable_endpoint_detection": "STT-Endpunkterkennung",
    "llm_vertex_ai_project_id": "Vertex AI-Projekt-ID",
    "llm_vertex_ai_location": "Vertex AI-Standort",
    "llm_vertex_ai_key": "Vertex AI-Dienstkonto-JSON",
    "system_prompt": "System-Prompt",
    "system_prompt_prepend": "System-Prompt voranstellen",
    "system_prompt_append": "System-Prompt anhängen",
    "available_tools": "Verfügbare Werkzeuge",
    "no_available_tools": "Alle Tools sind zugeordnet",
    "additional_tools": "Zusätzliche Werkzeuge",
    "tool_calling_behavior": "Werkzeugaufruf-Verhalten",
    "interim_message_enabled": "Zwischennachricht aktiviert",
    "interim_message_enabled_help": "Zeige eine Nachricht während der Verarbeitung von Tool-Ergebnissen",
    "session_timeout_enabled": "Sitzungs-Timeout aktiviert",
    "session_timeout_seconds": "Sitzungs-Timeout (Sekunden)",
    "session_timeout_goodbye_message": "Abschiedsnachricht bei Sitzungs-Timeout",
    "single_channel_session_timeout_enabled": "Einzelkanal-Sitzungs-Timeout aktiviert",
    "language": "Sprache",
    "tool_calling_attempts": "Werkzeugaufruf-Versuche",
    "barge_in_enabled": "Barge-in aktiviert",
    "g729_transcoding": "G.729-Transkodierung",
    "llm_streaming_enabled": "LLM-Streaming aktiviert",
    "tool_runner_ping_interval": "Tool-Runner-Ping-Intervall",
    "tool_runner_absence_timeout": "Tool-Runner-Abwesenheitszeitlimit",
    "welcome_message": "Begrüßungsnachricht",
    "goodbye_message": "Abschiedsnachricht",
    "telegram_enable_polling": "Telegram-Polling aktivieren",
    "telegram_polling_interval": "Telegram-Polling-Intervall",
    "whatsapp_messaging_instructions": "WhatsApp-Nachrichtenübermittlungsanweisungen",
    "telegram_messaging_instructions": "Telegram-Nachrichtenübermittlungsanweisungen",
    "voice_tts_timeout": "Sprach-TTS-Zeitlimit",
    "voice_analysis_enabled": "Sprachanalyse aktiviert",
    "speaker_gated_barge_in_enabled": "Sprecher-gesteuerte Unterbrechung aktivieren",
    "speaker_similarity_threshold": "Ähnlichkeitsschwelle",
    "speaker_ema_alpha": "EMA-Alpha",
    "voice_analysis_min_frames": "Minimale Frames für Sprachanalyse",
    "voice_gender_threshold_hz": "Stimmgeschlechtsschwelle (Hz)",
    "voice_gender_ambiguous_zone_hz": "Mehrdeutige Zone Stimmgeschlecht (Hz)",
    "voice_analysis_window_ms": "Sprachanalyse-Fenster (ms)",
    "voice_analysis_update_interval_ms": "Sprachanalyse-Aktualisierungsintervall (ms)",
    "voice_gender_reset_threshold_hz": "Stimmgeschlecht-Zurücksetzschwelle (Hz)",
    "tool_processing_prompt": "Werkzeugverarbeitungsaufforderung",
    "tool_processing_delay": "Werkzeugverarbeitungsverzögerung",
    "tool_processing_message": "Werkzeugverarbeitungsnachricht",
    "session_idle_timeout_voice": "Sitzungs-Leerlaufzeitlimit (Sprache, Sekunden)",
    "session_absolute_timeout_voice": "Sitzungs-absolutes Zeitlimit (Sprache, Minuten)",
    "session_idle_timeout_text": "Sitzungs-Leerlaufzeitlimit (Text, Sekunden)",
    "session_absolute_timeout_text": "Sitzungs-absolutes Zeitlimit (Text, Minuten)",
    "session_pre_expire_message": "Nachricht vor Sitzungsablauf",
    "session_pre_expire_message_help": "Wird einmal gesendet, bevor der Leerlauf-Timeout die Sitzung schließt. Leer = deaktiviert.",
    "session_pre_expire_timeout_text": "Vorlaufzeit vor Sitzungsablauf (Sekunden)",
    "session_pre_expire_timeout_text_help": "Sekunden vor dem Leerlauf-Timeout, in denen die Nachricht gesendet wird. 0 = deaktiviert.",
    "perm_tenant_wide": "Mandantenweite Berechtigungen",
    "page_tenant_wide": "Seitenzugriff",
    "audio_chunk_size": "Audio-Chunk-Größe",
    "audio_chunk_transfer_encoding": "Audio-Chunk-Übertragungskodierung",
    "audio_tts_queue_size": "TTS-Warteschlangengröße",
    "audio_energy_threshold": "Audio-Energieschwelle",
    "audio_silence_duration": "Stille-Dauer",
    "audio_min_speech_duration": "Minimale Sprechdauer",
    "audio_vad_hysteresis": "VAD-Hysterese aktiviert",
    "audio_barge_in_enabled": "Audio-Barge-in aktiviert",
    "audio_barge_in_threshold": "Audio-Barge-in-Schwelle",
    "audio_barge_in_min_speech": "Minimale Sprache für Barge-in",
    "barge_in_grace_time": "Barge-in-Schonfrist",
    "barge_in_auto_raise_energy": "Barge-in Auto-Energieerhöhung",
    "barge_in_auto_raise_margin": "Barge-in Auto-Energieerhöhungsspanne",
    "barge_in_auto_raise_max": "Barge-in Auto-Energieerhöhung Maximalwert",
    "audio_jitter_buffer_ms": "Audio-Jitter-Puffer (ms)",
    "audio_max_buffer_frames": "Maximale Audio-Puffer-Frames",
    "audio_packet_loss_concealment": "Audio-Paketverlustverschleierung",
    "utility_extensions_enable": "Dienstprogrammerweiterungen aktivieren",
    "utility_extension_local_echo": "Lokale Echo-Erweiterung",
    "media_server_utility_agent_id": "Dienstprogramm-Agenten-ID",
    "utility_extension_dictation": "Diktiererweiterung",
    "utility_extension_dictation_announcement": "Diktieransage",
    "utility_extension_dictation_stt_error": "Diktier-STT-Fehlermeldung",
    "audio_enhance_enabled": "Audioverbesserung aktiviert",
    "audio_enhance_noise_suppression": "Audio-Rauschunterdrückung",
    "audio_enhance_agc_target": "Audio-AGC-Ziel",
    "audio_enhance_highpass_hz": "Audio-Hochpass (Hz)",
    "audio_enhance_aec_enabled": "Audio-AEC aktiviert",
    "smtp_host": "SMTP-Host",
    "smtp_port": "SMTP-Port",
    "smtp_encryption": "SMTP-Verschlüsselung",
    "smtp_ignore_certificates": "SMTP-Zertifikatsfehler ignorieren",
    "smtp_username": "SMTP-Benutzername",
    "smtp_password": "SMTP-Passwort",
    "smtp_from_email": "SMTP-Absender-E-Mail",
    "smtp_from_name": "SMTP-Absendername",
    "smtp_verify_peer": "SMTP-Peer-Zertifikat prüfen",
    "smtp_verify_peer_name": "SMTP-Peer-Namen prüfen",
    "smtp_allow_self_signed": "Selbstsignierte SMTP-Zertifikate erlauben",
    "email_tag_wrapper": "Tag-Umhüllung",
    "chat_bridge_virtual_interface": "Chat-Bridge Virtuelle Schnittstelle",
    "chat_bridge_auto_add_users": "Automatisch Benutzer hinzufügen",
    "chat_bridge_activation": "Aktivierung",
    "chat_bridge_include_context": "Gesprächskontext einbeziehen",
    "chat_bridge_agent_entity": "Agent-Entität",
    "chat_bridge_caller_entity": "Anrufer-Entität",
    "chat_bridge_service_person_entity": "Service-Person Entität",
    "chat_bridge_handoff_silence_timeout_seconds": "Wartezeit für Bot-Rückkehr (Sekunden)",
    "chat_bridge_handoff_return_message": "Bot-Rückkehr-Nachricht",
    "agent_training_llm": "Agent-Trainings-LLM",
    "agent_training_llm_help": "Das LLM, das für die Funktion „Mit AI bearbeiten“ verwendet wird. Konfigurierbar auf Mandanten-/Systemebene durch globale Administratoren.",
    "agent_training_llm_timeout_seconds": "Trainings-LLM-Timeout (Sekunden)",
    "agent_training_llm_timeout_seconds_help": "Timeout pro LLM-Aufruf für den Trainings-/„Mit AI bearbeiten“-Agenten.",
    "agent_training_loop_timeout_seconds": "Trainings-Schleifen-Timeout (Sekunden)",
    "agent_training_loop_timeout_seconds_help": "Gesamt-Timeout für einen Trainings-/„Mit AI bearbeiten“-Lauf (alle LLM-Aufrufe und Werkzeuge zusammen).",
    "session_feedback_llm_provider": "Sitzungs-Feedback-LLM",
    "session_feedback_llm_provider_help": "Das LLM, das nach Sitzungsende Anrufe zusammenfasst und Insights auswertet. Leer lassen, um Feedback für diesen Agenten zu deaktivieren.",
    "session_feedback_prompt": "Sitzungs-Feedback-Prompt",
    "session_feedback_prompt_help": "Statischer Prompt-Kopf (bis „Trait Definitions:“). Trait-Definitionen, Schema und Transkript werden dynamisch angehängt. Leer lassen für den integrierten Standardwert.",
    "performance_assessment_prompt": "Performance-Assessment-Prompt",
    "performance_assessment_prompt_help": "System-Prompt für den autonomen Performance-Assessment-Agenten. Vorab mit dem integrierten Standardwert gefüllt; zum Anpassen bearbeiten.",
    "performance_assessment_history_hours": "Verlaufsstunden",
    "performance_assessment_history_hours_help": "Stunden letzter Anrufe, die der Assessment-Agent auswertet.",
    "performance_assessment_stale_min_gap_minutes": "Mindestabstand Auto-Trigger (Minuten)",
    "performance_assessment_stale_min_gap_minutes_help": "Mindestanzahl Minuten zwischen automatischen stale-Assessment-Läufen für diesen Agenten. 0 deaktiviert Auto-Trigger beim Laden (Cron und die manuelle Schaltfläche „Ausführen“ funktionieren weiterhin).",
    "auto_reply_enabled": "Auto-Antwort aktiviert",
    "session_timeout": "Sitzungs-Timeout (Minuten)",
    "telegram_parse_mode": "Telegram-Parse-Modus",
    "telegram_disable_notification": "Telegram-Benachrichtigungen deaktivieren",
    "telegram_protect_content": "Telegram-Inhalt schützen",
    "whatsapp_template_namespace": "WhatsApp-Vorlagen-Namespace",
    "whatsapp_message_type": "WhatsApp-Nachrichtentyp",
    "voice_greeting": "Voice-Begrüßung",
    "voice_timeout": "Voice-Timeout (Sekunden)",
    "webhook_url": "Webhook-URL",
    "webhook_secret": "Webhook-Geheimnis",
    "webhook_events": "Webhook-Ereignisse",
    "rocketchat_hook_register_interval": "Webhook-Registrierungsintervall (Sekunden)",
    "rocketchat_integration_channel": "Integrations-Channel",
    "consumer_api_enabled": "Consumer API aktiviert",
    "consumer_api_agents_enabled": "Agenten-Endpunkt aktiviert",
    "consumer_api_call_logs_enabled": "Anrufprotokoll-Endpunkt aktiviert",
    "consumer_api_tools_enabled": "Tool-Endpunkt aktiviert",
    "consumer_api_knowledge_bases_enabled": "Wissensdatenbanken-Endpunkt aktiviert",
    "consumer_api_tool_calls_enabled": "Tool-Aufruf-Endpunkt aktiviert",
    "consumer_api_dial_queue_enabled": "Wählwarteschlange — Laden über API",
    "outbound_dialer_active": "Aktiv",
    "simultaneous_outbound_calls": "Gleichzeitige ausgehende Anrufe",
    "answer_timeout_seconds": "Antwort-Timeout (Sekunden)",
    "call_attempts": "Anrufversuche",
    "call_retry_interval_seconds": "Wiederholungsintervall (Sekunden)",
    "call_retry_interval_randomization_seconds": "Randomisierung des Wiederholungsintervalls (Sekunden)",
    "caller_id_number": "Anruferkennungs-Nummer",
    "caller_id_name": "Anruferkennungs-Name",
    "outbound_sip_proxy_host": "Outbound-SIP-Proxy-Host",
    "outbound_sip_proxy_port": "Outbound-SIP-Proxy-Port",
    "outbound_sip_proxy_transport": "Outbound-SIP-Proxy-Transport",
    "outbound_sip_username": "Outbound-SIP-Benutzername",
    "outbound_sip_password": "Outbound-SIP-Passwort",
    "consumer_api_calls_include_transcripts": "Anrufe enthalten Transkripte",
    "consumer_api_rate_limit_window_seconds": "Ratenlimit-Fenster (Sekunden)",
    "consumer_api_rate_limit_max_requests": "Max. Anfragen pro Fenster",
    "consumer_api_rate_limit_concurrent": "Max. gleichzeitige Anfragen",
    "consumer_api_unauth_rate_limit_window_seconds": "Ratenlimit-Fenster ohne Authentifizierung (Sekunden)",
    "consumer_api_unauth_rate_limit_max_requests": "Max. Anfragen pro Fenster ohne Authentifizierung"
  },
  "attributeGroups": {
    "attachments": "Anhänge",
    "agent_collaboration": "Agenten-Zusammenarbeit",
    "stt_provider": "STT-Anbieterkonfiguration",
    "tts_provider": "TTS-Anbieterkonfiguration",
    "llm_provider": "LLM-Anbieterkonfiguration",
    "vertex_ai": "Vertex AI-Systemkonto",
    "tts_advanced": "TTS Erweiterte Einstellungen",
    "tts_google": "Google TTS-Einstellungen",
    "tts_openai": "OpenAI-Einstellungen",
    "core_agent": "Kern-Agentenkonfiguration",
    "tool_runner_health": "Tool-Runner-Integritätsüberwachung",
    "virtual_interface": "Konfiguration der virtuellen Schnittstelle",
    "voice_analysis": "Sprachanalyse",
    "speaker_barge_in": "Sprecher-gesteuerte Unterbrechung",
    "tool_processing": "Werkzeugverarbeitungs-Benutzererfahrung",
    "session_timeout": "Sitzungszeitlimit",
    "messaging_instructions": "Nachrichtenübermittlungsanweisungen",
    "admin_permissions": "Administratorberechtigungen",
    "audio_streaming": "Audio-Streaming",
    "vad": "Sprachende-Erkennung (VAD)",
    "barge_in": "TTS-Unterbrechung (Barge-in)",
    "rtp": "RTP-Konfiguration",
    "utility_extensions": "Dienstprogrammerweiterungen",
    "audio_enhancement": "Audioverbesserung (APM)",
    "smtp_provider": "SMTP-Anbieterkonfiguration",
    "email_template": "E-Mail-Vorlagenkonfiguration",
    "chat_bridging": "Chat-Bridging",
    "general": "Allgemeine Konfiguration",
    "session-timeout": "Sitzungs-Timeout",
    "bargein-config": "TTS-Unterbrechung (Barge-in)",
    "tool-processing": "Werkzeugverarbeitung",
    "vertex-ai": "Google Vertex AI",
    "codec": "Codec-Transkodierung",
    "tool-runner": "Tool-Runner-Konfiguration",
    "smtp": "SMTP-Konfiguration (E-Mail)",
    "chat-bridging": "Chat-Brücke",
    "audio-streaming": "Audio-Streaming",
    "vad-config": "Sprachendeerkennung (VAD)",
    "rtp-config": "RTP-Konfiguration",
    "utility-functions": "Dienstfunktionen",
    "audio-enhancement": "Audioverbesserung",
    "telegram": "Telegram-Einstellungen",
    "whatsapp": "WhatsApp-Einstellungen",
    "voice": "Voice-Einstellungen",
    "voice-analysis": "Sprachanalyse",
    "webhook": "Webhook-Konfiguration",
    "rocketchat": "RocketChat-Einstellungen",
    "permissions": "Standardberechtigungen",
    "consumer_api": "Consumer API",
    "kb_embedding": "KB-Embedding",
    "kb_image_llm": "KB-Bild-LLM (Vision)",
    "outboundDialer": "Outbound-Dialer-Konfiguration",
    "execution_settings": "Ausführungseinstellungen"
  },
  "tool_tester": {
    "title": "Tool-Tester",
    "tool_runner": "Tool-Runner",
    "tool": "Werkzeug",
    "parameters": "Parameter",
    "timeout": "Zeitlimit",
    "populate": "Ausfüllen",
    "run_tool": "Werkzeug ausführen",
    "running": "Läuft...",
    "result": "Ergebnis",
    "select_runner": "Tool-Runner auswählen...",
    "select_tool": "Werkzeug auswählen...",
    "select_runner_first": "Zuerst Runner auswählen",
    "parameters_placeholder": '{"key": "value"}',
    "parameters_help": "Parameter als JSON-Objekt eingeben",
    "help_title": "Verwendung",
    "help_text": "Testen Sie die Werkzeugausführung ohne eine vollständige Konversationssitzung.",
    "step1_title": "1. Runner auswählen",
    "step1_desc": "Wählen Sie einen Online-Tool-Runner.",
    "step2_title": "2. Werkzeug auswählen",
    "step2_desc": "Wählen Sie das zu testende Werkzeug.",
    "step3_title": "3. Parameter festlegen",
    "step3_desc": "Klicken Sie auf 'Ausfüllen' für Beispielparameter.",
    "step4_title": "4. Zeitlimit konfigurieren",
    "step4_desc": "Zeitlimit festlegen (Standard: 60 Sekunden).",
    "step5_title": "5. Test ausführen",
    "step5_desc": "Klicken Sie auf 'Werkzeug ausführen' zum Ausführen."
  },
  "dashboard": {
    "title": "Dashboard",
    "time_series": "Zeitreihen-Analytik",
    "today": "Heute",
    "last_7_days": "Letzte 7 Tage",
    "last_30_days": "Letzte 30 Tage",
    "this_month": "Dieser Monat",
    "last_month": "Letzter Monat",
    "processed_calls": "Verarbeitete Anrufe",
    "tools_run": "Ausgeführte Werkzeuge",
    "total_call_time": "Gesamtanrufzeit",
    "tool_processing_time": "Werkzeugverarbeitungszeit",
    "updated": "Aktualisiert",
    "tenant_scope": "Mandantenbereich",
    "current_tenant": "Aktuell",
    "all_tenants": "Alle",
    "system_health": "Systemgesundheit",
    "no_infrastructure": "Keine Infrastruktur konfiguriert.",
    "recent_tool_logs": "Letzte Werkzeugausführungen",
    "no_recent_tool_logs": "Keine letzten Werkzeugausführungen."
  },
  "agent": {
    "new": "Neuer Agent",
    "no_agents": "Keine Agenten gefunden",
    "status": {
      "active": "Aktiv",
      "inactive": "Inaktiv"
    }
  },
  "forms": {
    "tables": {
      "headers": {
        "attribute": "Attribut",
        "value": "Wert",
        "level": "Ebene",
        "action": "Aktion"
      }
    },
    "agents": {
      "tabs": {
        "details": "Details",
        "configuration": "Konfiguration",
        "upstreamProviders": "Externe Anbieter"
      },
      "labels": {
        "name": "Name",
        "description": "Beschreibung",
        "agentGroup": "Agentengruppe"
      },
      "placeholders": {
        "noGroup": "Keine Gruppe"
      },
      "errors": {
        "nameRequired": "Agentenname ist erforderlich"
      },
      "loading": {
        "tools": "Werkzeuge werden geladen...",
        "agents": "Agenten werden geladen..."
      },
      "empty": {
        "noTools": "Keine Werkzeuge verfügbar",
        "noDelegateAgents": "Keine anderen Agenten in diesem Mandanten"
      },
      "badge": {
        "builtin": "Integriert"
      },
      "alerts": {
        "saveFirst": "Speichern Sie zuerst den Agenten, um externe Anbieter zu konfigurieren."
      },
      "otherConfiguration": "Andere Konfiguration"
    },
    "auth": {
      "login": { "title": "Passwort-Anmeldung" }
    },
    "outboundDialers": {
      "name": "Name",
      "originatingMediaServer": "Ausgehender Medienserver",
      "virtualInterface": "Virtuelle Schnittstelle",
      "activitySchedule": "Zeitplan",
      "activitySchedule.enabled": "Aktiv",
      "activitySchedule.start": "Öffnung",
      "activitySchedule.end": "Schließung",
      "activitySchedule.day": "Tag",
      "activitySchedule.invalidRange": "Start muss vor dem Ende liegen",
      "timezone": "Zeitzone",
      "anyCloudMediaServer": "Beliebiger verfügbarer Cloud-Medienserver",
      "weekday": {
        "sun": "Sonntag",
        "mon": "Montag",
        "tue": "Dienstag",
        "wed": "Mittwoch",
        "thu": "Donnerstag",
        "fri": "Freitag",
        "sat": "Samstag"
      }
    }
  },
  "infrastructure": {
    ...enCommon.infrastructure,
    "media_servers": "Medienserver",
    "tool_runners": "Tool-Runner",
    "new_server": "Neuer Server",
    "new_runner": "Neuer Runner",
    "new_media_server": "Neuer Medienserver",
    "new_tool_runner": "Neuer Tool-Runner",
    "edit_media_server": "Medienserver bearbeiten",
    "edit_tool_runner": "Tool-Runner bearbeiten",
    "api_key": "API-Schlüssel",
    "type": "Typ",
    "last_seen": "Zuletzt gesehen",
    "never": "Niemals",
    "on_prem": "On-Prem",
    "cloud": "Cloud",
    "copy_api_key": "API-Schlüssel kopieren",
    "api_key_copied": "API-Schlüssel in Zwischenablage kopiert",
    "api_key_copy_failed": "API-Schlüssel konnte nicht kopiert werden",
    "no_media_servers": "Keine Medienserver gefunden",
    "no_tool_runners": "Keine Tool-Runner gefunden",
    "connection_config": "Verbindungskonfiguration",
    "deployment_type": "Bereitstellungstyp",
    "on_premises_deployment": "On-Premises-Bereitstellung",
    "on_prem_help": "Aktivieren, wenn der Server in Ihrer Infrastruktur bereitgestellt wird.",
    "runner_on_prem_help": "Aktivieren, wenn der Tool-Runner in Ihrer Infrastruktur bereitgestellt wird.",
    "create_server": "Server erstellen",
    "create_runner": "Runner erstellen",
    "creating": "Erstellen...",
    "saving": "Speichern...",
    "save_changes": "Änderungen speichern",
    "details": "Details",
    "configuration": "Konfiguration",
    "regenerate_key": "Schlüssel neu generieren",
    "regenerating": "Neu generieren...",
    "regenerate_warning": "Das Neu generieren des API-Schlüssels macht den alten Schlüssel sofort ungültig.",
    "regenerate_confirm": "Möchten Sie den API-Schlüssel wirklich neu generieren? Der alte Schlüssel wird sofort nicht mehr funktionieren.",
    "key_regenerated": "API-Schlüssel erfolgreich neu generiert",
    "key_regenerate_failed": "Neu generieren des API-Schlüssels fehlgeschlagen",
    "server_created_title": "Medienserver erstellt",
    "runner_created_title": "Tool-Runner erstellt",
    "success": "Erfolg!",
    "server_created_desc": "Medienserver erstellt. Bitte speichern Sie den API-Schlüssel unten - er wird nicht erneut angezeigt.",
    "runner_created_desc": "Tool-Runner erstellt. Bitte speichern Sie den API-Schlüssel unten - er wird nicht erneut angezeigt.",
    "server_id": "Server-ID",
    "runner_id": "Runner-ID",
    "key_shown_once": "Dieser API-Schlüssel wird nur einmal angezeigt. Bitte sicher speichern.",
    "config_title": "Konfiguration",
    "config_env_vars": "Konfigurieren Sie Ihren Server mit den folgenden Umgebungsvariablen:",
    "runner_config_env_vars": "Konfigurieren Sie Ihren Tool-Runner mit den folgenden Umgebungsvariablen:",
    "done": "Fertig",
    "auth_required": "Authentifizierung erforderlich. Bitte melden Sie sich erneut an.",
    "save_first_attributes": "Speichern Sie zuerst den Medienserver, um Attribute zu konfigurieren.",
    "load_failed_media_server": "Medienserver konnte nicht geladen werden",
    "create_failed_media_server": "Erstellen des Medienservers fehlgeschlagen",
    "update_failed_media_server": "Aktualisieren des Medienservers fehlgeschlagen",
    "load_failed_tool_runner": "Tool-Runner konnte nicht geladen werden",
    "create_failed_tool_runner": "Erstellen des Tool-Runners fehlgeschlagen",
    "update_failed_tool_runner": "Aktualisieren des Tool-Runners fehlgeschlagen",
    "delete_failed_media_server": "Löschen des Medienservers fehlgeschlagen",
    "delete_failed_tool_runner": "Löschen des Tool-Runners fehlgeschlagen",
    "delete_failed_runner": "Löschen des Runners fehlgeschlagen",
    "delete_runner_confirm": "Möchten Sie den Runner \"{{name}}\" wirklich löschen?",
    "server_deleted": "Medienserver erfolgreich gelöscht",
    "runner_deleted": "Tool-Runner erfolgreich gelöscht",
    "no_name": "Kein Name",
    "health_check_url": "Health-Check-URL",
    "websocket_url": "WebSocket-URL",
    "actions": "Aktionen",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "confirm_delete_server": "Möchten Sie den Medienserver wirklich löschen?",
    "confirm_delete_runner": "Möchten Sie den Tool-Runner wirklich löschen?",
    "delete_server": "Server löschen",
    "delete_runner": "Runner löschen",
    "server_name": "Servername",
    "runner_name": "Runner-Name",
    "server_url": "Server-URL",
    "runner_url": "Runner-URL",
    "status": "Status",
    "online": "Online",
    "offline": "Offline",
    "version": "Version",
    "active_calls": "Aktive Anrufe",
    "cpu_usage": "CPU-Auslastung",
    "memory_usage": "Speichernutzung",
    "uptime": "Betriebszeit",
    "last_heartbeat": "Letzter Heartbeat",
    "no_data": "Keine Daten",
    "refresh": "Aktualisieren",
    "auto_refresh": "Automatische Aktualisierung",
    "auto_refresh_enabled": "Automatische Aktualisierung aktiviert",
    "auto_refresh_disabled": "Automatische Aktualisierung deaktiviert",
    "refresh_interval": "Aktualisierungsintervall",
    "seconds": "Sekunden",
    "minutes": "Minuten",
    "hours": "Stunden",
    "days": "Tage",
    "media_server_connect": "Medienserver verbinden sich mit AI Orchestrator über den oben angezeigten API-Schlüssel. Konfigurieren Sie die Verbindungs-URL auf dem Medienserver über",
    "tool_runner_connect": "Tool-Runner verbinden sich mit AI Orchestrator über den oben angezeigten API-Schlüssel. Konfigurieren Sie die Verbindungs-URL auf dem Tool-Runner über",
    "env_var": "Umgebungsvariable.",
    "media_server_env_help": "Der Medienserver verbindet sich mit AI Orchestrator über Umgebungsvariablen. Der API-Schlüssel wird nach der Erstellung erstellt und angezeigt.",
    "runner_env_help": "Der Tool-Runner verbindet sich mit AI Orchestrator über Umgebungsvariablen. Der API-Schlüssel wird nach der Erstellung erstellt und angezeigt.",
    "example": "Beispiel",
    "copy": "Kopieren"
  },
  "toolRunner": {
    ...enCommon.toolRunner,
    "title": "Tool-Runner",
    "new": "Neuer Tool-Runner",
    "edit": "Tool-Runner bearbeiten",
    "edit_title": "Tool-Runner bearbeiten",
    "basic_info": "Grundlegende Informationen",
    "api_key": "API-Schlüssel",
    "copy": "Kopieren",
    "copy_success": "API-Schlüssel in Zwischenablage kopiert",
    "copy_failed": "API-Schlüssel konnte nicht kopiert werden",
    "regenerate_key": "Schlüssel neu generieren",
    "regenerating": "Neu generieren...",
    "regenerate_warning": "Das Neu generieren des API-Schlüssels macht den alten Schlüssel sofort ungültig.",
    "regenerate_confirm": "Möchten Sie den API-Schlüssel wirklich neu generieren? Der alte Schlüssel wird sofort nicht mehr funktionieren.",
    "key_regenerated": "API-Schlüssel erfolgreich neu generiert",
    "key_regenerate_failed": "Neu generieren des API-Schlüssels fehlgeschlagen",
    "api_key_copied": "API-Schlüssel in Zwischenablage kopiert",
    "api_key_copy_failed": "API-Schlüssel konnte nicht kopiert werden",
    "status_online": "Online",
    "status_offline": "Offline",
    "status_pending": "Ausstehend",
    "status_error": "Fehler",
    "status_readonly": "Status wird automatisch basierend auf der Runner-Konnektivität aktualisiert",
    "acceptConnections": "Verbindungen akzeptieren",
    "acceptConnections_help": "Diesem Runner erlauben, neue Tool-Ausführungsverbindungen anzunehmen",
    "deployment_type": "Bereitstellungstyp",
    "on_premises": "On-Premises-Bereitstellung",
    "save_changes": "Änderungen speichern",
    "saving": "Speichern...",
    "cancel": "Abbrechen",
    "tools_panel_title": "Verfügbare Tools in diesem Runner",
    "no_tools": "Keine Tools in diesem Runner",
    "load_failed": "Tool-Runner konnte nicht geladen werden",
    "create_failed": "Erstellen des Tool-Runners fehlgeschlagen",
    "update_failed": "Aktualisieren des Tool-Runners fehlgeschlagen",
    "delete_failed": "Löschen des Tool-Runners fehlgeschlagen",
    "runner_deleted": "Tool-Runner erfolgreich gelöscht",
    "confirm_delete": "Möchten Sie den Tool-Runner wirklich löschen?",
    "delete": "Löschen",
    "back_to_runners": "Zurück zu Tool-Runners",
    "associated_tools": "Zugeordnete Tools",
    "runner_tools": "Runner-Tools",
    "available_tools": "Verfügbare Tools",
    "items_count": "{{count}} Elemente",
    "built_in": "Integriert",
    "no_available_tools": "Alle Tools sind zugeordnet",
    "no_associated_tools": "Keine Tools zugeordnet",
    "add_selected": "Ausgewählte Tools hinzufügen",
    "remove_selected": "Ausgewählte Tools entfernen",
    "selection_hint": "Halten Sie Strg/Cmd gedrückt, um mehrere Elemente auszuwählen",
    "tools_updated": "Tool-Zuordnungen erfolgreich aktualisiert",
    "error_load_tools": "Tools konnten nicht geladen werden",
    "error_save_tools": "Speichern der Tool-Zuordnungen fehlgeschlagen"
  },
  "virtual_interface": {
    ...enCommon.virtual_interface,
    "title": "Virtuelle Schnittstellen",
    "new": "Neue virtuelle Schnittstelle",
    "edit": "Virtuelle Schnittstelle bearbeiten",
    "info_text": "Virtuelle Schnittstellen verbinden externe Kanäle (Telegram, WhatsApp, RocketChat, Voice) mit Ihren Agenten. Jede Schnittstelle definiert Übereinstimmungskriterien, um eingehende Nachrichten an den richtigen Agenten weiterzuleiten.",
    "technology": "Technologie",
    "voice_sip": "Voice (SIP)",
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "match_criteria": "Übereinstimmungskriterien",
    "information": "Informationen",
    "save_first_attributes": "Speichern Sie zuerst den Medienserver, um Attribute zu konfigurieren.",
    "waba_required": "WABA-ID ist für WhatsApp-Schnittstellen erforderlich.",
    "workspace_url_required": "Workspace-URL ist für RocketChat erforderlich",
    "bot_username_required": "Bot-Benutzername ist für RocketChat erforderlich",
    "bot_password_required": "Bot-Passwort ist für RocketChat erforderlich",
    "invalid_rocketchat_config": "Ungültige Konfiguration für RocketChat",
    "step1_basic": "Schritt 1: Grundlegende Informationen",
    "step2_config": "Schritt 2: Konfiguration",
    "configure_tech": "Konfigurieren Sie die Integrations-Einstellungen für {{technology}}.",
    "match_criteria_desc": "Legen Sie fest, wie eingehende Nachrichten dieser Schnittstelle zugeordnet werden.",
    "step3_agent": "Schritt 3: Agentenzuweisung",
    "select_agent": "Agent auswählen...",
    "no_agents_available": "Keine Agenten verfügbar. Bitte erstellen Sie zuerst einen Agenten.",
    "save_changes": "Änderungen speichern",
    "saving": "Speichern...",
    "details": "Details",
    "configuration": "Konfiguration",
    "progress": "Fortschritt",
    "basic_information": "Grundlegende Informationen",
    "agent_assignment": "Agentenzuweisung",
    "configuration_attributes": "Konfigurationsattribute",
    "review_create": "Überprüfen & Erstellen",
    "review": "Überprüfen",
    "configured": "Konfiguriert",
    "edit_desc": "Bearbeiten Sie die virtuelle Schnittstellenkonfiguration. Änderungen werden automatisch mit Channel Gateways synchronisiert.",
    "telegram_chat_id": "Telegram-Chat-ID",
    "whatsapp_phone": "WhatsApp-Telefonnummer",
    "caller_id": "Anrufer-ID",
    "did_number": "DID-Nummer",
    "multi_value_help": "Eingabe, Komma oder Tab drücken, um jeden Wert hinzuzufügen. Klicken Sie auf einen Wert, um ihn zu bearbeiten.",
    "telegram_chat_id_help": "Wenn festgelegt, können nur Chats in dieser Liste mit dieser Schnittstelle interagieren; lassen Sie das Feld leer, um allen zu erlauben.",
    "whatsapp_caller_id_help": "Wenn festgelegt, können nur diese Telefonnummern mit dieser Schnittstelle interagieren; lassen Sie das Feld leer, um allen zu erlauben. Nummern können mit oder ohne führendes + eingegeben werden.",
    "multi_value_remove": "Entfernen",
    "sip_domain": "SIP-Domain",
    "webchat_info": "Webchat-Schnittstellen werden automatisch nach Session-ID zugeordnet.",
    "rocketchat_info": "RocketChat-Schnittstellen werden automatisch nach ihrer Webhook-Route zugeordnet. Keine manuellen Übereinstimmungskriterien erforderlich.",
    "agent_select": "Agent auswählen...",
    "agent_label": "Agent",
    "status_label": "Status",
    "hook_parameters": "Hook-Parameter (JSON)",
    "rocketchat_config": "RocketChat-Konfiguration",
    "workspace_url": "Workspace-URL",
    "workspace_url_label": "Workspace-URL",
    "workspace_url_help": "Die URL Ihres RocketChat-Workspaces",
    "bot_username": "Bot-Benutzername",
    "bot_username_label": "Bot-Benutzername",
    "bot_password": "Bot-Passwort",
    "bot_password_label": "Bot-Passwort",
    "bot_password_help": "Das Passwort für das Bot-Konto",
    "webhook_url": "Webhook-URL",
    "last_incoming_request": "Letzte eingehende Anfrage",
    "last_outbound_call": "Letzter ausgehender Anruf",
    "last_webhook_register": "Letzte Webhook-Registrierung",
    "error_details": "Fehlerdetails",
    "warning_change_tech": "Das Ändern der Technologie setzt die Übereinstimmungskriterien zurück.",
    "never": "Niemals",
    "success": "Erfolg",
    "fail": "Fehlgeschlagen",
    "whatsapp_phone_number_id": "Phone Number ID",
    "whatsapp_phone_number_id_help": "The Phone Number ID from your WhatsApp registration service onboarding.",
    "whatsapp_registration_section": "WhatsApp Registration",
    "display_phone_number": "Display Phone Number",
    "registration_id": "Registration ID",
    "last_refreshed": "Last refreshed",
    "refresh_registration": "Refresh Registration",
    "refreshing_registration": "Refreshing...",
    "registration_refreshed": "Registration refreshed",
    "registration_refresh_failed": "Registration refresh failed",
    "whatsapp_phone_number": "WhatsApp Number",
    "whatsapp_number_help": "Choose a number onboarded in the WhatsApp registration service for this tenant.",
    "select_whatsapp_number": "Select a number...",
    "loading_numbers": "Loading numbers...",
    "whatsapp_numbers_load_failed": "Failed to load WhatsApp numbers.",
    "no_whatsapp_numbers": "No WhatsApp numbers are available for this tenant. Onboard numbers in the WhatsApp registration service first.",
    "in_use": "in use",
    "number_in_use_warning": "This number is already connected to another interface. Connecting it here will move it to this interface; the other interface will stop receiving messages for this number.",
    "change_number": "Change Number",
    "change_number_title": "Change WhatsApp Number",
    "changing_number": "Changing...",
    "change_number_failed": "Failed to change the number.",
    "change_number_success": "Number changed.",
    "not_registered_hint": "This number is not registered yet. Click Refresh Registration to register it."
  },
  "virtual_interface_create": {
    "step4_title": "Schritt 4: Konfigurationsattribute",
    "step4_desc": "Konfigurieren Sie zusätzliche Einstellungen für diese virtuelle Schnittstelle. Diese Einstellungen können später geändert werden.",
    "step4_info": "Attribute werden nach dem Erstellen der virtuellen Schnittstelle gespeichert.",
    "step5_title": "Schritt 5: Überprüfen & Erstellen",
    "review_label": "Überprüfen",
    "review_name": "Name",
    "review_technology": "Technologie",
    "review_agent": "Agent",
    "review_attributes": "Attribute",
    "review_attributes_configured": "{{count}} konfiguriert",
    "creating": "Erstellen...",
    "create_interface": "Schnittstelle erstellen",
    "webhook_failed_title": "Webhook-Registrierung fehlgeschlagen",
    "webhook_failed_desc": "Registrierung des WhatsApp-Webhook-Overrides bei Meta fehlgeschlagen. Die virtuelle Schnittstelle wurde nicht erstellt.",
    "error_details_card": "Fehlerdetails",
    "error_endpoint": "Endpunkt",
    "error_response_status": "Antwortstatus",
    "error_response_body": "Antwortkörper",
    "close": "Schließen",
    "telegram_bot_token": "Telegram-Bot-Token",
    "telegram_bot_token_help": "Von @BotFather auf Telegram erhalten. Format: 123456789:ABCdef...",
    "whatsapp_api_token": "WhatsApp-API-Token",
    "whatsapp_phone_number_id": "Telefonnummer-ID",
    "whatsapp_waba_id": "WABA-ID",
    "whatsapp_waba_id_help": "Ihre WhatsApp Business-Konto-ID von Meta Business-Einstellungen.",
    "rocketchat_workspace_url_help": "Die URL Ihres RocketChat-Workspaces (z.B. https://mycompany.rocket.chat)",
    "rocketchat_bot_username_help": "Der Benutzername des in RocketChat erstellten Bot-Kontos",
    "rocketchat_bot_password_help": "Das Passwort für das Bot-Konto. Der Webhook wird bei der Erstellung automatisch registriert.",
    "rocketchat_info_create": "Eine Webhook-Integration wird automatisch mit Ihrem RocketChat-Workspace registriert, wenn diese Schnittstelle erstellt wird. Der Bot antwortet auf @Erwähnungen in Channels und direkten Nachrichten.",
    "match_chat_id_optional": "Telegram-Chat-ID (Optional)",
    "match_chat_id_help": "Leer lassen, um alle Chats zuzuordnen. Für private Gruppen/Channels verwenden. Von @userinfobot erhalten.",
    "match_whatsapp_help": "Die WhatsApp-Telefonnummer zum Zuordnen (mit Ländervorwahl).",
    "match_caller_id_optional": "Anrufer-ID (Optional)",
    "match_did_optional": "DID-Nummer (Optional)",
    "match_sip_optional": "SIP-Domain (Optional)"
  },
  "session": {
    ...enCommon.session,
    "timeouts_title": "Session-Timeouts",
    "timeouts_desc": "Konfigurieren Sie Session-Timeout-Verhalten für Voice- und Text-Kanäle",
    "attribute": "Attribut",
    "value": "Wert",
    "level": "Ebene",
    "action": "Aktion",
    "idle_timeout_voice": "Leerlauf-Timeout (Voice)",
    "idle_timeout_voice_desc": "Zeit der Inaktivität bevor Voice-Session endet",
    "idle_timeout_text": "Leerlauf-Timeout (Text)",
    "idle_timeout_text_desc": "Zeit der Inaktivität bevor Text-Session endet",
    "absolute_timeout_voice": "Absolutes Timeout (Voice)",
    "absolute_timeout_voice_desc": "Maximale Dauer einer Voice-Session",
    "absolute_timeout_text": "Absolutes Timeout (Text)",
    "absolute_timeout_text_desc": "Maximale Dauer einer Text-Session (0 = unendlich)",
    "seconds": "Sekunden",
    "minutes": "Minuten",
    "timeout_behavior": "Timeout-Verhalten",
    "idle_timeout": "Leerlauf-Timeout",
    "idle_timeout_explanation": "Session endet bei Inaktivität für die angegebene Dauer.",
    "absolute_timeout": "Absolutes Timeout",
    "absolute_timeout_explanation": "Session endet nach der maximalen Dauer unabhängig von Aktivität.",
    "channel_types": "Kanaltypen",
    "channel_types_explanation": "Voice-Kanäle (SIP, WebRTC) verwenden Voice-Timeouts. Text-Kanäle (Telegram, WhatsApp, Webchat) verwenden Text-Timeouts.",
    "30_minutes": "30 Minuten",
    "1_hour": "1 Stunde",
    "2_hours": "2 Stunden",
    "3_hours": "3 Stunden",
    "4_hours": "4 Stunden",
    "5_hours": "5 Stunden",
    "6_hours": "6 Stunden",
    "12_hours": "12 Stunden",
    "18_hours": "18 Stunden",
    "24_hours": "24 Stunden",
    "36_hours": "36 Stunden",
    "48_hours": "48 Stunden",
    "72_hours": "72 Stunden",
    "infinite_no_timeout": "Unendlich (kein Timeout)",
    "96_hours_4_days": "96 Stunden (4 Tage)",
    "168_hours_7_days": "168 Stunden (7 Tage)"
  },
  "system_attributes": {
    ...enCommon.system_attributes,
    "loading": "System-Attribute werden geladen...",
    "fetch_failed": "System-Attribute konnten nicht abgerufen werden",
    "save_failed": "Speichern der System-Attribute fehlgeschlagen",
    "chat_agent_title": "Chat-Agent-Standards",
    "chat_agent_desc": "Standard-Konfiguration für Chat-Agenten im System",
    "tool_runner_title": "Tool-Runner-Konfiguration",
    "tool_runner_desc": "Globale Einstellungen für Tool-Runner-Konnektivität",
    "vertex_ai_title": "Google Vertex AI-Konfiguration",
    "vertex_ai_desc": "Dienstkontozertifikat für Vertex AI (LLM und TTS)",
    "system_prompt": "System-Prompt",
    "barge_in_enabled": "Barge-In aktiviert",
    "ping_interval": "Ping-Intervall (Sekunden)",
    "absence_timeout": "Abwesenheits-Timeout (Sekunden)",
    "project_id": "Projekt-ID",
    "location": "Standort",
    "sa_json": "Dienstkonto-JSON",
    "paste_sa_json": "Dienstkonto-JSON hier einfügen"
  },
  "knowledgeBases": {
    ...enCommon.knowledgeBases,
    "title": "Wissensdatenbanken"
  },
  "vocabulary": {
    "title": "Vokabularbücher",
    "add_book": "Vokabularbuch hinzufügen",
    "create": "Erstellen",
    "items": "Einträge",
    "phrase": "Begriff",
    "created": "Erstellt",
    "updated": "Aktualisiert",
    "empty": "Noch keine Vokabularbücher",
    "delete_book_confirm": "Dieses Vokabularbuch löschen? Alle Begriffe werden entfernt.",
    "search_placeholder": "Begriffe suchen...",
    "new_phrase": "Neuer Begriff...",
    "add_phrase": "Hinzufügen",
    "import": "Importieren",
    "export": "CSV exportieren",
    "import_result": "{added} hinzugefügt, {duplicates} Duplikate, {dropped} verworfen",
    "delete_selected": "Auswahl löschen",
    "delete_selected_confirm": "Ausgewählte Begriffe löschen?",
    "load_failed": "Laden fehlgeschlagen",
    "save_failed": "Speichern fehlgeschlagen",
    "no_book": "(keine)"
  }
};

const frCommon = {
  ...enCommon,
  "navigation": {
    ...enCommon.navigation,
    "infrastructure": "Infrastructure",
    "configuration": "Configuration",
    "analytics": "Analytique",
    "administration": "Administration",
    "logs": "Journaux",
    "media_servers": "Serveurs Média",
    "tool_runners": "Exécuteurs d'outils",
    "virtual_interfaces": "Interfaces Virtuelles",
    "tools_list": "Liste d'outils",
    "webhook_tester": "Testeur Webhook",
    "agents": "Agents",
    "tools": "Outils",
    "knowledgeBases": "Bases de connaissances",
    "vocabulary": "Vocabulaire",
    "groups": "Groupes",
    "agent_groups": "Groupes d'agents",
    "tool_groups": "Groupes d'outils",
    "channel_groups": "Groupes de canaux",
    "user_groups": "Groupes d'utilisateurs",
    "tool_tester": "Testeur d'outils",
    "dashboard": "Tableau de bord",
    "call_logs": "Journaux d'appels",
    "tool_logs": "Journaux d'outils",
    "tenants": "Locataires",
    "audit_logs": "Journaux d'audit",
    "administrators": "Administrateurs",
    "settings": "Paramètres",
    "email_templates": "Modèles d'e-mail",
    "upstreamProviders": "Fournisseurs externes",
    "outboundDialers": "Composeurs sortants"
  },
  "groups": {
    "new_group": "Nouveau groupe",
    "delete_failed": "Échec de la suppression du groupe",
    "confirm_delete": "Êtes-vous sûr de vouloir supprimer ce groupe ?",
    "agent": {
      "title": "Groupes d'agents",
      "create_title": "Créer un nouveau groupe d'agents",
      "edit_title": "Modifier le groupe d'agents",
      "empty": "Aucun groupe d'agents trouvé",
      "load_failed": "Échec du chargement des groupes d'agents",
      "create_failed": "Échec de la création du groupe d'agents",
      "update_failed": "Échec de la mise à jour du groupe d'agents",
      "manage": "Gérer les agents"
    },
    "tool": {
      "title": "Groupes d'outils",
      "create_title": "Créer un nouveau groupe d'outils",
      "edit_title": "Modifier le groupe d'outils",
      "empty": "Aucun groupe d'outils trouvé",
      "load_failed": "Échec du chargement des groupes d'outils",
      "create_failed": "Échec de la création du groupe d'outils",
      "update_failed": "Échec de la mise à jour du groupe d'outils",
      "manage": "Gérer les outils",
      "tab_details": "Détails",
      "tab_attributes": "Attributs"
    },
    "channel": {
      "title": "Groupes de canaux",
      "create_title": "Créer un nouveau groupe de canaux",
      "edit_title": "Modifier le groupe de canaux",
      "empty": "Aucun groupe de canaux trouvé",
      "load_failed": "Échec du chargement des groupes de canaux",
      "create_failed": "Échec de la création du groupe de canaux",
      "update_failed": "Échec de la mise à jour du groupe de canaux",
      "type_label": "Type de canal",
      "channel_type_voice": "Voix",
      "channel_type_chat": "Chat",
      "channel_type_email": "E-mail",
      "channel_type_sms": "SMS"
    },
    "user": {
      "title": "Groupes d'utilisateurs",
      "create_title": "Créer un nouveau groupe d'utilisateurs",
      "edit_title": "Modifier le groupe d'utilisateurs",
      "empty": "Aucun groupe d'utilisateurs trouvé",
      "load_failed": "Échec du chargement des groupes d'utilisateurs",
      "create_failed": "Échec de la création du groupe d'utilisateurs",
      "update_failed": "Échec de la mise à jour du groupe d'utilisateurs"
    },
    "delete_group_confirm": "Êtes-vous sûr de vouloir supprimer ce groupe ?",
    "delete_type_confirm": "Êtes-vous sûr de vouloir supprimer ce groupe {{type}} ?",
    "delete_type_failed": "Échec de la suppression du groupe {{type}}",
    "modal": {
      "manage_title": "Gérer {{itemType}} - {{name}}",
      "available_items": "{{itemType}} disponibles",
      "group_members": "Membres du groupe",
      "no_available": "Aucun {{itemType}} disponible",
      "no_members": "Aucun {{itemType}} dans ce groupe",
      "count_available": "{{count}} disponibles",
      "count_members": "{{count}} membres",
      "add_selected": "Ajouter sélectionnés",
      "add_all": "Tout ajouter",
      "remove_selected": "Supprimer sélectionnés",
      "remove_all": "Tout supprimer",
      "load_failed": "Échec du chargement des {{itemType}}",
      "add_failed": "Échec de l'ajout des {{itemType}}",
      "remove_failed": "Échec de la suppression des {{itemType}}",
      "enabled": "Activé",
      "disabled": "Désactivé",
      "close": "Fermer"
    }
  },
  "auth": {
    "sign_in": "Connexion",
    "sign_out": "Déconnexion",
    "username": "Nom d'utilisateur",
    "password": "Mot de passe",
    "totp_code": "Code TOTP",
    "otp_code": "Code OTP",
    "verify": "Vérifier",
    "send_otp": "Envoyer OTP",
    "back_to_password": "Retour à la connexion par mot de passe",
    "use_otp_instead": "Utiliser OTP à la place",
    "two_factor_auth": "Authentification à deux facteurs",
    "otp_login": "Connexion OTP",
    "enter_totp": "Entrez le code à 6 chiffres de votre application d'authentification.",
    "enter_otp": "Entrez le code à 6 chiffres envoyé à votre email."
  },
  "common": {
    ...enCommon.common,
    "create": "Créer",
    "edit": "Modifier",
    "configure": "Configurer",
    "delete": "Supprimer",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "loading": "Chargement...",
    "search": "Rechercher",
    "filter": "Filtrer",
    "actions": "Actions",
    "export": "Exporter",
    "name": "Nom",
    "description": "Description",
    "status": "Statut",
    "created_at": "Créé le",
    "updated_at": "Mis à jour le",
    "reset": "Réinitialiser",
    "update": "Mettre à jour",
    "select_tenant": "Veuillez sélectionner un locataire",
    "seconds": "secondes",
    "saving": "Enregistrement...",
    "deleting": "Suppression...",
    "dismiss": "Fermer",
    "view": "Voir",
    "active": "Actif",
    "inactive": "Inactif",
    "suspended": "Suspendu",
    "deleted": "Supprimé",
    "refresh": "Actualiser",
    "creating_in_tenant": "Création dans le locataire",
    "no_tenant_selected_warning": "Aucun locataire sélectionné. Veuillez sélectionner un locataire dans le menu déroulant en haut.",
    "online": "En ligne",
    "offline": "Hors ligne",
    "degraded": "Dégradé",
    "no_group": "Aucun groupe",
    "time": "Temps",
    "tool": "Outil",
    "tools": "Outils",
    "agent": "Agent",
    "agents": "Agents",
    "no_description": "Aucune description",
    "group": "Groupe",
    "confirm_delete": "Êtes-vous sûr de vouloir supprimer cet élément ?",
    "delete_failed": "Échec de la suppression",
    "agent_delete_blocked": "Suppression impossible : {{count}} interface(s) virtuelle(s) utilisent encore cet agent. Supprimez-les ou réaffectez-les d'abord.",
    "load_failed": "Échec du chargement",
    "create_failed": "Échec de la création",
    "update_failed": "Échec de la mise à jour",
    "view_all": "Voir tout",
    "view_infrastructure": "Voir l'infrastructure",
    "modified": "Modifié",
    "next": "Suivant",
    "previous": "Précédent",
    "back": "Retour",
    "items": "Éléments",
    "none": "Aucun",
    "enabled": "Activé",
    "disabled": "Désactivé",
    "close": "Fermer",
    "save_failed": "Échec de l'enregistrement"
  },
  "call_logs": {
    "title": "Journaux d'appels",
    "filters": "Filtres",
    "from_date": "Du",
    "to_date": "Au",
    "status": "Statut",
    "agent": "Agent",
    "gender": "Genre",
    "all_statuses": "Tous les statuts",
    "started": "Démarré",
    "phone": "Téléphone",
    "channel": "Canal",
    "duration": "Durée",
    "medium": "Médium",
    "no_logs": "Aucun journal d'appel trouvé",
    "previous": "Précédent",
    "next": "Suivant",
    "message": "Message",
    "search_messages": "Rechercher des messages...",
    "conversation": "Conversation",
    "view_conversation": "Voir la conversation",
    "system_prompt": "Prompt système",
    "tool_result": "Résultat d'outil",
    "no_messages": "Aucun message de conversation",
    "subagent_activity": "Activité des sous-agents",
    "subagent_badge": "Sous-agent",
    "subagent_count_title": "Consultations de sous-agents",
    "direction": {
      "inbound": "Entrant",
      "outbound": "Sortant",
      "internal": "Interne",
      "all": "Tous"
    },
    "attachments": {
      "title": "Pièces jointes",
      "expired": "Pièce jointe expirée",
      "download_failed": "Échec du téléchargement",
      "kind": {
        "photo": "Photo",
        "video": "Vidéo",
        "voice": "Message vocal",
        "audio": "Audio",
        "document": "Document"
      }
    }
  },
  "tool_logs": {
    "input": "Entrée",
    "csv_input": "Entrée",
  },
  "outboundDialers": {
    "pause": "Pause",
    "play": "Lecture",
    "configure": "Configurer",
    "load_error": "Échec du chargement des composeurs sortants",
    "status": {
      "pending": "En attente",
      "dialing": "Composition",
      "answered": "Répondu",
      "completed": "Terminé",
      "no_answer": "Pas de réponse",
      "busy": "Occupé",
      "failed": "Échec",
      "invalid_number": "Numéro invalide",
      "retry_scheduled": "Nouvel essai planifié",
      "paused": "En pause",
      "playing": "En lecture"
    },
    "queue": {
      "title": "File d'attente",
      "empty": "La file d'attente est vide",
      "showing": "Affichage de {{start}}-{{end}} sur {{total}}",
      "number": "Numéro",
      "name": "Nom",
      "status": "Statut",
      "context": "Contexte",
      "actions": "Actions"
    },
    "upload": {
      "title": "Téléverser un fichier",
      "chooseFile": "Choisir un fichier (.csv ou .json)",
      "upload": "Téléverser",
      "sampleCsv": "Télécharger l'exemple CSV",
      "sampleJson": "Télécharger l'exemple JSON",
      "valid": "Valide",
      "summary": "{{valid}} valides, {{invalid}} invalides",
      "added": "Ajoutés : {{added}}, ignorés : {{skipped}}",
      "approve": "Approuver",
      "cancel": "Annuler"
    },
    "list": {
      "empty": "Aucun composeur sortant trouvé"
    }
  },
  "recent_calls": {
    "title": "Appels récents",
    "time": "Temps",
    "type": "Type",
    "duration": "Durée",
    "agent": "Agent",
    "status": "Statut",
    "no_recent_calls": "Aucun appel récent.",
    "view_all": "Voir tout",
    "just_now": "À l'instant",
    "minutes_ago": "Il y a {{minutes}} minutes",
    "hours_ago": "Il y a {{hours}} heures",
    "seconds": "secondes",
    "minutes": "minutes"
  },
  "voice_analysis": {
    "summary_label": "Analyse vocale",
    "male": "Homme",
    "female": "Femme",
    "angry": "En colère",
    "happy": "Joyeux",
    "sad": "Triste",
    "neutral": "Neutre",
    "low": "Bas",
    "normal": "Normal",
    "high": "Élevé",
    "gender": "Genre",
    "mood": "Humeur",
    "energy": "Énergie",
    "carried": "repris d'une détection antérieure"
  },
  "attributes": {
    "title": "Attributs de configuration",
    "search_placeholder": "Rechercher des attributs...",
    "level_default": "Par défaut",
    "level_set": "Défini",
    "level_force": "Forcer",
    "level_forced": "Forcé (héritage)",
    "modified_count": "{{count}} modifié(s)",
    "system_default": "Par défaut système",
    "product_default": "Par défaut produit",
    "inherited_tenant": "Hérité du locataire",
    "inherited_group": "Hérité du groupe",
    "collapse_all": "Tout réduire",
    "expand_all": "Tout développer",
    "level_locked": "Verrouillé",
    "paste_sa_json": "Coller le JSON du compte de service ici",
    "stt_provider_id": "Fournisseur STT",
    "tts_provider_id": "Fournisseur TTS",
    "llm_provider_id": "Modèle LLM",
    "kb_embedding_provider": "KB Embedding Provider",
    "kb_embedding_base_url": "KB Embedding Base URL",
    "kb_embedding_model": "KB Embedding Model",
    "kb_embedding_api_key": "KB Embedding API Key",
    "kb_embedding_dimensions": "KB Embedding Dimensions",
    "kb_image_llm_provider": "KB Image LLM Provider",
    "kb_image_llm_base_url": "KB Image LLM Base URL",
    "kb_image_llm_model": "KB Image LLM Model",
    "kb_image_llm_api_key": "KB Image LLM API Key",
    "kb_image_instructions": "KB Image Instructions",
    "tool_timeout": "Délai d'exécution de l'outil (secondes)",
    "tool_timeout_error_message": "Message d'erreur de délai d'expiration de l'outil",
    "level": {
      "title": "Niveau d'attribut",
      "default": "Par défaut",
      "set": "Défini",
      "force": "Forcer"
    }
  },
  "createFromJson": {
    "title": "Créer des outils depuis JSON",
    "button": "Créer depuis JSON",
    "executionMethod": "Méthode d'exécution",
    "pathPrefix": "Préfixe de chemin / URL",
    "pathPrefixHelp": "Ce préfixe sera ajouté à chaque nom d'outil",
    "jsonInput": "Entrée JSON",
    "toolCount": "{{count}} outil(s) seront créés/mis à jour",
    "quotaExceeded": "Cela créerait {{new}} outil(s) mais il ne vous reste que {{available}} de quota",
    "processing": "Traitement...",
    "creating": "Création : {{name}}",
    "updating": "Mise à jour : {{name}}",
    "create": "Créer",
    "success": "Créés : {{created}}, Mis à jour : {{updated}}",
    "http_rest": "HTTP REST",
    "local_script": "Script local",
    "builtin": "Intégré"
  },
  "errors": {
    ...enCommon.errors,
    "fetch_runners_failed": "Échec de la récupération des exécuteurs",
    "fetch_tools_failed": "Échec de la récupération des outils",
    "select_runner_and_tool": "Veuillez sélectionner un exécuteur et un outil",
    "invalid_json_parameters": "JSON invalide dans les paramètres",
    "tool_execution_failed": "Échec de l'exécution de l'outil"
  },
  "tools": {
    ...enCommon.tools,
    "new": "Nouvel outil",
    "no_tools": "Aucun outil trouvé",
    "error_name_required": "Le nom de l'outil est requis",
    "is_builtin_short": "Intégré",
    "tab_details": "Détails",
    "tab_attributes": "Attributs",
    "effective_value": "Effectif : {{value}} — de {{source}}",
    "effective_source_default": "Valeur par défaut du registre"
  },
  "pages": {
    "agents": {
      "page": {
        "back": "Retour aux agents",
        "advanced_properties": "Propriétés avancées",
        "tab_stats": "Statistiques",
        "tab_training": "Formation de l'agent",
        "tab_call_logs": "Journaux d'appels",
        "tab_session_feedback": "Commentaires de session"
      },
      "training": {
        "title": "Entraînement de l'agent",
        "agent_prompt": "Prompt système de l'agent",
        "interface_instructions": "Instructions d'interface",
        "edit_with_ai": "Modifier avec AI",
        "restore": "Restaurer",
        "no_llm": "Aucun LLM d'entraînement configuré",
        "no_vis": "Aucune interface virtuelle liée à cet agent",
        "no_history": "Aucun historique de prompt",
        "saved": "Enregistré avec succès",
        "restored": "Prompt restauré",
        "confirm_restore": "Restaurer cette version du prompt ?",
        "load_failed": "Échec du chargement des données d'entraînement",
        "history_title": "Historique des prompts",
        "assessment": {
          "title": "Évaluation AI",
          "run": "Évaluation AI",
          "empty": "Aucune évaluation. Cliquez sur Évaluation AI.",
          "analyzing": "Analyse des appels récents…",
          "no_recommendations": "Aucune recommandation.",
          "recommendations_count": "{{count}} recommandations",
          "stale": "La dernière évaluation est obsolète. Une nouvelle est en cours de génération.",
          "quota_exceeded": "Quota d'évaluations manuelles atteint ({{quota}} par agent).",
          "quota_reached": "Quota d'évaluations manuelles atteint",
          "running": "Évaluation en cours…",
          "applied": "Appliqué",
          "dismissed": "Rejeté",
          "accept": "Accepter",
          "dismiss": "Rejeter",
          "apply": "Appliquer",
          "reject": "Refuser",
          "retry": "Réessayer",
          "failed": "Échec de l'évaluation",
          "load_failed": "Échec du chargement de l'évaluation",
          "severity_high": "Élevée",
          "severity_medium": "Moyenne",
          "severity_low": "Basse",
          "category_system_prompt": "Prompt système",
          "category_vi": "Interface",
          "category_service": "Service",
          "summary": "Résumé",
          "satisfaction": "Satisfaction",
          "efficiency": "Efficacité"
        },
        "chat": {
          "title": "Modifier avec AI",
          "placeholder": "Décrire un problème ou demander une modification…",
          "send": "Envoyer",
          "pending": "Réflexion…",
          "applied_to": "Appliqué à {{target}}",
          "target_agent": "Prompt système de l'agent",
          "calling_tool": "Appel de {{tool}}…",
          "tools_done": "Terminé : {{tools}}",
          "target_vi": "Prompt d'interface : {{name}}",
          "failed": "Échec de la requête",
          "empty": "Demandez à l'agent d'examiner les journaux et de proposer des modifications de prompt."
        }
      },
      "create": { "title": "Créer un nouvel agent" },
      "edit": {
        "title": "Modifier l'agent",
        "back_to_agents": "Retour aux agents",
        "not_found_or_no_permission": "Agent introuvable ou vous n'avez pas la permission de le modifier."
      }
    },
    "tools": {
      "create": { "title": "Créer un nouvel outil" },
      "edit": {
        "title": "Modifier l'outil",
        "back_to_tools": "Retour aux outils",
        "tool_not_found": "Outil introuvable"
      }
    },
    "outboundDialers": {
      "list": {
        "title": "Composeurs sortants",
        "new": "Nouveau composeur sortant",
        "empty": "Aucun composeur sortant trouvé"
      },
      "create": { "title": "Créer un nouveau composeur sortant" },
      "edit": { "title": "Modifier le composeur sortant" },
      "view": { "title": "Composeur sortant" }
    }
  },
  "upstreamProviders": {
    "title": "Fournisseurs externes",
    "forbiddenDescription": "Seuls les administrateurs globaux peuvent gérer les fournisseurs externes.",
    "tabs": {
      "stt": "Reconnaissance vocale",
      "tts": "Synthèse vocale",
      "llm": "LLM"
    },
    "addStt": "Ajouter un fournisseur STT",
    "addTts": "Ajouter un fournisseur TTS",
    "addLlm": "Ajouter un modèle LLM",
    "createStt": "Nouveau fournisseur STT",
    "createTts": "Nouveau fournisseur TTS",
    "createLlm": "Nouveau modèle LLM",
    "editStt": "Modifier le fournisseur STT",
    "editTts": "Modifier le fournisseur TTS",
    "editLlm": "Modifier le modèle LLM",
    "name": "Nom",
    "providerColumn": "Fournisseur",
    "model": "Modèle",
    "actions": "Actions",
    "searchPlaceholder": "Rechercher par nom…",
    "noStt": "Aucun fournisseur STT configuré.",
    "noTts": "Aucun fournisseur TTS configuré.",
    "noLlm": "Aucun modèle LLM configuré.",
    "deleteConfirm": "Supprimer ce fournisseur ?",
    "deleteBlocked": "Impossible de supprimer : ce fournisseur est utilisé par {{count}} agent(s).",
    "failedToLoad": "Échec du chargement des fournisseurs.",
    "failedToSave": "Échec de l'enregistrement du fournisseur.",
    "failedToDelete": "Échec de la suppression du fournisseur.",
    "manageProviders": "Gérer les fournisseurs",
    "selectStt": "Fournisseur STT",
    "selectTts": "Fournisseur TTS",
    "selectLlm": "Modèle LLM",
    "createStep1Hint": "Après la création du fournisseur, vous configurerez ses paramètres.",
    "stt_ignored_badge": "STT ignored",
    "stt_ignored_hint": "OpenAI Realtime Speech-to-Speech is active for this agent. The selected STT provider is ignored — OpenAI Realtime handles speech-to-text using the TTS API key.",
    "provider": {
      "soniox": "Soniox",
      "faster_whisper": "Faster Whisper",
      "google": "Google",
      "google_vertex_ai": "Google Vertex AI",
      "elevenlabs": "ElevenLabs",
      "openai": "OpenAI",
      "anthropic": "Anthropic",
      "azure_openai": "Azure OpenAI",
      "self_hosted": "Auto-hébergé"
    },
    "stt": "Parole-vers-texte (STT)",
    "tts": "Texte-vers-parole (TTS)",
    "llm": "Fournisseur LLM",
    "optionalDefault": "Optionnel, utilise le défaut du fournisseur",
    "language": "Langue",
    "vocabulary_book": "Livre de vocabulaire",
    "encrypted": "Chiffré",
    "smtp": "Configuration SMTP"
  },
  "billing": { ...enCommon.billing },
  "webhook_tester": {
    "title": "Testeur Webhook",
    "description": "Tester les points de terminaison Webhook pour les interfaces virtuelles",
    "request": "Requête",
    "response": "Réponse",
    "webhook_url": "URL Webhook",
    "webhook_url_help": "Entrez l'URL Webhook complète, y compris l'ID de l'interface virtuelle",
    "sample_payloads": "Exemples de contenu",
    "payload_json": "Contenu (JSON)",
    "sending": "Envoi...",
    "send_webhook": "Envoyer Webhook",
    "status_label": "Statut",
    "response_body": "Corps de la réponse",
    "response_headers": "En-têtes de réponse",
    "empty_state": "Envoyez une requête pour voir la réponse",
    "tips_title": "Conseils",
    "tip1": "Assurez-vous que la passerelle de canal fonctionne sur le port 3002",
    "tip2": "Utilisez un ID d'interface virtuelle valide dans l'URL",
    "tip3": "Vérifiez la console du navigateur pour les erreurs CORS si la requête échoue",
    "tip4": "Affichez les journaux de la passerelle avec : docker logs sophia-channel-gateway-1"
  },
  "sections": {
    "chat_agent": "Agent de Chat",
    "user_preferences": "Préférences Utilisateur",
    "user_permissions": "Permissions Utilisateur",
    "media_server": "Serveur Média",
    "upstream_providers": "Fournisseurs externes",
    "knowledge_base": "Base de connaissances"
  },
  "attributeLabels": {
    "attachment_retention_seconds": "Rétention des pièces jointes (secondes)",
    "attachment_max_size_bytes": "Taille maximale des pièces jointes (octets)",
    "consult_delegate_agents": "Agents délégués",
    "consult_timeout_seconds": "Délai de consultation (secondes)",
    "consult_max_iterations": "Itérations max de consultation",
    "stt_provider": "Fournisseur STT",
    "stt_api_base_url": "URL de base API STT",
    "stt_api_key": "Clé API STT",
    "stt_model": "Modèle STT",
    "stt_language": "Langue STT",
    "stt_provider_params": "Paramètres fournisseur STT",
    "stt_protocol": "STT Protocol",
    "tts_provider": "Fournisseur TTS",
    "tts_api_base_url": "URL de base API TTS",
    "tts_api_key": "Clé API TTS",
    "tts_voice_id": "ID vocale TTS",
    "tts_model": "Modèle TTS",
    "tts_provider_params": "Paramètres fournisseur TTS",
    "tts_style_instructions": "Instructions de style TTS",
    "s2s_greeting_instructions": "Instructions de salutation S2S",
    "s2s_temperature": "Température",
    "s2s_top_p": "Top P",
    "s2s_top_k": "Top K",
    "tool_timeout": "Délai d'exécution de l'outil (secondes)",
    "tool_timeout_error_message": "Message d'erreur de délai d'expiration de l'outil",
    "stt_vocabulary_book": "Livre de vocabulaire",
    "tts_language": "Langue TTS",
    "tts_speed": "Vitesse TTS",
    "tts_protocol": "Protocole TTS",
    "tts_audio_format": "Format audio TTS",
    "tts_sample_rate": "Taux d'échantillonnage TTS",
    "tts_bitrate": "Bitrate TTS",
    "llm_provider": "Fournisseur LLM",
    "llm_api_base_url": "URL de base API LLM",
    "llm_api_key": "Clé API LLM",
    "llm_model": "Modèle LLM",
    "llm_temperature": "Température LLM",
    "llm_max_tokens": "Max. de jetons LLM",
    "llm_provider_params": "Paramètres fournisseur LLM",
    "llm_api_response_timeout": "Délai d'attente réponse API LLM",
    "llm_retry_count": "Nombre de tentatives LLM",
    "stt_audio_format": "Format audio STT",
    "stt_sample_rate": "Taux d'échantillonnage STT",
    "stt_num_channels": "Canaux STT",
    "stt_enable_endpoint_detection": "Détection de point final STT",
    "llm_vertex_ai_project_id": "ID projet Vertex AI",
    "llm_vertex_ai_location": "Emplacement Vertex AI",
    "llm_vertex_ai_key": "JSON compte de service Vertex AI",
    "system_prompt": "Prompt système",
    "system_prompt_prepend": "Préfixe du prompt système",
    "system_prompt_append": "Suffixe du prompt système",
    "available_tools": "Outils disponibles",
    "no_available_tools": "Tous les outils sont associés",
    "additional_tools": "Outils supplémentaires",
    "tool_calling_behavior": "Comportement d'appel d'outil",
    "interim_message_enabled": "Message intermédiaire activé",
    "interim_message_enabled_help": "Afficher un message pendant le traitement des résultats d'outil",
    "session_timeout_enabled": "Délai d'expiration de session activé",
    "session_timeout_seconds": "Délai d'expiration de session (secondes)",
    "session_timeout_goodbye_message": "Message d'au revoir pour délai d'expiration de session",
    "single_channel_session_timeout_enabled": "Délai d'expiration de session à canal unique activé",
    "language": "Langue",
    "tool_calling_attempts": "Tentatives d'appel d'outil",
    "barge_in_enabled": "Interruption activée",
    "g729_transcoding": "Transcodage G.729",
    "llm_streaming_enabled": "Diffusion LLM activée",
    "tool_runner_ping_interval": "Intervalle de ping Tool Runner",
    "tool_runner_absence_timeout": "Délai d'absence Tool Runner",
    "welcome_message": "Message de bienvenue",
    "goodbye_message": "Message d'au revoir",
    "telegram_enable_polling": "Activer le polling Telegram",
    "telegram_polling_interval": "Intervalle de polling Telegram",
    "whatsapp_messaging_instructions": "Instructions de messagerie WhatsApp",
    "telegram_messaging_instructions": "Instructions de messagerie Telegram",
    "voice_tts_timeout": "Délai TTS vocal",
    "voice_analysis_enabled": "Analyse vocale activée",
    "speaker_gated_barge_in_enabled": "Activer l'interruption conditionnée par le locuteur",
    "speaker_similarity_threshold": "Seuil de similarité",
    "speaker_ema_alpha": "Alpha EMA",
    "voice_analysis_min_frames": "Trames min. analyse vocale",
    "voice_gender_threshold_hz": "Seuil de genre vocal (Hz)",
    "voice_gender_ambiguous_zone_hz": "Zone ambiguë de genre vocal (Hz)",
    "voice_analysis_window_ms": "Fenêtre d'analyse vocale (ms)",
    "voice_analysis_update_interval_ms": "Intervalle mise à jour analyse vocale (ms)",
    "voice_gender_reset_threshold_hz": "Seuil de réinitialisation du genre vocal (Hz)",
    "tool_processing_prompt": "Invite de traitement d'outil",
    "tool_processing_delay": "Délai de traitement d'outil",
    "tool_processing_message": "Message de traitement d'outil",
    "session_idle_timeout_voice": "Délai d'inactivité session (voix, secondes)",
    "session_absolute_timeout_voice": "Délai absolu session (voix, minutes)",
    "session_idle_timeout_text": "Délai d'inactivité session (texte, secondes)",
    "session_absolute_timeout_text": "Délai absolu session (texte, minutes)",
    "session_pre_expire_message": "Message d'alerte avant expiration",
    "session_pre_expire_message_help": "Envoyé une fois avant que le délai d'inactivité ne ferme la session. Vide = désactivé.",
    "session_pre_expire_timeout_text": "Délai d'alerte avant expiration (secondes)",
    "session_pre_expire_timeout_text_help": "Secondes avant le délai d'inactivité pour envoyer le message d'alerte. 0 = désactivé.",
    "perm_tenant_wide": "Permissions inter-locataire",
    "page_tenant_wide": "Accès aux pages",
    "audio_chunk_size": "Taille de segment audio",
    "audio_chunk_transfer_encoding": "Encodage transfert segment audio",
    "audio_tts_queue_size": "Taille file d'attente TTS",
    "audio_energy_threshold": "Seuil d'énergie audio",
    "audio_silence_duration": "Durée de silence",
    "audio_min_speech_duration": "Durée min. de parole",
    "audio_vad_hysteresis": "Hystérésis VAD activé",
    "audio_barge_in_enabled": "Interruption audio activée",
    "audio_barge_in_threshold": "Seuil d'interruption audio",
    "audio_barge_in_min_speech": "Parole min. pour interruption",
    "barge_in_grace_time": "Délai de grâce interruption",
    "barge_in_auto_raise_energy": "Augmentation auto. énergie interruption",
    "barge_in_auto_raise_margin": "Marge augmentation auto. énergie",
    "barge_in_auto_raise_max": "Énergie max. augmentation auto.",
    "audio_jitter_buffer_ms": "Tampon de gigue audio (ms)",
    "audio_max_buffer_frames": "Trames max. tampon audio",
    "audio_packet_loss_concealment": "Masquage perte paquets audio",
    "utility_extensions_enable": "Activer extensions utilitaires",
    "utility_extension_local_echo": "Extension d'écho local",
    "media_server_utility_agent_id": "ID agent utilitaire",
    "utility_extension_dictation": "Extension de dictée",
    "utility_extension_dictation_announcement": "Annonce de dictée",
    "utility_extension_dictation_stt_error": "Message d'erreur STT dictée",
    "audio_enhance_enabled": "Amélioration audio activée",
    "audio_enhance_noise_suppression": "Suppression du bruit audio",
    "audio_enhance_agc_target": "Cible AGC amélioration audio",
    "audio_enhance_highpass_hz": "Filtre passe-haut audio (Hz)",
    "audio_enhance_aec_enabled": "Annulation d'écho acoustique activée",
    "smtp_host": "Hôte SMTP",
    "smtp_port": "Port SMTP",
    "smtp_encryption": "Chiffrement SMTP",
    "smtp_ignore_certificates": "Ignorer les erreurs de certificat SMTP",
    "smtp_username": "Nom d'utilisateur SMTP",
    "smtp_password": "Mot de passe SMTP",
    "smtp_from_email": "E-mail expéditeur SMTP",
    "smtp_from_name": "Nom d'expéditeur SMTP",
    "smtp_verify_peer": "Vérifier le certificat du pair SMTP",
    "smtp_verify_peer_name": "Vérifier le nom du pair SMTP",
    "smtp_allow_self_signed": "Autoriser les certificats auto-signés SMTP",
    "email_tag_wrapper": "Enveloppe de balise",
    "chat_bridge_virtual_interface": "Interface virtuelle de pont de chat",
    "chat_bridge_auto_add_users": "Ajout automatique d'utilisateurs",
    "chat_bridge_activation": "Activation",
    "chat_bridge_include_context": "Inclure le contexte de conversation",
    "chat_bridge_agent_entity": "Entité agent",
    "chat_bridge_caller_entity": "Entité appelant",
    "chat_bridge_service_person_entity": "Entité personnel de service",
    "chat_bridge_handoff_silence_timeout_seconds": "Délai d'attente de retour du bot (secondes)",
    "chat_bridge_handoff_return_message": "Message de retour du bot",
    "agent_training_llm": "LLM d'entraînement de l'agent",
    "agent_training_llm_help": "Le LLM utilisé par la fonction « Modifier avec AI ». Configurable au niveau locataire/système par les administrateurs globaux.",
    "agent_training_llm_timeout_seconds": "Délai d'attente LLM d'entraînement (secondes)",
    "agent_training_llm_timeout_seconds_help": "Délai d'attente par appel LLM pour l'agent d'entraînement/« Modifier avec AI ».",
    "agent_training_loop_timeout_seconds": "Délai d'attente global d'entraînement (secondes)",
    "agent_training_loop_timeout_seconds_help": "Délai d'attente global pour une exécution d'entraînement/« Modifier avec AI » (tous les appels LLM et outils combinés).",
    "session_feedback_llm_provider": "LLM de feedback de session",
    "session_feedback_llm_provider_help": "Le LLM utilisé pour résumer les appels et évaluer les insights après une session. Laisser vide pour désactiver le feedback pour cet agent.",
    "session_feedback_prompt": "Prompt de feedback de session",
    "session_feedback_prompt_help": "En-tête de prompt statique (jusqu'à « Trait Definitions: »). Définitions des traits, schéma et transcription sont ajoutés dynamiquement. Laisser vide pour la valeur par défaut intégrée.",
    "performance_assessment_prompt": "Prompt d'évaluation de performance",
    "performance_assessment_prompt_help": "Prompt système pour l'agent autonome d'évaluation de performance. Pré-rempli avec la valeur par défaut intégrée ; modifier pour personnaliser.",
    "performance_assessment_history_hours": "Heures d'historique",
    "performance_assessment_history_hours_help": "Heures d'appels récents que l'agent d'évaluation examine.",
    "performance_assessment_stale_min_gap_minutes": "Intervalle min. de déclenchement auto (minutes)",
    "performance_assessment_stale_min_gap_minutes_help": "Minutes minimum entre les exécutions automatiques d'évaluation obsolète pour cet agent. 0 désactive le déclenchement auto au chargement (cron et le bouton manuel fonctionnent toujours).",
    "auto_reply_enabled": "Réponse automatique activée",
    "session_timeout": "Délai d'expiration session (minutes)",
    "telegram_parse_mode": "Mode d'analyse Telegram",
    "telegram_disable_notification": "Désactiver notifications Telegram",
    "telegram_protect_content": "Protéger contenu Telegram",
    "whatsapp_template_namespace": "Espace de noms modèle WhatsApp",
    "whatsapp_message_type": "Type de message WhatsApp",
    "voice_greeting": "Salutation vocale",
    "voice_timeout": "Délai d'expiration vocal (secondes)",
    "webhook_url": "URL Webhook",
    "webhook_secret": "Secret Webhook",
    "webhook_events": "Événements Webhook",
    "rocketchat_hook_register_interval": "Intervalle d'enregistrement Webhook (secondes)",
    "rocketchat_integration_channel": "Canal d'intégration",
    "consumer_api_enabled": "API consommateur activée",
    "consumer_api_agents_enabled": "Point de terminaison Agents activé",
    "consumer_api_call_logs_enabled": "Point de terminaison Journaux d'appels activé",
    "consumer_api_tools_enabled": "Point de terminaison Outils activé",
    "consumer_api_knowledge_bases_enabled": "Point de terminaison Bases de connaissances activé",
    "consumer_api_tool_calls_enabled": "Point de terminaison Appels d'outils activé",
    "consumer_api_dial_queue_enabled": "File d'appels — Charger via API",
    "outbound_dialer_active": "Actif",
    "simultaneous_outbound_calls": "Appels sortants simultanés",
    "answer_timeout_seconds": "Délai de réponse (secondes)",
    "call_attempts": "Tentatives d'appel",
    "call_retry_interval_seconds": "Intervalle de nouvelle tentative (secondes)",
    "call_retry_interval_randomization_seconds": "Aléa de l'intervalle de nouvelle tentative (secondes)",
    "caller_id_number": "Numéro d'appelant",
    "caller_id_name": "Nom d'appelant",
    "outbound_sip_proxy_host": "Hôte du proxy SIP sortant",
    "outbound_sip_proxy_port": "Port du proxy SIP sortant",
    "outbound_sip_proxy_transport": "Transport du proxy SIP sortant",
    "outbound_sip_username": "Nom d'utilisateur SIP sortant",
    "outbound_sip_password": "Mot de passe SIP sortant",
    "consumer_api_calls_include_transcripts": "Les appels incluent les transcriptions",
    "consumer_api_rate_limit_window_seconds": "Fenêtre de limite de débit (secondes)",
    "consumer_api_rate_limit_max_requests": "Max de requêtes par fenêtre",
    "consumer_api_rate_limit_concurrent": "Max de requêtes simultanées",
    "consumer_api_unauth_rate_limit_window_seconds": "Fenêtre de limite de débit non authentifiée (secondes)",
    "consumer_api_unauth_rate_limit_max_requests": "Max de requêtes non authentifiées par fenêtre"
  },
  "attributeGroups": {
    "attachments": "Pièces jointes",
    "agent_collaboration": "Collaboration entre agents",
    "stt_provider": "Configuration fournisseur STT",
    "tts_provider": "Configuration fournisseur TTS",
    "llm_provider": "Configuration fournisseur LLM",
    "vertex_ai": "Compte système Vertex AI",
    "tts_advanced": "Paramètres TTS avancés",
    "tts_google": "Paramètres TTS Google",
    "tts_openai": "Paramètres OpenAI",
    "core_agent": "Configuration agent principal",
    "tool_runner_health": "Surveillance santé Tool Runner",
    "virtual_interface": "Configuration interface virtuelle",
    "voice_analysis": "Analyse vocale",
    "speaker_barge_in": "Interruption conditionnée par le locuteur",
    "tool_processing": "UX traitement d'outils",
    "session_timeout": "Délai d'expiration session",
    "messaging_instructions": "Instructions de messagerie",
    "admin_permissions": "Permissions administrateur",
    "audio_streaming": "Diffusion audio",
    "vad": "Détection fin de parole (VAD)",
    "barge_in": "Interruption TTS (Barge-in)",
    "rtp": "Configuration RTP",
    "utility_extensions": "Extensions utilitaires",
    "audio_enhancement": "Amélioration audio (APM)",
    "smtp_provider": "Configuration du fournisseur SMTP",
    "email_template": "Configuration des modèles d'e-mail",
    "chat_bridging": "Pont de chat",
    "general": "Configuration générale",
    "session-timeout": "Délai d'expiration session",
    "bargein-config": "Interruption TTS (Barge-in)",
    "tool-processing": "Traitement d'outils",
    "vertex-ai": "Google Vertex AI",
    "codec": "Transcodage codec",
    "tool-runner": "Configuration Tool Runner",
    "smtp": "Configuration SMTP (E-mail)",
    "chat-bridging": "Pont de chat",
    "audio-streaming": "Diffusion audio",
    "vad-config": "Détection fin de parole (VAD)",
    "rtp-config": "Configuration RTP",
    "utility-functions": "Fonctions utilitaires",
    "audio-enhancement": "Amélioration audio",
    "telegram": "Paramètres Telegram",
    "whatsapp": "Paramètres WhatsApp",
    "voice": "Paramètres vocaux",
    "voice-analysis": "Analyse vocale",
    "webhook": "Configuration Webhook",
    "rocketchat": "Paramètres RocketChat",
    "permissions": "Permissions par défaut",
    "consumer_api": "API consommateur",
    "kb_embedding": "Embedding de base de connaissances",
    "kb_image_llm": "LLM d'images de base de connaissances (Vision)",
    "outboundDialer": "Configuration du composeur sortant",
    "execution_settings": "Paramètres d'exécution"
  },
  "tool_tester": {
    "title": "Testeur d'outils",
    "tool_runner": "Exécuteur d'outils",
    "tool": "Outil",
    "parameters": "Paramètres",
    "timeout": "Délai d'expiration",
    "populate": "Remplir",
    "run_tool": "Exécuter l'outil",
    "running": "En cours...",
    "result": "Résultat",
    "select_runner": "Sélectionner un exécuteur...",
    "select_tool": "Sélectionner un outil...",
    "select_runner_first": "Sélectionner d'abord un exécuteur",
    "parameters_placeholder": '{"clé": "valeur"}',
    "parameters_help": "Saisir les paramètres comme objet JSON",
    "help_title": "Comment utiliser",
    "help_text": "Tester l'exécution d'un outil sans exécuter une session de conversation complète.",
    "step1_title": "1. Sélectionner un exécuteur",
    "step1_desc": "Choisissez un exécuteur d'outils en ligne.",
    "step2_title": "2. Sélectionner un outil",
    "step2_desc": "Choisissez l'outil à tester.",
    "step3_title": "3. Définir les paramètres",
    "step3_desc": "Cliquez sur 'Remplir' pour des exemples de paramètres.",
    "step4_title": "4. Configurer le délai",
    "step4_desc": "Définir le délai (par défaut : 60 secondes).",
    "step5_title": "5. Exécuter le test",
    "step5_desc": "Cliquez sur 'Exécuter l'outil' pour exécuter."
  },
  "dashboard": {
    "title": "Tableau de bord",
    "time_series": "Analytique de séries temporelles",
    "today": "Aujourd'hui",
    "last_7_days": "7 derniers jours",
    "last_30_days": "30 derniers jours",
    "this_month": "Ce mois-ci",
    "last_month": "Mois dernier",
    "processed_calls": "Appels traités",
    "tools_run": "Outils exécutés",
    "total_call_time": "Temps d'appel total",
    "tool_processing_time": "Temps de traitement des outils",
    "updated": "Mis à jour",
    "tenant_scope": "Portée du locataire",
    "current_tenant": "Actuel",
    "all_tenants": "Tous",
    "system_health": "Santé du système",
    "no_infrastructure": "Aucune infrastructure configurée.",
    "recent_tool_logs": "Dernières exécutions d'outils",
    "no_recent_tool_logs": "Aucune exécution d'outils récente."
  },
  "agent": {
    "new": "Nouvel agent",
    "no_agents": "Aucun agent trouvé",
    "status": {
      "active": "Actif",
      "inactive": "Inactif"
    }
  },
  "forms": {
    "tables": {
      "headers": {
        "attribute": "Attribut",
        "value": "Valeur",
        "level": "Niveau",
        "action": "Action"
      }
    },
    "agents": {
      "tabs": {
        "details": "Détails",
        "configuration": "Configuration",
        "upstreamProviders": "Fournisseurs externes"
      },
      "labels": {
        "name": "Nom",
        "description": "Description",
        "agentGroup": "Groupe d'agents"
      },
      "placeholders": {
        "noGroup": "Aucun groupe"
      },
      "errors": {
        "nameRequired": "Le nom de l'agent est requis"
      },
      "loading": {
        "tools": "Chargement des outils...",
        "agents": "Chargement des agents..."
      },
      "empty": {
        "noTools": "Aucun outil disponible",
        "noDelegateAgents": "Aucun autre agent dans ce tenant"
      },
      "badge": {
        "builtin": "Intégré"
      },
      "alerts": {
        "saveFirst": "Enregistrez d'abord l'agent pour configurer les fournisseurs externes."
      },
      "otherConfiguration": "Autre configuration"
    },
    "auth": {
      "login": { "title": "Connexion par mot de passe" }
    },
    "outboundDialers": {
      "name": "Nom",
      "originatingMediaServer": "Serveur média d'origine",
      "virtualInterface": "Interface virtuelle",
      "activitySchedule": "Horaire d'activité",
      "activitySchedule.enabled": "Actif",
      "activitySchedule.start": "Ouverture",
      "activitySchedule.end": "Fermeture",
      "activitySchedule.day": "Jour",
      "activitySchedule.invalidRange": "Le début doit être avant la fin",
      "timezone": "Fuseau horaire",
      "anyCloudMediaServer": "Tout serveur média cloud disponible",
      "weekday": {
        "sun": "Dimanche",
        "mon": "Lundi",
        "tue": "Mardi",
        "wed": "Mercredi",
        "thu": "Jeudi",
        "fri": "Vendredi",
        "sat": "Samedi"
      }
    }
  },
  "infrastructure": {
    ...enCommon.infrastructure,
    "media_servers": "Serveurs Média",
    "tool_runners": "Exécuteurs d'outils",
    "new_server": "Nouveau serveur",
    "new_runner": "Nouvel exécuteur",
    "new_media_server": "Nouveau serveur média",
    "new_tool_runner": "Nouvel exécuteur d'outils",
    "edit_media_server": "Modifier le serveur média",
    "edit_tool_runner": "Modifier l'exécuteur d'outils",
    "api_key": "Clé API",
    "type": "Type",
    "last_seen": "Dernière connexion",
    "never": "Jamais",
    "on_prem": "On-Prem",
    "cloud": "Cloud",
    "copy_api_key": "Copier la clé API",
    "api_key_copied": "Clé API copiée dans le presse-papier",
    "api_key_copy_failed": "Échec de la copie de la clé API",
    "no_media_servers": "Aucun serveur média trouvé",
    "no_tool_runners": "Aucun exécuteur d'outils trouvé",
    "connection_config": "Configuration de connexion",
    "deployment_type": "Type de déploiement",
    "on_premises_deployment": "Déploiement On-Premises",
    "on_prem_help": "Cochez si le serveur sera déployé dans votre infrastructure.",
    "runner_on_prem_help": "Cochez si l'exécuteur d'outils sera déployé dans votre infrastructure.",
    "create_server": "Créer un serveur",
    "create_runner": "Créer un exécuteur",
    "creating": "Création...",
    "saving": "Enregistrement...",
    "save_changes": "Enregistrer les modifications",
    "details": "Détails",
    "configuration": "Configuration",
    "regenerate_key": "Régénérer la clé",
    "regenerating": "Régénération...",
    "regenerate_warning": "La régénération de la clé API rendra immédiatement l'ancienne clé invalide.",
    "regenerate_confirm": "Êtes-vous sûr de vouloir régénérer la clé API ? L'ancienne clé cessera de fonctionner immédiatement.",
    "key_regenerated": "Clé API régénérée avec succès",
    "key_regenerate_failed": "Échec de la régénération de la clé API",
    "server_created_title": "Serveur média créé",
    "runner_created_title": "Exécuteur d'outils créé",
    "success": "Succès !",
    "server_created_desc": "Serveur média créé. Veuillez enregistrer la clé API ci-dessous - elle ne sera plus affichée.",
    "runner_created_desc": "Exécuteur d'outils créé. Veuillez enregistrer la clé API ci-dessous - elle ne sera plus affichée.",
    "server_id": "ID du serveur",
    "runner_id": "ID de l'exécuteur",
    "key_shown_once": "Cette clé API ne sera affichée qu'une seule fois. Veuillez la enregistrer en toute sécurité.",
    "config_title": "Configuration",
    "config_env_vars": "Configurez votre serveur avec les variables d'environnement suivantes :",
    "runner_config_env_vars": "Configurez votre exécuteur d'outils avec les variables d'environnement suivantes :",
    "done": "Terminé",
    "auth_required": "Authentification requise. Veuillez vous reconnecter.",
    "save_first_attributes": "Enregistrez d'abord le serveur média pour configurer les attributs.",
    "load_failed_media_server": "Échec du chargement du serveur média",
    "create_failed_media_server": "Échec de la création du serveur média",
    "update_failed_media_server": "Échec de la mise à jour du serveur média",
    "load_failed_tool_runner": "Échec du chargement de l'exécuteur d'outils",
    "create_failed_tool_runner": "Échec de la création de l'exécuteur d'outils",
    "update_failed_tool_runner": "Échec de la mise à jour de l'exécuteur d'outils",
    "delete_failed_media_server": "Échec de la suppression du serveur média",
    "delete_failed_tool_runner": "Échec de la suppression de l'exécuteur d'outils",
    "delete_failed_runner": "Échec de la suppression de l'exécuteur",
    "delete_runner_confirm": "Êtes-vous sûr de vouloir supprimer l'exécuteur \"{{name}}\" ?",
    "server_deleted": "Serveur média supprimé avec succès",
    "runner_deleted": "Exécuteur d'outils supprimé avec succès",
    "no_name": "Aucun nom",
    "health_check_url": "URL de contrôle de santé",
    "websocket_url": "URL WebSocket",
    "actions": "Actions",
    "edit": "Modifier",
    "delete": "Supprimer",
    "confirm_delete_server": "Êtes-vous sûr de vouloir supprimer le serveur média ?",
    "confirm_delete_runner": "Êtes-vous sûr de vouloir supprimer l'exécuteur d'outils ?",
    "delete_server": "Supprimer le serveur",
    "delete_runner": "Supprimer l'exécuteur",
    "server_name": "Nom du serveur",
    "runner_name": "Nom de l'exécuteur",
    "server_url": "URL du serveur",
    "runner_url": "URL de l'exécuteur",
    "status": "Statut",
    "online": "En ligne",
    "offline": "Hors ligne",
    "version": "Version",
    "active_calls": "Appels actifs",
    "cpu_usage": "Utilisation CPU",
    "memory_usage": "Utilisation mémoire",
    "uptime": "Temps de fonctionnement",
    "last_heartbeat": "Dernier heartbeat",
    "no_data": "Aucune donnée",
    "refresh": "Actualiser",
    "auto_refresh": "Actualisation automatique",
    "auto_refresh_enabled": "Actualisation automatique activée",
    "auto_refresh_disabled": "Actualisation automatique désactivée",
    "refresh_interval": "Intervalle d'actualisation",
    "seconds": "secondes",
    "minutes": "minutes",
    "hours": "heures",
    "days": "jours",
    "media_server_connect": "Les serveurs média se connectent à AI Orchestrator en utilisant la clé API affichée ci-dessus. Configurez l'URL de connexion sur le serveur média via",
    "tool_runner_connect": "Les exécuteurs d'outils se connectent à AI Orchestrator en utilisant la clé API affichée ci-dessus. Configurez l'URL de connexion sur l'exécuteur d'outils via",
    "env_var": "variable d'environnement.",
    "media_server_env_help": "Le serveur média se connectera à AI Orchestrator en utilisant des variables d'environnement. La clé API sera créée et affichée après la création.",
    "runner_env_help": "L'exécuteur d'outils se connectera à AI Orchestrator en utilisant des variables d'environnement. La clé API sera créée et affichée après la création.",
    "example": "Exemple",
    "copy": "Copier"
  },
  "toolRunner": {
    ...enCommon.toolRunner,
    "title": "Exécuteurs d'outils",
    "new": "Nouvel exécuteur d'outils",
    "edit": "Modifier l'exécuteur d'outils",
    "edit_title": "Modifier l'exécuteur d'outils",
    "basic_info": "Informations de base",
    "api_key": "Clé API",
    "copy": "Copier",
    "copy_success": "Clé API copiée dans le presse-papier",
    "copy_failed": "Échec de la copie de la clé API",
    "regenerate_key": "Régénérer la clé",
    "regenerating": "Régénération...",
    "regenerate_warning": "La régénération de la clé API rendra immédiatement l'ancienne clé invalide.",
    "regenerate_confirm": "Êtes-vous sûr de vouloir régénérer la clé API ? L'ancienne clé cessera de fonctionner immédiatement.",
    "key_regenerated": "Clé API régénérée avec succès",
    "key_regenerate_failed": "Échec de la régénération de la clé API",
    "api_key_copied": "Clé API copiée dans le presse-papier",
    "api_key_copy_failed": "Échec de la copie de la clé API",
    "status_online": "En ligne",
    "status_offline": "Hors ligne",
    "status_pending": "En attente",
    "status_error": "Erreur",
    "status_readonly": "Le statut est mis à jour automatiquement en fonction de la connectivité de l'exécuteur",
    "acceptConnections": "Accepter les connexions",
    "acceptConnections_help": "Permettre à cet exécuteur d'accepter de nouvelles connexions d'exécution d'outils",
    "deployment_type": "Type de déploiement",
    "on_premises": "Déploiement On-Premises",
    "save_changes": "Enregistrer les modifications",
    "saving": "Enregistrement...",
    "cancel": "Annuler",
    "tools_panel_title": "Outils disponibles dans cet exécuteur",
    "no_tools": "Aucun outil dans cet exécuteur",
    "load_failed": "Échec du chargement de l'exécuteur d'outils",
    "create_failed": "Échec de la création de l'exécuteur d'outils",
    "update_failed": "Échec de la mise à jour de l'exécuteur d'outils",
    "delete_failed": "Échec de la suppression de l'exécuteur d'outils",
    "runner_deleted": "Exécuteur d'outils supprimé avec succès",
    "confirm_delete": "Êtes-vous sûr de vouloir supprimer l'exécuteur d'outils ?",
    "delete": "Supprimer",
    "back_to_runners": "Retour aux exécuteurs d'outils",
    "associated_tools": "Outils associés",
    "runner_tools": "Outils de l'exécuteur",
    "available_tools": "Outils disponibles",
    "items_count": "{{count}} éléments",
    "built_in": "Intégré",
    "no_available_tools": "Tous les outils sont associés",
    "no_associated_tools": "Aucun outil associé",
    "add_selected": "Ajouter les outils sélectionnés",
    "remove_selected": "Supprimer les outils sélectionnés",
    "selection_hint": "Maintenez Ctrl/Cmd pour sélectionner plusieurs éléments",
    "tools_updated": "Associations d'outils mises à jour avec succès",
    "error_load_tools": "Échec du chargement des outils",
    "error_save_tools": "Échec de l'enregistrement des associations d'outils"
  },
  "virtual_interface": {
    ...enCommon.virtual_interface,
    "title": "Interfaces Virtuelles",
    "new": "Nouvelle Interface Virtuelle",
    "edit": "Modifier l'Interface Virtuelle",
    "info_text": "Les interfaces virtuelles connectent des canaux externes (Telegram, WhatsApp, RocketChat, Voice) à vos agents. Chaque interface définit des critères de correspondance pour router les messages entrants vers le bon agent.",
    "technology": "Technologie",
    "voice_sip": "Voice (SIP)",
    "active": "Actif",
    "inactive": "Inactif",
    "match_criteria": "Critères de correspondance",
    "information": "Informations",
    "save_first_attributes": "Enregistrez d'abord le serveur média pour configurer les attributs.",
    "waba_required": "L'ID WABA est requis pour les interfaces WhatsApp.",
    "workspace_url_required": "L'URL de l'espace de travail est requise pour RocketChat",
    "bot_username_required": "Le nom d'utilisateur du bot est requis pour RocketChat",
    "bot_password_required": "Le mot de passe du bot est requis pour RocketChat",
    "invalid_rocketchat_config": "Configuration RocketChat invalide",
    "step1_basic": "Étape 1 : Informations de base",
    "step2_config": "Étape 2 : Configuration",
    "configure_tech": "Configurez les paramètres d'intégration pour {{technology}}.",
    "match_criteria_desc": "Définissez comment les messages entrants sont associés à cette interface.",
    "step3_agent": "Étape 3 : Attribution d'agent",
    "select_agent": "Sélectionner un agent...",
    "no_agents_available": "Aucun agent disponible. Veuillez d'abord créer un agent.",
    "save_changes": "Enregistrer les modifications",
    "saving": "Enregistrement...",
    "details": "Détails",
    "configuration": "Configuration",
    "progress": "Progression",
    "basic_information": "Informations de base",
    "agent_assignment": "Attribution d'agent",
    "configuration_attributes": "Attributs de configuration",
    "review_create": "Vérifier et créer",
    "review": "Vérifier",
    "configured": "Configuré",
    "edit_desc": "Modifiez la configuration de l'interface virtuelle. Les modifications seront synchronisées automatiquement avec les Channel Gateways.",
    "telegram_chat_id": "ID de chat Telegram",
    "whatsapp_phone": "Numéro de téléphone WhatsApp",
    "caller_id": "ID d'appelant",
    "did_number": "Numéro DID",
    "multi_value_help": "Appuyez sur Entrée, virgule ou Tab pour ajouter chaque valeur. Cliquez sur une valeur pour la modifier.",
    "telegram_chat_id_help": "Lorsque défini, seuls les chats de cette liste peuvent interagir avec cette interface ; laissez vide pour autoriser tout le monde.",
    "whatsapp_caller_id_help": "Lorsque défini, seuls ces numéros de téléphone peuvent interagir avec cette interface ; laissez vide pour autoriser tout le monde. Les numéros peuvent être saisis avec ou sans le signe + initial.",
    "multi_value_remove": "Supprimer",
    "sip_domain": "Domaine SIP",
    "webchat_info": "Les interfaces Webchat sont automatiquement associées par ID de session.",
    "rocketchat_info": "Les interfaces RocketChat sont automatiquement associées par leur chemin webhook. Aucun critère de correspondance manuel requis.",
    "agent_select": "Sélectionner un agent...",
    "agent_label": "Agent",
    "status_label": "Statut",
    "hook_parameters": "Paramètres Hook (JSON)",
    "rocketchat_config": "Configuration RocketChat",
    "workspace_url": "URL de l'espace de travail",
    "workspace_url_label": "URL de l'espace de travail",
    "workspace_url_help": "L'URL de votre espace de travail RocketChat",
    "bot_username": "Nom d'utilisateur du bot",
    "bot_username_label": "Nom d'utilisateur du bot",
    "bot_password": "Mot de passe du bot",
    "bot_password_label": "Mot de passe du bot",
    "bot_password_help": "Le mot de passe pour le compte du bot",
    "webhook_url": "URL Webhook",
    "last_incoming_request": "Dernière requête entrante",
    "last_outbound_call": "Dernier appel sortant",
    "last_webhook_register": "Dernier enregistrement Webhook",
    "error_details": "Détails de l'erreur",
    "warning_change_tech": "Changer la technologie réinitialisera les critères de correspondance.",
    "never": "Jamais",
    "success": "Succès",
    "fail": "Échec",
    "whatsapp_phone_number_id": "Phone Number ID",
    "whatsapp_phone_number_id_help": "The Phone Number ID from your WhatsApp registration service onboarding.",
    "whatsapp_registration_section": "WhatsApp Registration",
    "display_phone_number": "Display Phone Number",
    "registration_id": "Registration ID",
    "last_refreshed": "Last refreshed",
    "refresh_registration": "Refresh Registration",
    "refreshing_registration": "Refreshing...",
    "registration_refreshed": "Registration refreshed",
    "registration_refresh_failed": "Registration refresh failed",
    "whatsapp_phone_number": "WhatsApp Number",
    "whatsapp_number_help": "Choose a number onboarded in the WhatsApp registration service for this tenant.",
    "select_whatsapp_number": "Select a number...",
    "loading_numbers": "Loading numbers...",
    "whatsapp_numbers_load_failed": "Failed to load WhatsApp numbers.",
    "no_whatsapp_numbers": "No WhatsApp numbers are available for this tenant. Onboard numbers in the WhatsApp registration service first.",
    "in_use": "in use",
    "number_in_use_warning": "This number is already connected to another interface. Connecting it here will move it to this interface; the other interface will stop receiving messages for this number.",
    "change_number": "Change Number",
    "change_number_title": "Change WhatsApp Number",
    "changing_number": "Changing...",
    "change_number_failed": "Failed to change the number.",
    "change_number_success": "Number changed.",
    "not_registered_hint": "This number is not registered yet. Click Refresh Registration to register it."
  },
  "virtual_interface_create": {
    "step4_title": "Étape 4 : Attributs de configuration",
    "step4_desc": "Configurez des paramètres supplémentaires pour cette interface virtuelle. Ces paramètres peuvent être modifiés ultérieurement.",
    "step4_info": "Les attributs seront enregistrés après la création de l'interface virtuelle.",
    "step5_title": "Étape 5 : Vérifier et créer",
    "review_label": "Vérifier",
    "review_name": "Nom",
    "review_technology": "Technologie",
    "review_agent": "Agent",
    "review_attributes": "Attributs",
    "review_attributes_configured": "{{count}} configuré(s)",
    "creating": "Création...",
    "create_interface": "Créer l'interface",
    "webhook_failed_title": "Échec de l'enregistrement Webhook",
    "webhook_failed_desc": "Échec de l'enregistrement du webhook WhatsApp Override chez Meta. L'interface virtuelle n'a pas été créée.",
    "error_details_card": "Détails de l'erreur",
    "error_endpoint": "Point de terminaison",
    "error_response_status": "Statut de la réponse",
    "error_response_body": "Corps de la réponse",
    "close": "Fermer",
    "telegram_bot_token": "Token du bot Telegram",
    "telegram_bot_token_help": "Obtenu depuis @BotFather sur Telegram. Format : 123456789:ABCdef...",
    "whatsapp_api_token": "Token API WhatsApp",
    "whatsapp_phone_number_id": "ID du numéro de téléphone",
    "whatsapp_waba_id": "ID WABA",
    "whatsapp_waba_id_help": "Votre ID de compte WhatsApp Business depuis les paramètres Meta Business.",
    "rocketchat_workspace_url_help": "L'URL de votre espace de travail RocketChat (par exemple https://mycompany.rocket.chat)",
    "rocketchat_bot_username_help": "Le nom d'utilisateur du compte bot créé dans RocketChat",
    "rocketchat_bot_password_help": "Le mot de passe pour le compte du bot. Le webhook sera automatiquement enregistré lors de la création.",
    "rocketchat_info_create": "Une intégration webhook sera automatiquement enregistrée avec votre espace de travail RocketChat lors de la création de cette interface. Le bot répondra aux @mentions dans les canaux et messages directs.",
    "match_chat_id_optional": "ID de chat Telegram (optionnel)",
    "match_chat_id_help": "Laisser vide pour associer tous les chats. À utiliser pour les groupes/canaux privés. Obtenu depuis @userinfobot.",
    "match_whatsapp_help": "Le numéro de téléphone WhatsApp à associer (avec l'indicatif pays).",
    "match_caller_id_optional": "ID d'appelant (optionnel)",
    "match_did_optional": "Numéro DID (optionnel)",
    "match_sip_optional": "Domaine SIP (optionnel)"
  },
  "session": {
    ...enCommon.session,
    "timeouts_title": "Délais d'expiration de session",
    "timeouts_desc": "Configurez le comportement des délais d'expiration de session pour les canaux vocaux et textuels",
    "attribute": "Attribut",
    "value": "Valeur",
    "level": "Niveau",
    "action": "Action",
    "idle_timeout_voice": "Délai d'inactivité (Voix)",
    "idle_timeout_voice_desc": "Durée d'inactivité avant la fin de la session vocale",
    "idle_timeout_text": "Délai d'inactivité (Texte)",
    "idle_timeout_text_desc": "Durée d'inactivité avant la fin de la session textuelle",
    "absolute_timeout_voice": "Délai absolu (Voix)",
    "absolute_timeout_voice_desc": "Durée maximale de la session vocale",
    "absolute_timeout_text": "Délai absolu (Texte)",
    "absolute_timeout_text_desc": "Durée maximale de la session textuelle (0 = infini)",
    "seconds": "secondes",
    "minutes": "minutes",
    "timeout_behavior": "Comportement des délais d'expiration",
    "idle_timeout": "Délai d'inactivité",
    "idle_timeout_explanation": "La session se termine si l'utilisateur est inactif pendant la durée spécifiée.",
    "absolute_timeout": "Délai absolu",
    "absolute_timeout_explanation": "La session se termine après la durée maximale indépendamment de l'activité.",
    "channel_types": "Types de canaux",
    "channel_types_explanation": "Les canaux vocaux (SIP, WebRTC) utilisent les délais d'expiration vocaux. Les canaux textuels (Telegram, WhatsApp, Webchat) utilisent les délais d'expiration textuels.",
    "30_minutes": "30 minutes",
    "1_hour": "1 heure",
    "2_hours": "2 heures",
    "3_hours": "3 heures",
    "4_hours": "4 heures",
    "5_hours": "5 heures",
    "6_hours": "6 heures",
    "12_hours": "12 heures",
    "18_hours": "18 heures",
    "24_hours": "24 heures",
    "36_hours": "36 heures",
    "48_hours": "48 heures",
    "72_hours": "72 heures",
    "infinite_no_timeout": "Infini (pas de délai d'expiration)",
    "96_hours_4_days": "96 heures (4 jours)",
    "168_hours_7_days": "168 heures (7 jours)"
  },
  "system_attributes": {
    ...enCommon.system_attributes,
    "loading": "Chargement des attributs système...",
    "fetch_failed": "Échec de la récupération des attributs système",
    "save_failed": "Échec de l'enregistrement des attributs système",
    "chat_agent_title": "Paramètres par défaut de l'agent de chat",
    "chat_agent_desc": "Configuration par défaut de l'agent de chat pour le système",
    "tool_runner_title": "Configuration de l'exécuteur d'outils",
    "tool_runner_desc": "Paramètres de connectivité globaux de l'exécuteur d'outils",
    "vertex_ai_title": "Configuration Google Vertex AI",
    "vertex_ai_desc": "Identifiants de compte de service pour Vertex AI (LLM et TTS)",
    "system_prompt": "Prompt système",
    "barge_in_enabled": "Interruption activée",
    "ping_interval": "Intervalle de ping (secondes)",
    "absence_timeout": "Délai d'absence (secondes)",
    "project_id": "ID du projet",
    "location": "Emplacement",
    "sa_json": "JSON du compte de service",
    "paste_sa_json": "Collez le JSON du compte de service ici"
  },
  "knowledgeBases": {
    ...enCommon.knowledgeBases,
    "title": "Bases de connaissances"
  },
  "vocabulary": {
    "title": "Livres de vocabulaire",
    "add_book": "Ajouter un livre de vocabulaire",
    "create": "Créer",
    "items": "Éléments",
    "phrase": "Phrase",
    "created": "Créé",
    "updated": "Mis à jour",
    "empty": "Aucun livre de vocabulaire",
    "delete_book_confirm": "Supprimer ce livre de vocabulaire ? Toutes les phrases seront supprimées.",
    "search_placeholder": "Rechercher des phrases...",
    "new_phrase": "Nouvelle phrase...",
    "add_phrase": "Ajouter",
    "import": "Importer",
    "export": "Exporter CSV",
    "import_result": "{added} ajoutés, {duplicates} doublons, {dropped} ignorés",
    "delete_selected": "Supprimer la sélection",
    "delete_selected_confirm": "Supprimer les phrases sélectionnées ?",
    "load_failed": "Échec du chargement",
    "save_failed": "Échec de l'enregistrement",
    "no_book": "(aucun)"
  }
};

const ruCommon = {
  ...enCommon,
  "navigation": {
    ...enCommon.navigation,
    "infrastructure": "Инфраструктура",
    "configuration": "Конфигурация",
    "analytics": "Аналитика",
    "administration": "Администрирование",
    "logs": "Журналы",
    "media_servers": "Медиасерверы",
    "tool_runners": "Исполнители инструментов",
    "virtual_interfaces": "Виртуальные интерфейсы",
    "tools_list": "Список инструментов",
    "webhook_tester": "Тестер Webhook",
    "agents": "Агенты",
    "tools": "Инструменты",
    "knowledgeBases": "Базы знаний",
    "vocabulary": "Словарь",
    "groups": "Группы",
    "agent_groups": "Группы агентов",
    "tool_groups": "Группы инструментов",
    "channel_groups": "Группы каналов",
    "user_groups": "Группы пользователей",
    "tool_tester": "Тестер инструментов",
    "dashboard": "Панель управления",
    "call_logs": "Журнал вызовов",
    "tool_logs": "Журнал инструментов",
    "tenants": "Арендаторы",
    "audit_logs": "Журнал аудита",
    "administrators": "Администраторы",
    "settings": "Настройки",
    "email_templates": "Шаблоны писем",
    "upstreamProviders": "Внешние провайдеры",
    "outboundDialers": "Исходящие обзвоны"
  },
  "groups": {
    "new_group": "Новая группа",
    "delete_failed": "Не удалось удалить группу",
    "confirm_delete": "Вы уверены, что хотите удалить эту группу?",
    "agent": {
      "title": "Группы агентов",
      "create_title": "Создать новую группу агентов",
      "edit_title": "Редактировать группу агентов",
      "empty": "Группы агентов не найдены",
      "load_failed": "Не удалось загрузить группы агентов",
      "create_failed": "Не удалось создать группу агентов",
      "update_failed": "Не удалось обновить группу агентов",
      "manage": "Управление агентами"
    },
    "tool": {
      "title": "Группы инструментов",
      "create_title": "Создать новую группу инструментов",
      "edit_title": "Редактировать группу инструментов",
      "empty": "Группы инструментов не найдены",
      "load_failed": "Не удалось загрузить группы инструментов",
      "create_failed": "Не удалось создать группу инструментов",
      "update_failed": "Не удалось обновить группу инструментов",
      "manage": "Управление инструментами",
      "tab_details": "Детали",
      "tab_attributes": "Атрибуты"
    },
    "channel": {
      "title": "Группы каналов",
      "create_title": "Создать новую группу каналов",
      "edit_title": "Редактировать группу каналов",
      "empty": "Группы каналов не найдены",
      "load_failed": "Не удалось загрузить группы каналов",
      "create_failed": "Не удалось создать группу каналов",
      "update_failed": "Не удалось обновить группу каналов",
      "type_label": "Тип канала",
      "channel_type_voice": "Голос",
      "channel_type_chat": "Чат",
      "channel_type_email": "E-mail",
      "channel_type_sms": "SMS"
    },
    "user": {
      "title": "Группы пользователей",
      "create_title": "Создать новую группу пользователей",
      "edit_title": "Редактировать группу пользователей",
      "empty": "Группы пользователей не найдены",
      "load_failed": "Не удалось загрузить группы пользователей",
      "create_failed": "Не удалось создать группу пользователей",
      "update_failed": "Не удалось обновить группу пользователей"
    },
    "delete_group_confirm": "Вы уверены, что хотите удалить эту группу?",
    "delete_type_confirm": "Вы уверены, что хотите удалить эту группу {{type}}?",
    "delete_type_failed": "Не удалось удалить группу {{type}}",
    "modal": {
      "manage_title": "Управление {{itemType}} - {{name}}",
      "available_items": "Доступные {{itemType}}",
      "group_members": "Члены группы",
      "no_available": "Нет доступных {{itemType}}",
      "no_members": "Нет {{itemType}} в этой группе",
      "count_available": "{{count}} доступно",
      "count_members": "{{count}} членов",
      "add_selected": "Добавить выбранные",
      "add_all": "Добавить все",
      "remove_selected": "Удалить выбранные",
      "remove_all": "Удалить все",
      "load_failed": "Не удалось загрузить {{itemType}}",
      "add_failed": "Не удалось добавить {{itemType}}",
      "remove_failed": "Не удалось удалить {{itemType}}",
      "enabled": "Включено",
      "disabled": "Отключено",
      "close": "Закрыть"
    }
  },
  "auth": {
    "sign_in": "Войти",
    "sign_out": "Выйти",
    "username": "Имя пользователя",
    "password": "Пароль",
    "totp_code": "Код TOTP",
    "otp_code": "Код OTP",
    "verify": "Подтвердить",
    "send_otp": "Отправить OTP",
    "back_to_password": "Вернуться к входу с паролем",
    "use_otp_instead": "Использовать OTP",
    "two_factor_auth": "Двухфакторная аутентификация",
    "otp_login": "Вход по OTP",
    "enter_totp": "Введите 6-значный код из приложения-аутентификатора.",
    "enter_otp": "Введите 6-значный код, отправленный на вашу почту."
  },
  "common": {
    ...enCommon.common,
    "create": "Создать",
    "edit": "Редактировать",
    "configure": "Настроить",
    "delete": "Удалить",
    "save": "Сохранить",
    "cancel": "Отмена",
    "loading": "Загрузка...",
    "search": "Поиск",
    "filter": "Фильтр",
    "actions": "Действия",
    "export": "Экспорт",
    "name": "Имя",
    "description": "Описание",
    "status": "Статус",
    "created_at": "Создано",
    "updated_at": "Обновлено",
    "reset": "Сброс",
    "update": "Обновить",
    "select_tenant": "Пожалуйста, выберите арендатора",
    "seconds": "секунд",
    "saving": "Сохранение...",
    "deleting": "Удаление...",
    "dismiss": "Закрыть",
    "view": "Просмотр",
    "active": "Активен",
    "inactive": "Неактивен",
    "suspended": "Приостановлен",
    "deleted": "Удален",
    "refresh": "Обновить",
    "creating_in_tenant": "Создание в арендаторе",
    "no_tenant_selected_warning": "Арендатор не выбран. Пожалуйста, выберите арендатора из выпадающего списка вверху.",
    "online": "В сети",
    "offline": "Не в сети",
    "degraded": "Деградирован",
    "no_group": "Нет группы",
    "time": "Время",
    "tool": "Инструмент",
    "tools": "Инструменты",
    "agent": "Агент",
    "agents": "Агенты",
    "no_description": "Нет описания",
    "group": "Группа",
    "confirm_delete": "Вы уверены, что хотите удалить этот элемент?",
    "delete_failed": "Не удалось удалить",
    "agent_delete_blocked": "Нельзя удалить: {{count}} виртуальный(х) интерфейс(ов) всё ещё используют этого агента. Сначала удалите или переназначьте их.",
    "load_failed": "Не удалось загрузить",
    "create_failed": "Не удалось создать",
    "update_failed": "Не удалось обновить",
    "view_all": "Показать все",
    "view_infrastructure": "Просмотр инфраструктуры",
    "modified": "Изменено",
    "next": "Далее",
    "previous": "Предыдущий",
    "back": "Назад",
    "items": "Элементы",
    "none": "Нет",
    "enabled": "Включено",
    "disabled": "Отключено",
    "close": "Закрыть",
    "save_failed": "Не удалось сохранить"
  },
  "call_logs": {
    "title": "Журнал вызовов",
    "filters": "Фильтры",
    "from_date": "С",
    "to_date": "По",
    "status": "Статус",
    "agent": "Агент",
    "gender": "Пол",
    "all_statuses": "Все статусы",
    "started": "Начато",
    "phone": "Телефон",
    "channel": "Канал",
    "duration": "Длительность",
    "medium": "Среда",
    "no_logs": "Журналы вызовов не найдены",
    "previous": "Предыдущий",
    "next": "Следующий",
    "message": "Сообщение",
    "search_messages": "Поиск сообщений...",
    "conversation": "Разговор",
    "view_conversation": "Просмотр разговора",
    "system_prompt": "Системный промпт",
    "tool_result": "Результат инструмента",
    "no_messages": "Нет сообщений",
    "subagent_activity": "Активность субагентов",
    "subagent_badge": "Субагент",
    "subagent_count_title": "Консультации субагентов",
    "direction": {
      "inbound": "Входящий",
      "outbound": "Исходящий",
      "internal": "Внутренний",
      "all": "Все"
    },
    "attachments": {
      "title": "Вложения",
      "expired": "Срок действия вложения истёк",
      "download_failed": "Не удалось скачать",
      "kind": {
        "photo": "Фото",
        "video": "Видео",
        "voice": "Голосовое сообщение",
        "audio": "Аудио",
        "document": "Документ"
      }
    }
  },
  "tool_logs": {
    "input": "Входные данные",
    "csv_input": "Входные данные",
  },
  "outboundDialers": {
    "pause": "Пауза",
    "play": "Запустить",
    "configure": "Настроить",
    "load_error": "Не удалось загрузить исходящие обзвоны",
    "status": {
      "pending": "В ожидании",
      "dialing": "Набор",
      "answered": "Ответил",
      "completed": "Завершён",
      "no_answer": "Нет ответа",
      "busy": "Занято",
      "failed": "Сбой",
      "invalid_number": "Неверный номер",
      "retry_scheduled": "Повтор запланирован",
      "paused": "Приостановлен",
      "playing": "Активен"
    },
    "queue": {
      "title": "Очередь",
      "empty": "Очередь пуста",
      "showing": "Показано {{start}}-{{end}} из {{total}}",
      "number": "Номер",
      "name": "Имя",
      "status": "Статус",
      "context": "Контекст",
      "actions": "Действия"
    },
    "upload": {
      "title": "Загрузить файл",
      "chooseFile": "Выберите файл (.csv или .json)",
      "upload": "Загрузить",
      "sampleCsv": "Скачать пример CSV",
      "sampleJson": "Скачать пример JSON",
      "valid": "Допустимо",
      "summary": "{{valid}} допустимых, {{invalid}} недопустимых",
      "added": "Добавлено: {{added}}, пропущено: {{skipped}}",
      "approve": "Подтвердить",
      "cancel": "Отмена"
    },
    "list": {
      "empty": "Исходящие обзвоны не найдены"
    }
  },
  "recent_calls": {
    "title": "Последние вызовы",
    "time": "Время",
    "type": "Тип",
    "duration": "Длительность",
    "agent": "Агент",
    "status": "Статус",
    "no_recent_calls": "Нет последних вызовов.",
    "view_all": "Показать все",
    "just_now": "Только что",
    "minutes_ago": "{{minutes}} мин. назад",
    "hours_ago": "{{hours}} ч. назад",
    "seconds": "сек.",
    "minutes": "мин."
  },
  "upstreamProviders": {
    "title": "Внешние провайдеры",
    "forbiddenDescription": "Только глобальные администраторы могут управлять внешними провайдерами.",
    "tabs": {
      "stt": "Распознавание речи",
      "tts": "Синтез речи",
      "llm": "LLM"
    },
    "addStt": "Добавить STT-провайдера",
    "addTts": "Добавить TTS-провайдера",
    "addLlm": "Добавить LLM-модель",
    "createStt": "Новый STT-провайдер",
    "createTts": "Новый TTS-провайдер",
    "createLlm": "Новая LLM-модель",
    "editStt": "Редактировать STT-провайдера",
    "editTts": "Редактировать TTS-провайдера",
    "editLlm": "Редактировать LLM-модель",
    "name": "Название",
    "providerColumn": "Провайдер",
    "model": "Модель",
    "actions": "Действия",
    "searchPlaceholder": "Поиск по названию…",
    "noStt": "STT-провайдеры не настроены.",
    "noTts": "TTS-провайдеры не настроены.",
    "noLlm": "LLM-модели не настроены.",
    "deleteConfirm": "Удалить этого провайдера?",
    "deleteBlocked": "Нельзя удалить: провайдер используется {{count}} агентом/агентами.",
    "failedToLoad": "Не удалось загрузить провайдеров.",
    "failedToSave": "Не удалось сохранить провайдера.",
    "failedToDelete": "Не удалось удалить провайдера.",
    "manageProviders": "Управление провайдерами",
    "selectStt": "STT-провайдер",
    "selectTts": "TTS-провайдер",
    "selectLlm": "LLM-модель",
    "createStep1Hint": "После создания провайдера вы настроите его параметры.",
    "stt_ignored_badge": "STT ignored",
    "stt_ignored_hint": "OpenAI Realtime Speech-to-Speech is active for this agent. The selected STT provider is ignored — OpenAI Realtime handles speech-to-text using the TTS API key.",
    "provider": {
      "soniox": "Soniox",
      "faster_whisper": "Faster Whisper",
      "google": "Google",
      "google_vertex_ai": "Google Vertex AI",
      "elevenlabs": "ElevenLabs",
      "openai": "OpenAI",
      "anthropic": "Anthropic",
      "azure_openai": "Azure OpenAI",
      "self_hosted": "Самостоятельное размещение"
    },
    "stt": "Распознавание речи (STT)",
    "tts": "Синтез речи (TTS)",
    "llm": "LLM провайдер",
    "optionalDefault": "Необязательно, используется значение провайдера по умолчанию",
    "language": "Язык",
    "vocabulary_book": "Книга словаря",
    "encrypted": "Зашифровано",
    "smtp": "SMTP конфигурация"
  },
  "billing": { ...enCommon.billing },
  "voice_analysis": {
    "summary_label": "Анализ голоса",
    "male": "Мужской",
    "female": "Женский",
    "angry": "Злость",
    "happy": "Радость",
    "sad": "Грусть",
    "neutral": "Нейтральный",
    "low": "Низкий",
    "normal": "Нормальный",
    "high": "Высокий",
    "gender": "Пол",
    "mood": "Настроение",
    "energy": "Энергия",
    "carried": "перенесено из более раннего определения"
  },
  "attributes": {
    "title": "Атрибуты конфигурации",
    "search_placeholder": "Поиск атрибутов...",
    "level_default": "По умолчанию",
    "level_set": "Установлен",
    "level_force": "Принудительно",
    "level_forced": "Принудительно (наследование)",
    "modified_count": "{{count}} изменено",
    "system_default": "Системный стандарт",
    "product_default": "Стандарт продукта",
    "inherited_tenant": "Унаследовано от арендатора",
    "inherited_group": "Унаследовано от группы",
    "collapse_all": "Свернуть все",
    "expand_all": "Развернуть все",
    "level_locked": "Заблокировано",
    "paste_sa_json": "Вставьте JSON сервисного аккаунта здесь",
    "stt_provider_id": "STT-провайдер",
    "tts_provider_id": "TTS-провайдер",
    "llm_provider_id": "LLM-модель",
    "kb_embedding_provider": "KB Embedding Provider",
    "kb_embedding_base_url": "KB Embedding Base URL",
    "kb_embedding_model": "KB Embedding Model",
    "kb_embedding_api_key": "KB Embedding API Key",
    "kb_embedding_dimensions": "KB Embedding Dimensions",
    "kb_image_llm_provider": "KB Image LLM Provider",
    "kb_image_llm_base_url": "KB Image LLM Base URL",
    "kb_image_llm_model": "KB Image LLM Model",
    "kb_image_llm_api_key": "KB Image LLM API Key",
    "kb_image_instructions": "KB Image Instructions",
    "tool_timeout": "Тайм-аут выполнения инструмента (сек)",
    "tool_timeout_error_message": "Сообщение об ошибке тайм-аута инструмента",
    "level": {
      "title": "Уровень атрибута",
      "default": "По умолчанию",
      "set": "Установлен",
      "force": "Принудительно"
    }
  },
  "createFromJson": {
    "title": "Создать инструменты из JSON",
    "button": "Создать из JSON",
    "executionMethod": "Метод выполнения",
    "pathPrefix": "Префикс пути / URL",
    "pathPrefixHelp": "Этот префикс будет добавлен к каждому имени инструмента",
    "jsonInput": "Ввод JSON",
    "toolCount": "{{count}} инструмент(ов) будет создано/обновлено",
    "quotaExceeded": "Будет создано {{new}} инструмент(ов), но осталось только {{available}} квоты",
    "processing": "Обработка...",
    "creating": "Создание: {{name}}",
    "updating": "Обновление: {{name}}",
    "create": "Создать",
    "success": "Создано: {{created}}, Обновлено: {{updated}}",
    "http_rest": "HTTP REST",
    "local_script": "Локальный скрипт",
    "builtin": "Встроенный"
  },
  "errors": {
    ...enCommon.errors,
    "fetch_runners_failed": "Не удалось получить исполнителей",
    "fetch_tools_failed": "Не удалось получить инструменты",
    "select_runner_and_tool": "Пожалуйста, выберите исполнителя и инструмент",
    "invalid_json_parameters": "Неверный JSON в параметрах",
    "tool_execution_failed": "Не удалось выполнить инструмент"
  },
  "tools": {
    ...enCommon.tools,
    "new": "Новый инструмент",
    "no_tools": "Инструменты не найдены",
    "error_name_required": "Имя инструмента обязательно",
    "is_builtin_short": "Встроенный",
    "tab_details": "Детали",
    "tab_attributes": "Атрибуты",
    "effective_value": "Действует: {{value}} — из {{source}}",
    "effective_source_default": "Значение по умолчанию (реестр)"
  },
  "pages": {
    "agents": {
      "page": {
        "back": "Вернуться к агентам",
        "advanced_properties": "Расширенные свойства",
        "tab_stats": "Статистика",
        "tab_training": "Обучение агента",
        "tab_call_logs": "Журналы звонков",
        "tab_session_feedback": "Отзывы по сессиям"
      },
      "training": {
        "title": "Обучение агента",
        "agent_prompt": "Системный промпт агента",
        "interface_instructions": "Инструкции интерфейса",
        "edit_with_ai": "Редактировать с AI",
        "restore": "Восстановить",
        "no_llm": "LLM обучения не настроен",
        "no_vis": "С этим агентом не связано ни одного виртуального интерфейса",
        "no_history": "Нет истории промптов",
        "saved": "Успешно сохранено",
        "restored": "Промпт восстановлен",
        "confirm_restore": "Восстановить эту версию промпта?",
        "load_failed": "Не удалось загрузить данные обучения",
        "history_title": "История промптов",
        "assessment": {
          "title": "AI-оценка",
          "run": "AI-оценка",
          "empty": "Оценки пока нет. Нажмите «AI-оценка».",
          "analyzing": "Анализ недавних звонков…",
          "no_recommendations": "Нет рекомендаций.",
          "recommendations_count": "{{count}} рекомендаций",
          "stale": "Последняя оценка устарела. Генерируется новая.",
          "quota_exceeded": "Квота ручных оценок исчерпана ({{quota}} на агента).",
          "quota_reached": "Квота ручных оценок исчерпана",
          "running": "Оценка выполняется…",
          "applied": "Применено",
          "dismissed": "Отклонено",
          "accept": "Принять",
          "dismiss": "Отклонить",
          "apply": "Применить",
          "reject": "Отклонить",
          "retry": "Повторить",
          "failed": "Оценка не удалась",
          "load_failed": "Не удалось загрузить оценку",
          "severity_high": "Высокая",
          "severity_medium": "Средняя",
          "severity_low": "Низкая",
          "category_system_prompt": "Системный промпт",
          "category_vi": "Интерфейс",
          "category_service": "Сервис",
          "summary": "Сводка",
          "satisfaction": "Удовлетворённость",
          "efficiency": "Эффективность"
        },
        "chat": {
          "title": "Редактировать с AI",
          "placeholder": "Опишите проблему или запросите изменение…",
          "send": "Отправить",
          "pending": "Размышляю…",
          "applied_to": "Применено к {{target}}",
          "target_agent": "Системный промпт агента",
          "calling_tool": "Вызов {{tool}}…",
          "tools_done": "Готово: {{tools}}",
          "target_vi": "Промпт интерфейса: {{name}}",
          "failed": "Ошибка запроса",
          "empty": "Попросите агента просмотреть журналы и предложить изменения промпта."
        }
      },
      "create": { "title": "Создать нового агента" },
      "edit": {
        "title": "Редактировать агента",
        "back_to_agents": "Вернуться к агентам",
        "not_found_or_no_permission": "Агент не найден или у вас нет прав на редактирование."
      }
    },
    "tools": {
      "create": { "title": "Создать новый инструмент" },
      "edit": {
        "title": "Редактировать инструмент",
        "back_to_tools": "Вернуться к инструментам",
        "tool_not_found": "Инструмент не найден"
      }
    },
    "outboundDialers": {
      "list": {
        "title": "Исходящие обзвоны",
        "new": "Новый исходящий обзвон",
        "empty": "Исходящие обзвоны не найдены"
      },
      "create": { "title": "Создать новый исходящий обзвон" },
      "edit": { "title": "Редактировать исходящий обзвон" },
      "view": { "title": "Исходящий обзвон" }
    }
  },
  "webhook_tester": {
    "title": "Тестер Webhook",
    "description": "Тестирование конечных точек Webhook для виртуальных интерфейсов",
    "request": "Запрос",
    "response": "Ответ",
    "webhook_url": "URL Webhook",
    "webhook_url_help": "Введите полный URL Webhook, включая ID виртуального интерфейса",
    "sample_payloads": "Примеры данных",
    "payload_json": "Данные (JSON)",
    "sending": "Отправка...",
    "send_webhook": "Отправить Webhook",
    "status_label": "Статус",
    "response_body": "Тело ответа",
    "response_headers": "Заголовки ответа",
    "empty_state": "Отправьте запрос, чтобы увидеть ответ",
    "tips_title": "Советы",
    "tip1": "Убедитесь, что Channel Gateway работает на порту 3002",
    "tip2": "Используйте действительный ID виртуального интерфейса в URL",
    "tip3": "Проверьте консоль браузера на наличие ошибок CORS, если запрос не удался",
    "tip4": "Просмотр логов Channel Gateway: docker logs sophia-channel-gateway-1"
  },
  "sections": {
    "chat_agent": "Чат-агент",
    "user_preferences": "Настройки пользователя",
    "user_permissions": "Права пользователя",
    "media_server": "Медиасервер",
    "upstream_providers": "Внешние провайдеры",
    "knowledge_base": "База знаний"
  },
  "attributeLabels": {
    "attachment_retention_seconds": "Хранение вложений (секунды)",
    "attachment_max_size_bytes": "Максимальный размер вложения (байты)",
    "consult_delegate_agents": "Делегированные агенты",
    "consult_timeout_seconds": "Таймаут консультации (секунды)",
    "consult_max_iterations": "Макс. итераций консультации",
    "stt_provider": "Поставщик STT",
    "stt_api_base_url": "Базовый URL API STT",
    "stt_api_key": "Ключ API STT",
    "stt_model": "Модель STT",
    "stt_language": "Язык STT",
    "stt_provider_params": "Параметры поставщика STT",
    "stt_protocol": "STT Protocol",
    "tts_provider": "Поставщик TTS",
    "tts_api_base_url": "Базовый URL API TTS",
    "tts_api_key": "Ключ API TTS",
    "tts_voice_id": "ID голоса TTS",
    "tts_model": "Модель TTS",
    "tts_provider_params": "Параметры поставщика TTS",
    "tts_style_instructions": "Инструкции по стилю TTS",
    "s2s_greeting_instructions": "Инструкции S2S для приветствия",
    "s2s_temperature": "Температура",
    "s2s_top_p": "Top P",
    "s2s_top_k": "Top K",
    "tool_timeout": "Тайм-аут выполнения инструмента (сек)",
    "tool_timeout_error_message": "Сообщение об ошибке тайм-аута инструмента",
    "stt_vocabulary_book": "Книга словаря",
    "tts_language": "Язык TTS",
    "tts_speed": "Скорость TTS",
    "tts_protocol": "Протокол TTS",
    "tts_audio_format": "Аудиоформат TTS",
    "tts_sample_rate": "Частота дискретизации TTS",
    "tts_bitrate": "Битрейт TTS",
    "llm_provider": "Поставщик LLM",
    "llm_api_base_url": "Базовый URL API LLM",
    "llm_api_key": "Ключ API LLM",
    "llm_model": "Модель LLM",
    "llm_temperature": "Температура LLM",
    "llm_max_tokens": "Макс. токенов LLM",
    "llm_provider_params": "Параметры поставщика LLM",
    "llm_api_response_timeout": "Тайм-аут ответа API LLM",
    "llm_retry_count": "Кол-во повторов LLM",
    "stt_audio_format": "Аудиоформат STT",
    "stt_sample_rate": "Частота дискретизации STT",
    "stt_num_channels": "Каналы STT",
    "stt_enable_endpoint_detection": "Обнаружение конечной точки STT",
    "llm_vertex_ai_project_id": "ID проекта Vertex AI",
    "llm_vertex_ai_location": "Расположение Vertex AI",
    "llm_vertex_ai_key": "JSON сервисного аккаунта Vertex AI",
    "system_prompt": "Системный промпт",
    "system_prompt_prepend": "Префикс системного промпта",
    "system_prompt_append": "Суффикс системного промпта",
    "available_tools": "Доступные инструменты",
    "no_available_tools": "Все инструменты назначены",
    "additional_tools": "Дополнительные инструменты",
    "tool_calling_behavior": "Поведение вызова инструментов",
    "interim_message_enabled": "Промежуточное сообщение включено",
    "interim_message_enabled_help": "Показывать сообщение во время обработки результатов инструмента",
    "session_timeout_enabled": "Тайм-аут сессии включен",
    "session_timeout_seconds": "Тайм-аут сессии (секунды)",
    "session_timeout_goodbye_message": "Прощальное сообщение при тайм-ауте сессии",
    "single_channel_session_timeout_enabled": "Тайм-аут сессии для одного канала включен",
    "language": "Язык",
    "tool_calling_attempts": "Попытки вызова инструментов",
    "barge_in_enabled": "Прерывание включено",
    "g729_transcoding": "Транскодирование G.729",
    "llm_streaming_enabled": "Потоковая передача LLM включена",
    "tool_runner_ping_interval": "Интервал ping Tool Runner",
    "tool_runner_absence_timeout": "Тайм-аут отсутствия Tool Runner",
    "welcome_message": "Приветственное сообщение",
    "goodbye_message": "Прощальное сообщение",
    "telegram_enable_polling": "Включить опрос Telegram",
    "telegram_polling_interval": "Интервал опроса Telegram",
    "whatsapp_messaging_instructions": "Инструкции по обмену сообщениями WhatsApp",
    "telegram_messaging_instructions": "Инструкции по обмену сообщениями Telegram",
    "voice_tts_timeout": "Тайм-аут голосового TTS",
    "voice_analysis_enabled": "Анализ голоса включен",
    "speaker_gated_barge_in_enabled": "Включить прерывание по голосу говорящего",
    "speaker_similarity_threshold": "Порог сходства",
    "speaker_ema_alpha": "Альфа EMA",
    "voice_analysis_min_frames": "Мин. кадров анализа голоса",
    "voice_gender_threshold_hz": "Порог пола голоса (Гц)",
    "voice_gender_ambiguous_zone_hz": "Неоднозначная зона пола голоса (Гц)",
    "voice_analysis_window_ms": "Окно анализа голоса (мс)",
    "voice_analysis_update_interval_ms": "Интервал обновления анализа голоса (мс)",
    "voice_gender_reset_threshold_hz": "Порог сброса пола голоса (Гц)",
    "tool_processing_prompt": "Запрос обработки инструмента",
    "tool_processing_delay": "Задержка обработки инструмента",
    "tool_processing_message": "Сообщение обработки инструмента",
    "session_idle_timeout_voice": "Тайм-аут бездействия (голос, секунды)",
    "session_absolute_timeout_voice": "Абсолютный тайм-аут (голос, минуты)",
    "session_idle_timeout_text": "Тайм-аут бездействия (текст, секунды)",
    "session_absolute_timeout_text": "Абсолютный тайм-аут (текст, минуты)",
    "session_pre_expire_message": "Сообщение-предупреждение перед закрытием",
    "session_pre_expire_message_help": "Отправляется один раз до того, как тайм-аут бездействия закроет сеанс. Пусто = отключено.",
    "session_pre_expire_timeout_text": "Время предупреждения перед закрытием (секунды)",
    "session_pre_expire_timeout_text_help": "За сколько секунд до тайм-аута бездействия отправить сообщение-предупреждение. 0 = отключено.",
    "perm_tenant_wide": "Общие права арендатора",
    "page_tenant_wide": "Доступ к страницам",
    "audio_chunk_size": "Размер фрагмента аудио",
    "audio_chunk_transfer_encoding": "Кодировка передачи фрагментов аудио",
    "audio_tts_queue_size": "Размер очереди TTS",
    "audio_energy_threshold": "Порог энергии аудио",
    "audio_silence_duration": "Длительность тишины",
    "audio_min_speech_duration": "Мин. длительность речи",
    "audio_vad_hysteresis": "Гистерезис VAD включен",
    "audio_barge_in_enabled": "Прерывание аудио включено",
    "audio_barge_in_threshold": "Порог прерывания аудио",
    "audio_barge_in_min_speech": "Мин. речи для прерывания",
    "barge_in_grace_time": "Льготный период прерывания",
    "barge_in_auto_raise_energy": "Автоповышение энергии прерывания",
    "barge_in_auto_raise_margin": "Запас автоповышения энергии",
    "barge_in_auto_raise_max": "Макс. энергия автоповышения",
    "audio_jitter_buffer_ms": "Буфер дрожания аудио (мс)",
    "audio_max_buffer_frames": "Макс. кадров буфера аудио",
    "audio_packet_loss_concealment": "Маскирование потери пакетов аудио",
    "utility_extensions_enable": "Включить служебные расширения",
    "utility_extension_local_echo": "Расширение локального эха",
    "media_server_utility_agent_id": "ID служебного агента",
    "utility_extension_dictation": "Расширение диктовки",
    "utility_extension_dictation_announcement": "Объявление диктовки",
    "utility_extension_dictation_stt_error": "Сообщение об ошибке STT диктовки",
    "audio_enhance_enabled": "Улучшение аудио включено",
    "audio_enhance_noise_suppression": "Подавление шума аудио",
    "audio_enhance_agc_target": "Цель AGC улучшения аудио",
    "audio_enhance_highpass_hz": "Фильтр высоких частот аудио (Гц)",
    "audio_enhance_aec_enabled": "Акустическое подавление эха включено",
    "smtp_host": "SMTP-сервер",
    "smtp_port": "Порт SMTP",
    "smtp_encryption": "Шифрование SMTP",
    "smtp_ignore_certificates": "Игнорировать ошибки сертификатов SMTP",
    "smtp_username": "Имя пользователя SMTP",
    "smtp_password": "Пароль SMTP",
    "smtp_from_email": "Email отправителя SMTP",
    "smtp_from_name": "Имя отправителя SMTP",
    "smtp_verify_peer": "Проверять сертификат узла SMTP",
    "smtp_verify_peer_name": "Проверять имя узла SMTP",
    "smtp_allow_self_signed": "Разрешать самоподписанные SMTP-сертификаты",
    "email_tag_wrapper": "Обертка тега",
    "chat_bridge_virtual_interface": "Виртуальный интерфейс моста чата",
    "chat_bridge_auto_add_users": "Автодобавление пользователей",
    "chat_bridge_activation": "Активация",
    "chat_bridge_include_context": "Включить контекст разговора",
    "chat_bridge_agent_entity": "Сущность агента",
    "chat_bridge_caller_entity": "Сущность звонящего",
    "chat_bridge_service_person_entity": "Сущность оператора",
    "chat_bridge_handoff_silence_timeout_seconds": "Тайм-аут ожидания возврата бота (сек)",
    "chat_bridge_handoff_return_message": "Сообщение возврата бота",
    "agent_training_llm": "LLM обучения агента",
    "agent_training_llm_help": "LLM, используемый функцией «Редактировать с AI». Настраивается на уровне тенанта/системы глобальными администраторами.",
    "agent_training_llm_timeout_seconds": "Тайм-аут LLM обучения (секунды)",
    "agent_training_llm_timeout_seconds_help": "Тайм-аут на каждый вызов LLM для агента обучения/«Редактировать с AI».",
    "agent_training_loop_timeout_seconds": "Общий тайм-аут обучения (секунды)",
    "agent_training_loop_timeout_seconds_help": "Общий тайм-аут для запуска обучения/«Редактировать с AI» (все вызовы LLM и инструменты вместе).",
    "session_feedback_llm_provider": "LLM обратной связи по сессии",
    "session_feedback_llm_provider_help": "LLM, используемый для суммаризации звонков и оценки инсайтов после сессии. Оставьте пустым, чтобы отключить обратную связь для этого агента.",
    "session_feedback_prompt": "Промпт обратной связи по сессии",
    "session_feedback_prompt_help": "Статическая часть промпта (до «Trait Definitions:»). Определения признаков, схема и транскрипт добавляются динамически. Оставьте пустым для встроенного значения по умолчанию.",
    "performance_assessment_prompt": "Промпт оценки производительности",
    "performance_assessment_prompt_help": "Системный промпт для автономного агента оценки производительности. Предзаполнен встроенным значением; отредактируйте для настройки.",
    "performance_assessment_history_hours": "Часы истории",
    "performance_assessment_history_hours_help": "Часы недавних звонков, которые просматривает агент оценки.",
    "performance_assessment_stale_min_gap_minutes": "Мин. интервал авто-запуска (минуты)",
    "performance_assessment_stale_min_gap_minutes_help": "Минимальные минуты между автоматическими запусками устаревшей оценки для этого агента. 0 отключает авто-запуск при загрузке (cron и ручная кнопка «Запустить» продолжают работать).",
    "auto_reply_enabled": "Автоответ включен",
    "session_timeout": "Тайм-аут сессии (минуты)",
    "telegram_parse_mode": "Режим разбора Telegram",
    "telegram_disable_notification": "Отключить уведомления Telegram",
    "telegram_protect_content": "Защитить контент Telegram",
    "whatsapp_template_namespace": "Пространство имен шаблона WhatsApp",
    "whatsapp_message_type": "Тип сообщения WhatsApp",
    "voice_greeting": "Голосовое приветствие",
    "voice_timeout": "Тайм-аут голоса (секунды)",
    "webhook_url": "URL Webhook",
    "webhook_secret": "Секрет Webhook",
    "webhook_events": "События Webhook",
    "rocketchat_hook_register_interval": "Интервал регистрации Webhook (секунды)",
    "rocketchat_integration_channel": "Канал интеграции",
    "consumer_api_enabled": "Consumer API включен",
    "consumer_api_agents_enabled": "Конечная точка агентов включена",
    "consumer_api_call_logs_enabled": "Конечная точка журнала звонков включена",
    "consumer_api_tools_enabled": "Конечная точка инструментов включена",
    "consumer_api_knowledge_bases_enabled": "Конечная точка баз знаний включена",
    "consumer_api_tool_calls_enabled": "Конечная точка вызовов инструментов включена",
    "consumer_api_dial_queue_enabled": "Очередь набора — загрузка через API",
    "outbound_dialer_active": "Активен",
    "simultaneous_outbound_calls": "Одновременные исходящие вызовы",
    "answer_timeout_seconds": "Таймаут ответа (секунды)",
    "call_attempts": "Попытки вызова",
    "call_retry_interval_seconds": "Интервал повтора (секунды)",
    "call_retry_interval_randomization_seconds": "Случайность интервала повтора (секунды)",
    "caller_id_number": "Номер вызывающего",
    "caller_id_name": "Имя вызывающего",
    "outbound_sip_proxy_host": "Хост исходящего SIP-прокси",
    "outbound_sip_proxy_port": "Порт исходящего SIP-прокси",
    "outbound_sip_proxy_transport": "Транспорт исходящего SIP-прокси",
    "outbound_sip_username": "Имя пользователя исходящего SIP",
    "outbound_sip_password": "Пароль исходящего SIP",
    "consumer_api_calls_include_transcripts": "Звонки включают транскрипты",
    "consumer_api_rate_limit_window_seconds": "Окно лимита запросов (секунды)",
    "consumer_api_rate_limit_max_requests": "Макс. запросов за окно",
    "consumer_api_rate_limit_concurrent": "Макс. одновременных запросов",
    "consumer_api_unauth_rate_limit_window_seconds": "Окно лимита без аутентификации (секунды)",
    "consumer_api_unauth_rate_limit_max_requests": "Макс. запросов за окно без аутентификации"
  },
  "attributeGroups": {
    "attachments": "Вложения",
    "agent_collaboration": "Взаимодействие агентов",
    "stt_provider": "Конфигурация поставщика STT",
    "tts_provider": "Конфигурация поставщика TTS",
    "llm_provider": "Конфигурация поставщика LLM",
    "vertex_ai": "Системная учетная запись Vertex AI",
    "tts_advanced": "Дополнительные настройки TTS",
    "tts_google": "Настройки TTS Google",
    "tts_openai": "Настройки OpenAI",
    "core_agent": "Конфигурация основного агента",
    "tool_runner_health": "Мониторинг работоспособности Tool Runner",
    "virtual_interface": "Конфигурация виртуального интерфейса",
    "voice_analysis": "Анализ голоса",
    "speaker_barge_in": "Прерывание по голосу говорящего",
    "tool_processing": "UX обработки инструментов",
    "session_timeout": "Тайм-аут сеанса",
    "messaging_instructions": "Инструкции по обмену сообщениями",
    "admin_permissions": "Права администратора",
    "audio_streaming": "Потоковое аудио",
    "vad": "Обнаружение окончания речи (VAD)",
    "barge_in": "Прерывание TTS (Barge-in)",
    "rtp": "Конфигурация RTP",
    "utility_extensions": "Служебные расширения",
    "audio_enhancement": "Улучшение аудио (APM)",
    "smtp_provider": "Конфигурация SMTP-провайдера",
    "email_template": "Конфигурация шаблонов электронной почты",
    "chat_bridging": "Мост чата",
    "general": "Общая конфигурация",
    "session-timeout": "Тайм-аут сеанса",
    "bargein-config": "Прерывание TTS (Barge-in)",
    "tool-processing": "Обработка инструментов",
    "vertex-ai": "Google Vertex AI",
    "codec": "Транскодирование кодеков",
    "tool-runner": "Конфигурация Tool Runner",
    "smtp": "Конфигурация SMTP (E-mail)",
    "chat-bridging": "Мост чата",
    "audio-streaming": "Потоковое аудио",
    "vad-config": "Обнаружение окончания речи (VAD)",
    "rtp-config": "Конфигурация RTP",
    "utility-functions": "Служебные функции",
    "audio-enhancement": "Улучшение аудио",
    "telegram": "Настройки Telegram",
    "whatsapp": "Настройки WhatsApp",
    "voice": "Настройки голоса",
    "voice-analysis": "Анализ голоса",
    "webhook": "Конфигурация Webhook",
    "rocketchat": "Настройки RocketChat",
    "permissions": "Права по умолчанию",
    "consumer_api": "Consumer API",
    "kb_embedding": "Эмбеддинг базы знаний",
    "kb_image_llm": "LLM изображений базы знаний (Vision)",
    "outboundDialer": "Конфигурация исходящего обзвона",
    "execution_settings": "Настройки выполнения"
  },
  "tool_tester": {
    "title": "Тестер инструментов",
    "tool_runner": "Исполнитель инструментов",
    "tool": "Инструмент",
    "parameters": "Параметры",
    "timeout": "Тайм-аут",
    "populate": "Заполнить",
    "run_tool": "Выполнить инструмент",
    "running": "Выполнение...",
    "result": "Результат",
    "select_runner": "Выбрать исполнителя...",
    "select_tool": "Выбрать инструмент...",
    "select_runner_first": "Сначала выберите исполнителя",
    "parameters_placeholder": '{"key": "value"}',
    "parameters_help": "Введите параметры как JSON-объект",
    "help_title": "Как использовать",
    "help_text": "Проверьте выполнение инструмента без запуска полной сессии разговора.",
    "step1_title": "1. Выбрать исполнителя",
    "step1_desc": "Выберите онлайн-исполнитель инструментов.",
    "step2_title": "2. Выбрать инструмент",
    "step2_desc": "Выберите инструмент для тестирования.",
    "step3_title": "3. Установить параметры",
    "step3_desc": "Нажмите 'Заполнить' для примера параметров.",
    "step4_title": "4. Настроить тайм-аут",
    "step4_desc": "Установите тайм-аут (по умолчанию: 60 секунд).",
    "step5_title": "5. Выполнить тест",
    "step5_desc": "Нажмите 'Выполнить инструмент' для запуска."
  },
  "dashboard": {
    "title": "Панель управления",
    "time_series": "Аналитика временных рядов",
    "today": "Сегодня",
    "last_7_days": "Последние 7 дней",
    "last_30_days": "Последние 30 дней",
    "this_month": "Этот месяц",
    "last_month": "Прошлый месяц",
    "processed_calls": "Обработанные вызовы",
    "tools_run": "Выполненные инструменты",
    "total_call_time": "Общее время вызовов",
    "tool_processing_time": "Время обработки инструментов",
    "updated": "Обновлено",
    "tenant_scope": "Область арендатора",
    "current_tenant": "Текущий",
    "all_tenants": "Все",
    "system_health": "Здоровье системы",
    "no_infrastructure": "Инфраструктура не настроена.",
    "recent_tool_logs": "Последние выполнения инструментов",
    "no_recent_tool_logs": "Нет последних выполнений инструментов."
  },
  "agent": {
    "new": "Новый агент",
    "no_agents": "Агенты не найдены",
    "status": {
      "active": "Активен",
      "inactive": "Неактивен"
    }
  },
  "forms": {
    "tables": {
      "headers": {
        "attribute": "Атрибут",
        "value": "Значение",
        "level": "Уровень",
        "action": "Действие"
      }
    },
    "agents": {
      "tabs": {
        "details": "Детали",
        "configuration": "Конфигурация",
        "upstreamProviders": "Внешние провайдеры"
      },
      "labels": {
        "name": "Имя",
        "description": "Описание",
        "agentGroup": "Группа агентов"
      },
      "placeholders": {
        "noGroup": "Нет группы"
      },
      "errors": {
        "nameRequired": "Имя агента обязательно"
      },
      "loading": {
        "tools": "Загрузка инструментов...",
        "agents": "Загрузка агентов..."
      },
      "empty": {
        "noTools": "Нет доступных инструментов",
        "noDelegateAgents": "Другие агенты в этом тенанте отсутствуют"
      },
      "badge": {
        "builtin": "Встроенный"
      },
      "alerts": {
        "saveFirst": "Сначала сохраните агента для настройки внешних поставщиков."
      },
      "otherConfiguration": "Другая конфигурация"
    },
    "auth": {
      "login": { "title": "Вход по паролю" }
    },
    "outboundDialers": {
      "name": "Имя",
      "originatingMediaServer": "Исходящий медиасервер",
      "virtualInterface": "Виртуальный интерфейс",
      "activitySchedule": "Расписание активности",
      "activitySchedule.enabled": "Активно",
      "activitySchedule.start": "Открытие",
      "activitySchedule.end": "Закрытие",
      "activitySchedule.day": "День",
      "activitySchedule.invalidRange": "Начало должно быть раньше окончания",
      "timezone": "Часовой пояс",
      "anyCloudMediaServer": "Любой доступный облачный медиасервер",
      "weekday": {
        "sun": "Вс",
        "mon": "Пн",
        "tue": "Вт",
        "wed": "Ср",
        "thu": "Чт",
        "fri": "Пт",
        "sat": "Сб"
      }
    }
  },
  "infrastructure": {
    ...enCommon.infrastructure,
    "media_servers": "Медиасерверы",
    "tool_runners": "Исполнители инструментов",
    "new_server": "Новый сервер",
    "new_runner": "Новый исполнитель",
    "new_media_server": "Новый медиасервер",
    "new_tool_runner": "Новый исполнитель инструментов",
    "edit_media_server": "Редактировать медиасервер",
    "edit_tool_runner": "Редактировать исполнитель инструментов",
    "api_key": "API-ключ",
    "type": "Тип",
    "last_seen": "Последний вход",
    "never": "Никогда",
    "on_prem": "On-Prem",
    "cloud": "Облако",
    "copy_api_key": "Копировать API-ключ",
    "api_key_copied": "API-ключ скопирован в буфер обмена",
    "api_key_copy_failed": "Не удалось скопировать API-ключ",
    "no_media_servers": "Медиасерверы не найдены",
    "no_tool_runners": "Исполнители инструментов не найдены",
    "connection_config": "Конфигурация подключения",
    "deployment_type": "Тип развертывания",
    "on_premises_deployment": "Развертывание On-Premises",
    "on_prem_help": "Отметьте, если сервер будет развернут в вашей инфраструктуре.",
    "runner_on_prem_help": "Отметьте, если исполнитель инструментов будет развернут в вашей инфраструктуре.",
    "create_server": "Создать сервер",
    "create_runner": "Создать исполнителя",
    "creating": "Создание...",
    "saving": "Сохранение...",
    "save_changes": "Сохранить изменения",
    "details": "Детали",
    "configuration": "Конфигурация",
    "regenerate_key": "Перегенерировать ключ",
    "regenerating": "Перегенерация...",
    "regenerate_warning": "Перегенерация API-ключа немедленно сделает старый ключ недействительным.",
    "regenerate_confirm": "Вы уверены, что хотите перегенерировать API-ключ? Старый ключ перестанет работать немедленно.",
    "key_regenerated": "API-ключ успешно перегенерирован",
    "key_regenerate_failed": "Не удалось перегенерировать API-ключ",
    "server_created_title": "Медиасервер создан",
    "runner_created_title": "Исполнитель инструментов создан",
    "success": "Успешно!",
    "server_created_desc": "Медиасервер создан. Пожалуйста, сохраните API-ключ ниже - он больше не будет показан.",
    "runner_created_desc": "Исполнитель инструментов создан. Пожалуйста, сохраните API-ключ ниже - он больше не будет показан.",
    "server_id": "ID сервера",
    "runner_id": "ID исполнителя",
    "key_shown_once": "Этот API-ключ будет показан только один раз. Пожалуйста, сохраните его в безопасном месте.",
    "config_title": "Конфигурация",
    "config_env_vars": "Настройте ваш сервер с помощью следующих переменных окружения:",
    "runner_config_env_vars": "Настройте ваш исполнитель инструментов с помощью следующих переменных окружения:",
    "done": "Готово",
    "auth_required": "Требуется аутентификация. Пожалуйста, войдите снова.",
    "save_first_attributes": "Сначала сохраните медиасервер, чтобы настроить атрибуты.",
    "load_failed_media_server": "Не удалось загрузить медиасервер",
    "create_failed_media_server": "Не удалось создать медиасервер",
    "update_failed_media_server": "Не удалось обновить медиасервер",
    "load_failed_tool_runner": "Не удалось загрузить исполнитель инструментов",
    "create_failed_tool_runner": "Не удалось создать исполнитель инструментов",
    "update_failed_tool_runner": "Не удалось обновить исполнитель инструментов",
    "delete_failed_media_server": "Не удалось удалить медиасервер",
    "delete_failed_tool_runner": "Не удалось удалить исполнитель инструментов",
    "delete_failed_runner": "Не удалось удалить исполнителя",
    "delete_runner_confirm": "Вы уверены, что хотите удалить исполнителя \"{{name}}\"?",
    "server_deleted": "Медиасервер успешно удален",
    "runner_deleted": "Исполнитель инструментов успешно удален",
    "no_name": "Без имени",
    "health_check_url": "URL проверки работоспособности",
    "websocket_url": "WebSocket URL",
    "actions": "Действия",
    "edit": "Редактировать",
    "delete": "Удалить",
    "confirm_delete_server": "Вы уверены, что хотите удалить медиасервер?",
    "confirm_delete_runner": "Вы уверены, что хотите удалить исполнитель инструментов?",
    "delete_server": "Удалить сервер",
    "delete_runner": "Удалить исполнителя",
    "server_name": "Имя сервера",
    "runner_name": "Имя исполнителя",
    "server_url": "URL сервера",
    "runner_url": "URL исполнителя",
    "status": "Статус",
    "online": "В сети",
    "offline": "Не в сети",
    "version": "Версия",
    "active_calls": "Активные вызовы",
    "cpu_usage": "Использование CPU",
    "memory_usage": "Использование памяти",
    "uptime": "Время работы",
    "last_heartbeat": "Последний heartbeat",
    "no_data": "Нет данных",
    "refresh": "Обновить",
    "auto_refresh": "Автообновление",
    "auto_refresh_enabled": "Автообновление включено",
    "auto_refresh_disabled": "Автообновление отключено",
    "refresh_interval": "Интервал обновления",
    "seconds": "секунд",
    "minutes": "минут",
    "hours": "часов",
    "days": "дней",
    "media_server_connect": "Медиасерверы подключаются к AI Orchestrator с помощью API-ключа, показанного выше. Настройте URL подключения на медиасервере через",
    "tool_runner_connect": "Исполнители инструментов подключаются к AI Orchestrator с помощью API-ключа, показанного выше. Настройте URL подключения на исполнителе инструментов через",
    "env_var": "переменная окружения.",
    "media_server_env_help": "Медиасервер подключится к AI Orchestrator с помощью переменных окружения. API-ключ будет создан и показан после создания.",
    "runner_env_help": "Исполнитель инструментов подключится к AI Orchestrator с помощью переменных окружения. API-ключ будет создан и показан после создания.",
    "example": "Пример",
    "copy": "Копировать"
  },
  "toolRunner": {
    ...enCommon.toolRunner,
    "title": "Исполнители инструментов",
    "new": "Новый исполнитель инструментов",
    "edit": "Редактировать исполнитель инструментов",
    "edit_title": "Редактировать исполнитель инструментов",
    "basic_info": "Основная информация",
    "api_key": "API-ключ",
    "copy": "Копировать",
    "copy_success": "API-ключ скопирован в буфер обмена",
    "copy_failed": "Не удалось скопировать API-ключ",
    "regenerate_key": "Перегенерировать ключ",
    "regenerating": "Перегенерация...",
    "regenerate_warning": "Перегенерация API-ключа немедленно сделает старый ключ недействительным.",
    "regenerate_confirm": "Вы уверены, что хотите перегенерировать API-ключ? Старый ключ перестанет работать немедленно.",
    "key_regenerated": "API-ключ успешно перегенерирован",
    "key_regenerate_failed": "Не удалось перегенерировать API-ключ",
    "api_key_copied": "API-ключ скопирован в буфер обмена",
    "api_key_copy_failed": "Не удалось скопировать API-ключ",
    "status_online": "В сети",
    "status_offline": "Не в сети",
    "status_pending": "В ожидании",
    "status_error": "Ошибка",
    "status_readonly": "Статус автоматически обновляется в зависимости от подключения исполнителя",
    "acceptConnections": "Принимать подключения",
    "acceptConnections_help": "Разрешить этому исполнителю принимать новые подключения для выполнения инструментов",
    "deployment_type": "Тип развертывания",
    "on_premises": "Развертывание On-Premises",
    "save_changes": "Сохранить изменения",
    "saving": "Сохранение...",
    "cancel": "Отмена",
    "tools_panel_title": "Доступные инструменты в этом исполнителе",
    "no_tools": "Нет инструментов в этом исполнителе",
    "load_failed": "Не удалось загрузить исполнитель инструментов",
    "create_failed": "Не удалось создать исполнитель инструментов",
    "update_failed": "Не удалось обновить исполнитель инструментов",
    "delete_failed": "Не удалось удалить исполнитель инструментов",
    "runner_deleted": "Исполнитель инструментов успешно удален",
    "confirm_delete": "Вы уверены, что хотите удалить исполнитель инструментов?",
    "delete": "Удалить",
    "back_to_runners": "Вернуться к исполнителям инструментов",
    "associated_tools": "Связанные инструменты",
    "runner_tools": "Инструменты исполнителя",
    "available_tools": "Доступные инструменты",
    "items_count": "{{count}} элементов",
    "built_in": "Встроенный",
    "no_available_tools": "Все инструменты связаны",
    "no_associated_tools": "Нет связанных инструментов",
    "add_selected": "Добавить выбранные инструменты",
    "remove_selected": "Удалить выбранные инструменты",
    "selection_hint": "Удерживайте Ctrl/Cmd для выбора нескольких элементов",
    "tools_updated": "Связи инструментов успешно обновлены",
    "error_load_tools": "Не удалось загрузить инструменты",
    "error_save_tools": "Не удалось сохранить связи инструментов"
  },
  "virtual_interface": {
    ...enCommon.virtual_interface,
    "title": "Виртуальные интерфейсы",
    "new": "Новый виртуальный интерфейс",
    "edit": "Редактировать виртуальный интерфейс",
    "info_text": "Виртуальные интерфейсы подключают внешние каналы (Telegram, WhatsApp, RocketChat, Voice) к вашим агентам. Каждый интерфейс определяет критерии соответствия для маршрутизации входящих сообщений к правильному агенту.",
    "technology": "Технология",
    "voice_sip": "Voice (SIP)",
    "active": "Активен",
    "inactive": "Неактивен",
    "match_criteria": "Критерии соответствия",
    "information": "Информация",
    "save_first_attributes": "Сначала сохраните медиасервер, чтобы настроить атрибуты.",
    "waba_required": "WABA ID требуется для интерфейсов WhatsApp.",
    "workspace_url_required": "URL рабочего пространства требуется для RocketChat",
    "bot_username_required": "Имя пользователя бота требуется для RocketChat",
    "bot_password_required": "Пароль бота требуется для RocketChat",
    "invalid_rocketchat_config": "Неверная конфигурация RocketChat",
    "step1_basic": "Шаг 1: Основная информация",
    "step2_config": "Шаг 2: Конфигурация",
    "configure_tech": "Настройте параметры интеграции для {{technology}}.",
    "match_criteria_desc": "Определите, как входящие сообщения сопоставляются с этим интерфейсом.",
    "step3_agent": "Шаг 3: Назначение агента",
    "select_agent": "Выберите агента...",
    "no_agents_available": "Нет доступных агентов. Пожалуйста, сначала создайте агента.",
    "save_changes": "Сохранить изменения",
    "saving": "Сохранение...",
    "details": "Детали",
    "configuration": "Конфигурация",
    "progress": "Прогресс",
    "basic_information": "Основная информация",
    "agent_assignment": "Назначение агента",
    "configuration_attributes": "Атрибуты конфигурации",
    "review_create": "Проверить и создать",
    "review": "Проверить",
    "configured": "Настроено",
    "edit_desc": "Измените конфигурацию виртуального интерфейса. Изменения будут автоматически синхронизированы с Channel Gateways.",
    "telegram_chat_id": "ID чата Telegram",
    "whatsapp_phone": "Номер телефона WhatsApp",
    "caller_id": "ID звонящего",
    "did_number": "Номер DID",
    "multi_value_help": "Нажмите Enter, запятую или Tab, чтобы добавить каждое значение. Нажмите на значение для редактирования.",
    "telegram_chat_id_help": "Если задано, только чаты из этого списка могут взаимодействовать с этим интерфейсом; оставьте поле пустым, чтобы разрешить всем.",
    "whatsapp_caller_id_help": "Если задано, только эти номера телефонов могут взаимодействовать с этим интерфейсом; оставьте поле пустым, чтобы разрешить всем. Номера можно вводить как с плюсом в начале, так и без него.",
    "multi_value_remove": "Удалить",
    "sip_domain": "SIP-домен",
    "webchat_info": "Интерфейсы Webchat автоматически сопоставляются по ID сессии.",
    "rocketchat_info": "Интерфейсы RocketChat автоматически сопоставляются по пути webhook. Никаких ручных критериев соответствия не требуется.",
    "agent_select": "Выберите агента...",
    "agent_label": "Агент",
    "status_label": "Статус",
    "hook_parameters": "Параметры Hook (JSON)",
    "rocketchat_config": "Конфигурация RocketChat",
    "workspace_url": "URL рабочего пространства",
    "workspace_url_label": "URL рабочего пространства",
    "workspace_url_help": "URL вашего рабочего пространства RocketChat",
    "bot_username": "Имя пользователя бота",
    "bot_username_label": "Имя пользователя бота",
    "bot_password": "Пароль бота",
    "bot_password_label": "Пароль бота",
    "bot_password_help": "Пароль для учетной записи бота",
    "webhook_url": "URL Webhook",
    "last_incoming_request": "Последний входящий запрос",
    "last_outbound_call": "Последний исходящий вызов",
    "last_webhook_register": "Последняя регистрация Webhook",
    "error_details": "Детали ошибки",
    "warning_change_tech": "Изменение технологии сбросит критерии соответствия.",
    "never": "Никогда",
    "success": "Успех",
    "fail": "Неудача",
    "whatsapp_phone_number_id": "Phone Number ID",
    "whatsapp_phone_number_id_help": "The Phone Number ID from your WhatsApp registration service onboarding.",
    "whatsapp_registration_section": "WhatsApp Registration",
    "display_phone_number": "Display Phone Number",
    "registration_id": "Registration ID",
    "last_refreshed": "Last refreshed",
    "refresh_registration": "Refresh Registration",
    "refreshing_registration": "Refreshing...",
    "registration_refreshed": "Registration refreshed",
    "registration_refresh_failed": "Registration refresh failed",
    "whatsapp_phone_number": "WhatsApp Number",
    "whatsapp_number_help": "Choose a number onboarded in the WhatsApp registration service for this tenant.",
    "select_whatsapp_number": "Select a number...",
    "loading_numbers": "Loading numbers...",
    "whatsapp_numbers_load_failed": "Failed to load WhatsApp numbers.",
    "no_whatsapp_numbers": "No WhatsApp numbers are available for this tenant. Onboard numbers in the WhatsApp registration service first.",
    "in_use": "in use",
    "number_in_use_warning": "This number is already connected to another interface. Connecting it here will move it to this interface; the other interface will stop receiving messages for this number.",
    "change_number": "Change Number",
    "change_number_title": "Change WhatsApp Number",
    "changing_number": "Changing...",
    "change_number_failed": "Failed to change the number.",
    "change_number_success": "Number changed.",
    "not_registered_hint": "This number is not registered yet. Click Refresh Registration to register it."
  },
  "virtual_interface_create": {
    "step4_title": "Шаг 4: Атрибуты конфигурации",
    "step4_desc": "Настройте дополнительные параметры для этого виртуального интерфейса. Эти параметры могут быть изменены позже.",
    "step4_info": "Атрибуты будут сохранены после создания виртуального интерфейса.",
    "step5_title": "Шаг 5: Проверить и создать",
    "review_label": "Проверить",
    "review_name": "Имя",
    "review_technology": "Технология",
    "review_agent": "Агент",
    "review_attributes": "Атрибуты",
    "review_attributes_configured": "{{count}} настроено",
    "creating": "Создание...",
    "create_interface": "Создать интерфейс",
    "webhook_failed_title": "Регистрация Webhook не удалась",
    "webhook_failed_desc": "Регистрация WhatsApp Webhook Override в Meta не удалась. Виртуальный интерфейс не был создан.",
    "error_details_card": "Детали ошибки",
    "error_endpoint": "Конечная точка",
    "error_response_status": "Статус ответа",
    "error_response_body": "Тело ответа",
    "close": "Закрыть",
    "telegram_bot_token": "Токен бота Telegram",
    "telegram_bot_token_help": "Получено от @BotFather в Telegram. Формат: 123456789:ABCdef...",
    "whatsapp_api_token": "Токен API WhatsApp",
    "whatsapp_phone_number_id": "ID номера телефона",
    "whatsapp_waba_id": "WABA ID",
    "whatsapp_waba_id_help": "Ваш ID учетной записи WhatsApp Business из настроек Meta Business.",
    "rocketchat_workspace_url_help": "URL вашего рабочего пространства RocketChat (например, https://mycompany.rocket.chat)",
    "rocketchat_bot_username_help": "Имя пользователя учетной записи бота, созданной в RocketChat",
    "rocketchat_bot_password_help": "Пароль для учетной записи бота. Webhook будет автоматически зарегистрирован при создании.",
    "rocketchat_info_create": "Интеграция webhook будет автоматически зарегистрирована с вашим рабочим пространством RocketChat при создании этого интерфейса. Бот будет отвечать на @упоминания в каналах и личных сообщениях.",
    "match_chat_id_optional": "ID чата Telegram (необязательно)",
    "match_chat_id_help": "Оставьте пустым для сопоставления всех чатов. Используйте для частных групп/каналов. Получено от @userinfobot.",
    "match_whatsapp_help": "Номер телефона WhatsApp для сопоставления (с кодом страны).",
    "match_caller_id_optional": "ID звонящего (необязательно)",
    "match_did_optional": "Номер DID (необязательно)",
    "match_sip_optional": "SIP-домен (необязательно)"
  },
  "session": {
    ...enCommon.session,
    "timeouts_title": "Тайм-ауты сессии",
    "timeouts_desc": "Настройте поведение тайм-аутов сессии для голосовых и текстовых каналов",
    "attribute": "Атрибут",
    "value": "Значение",
    "level": "Уровень",
    "action": "Действие",
    "idle_timeout_voice": "Тайм-аут бездействия (Голос)",
    "idle_timeout_voice_desc": "Время бездействия до завершения голосовой сессии",
    "idle_timeout_text": "Тайм-аут бездействия (Текст)",
    "idle_timeout_text_desc": "Время бездействия до завершения текстовой сессии",
    "absolute_timeout_voice": "Абсолютный тайм-аут (Голос)",
    "absolute_timeout_voice_desc": "Максимальная продолжительность голосовой сессии",
    "absolute_timeout_text": "Абсолютный тайм-аут (Текст)",
    "absolute_timeout_text_desc": "Максимальная продолжительность текстовой сессии (0 = бесконечно)",
    "seconds": "секунд",
    "minutes": "минут",
    "timeout_behavior": "Поведение тайм-аутов",
    "idle_timeout": "Тайм-аут бездействия",
    "idle_timeout_explanation": "Сессия завершается, если пользователь неактивен в течение указанного времени.",
    "absolute_timeout": "Абсолютный тайм-аут",
    "absolute_timeout_explanation": "Сессия завершается после максимальной продолжительности независимо от активности.",
    "channel_types": "Типы каналов",
    "channel_types_explanation": "Голосовые каналы (SIP, WebRTC) используют голосовые тайм-ауты. Текстовые каналы (Telegram, WhatsApp, Webchat) используют текстовые тайм-ауты.",
    "30_minutes": "30 минут",
    "1_hour": "1 час",
    "2_hours": "2 часа",
    "3_hours": "3 часа",
    "4_hours": "4 часа",
    "5_hours": "5 часов",
    "6_hours": "6 часов",
    "12_hours": "12 часов",
    "18_hours": "18 часов",
    "24_hours": "24 часа",
    "36_hours": "36 часов",
    "48_hours": "48 часов",
    "72_hours": "72 часа",
    "infinite_no_timeout": "Бесконечно (без тайм-аута)",
    "96_hours_4_days": "96 часов (4 дня)",
    "168_hours_7_days": "168 часов (7 дней)"
  },
  "system_attributes": {
    ...enCommon.system_attributes,
    "loading": "Загрузка системных атрибутов...",
    "fetch_failed": "Не удалось получить системные атрибуты",
    "save_failed": "Не удалось сохранить системные атрибуты",
    "chat_agent_title": "Настройки по умолчанию для чат-агента",
    "chat_agent_desc": "Конфигурация чат-агента по умолчанию для системы",
    "tool_runner_title": "Конфигурация исполнителя инструментов",
    "tool_runner_desc": "Глобальные настройки подключения исполнителя инструментов",
    "vertex_ai_title": "Конфигурация Google Vertex AI",
    "vertex_ai_desc": "Учетные данные сервисной учетной записи для Vertex AI (LLM и TTS)",
    "system_prompt": "Системный запрос",
    "barge_in_enabled": "Прерывание включено",
    "ping_interval": "Интервал ping (секунды)",
    "absence_timeout": "Тайм-аут отсутствия (секунды)",
    "project_id": "ID проекта",
    "location": "Расположение",
    "sa_json": "JSON сервисной учетной записи",
    "paste_sa_json": "Вставьте JSON сервисной учетной записи здесь"
  },
  "knowledgeBases": {
    ...enCommon.knowledgeBases,
    "title": "Базы знаний"
  },
  "vocabulary": {
    "title": "Книги словаря",
    "add_book": "Добавить книгу словаря",
    "create": "Создать",
    "items": "Элементы",
    "phrase": "Фраза",
    "created": "Создано",
    "updated": "Обновлено",
    "empty": "Книг словаря пока нет",
    "delete_book_confirm": "Удалить эту книгу словаря? Все фразы будут удалены.",
    "search_placeholder": "Поиск фраз...",
    "new_phrase": "Новая фраза...",
    "add_phrase": "Добавить",
    "import": "Импорт",
    "export": "Экспорт CSV",
    "import_result": "Добавлено: {added}, дубликатов: {duplicates}, пропущено: {dropped}",
    "delete_selected": "Удалить выбранные",
    "delete_selected_confirm": "Удалить выбранные фразы?",
    "load_failed": "Не удалось загрузить",
    "save_failed": "Не удалось сохранить",
    "no_book": "(нет)"
  }
};

const arCommon = {
  ...enCommon,
  "navigation": {
    ...enCommon.navigation,
    "infrastructure": "البنية التحتية",
    "configuration": "الإعدادات",
    "analytics": "التحليلات",
    "administration": "الإدارة",
    "logs": "السجلات",
    "media_servers": "خوادم الوسائط",
    "tool_runners": "مشغلات الأدوات",
    "virtual_interfaces": "الواجهات الافتراضية",
    "tools_list": "قائمة الأدوات",
    "webhook_tester": "مختبر Webhook",
    "agents": "الوكلاء",
    "tools": "الأدوات",
    "knowledgeBases": "قواعد المعرفة",
    "vocabulary": "المفردات",
    "groups": "المجموعات",
    "agent_groups": "مجموعات الوكلاء",
    "tool_groups": "مجموعات الأدوات",
    "channel_groups": "مجموعات القنوات",
    "user_groups": "مجموعات المستخدمين",
    "tool_tester": "مختبر الأدوات",
    "dashboard": "لوحة التحكم",
    "call_logs": "سجلات المكالمات",
    "tool_logs": "سجلات الأدوات",
    "tenants": "المستأجرين",
    "audit_logs": "سجلات التدقيق",
    "administrators": "المدراء",
    "settings": "الإعدادات",
    "email_templates": "قوالب البريد الإلكتروني",
    "upstreamProviders": "مقدمو الخدمات الخارجية",
    "outboundDialers": "الاتصال الصادر"
  },
  "groups": {
    "new_group": "مجموعة جديدة",
    "delete_failed": "فشل حذف المجموعة",
    "confirm_delete": "هل أنت متأكد أنك تريد حذف هذه المجموعة؟",
    "agent": {
      "title": "مجموعات الوكلاء",
      "create_title": "إنشاء مجموعة وكلاء جديدة",
      "edit_title": "تعديل مجموعة الوكلاء",
      "empty": "لم يتم العثور على مجموعات وكلاء",
      "load_failed": "فشل تحميل مجموعات الوكلاء",
      "create_failed": "فشل إنشاء مجموعة الوكلاء",
      "update_failed": "فشل تحديث مجموعة الوكلاء",
      "manage": "إدارة الوكلاء"
    },
    "tool": {
      "title": "مجموعات الأدوات",
      "create_title": "إنشاء مجموعة أدوات جديدة",
      "edit_title": "تعديل مجموعة الأدوات",
      "empty": "لم يتم العثور على مجموعات أدوات",
      "load_failed": "فشل تحميل مجموعات الأدوات",
      "create_failed": "فشل إنشاء مجموعة الأدوات",
      "update_failed": "فشل تحديث مجموعة الأدوات",
      "manage": "إدارة الأدوات",
      "tab_details": "التفاصيل",
      "tab_attributes": "الخصائص"
    },
    "channel": {
      "title": "مجموعات القنوات",
      "create_title": "إنشاء مجموعة قنوات جديدة",
      "edit_title": "تعديل مجموعة القنوات",
      "empty": "لم يتم العثور على مجموعات قنوات",
      "load_failed": "فشل تحميل مجموعات القنوات",
      "create_failed": "فشل إنشاء مجموعة القنوات",
      "update_failed": "فشل تحديث مجموعة القنوات",
      "type_label": "نوع القناة",
      "channel_type_voice": "صوت",
      "channel_type_chat": "دردشة",
      "channel_type_email": "بريد إلكتروني",
      "channel_type_sms": "رسالة نصية"
    },
    "user": {
      "title": "مجموعات المستخدمين",
      "create_title": "إنشاء مجموعة مستخدمين جديدة",
      "edit_title": "تعديل مجموعة المستخدمين",
      "empty": "لم يتم العثور على مجموعات مستخدمين",
      "load_failed": "فشل تحميل مجموعات المستخدمين",
      "create_failed": "فشل إنشاء مجموعة المستخدمين",
      "update_failed": "فشل تحديث مجموعة المستخدمين"
    },
    "delete_group_confirm": "هل أنت متأكد أنك تريد حذف هذه المجموعة؟",
    "delete_type_confirm": "هل أنت متأكد أنك تريد حذف مجموعة {{type}}؟",
    "delete_type_failed": "فشل حذف مجموعة {{type}}",
    "modal": {
      "manage_title": "إدارة {{itemType}} - {{name}}",
      "available_items": "{{itemType}} المتاحة",
      "group_members": "أعضاء المجموعة",
      "no_available": "لا توجد {{itemType}} متاحة",
      "no_members": "لا توجد {{itemType}} في هذه المجموعة",
      "count_available": "{{count}} متاحة",
      "count_members": "{{count}} أعضاء",
      "add_selected": "إضافة المحددة",
      "add_all": "إضافة الكل",
      "remove_selected": "إزالة المحددة",
      "remove_all": "إزالة الكل",
      "load_failed": "فشل تحميل {{itemType}}",
      "add_failed": "فشل إضافة {{itemType}}",
      "remove_failed": "فشل إزالة {{itemType}}",
      "enabled": "مفعل",
      "disabled": "معطل",
      "close": "إغلاق"
    }
  },
  "auth": {
    "sign_in": "تسجيل الدخول",
    "sign_out": "تسجيل الخروج",
    "username": "اسم المستخدم",
    "password": "كلمة المرور",
    "totp_code": "رمز TOTP",
    "otp_code": "رمز OTP",
    "verify": "تحقق",
    "send_otp": "إرسال OTP",
    "back_to_password": "العودة لتسجيل الدخول بكلمة المرور",
    "use_otp_instead": "استخدام OTP بدلاً من ذلك",
    "two_factor_auth": "المصادقة الثنائية",
    "otp_login": "تسجيل الدخول بـ OTP",
    "enter_totp": "أدخل الرمز المكون من 6 أرقام من تطبيق المصادقة.",
    "enter_otp": "أدخل الرمز المكون من 6 أرقام المرسل إلى بريدك الإلكتروني."
  },
  "common": {
    ...enCommon.common,
    "create": "إنشاء",
    "edit": "تعديل",
    "configure": "تكوين",
    "delete": "حذف",
    "save": "حفظ",
    "cancel": "إلغاء",
    "loading": "جار التحميل...",
    "search": "بحث",
    "filter": "تصفية",
    "actions": "إجراءات",
    "export": "تصدير",
    "name": "الاسم",
    "description": "الوصف",
    "status": "الحالة",
    "created_at": "تاريخ الإنشاء",
    "updated_at": "تاريخ التحديث",
    "reset": "إعادة تعيين",
    "update": "تحديث",
    "select_tenant": "يرجى اختيار مستأجر للمتابعة",
    "seconds": "ثوان",
    "saving": "جار الحفظ...",
    "deleting": "جار الحذف...",
    "dismiss": "إغلاق",
    "view": "عرض",
    "active": "نشط",
    "inactive": "غير نشط",
    "suspended": "معلق",
    "deleted": "محذوف",
    "refresh": "تحديث",
    "creating_in_tenant": "جار الإنشاء في المستأجر",
    "no_tenant_selected_warning": "لم يتم اختيار مستأجر. يرجى اختيار مستأجر من القائمة المنسدلة في الأعلى.",
    "online": "متصل",
    "offline": "غير متصل",
    "degraded": "متدهور",
    "no_group": "بدون مجموعة",
    "time": "الوقت",
    "tool": "الأداة",
    "tools": "الأدوات",
    "agent": "الوكيل",
    "agents": "الوكلاء",
    "no_description": "بدون وصف",
    "group": "المجموعة",
    "confirm_delete": "هل أنت متأكد أنك تريد حذف هذا العنصر؟",
    "delete_failed": "فشل الحذف",
    "agent_delete_blocked": "لا يمكن الحذف: {{count}} واجهة(ات) افتراضية لا تزال تستخدم هذا الوكيل. احذفها أو أعد تعيينها أولاً.",
    "load_failed": "فشل التحميل",
    "create_failed": "فشل الإنشاء",
    "update_failed": "فشل التحديث",
    "view_all": "عرض الكل",
    "view_infrastructure": "عرض البنية التحتية",
    "modified": "معدل",
    "next": "التالي",
    "previous": "السابق",
    "back": "رجوع",
    "items": "عناصر",
    "none": "لا شيء",
    "enabled": "مفعل",
    "disabled": "معطل",
    "close": "إغلاق",
    "save_failed": "فشل الحفظ"
  },
  "call_logs": {
    "title": "سجلات المكالمات",
    "filters": "التصفية",
    "from_date": "من تاريخ",
    "to_date": "إلى تاريخ",
    "status": "الحالة",
    "agent": "الوكيل",
    "gender": "الجنس",
    "all_statuses": "جميع الحالات",
    "started": "بدأت",
    "phone": "الهاتف",
    "channel": "القناة",
    "duration": "المدة",
    "medium": "الوسيط",
    "no_logs": "لم يتم العثور على سجلات مكالمات",
    "previous": "السابق",
    "next": "التالي",
    "message": "رسالة",
    "search_messages": "البحث في الرسائل...",
    "conversation": "المحادثة",
    "view_conversation": "عرض المحادثة",
    "system_prompt": "تعليمات النظام",
    "tool_result": "نتيجة الأداة",
    "no_messages": "لا توجد رسائل محادثة",
    "subagent_activity": "نشاط الوكلاء الفرعيين",
    "subagent_badge": "وكيل فرعي",
    "subagent_count_title": "استشارات الوكلاء الفرعيين",
    "direction": {
      "inbound": "وارد",
      "outbound": "صادر",
      "internal": "داخلي",
      "all": "الكل"
    },
    "attachments": {
      "title": "المرفقات",
      "expired": "انتهت صلاحية المرفق",
      "download_failed": "فشل التنزيل",
      "kind": {
        "photo": "صورة",
        "video": "فيديو",
        "voice": "رسالة صوتية",
        "audio": "صوت",
        "document": "مستند"
      }
    }
  },
  "tool_logs": {
    "input": "الإدخال",
    "csv_input": "الإدخال",
  },
  "outboundDialers": {
    "pause": "إيقاف مؤقت",
    "play": "تشغيل",
    "configure": "تكوين",
    "load_error": "فشل تحميل أجهزة الاتصال الصادرة",
    "status": {
      "pending": "قيد الانتظار",
      "dialing": "جارٍ الاتصال",
      "answered": "تم الرد",
      "completed": "مكتمل",
      "no_answer": "لا رد",
      "busy": "مشغول",
      "failed": "فشل",
      "invalid_number": "رقم غير صالح",
      "retry_scheduled": "إعادة المحاولة مجدولة",
      "paused": "متوقف مؤقتًا",
      "playing": "قيد التشغيل"
    },
    "queue": {
      "title": "قائمة الانتظار",
      "empty": "قائمة الانتظار فارغة",
      "showing": "عرض {{start}}-{{end}} من {{total}}",
      "number": "الرقم",
      "name": "الاسم",
      "status": "الحالة",
      "context": "السياق",
      "actions": "الإجراءات"
    },
    "upload": {
      "title": "رفع ملف",
      "chooseFile": "اختر ملفًا (.csv أو .json)",
      "upload": "رفع",
      "sampleCsv": "تنزيل نموذج CSV",
      "sampleJson": "تنزيل نموذج JSON",
      "valid": "صالح",
      "summary": "{{valid}} صالح، {{invalid}} غير صالح",
      "added": "تمت الإضافة: {{added}}، تم التخطي: {{skipped}}",
      "approve": "اعتماد",
      "cancel": "إلغاء"
    },
    "list": {
      "empty": "لا توجد أجهزة اتصال صادرة"
    }
  },
  "recent_calls": {
    "title": "المكالمات الأخيرة",
    "time": "الوقت",
    "type": "النوع",
    "duration": "المدة",
    "agent": "الوكيل",
    "status": "الحالة",
    "no_recent_calls": "لا توجد مكالمات أخيرة.",
    "view_all": "عرض الكل",
    "just_now": "الآن",
    "minutes_ago": "منذ {{minutes}} دقائق",
    "hours_ago": "منذ {{hours}} ساعات",
    "seconds": "ثوان",
    "minutes": "دقائق"
  },
  "voice_analysis": {
    "summary_label": "تحليل الصوت",
    "male": "ذكر",
    "female": "أنثى",
    "angry": "غاضب",
    "happy": "سعيد",
    "sad": "حزين",
    "neutral": "محايد",
    "low": "منخفض",
    "normal": "عادي",
    "high": "مرتفع",
    "gender": "الجنس",
    "mood": "المزاج",
    "energy": "الطاقة",
    "carried": "منقول من كشف سابق"
  },
  "upstreamProviders": {
    "title": "مقدمو الخدمات الخارجية",
    "forbiddenDescription": "يمكن للمديرين العامين فقط إدارة مقدمي الخدمات الخارجية.",
    "tabs": {
      "stt": "التحويل من كلام إلى نص",
      "tts": "التحويل من نص إلى كلام",
      "llm": "نموذج لغوي كبير"
    },
    "addStt": "إضافة مقدم STT",
    "addTts": "إضافة مقدم TTS",
    "addLlm": "إضافة نموذج LLM",
    "createStt": "مقدم STT جديد",
    "createTts": "مقدم TTS جديد",
    "createLlm": "نموذج LLM جديد",
    "editStt": "تعديل مقدم STT",
    "editTts": "تعديل مقدم TTS",
    "editLlm": "تعديل نموذج LLM",
    "name": "الاسم",
    "providerColumn": "المقدم",
    "model": "النموذج",
    "actions": "إجراءات",
    "searchPlaceholder": "البحث بالاسم…",
    "noStt": "لا توجد مقدمي STT مكوّنين.",
    "noTts": "لا توجد مقدمي TTS مكوّنين.",
    "noLlm": "لا توجد نماذج LLM مكوّنة.",
    "deleteConfirm": "حذف هذا المقدم؟",
    "deleteBlocked": "لا يمكن الحذف: هذا المقدم مستخدم من قبل {{count}} وكيل(اء).",
    "failedToLoad": "فشل تحميل المقدمين.",
    "failedToSave": "فشل حفظ المقدم.",
    "failedToDelete": "فشل حذف المقدم.",
    "manageProviders": "إدارة المقدمين",
    "selectStt": "مقدم STT",
    "selectTts": "مقدم TTS",
    "selectLlm": "نموذج LLM",
    "createStep1Hint": "بعد إنشاء المقدم، ستقوم بتكوين إعداداته.",
    "stt_ignored_badge": "STT ignored",
    "stt_ignored_hint": "OpenAI Realtime Speech-to-Speech is active for this agent. The selected STT provider is ignored — OpenAI Realtime handles speech-to-text using the TTS API key.",
    "provider": {
      "soniox": "Soniox",
      "faster_whisper": "Faster Whisper",
      "google": "Google",
      "google_vertex_ai": "Google Vertex AI",
      "elevenlabs": "ElevenLabs",
      "openai": "OpenAI",
      "anthropic": "Anthropic",
      "azure_openai": "Azure OpenAI",
      "self_hosted": "مستضاف ذاتيًا"
    },
    "stt": "تحويل الكلام إلى نص (STT)",
    "tts": "تحويل النص إلى كلام (TTS)",
    "llm": "مقدم LLM",
    "optionalDefault": "اختياري، يستخدم افتراضي المقدم",
    "language": "اللغة",
    "vocabulary_book": "كتاب المفردات",
    "encrypted": "مشفر",
    "smtp": "تكوين SMTP"
  },
  "billing": { ...enCommon.billing },
  "attributes": {
    "title": "سمات الإعداد",
    "search_placeholder": "البحث في السمات...",
    "level_default": "افتراضي",
    "level_set": "محدد",
    "level_force": "إجباري",
    "level_forced": "إجباري (موروث)",
    "modified_count": "{{count}} معدل",
    "system_default": "افتراضي النظام",
    "product_default": "افتراضي المنتج",
    "inherited_tenant": "موروث من المستأجر",
    "inherited_group": "موروث من المجموعة",
    "collapse_all": "طي الكل",
    "expand_all": "توسيع الكل",
    "level_locked": "مغلق",
    "paste_sa_json": "الصق JSON حساب الخدمة هنا",
    "stt_provider_id": "مقدم STT",
    "tts_provider_id": "مقدم TTS",
    "llm_provider_id": "نموذج LLM",
    "kb_embedding_provider": "KB Embedding Provider",
    "kb_embedding_base_url": "KB Embedding Base URL",
    "kb_embedding_model": "KB Embedding Model",
    "kb_embedding_api_key": "KB Embedding API Key",
    "kb_embedding_dimensions": "KB Embedding Dimensions",
    "kb_image_llm_provider": "KB Image LLM Provider",
    "kb_image_llm_base_url": "KB Image LLM Base URL",
    "kb_image_llm_model": "KB Image LLM Model",
    "kb_image_llm_api_key": "KB Image LLM API Key",
    "kb_image_instructions": "KB Image Instructions",
    "tool_timeout": "مهلة تنفيذ الأداة (ثوانٍ)",
    "tool_timeout_error_message": "رسالة خطأ مهلة الأداة",
    "level": {
      "title": "مستوى السمة",
      "default": "افتراضي",
      "set": "محدد",
      "force": "إجباري"
    }
  },
  "createFromJson": {
    "title": "إنشاء أدوات من JSON",
    "button": "إنشاء من JSON",
    "executionMethod": "طريقة التنفيذ",
    "pathPrefix": "بادئة المسار / URL",
    "pathPrefixHelp": "ستُضاف هذه البادئة إلى اسم كل أداة",
    "jsonInput": "إدخال JSON",
    "toolCount": "سيتم إنشاء/تحديث {{count}} أداة",
    "quotaExceeded": "سيؤدي هذا لإنشاء {{new}} أداة ولكن المتبقي {{available}} فقط",
    "processing": "جار المعالجة...",
    "creating": "جار الإنشاء: {{name}}",
    "updating": "جار التحديث: {{name}}",
    "create": "إنشاء",
    "success": "تم الإنشاء: {{created}}، تم التحديث: {{updated}}",
    "http_rest": "HTTP REST",
    "local_script": "سكريبت محلي",
    "builtin": "مدمج"
  },
  "errors": {
    ...enCommon.errors,
    "fetch_runners_failed": "فشل في جلب مشغلات الأدوات",
    "fetch_tools_failed": "فشل في جلب الأدوات",
    "select_runner_and_tool": "يرجى اختيار مشغل وأداة",
    "invalid_json_parameters": "JSON غير صالح في المعاملات",
    "tool_execution_failed": "فشل تنفيذ الأداة"
  },
  "tools": {
    ...enCommon.tools,
    "new": "أداة جديدة",
    "no_tools": "لم يتم العثور على أدوات",
    "error_name_required": "اسم الأداة مطلوب",
    "is_builtin_short": "مدمج",
    "tab_details": "التفاصيل",
    "tab_attributes": "الخصائص",
    "effective_value": "الساري: {{value}} — من {{source}}",
    "effective_source_default": "القيمة الافتراضية للتسجيل"
  },
  "pages": {
    "agents": {
      "page": {
        "back": "العودة إلى الوكلاء",
        "advanced_properties": "خصائص متقدمة",
        "tab_stats": "الإحصائيات",
        "tab_training": "تدريب الوكيل",
        "tab_call_logs": "سجلات المكالمات",
        "tab_session_feedback": "ملاحظات الجلسة"
      },
      "training": {
        "title": "تدريب الوكيل",
        "agent_prompt": "موجز نظام الوكيل",
        "interface_instructions": "تعليمات الواجهة",
        "edit_with_ai": "التعديل بالذكاء الاصطناعي",
        "restore": "استعادة",
        "no_llm": "لم يتم تكوين LLM للتدريب",
        "no_vis": "لا توجد واجهات افتراضية مرتبطة بهذا الوكيل",
        "no_history": "لا يوجد سجل للموجزات",
        "saved": "تم الحفظ بنجاح",
        "restored": "تمت استعادة الموجز",
        "confirm_restore": "استعادة هذا الإصدار من الموجز؟",
        "load_failed": "فشل تحميل بيانات التدريب",
        "history_title": "سجل الموجزات",
        "assessment": {
          "title": "تقييم الذكاء الاصطناعي",
          "run": "تقييم الذكاء الاصطناعي",
          "empty": "لا يوجد تقييم بعد. انقر على تقييم الذكاء الاصطناعي.",
          "analyzing": "جارٍ تحليل المكالمات الأخيرة…",
          "no_recommendations": "لا توجد توصيات.",
          "recommendations_count": "{{count}} توصيات",
          "stale": "التقييم الأخير قديم. يتم إنشاء تقييم جديد.",
          "quota_exceeded": "تم بلوغ حصة التقييمات اليدوية ({{quota}} لكل وكيل).",
          "quota_reached": "تم بلوغ حصة التقييمات اليدوية",
          "running": "جارٍ تشغيل التقييم…",
          "applied": "تم التطبيق",
          "dismissed": "تم الرفض",
          "accept": "قبول",
          "dismiss": "رفض",
          "apply": "تطبيق",
          "reject": "رفض",
          "retry": "إعادة المحاولة",
          "failed": "فشل التقييم",
          "load_failed": "فشل تحميل التقييم",
          "severity_high": "عالية",
          "severity_medium": "متوسطة",
          "severity_low": "منخفضة",
          "category_system_prompt": "موجز النظام",
          "category_vi": "الواجهة",
          "category_service": "الخدمة",
          "summary": "الملخص",
          "satisfaction": "الرضا",
          "efficiency": "الكفاءة"
        },
        "chat": {
          "title": "التعديل بالذكاء الاصطناعي",
          "placeholder": "صف المشكلة أو اطلب تعديلًا…",
          "send": "إرسال",
          "pending": "يفكّر…",
          "applied_to": "تم التطبيق على {{target}}",
          "target_agent": "موجز نظام الوكيل",
          "calling_tool": "يستدعي {{tool}}…",
          "tools_done": "اكتمل: {{tools}}",
          "target_vi": "موجز الواجهة: {{name}}",
          "failed": "فشل الطلب",
          "empty": "اطلب من الوكيل مراجعة السجلات واقتراح تعديلات على الموجز."
        }
      },
      "create": { "title": "إنشاء وكيل جديد" },
      "edit": {
        "title": "تعديل الوكيل",
        "back_to_agents": "العودة إلى الوكلاء",
        "not_found_or_no_permission": "الوكيل غير موجود أو ليس لديك صلاحية لتعديله."
      }
    },
    "tools": {
      "create": { "title": "إنشاء أداة جديدة" },
      "edit": {
        "title": "تعديل الأداة",
        "back_to_tools": "العودة إلى الأدوات",
        "tool_not_found": "الأداة غير موجودة"
      }
    },
    "outboundDialers": {
      "list": {
        "title": "الاتصال الصادر",
        "new": "جهاز اتصال صادر جديد",
        "empty": "لا توجد أجهزة اتصال صادرة"
      },
      "create": { "title": "إنشاء جهاز اتصال صادر جديد" },
      "edit": { "title": "تعديل جهاز الاتصال الصادر" },
      "view": { "title": "جهاز الاتصال الصادر" }
    }
  },
  "webhook_tester": {
    "title": "مختبر Webhook",
    "description": "اختبار نقاط نهاية Webhook للواجهات الافتراضية",
    "request": "الطلب",
    "response": "الاستجابة",
    "webhook_url": "رابط Webhook",
    "webhook_url_help": "أدخل رابط Webhook الكامل متضمناً معرف الواجهة الافتراضية",
    "sample_payloads": "حمولات نموذجية",
    "payload_json": "الحمولة (JSON)",
    "sending": "جار الإرسال...",
    "send_webhook": "إرسال Webhook",
    "status_label": "الحالة",
    "response_body": "نص الاستجابة",
    "response_headers": "ترويسات الاستجابة",
    "empty_state": "أرسل طلباً لرؤية الاستجابة",
    "tips_title": "نصائح",
    "tip1": "تأكد من أن Channel Gateway يعمل على المنفذ 3002",
    "tip2": "استخدم معرف واجهة افتراضية صالح في الرابط",
    "tip3": "تحقق من كونسول المتصفح لأخطاء CORS إذا فشل الطلب",
    "tip4": "عرض سجلات Channel Gateway: docker logs sophia-channel-gateway-1"
  },
  "sections": {
    "chat_agent": "وكيل الدردشة",
    "user_preferences": "تفضيلات المستخدم",
    "user_permissions": "صلاحيات المستخدم",
    "media_server": "خادم الوسائط",
    "upstream_providers": "مقدمو الخدمات الخارجية",
    "knowledge_base": "قاعدة المعرفة"
  },
  "attributeLabels": {
    "attachment_retention_seconds": "الاحتفاظ بالملفات المرفقة (ثوانٍ)",
    "attachment_max_size_bytes": "الحد الأقصى لحجم الملف المرفق (بايت)",
    "consult_delegate_agents": "الوكلاء المفوَّضون",
    "consult_timeout_seconds": "مهلة الاستشارة (ثوانٍ)",
    "consult_max_iterations": "أقصى عدد لتكرارات الاستشارة",
    "stt_provider": "موفر STT",
    "stt_api_base_url": "عنوان URL الأساسي لواجهة STT",
    "stt_api_key": "مفتاح واجهة STT",
    "stt_model": "نموذج STT",
    "stt_language": "لغة STT",
    "stt_provider_params": "معاملات موفر STT",
    "stt_protocol": "STT Protocol",
    "tts_provider": "موفر TTS",
    "tts_api_base_url": "عنوان URL الأساسي لواجهة TTS",
    "tts_api_key": "مفتاح واجهة TTS",
    "tts_voice_id": "معرف الصوت TTS",
    "tts_model": "نموذج TTS",
    "tts_provider_params": "معاملات موفر TTS",
    "tts_style_instructions": "تعليمات أسلوب TTS",
    "s2s_greeting_instructions": "تعليمات الترحيب S2S",
    "s2s_temperature": "درجة الحرارة",
    "s2s_top_p": "Top P",
    "s2s_top_k": "Top K",
    "tool_timeout": "مهلة تنفيذ الأداة (ثوانٍ)",
    "tool_timeout_error_message": "رسالة خطأ مهلة الأداة",
    "stt_vocabulary_book": "كتاب المفردات",
    "tts_language": "لغة TTS",
    "tts_speed": "سرعة TTS",
    "tts_protocol": "بروتوكول TTS",
    "tts_audio_format": "تنسيق الصوت TTS",
    "tts_sample_rate": "معدل العينة TTS",
    "tts_bitrate": "معدل البت TTS",
    "llm_provider": "موفر LLM",
    "llm_api_base_url": "عنوان URL الأساسي لواجهة LLM",
    "llm_api_key": "مفتاح واجهة LLM",
    "llm_model": "نموذج LLM",
    "llm_temperature": "درجة حرارة LLM",
    "llm_max_tokens": "الحد الأقصى لرموز LLM",
    "llm_provider_params": "معاملات موفر LLM",
    "llm_api_response_timeout": "مهلة استجابة واجهة LLM",
    "llm_retry_count": "عدد محاولات إعادة LLM",
    "stt_audio_format": "تنسيق صوت STT",
    "stt_sample_rate": "معدل عينة STT",
    "stt_num_channels": "قنوات STT",
    "stt_enable_endpoint_detection": "كشف نقطة النهاية STT",
    "llm_vertex_ai_project_id": "معرف مشروع Vertex AI",
    "llm_vertex_ai_location": "موقع Vertex AI",
    "llm_vertex_ai_key": "JSON حساب خدمة Vertex AI",
    "system_prompt": "تعليمات النظام",
    "system_prompt_prepend": "إضافة قبل تعليمات النظام",
    "system_prompt_append": "إضافة بعد تعليمات النظام",
    "available_tools": "الأدوات المتاحة",
    "no_available_tools": "جميع الأدوات معينة",
    "additional_tools": "أدوات إضافية",
    "tool_calling_behavior": "سلوك استدعاء الأداة",
    "interim_message_enabled": "الرسالة المؤقتة مفعلة",
    "interim_message_enabled_help": "اعرض رسالة أثناء معالجة نتائج الأداة",
    "session_timeout_enabled": "مهلة الجلسة مفعلة",
    "session_timeout_seconds": "مهلة الجلسة (ثوانٍ)",
    "session_timeout_goodbye_message": "رسالة الوداع لانتهاء مهلة الجلسة",
    "single_channel_session_timeout_enabled": "مهلة جلسة القناة الواحدة مفعلة",
    "language": "اللغة",
    "tool_calling_attempts": "محاولات استدعاء الأداة",
    "barge_in_enabled": "المقاطعة مفعلة",
    "g729_transcoding": "تحويل G.729",
    "llm_streaming_enabled": "بث LLM مفعّل",
    "tool_runner_ping_interval": "فاصل ping لمشغل الأدوات",
    "tool_runner_absence_timeout": "مهلة غياب مشغل الأدوات",
    "welcome_message": "رسالة ترحيب",
    "goodbye_message": "رسالة وداع",
    "telegram_enable_polling": "تفعيل الاستقصاء في Telegram",
    "telegram_polling_interval": "فاصل الاستقصاء في Telegram",
    "whatsapp_messaging_instructions": "تعليمات المراسلة في WhatsApp",
    "telegram_messaging_instructions": "تعليمات المراسلة في Telegram",
    "voice_tts_timeout": "مهلة TTS الصوتي",
    "voice_analysis_enabled": "تحليل الصوت مفعل",
    "speaker_gated_barge_in_enabled": "تمكين المقاطعة المشروطة بالمتكلم",
    "speaker_similarity_threshold": "حد التشابه",
    "speaker_ema_alpha": "ألفا EMA",
    "voice_analysis_min_frames": "الحد الأدنى لإطارات تحليل الصوت",
    "voice_gender_threshold_hz": "حد الجنس الصوتي (هرتز)",
    "voice_gender_ambiguous_zone_hz": "منطقة غموض الجنس الصوتي (هرتز)",
    "voice_analysis_window_ms": "نافذة تحليل الصوت (مللي ثانية)",
    "voice_analysis_update_interval_ms": "فاصل تحديث تحليل الصوت (مللي ثانية)",
    "voice_gender_reset_threshold_hz": "عتبة إعادة تعيين الجنس الصوتي (هرتز)",
    "tool_processing_prompt": "مطالبة معالجة الأداة",
    "tool_processing_delay": "تأخير معالجة الأداة",
    "tool_processing_message": "رسالة معالجة الأداة",
    "session_idle_timeout_voice": "مهلة الخمول للجلسة (صوتي، ثوانٍ)",
    "session_absolute_timeout_voice": "المهلة المطلقة للجلسة (صوتي، دقائق)",
    "session_idle_timeout_text": "مهلة الخمول للجلسة (نص، ثوانٍ)",
    "session_absolute_timeout_text": "المهلة المطلقة للجلسة (نص، دقائق)",
    "session_pre_expire_message": "رسالة تنبيه قبل انتهاء الجلسة",
    "session_pre_expire_message_help": "تُرسل مرة واحدة قبل أن تُغلق مهلة الخمول الجلسة. فارغ = معطّل.",
    "session_pre_expire_timeout_text": "وقت التنبيه قبل الانتهاء (ثوانٍ)",
    "session_pre_expire_timeout_text_help": "عدد الثواني قبل مهلة الخمول لإرسال رسالة التنبيه. 0 = معطّل.",
    "perm_tenant_wide": "صلاحيات عبر المستأجر",
    "page_tenant_wide": "الوصول إلى الصفحات",
    "audio_chunk_size": "حجم مقطع الصوت",
    "audio_chunk_transfer_encoding": "ترميز نقل مقاطع الصوت",
    "audio_tts_queue_size": "حجم قائمة انتظار TTS",
    "audio_energy_threshold": "حد طاقة الصوت",
    "audio_silence_duration": "مدة الصمت",
    "audio_min_speech_duration": "الحد الأدنى لمدة الكلام",
    "audio_vad_hysteresis": "تأخير VAD مفعل",
    "audio_barge_in_enabled": "مقاطعة الصوت مفعلة",
    "audio_barge_in_threshold": "حد مقاطعة الصوت",
    "audio_barge_in_min_speech": "الحد الأدنى للكلام للمقاطعة",
    "barge_in_grace_time": "مهلة السماح للمقاطعة",
    "barge_in_auto_raise_energy": "رفع الطاقة التلقائي للمقاطعة",
    "barge_in_auto_raise_margin": "هامش رفع الطاقة التلقائي",
    "barge_in_auto_raise_max": "الحد الأقصى لرفع الطاقة التلقائي",
    "audio_jitter_buffer_ms": "مخزن تموج الصوت (مللي ثانية)",
    "audio_max_buffer_frames": "الحد الأقصى لإطارات مخزن الصوت",
    "audio_packet_loss_concealment": "إخفاء فقدان حزم الصوت",
    "utility_extensions_enable": "تفعيل الإضافات المساعدة",
    "utility_extension_local_echo": "إضافة الصدى المحلي",
    "media_server_utility_agent_id": "معرف الوكيل المساعد",
    "utility_extension_dictation": "إضافة الإملاء",
    "utility_extension_dictation_announcement": "إعلان الإملاء",
    "utility_extension_dictation_stt_error": "رسالة خطأ STT للإملاء",
    "audio_enhance_enabled": "تحسين الصوت مفعل",
    "audio_enhance_noise_suppression": "كتم ضوضاء الصوت",
    "audio_enhance_agc_target": "هدف AGC لتحسين الصوت",
    "audio_enhance_highpass_hz": "مرشح الترددات العالية للصوت (هرتز)",
    "audio_enhance_aec_enabled": "إلغاء الصدى الصوتي مفعل",
    "smtp_host": "مضيف SMTP",
    "smtp_port": "منفذ SMTP",
    "smtp_encryption": "تشفير SMTP",
    "smtp_ignore_certificates": "تجاهل أخطاء شهادات SMTP",
    "smtp_username": "اسم مستخدم SMTP",
    "smtp_password": "كلمة مرور SMTP",
    "smtp_from_email": "بريد المرسل SMTP",
    "smtp_from_name": "اسم المرسل SMTP",
    "smtp_verify_peer": "التحقق من شهادة نظير SMTP",
    "smtp_verify_peer_name": "التحقق من اسم نظير SMTP",
    "smtp_allow_self_signed": "السماح بالشهادات الموقعة ذاتيًا لـ SMTP",
    "email_tag_wrapper": "مغلف الوسم",
    "chat_bridge_virtual_interface": "واجهة افتراضية لجسر الدردشة",
    "chat_bridge_auto_add_users": "إضافة المستخدمين تلقائياً",
    "chat_bridge_activation": "التفعيل",
    "chat_bridge_include_context": "تضمين سياق المحادثة",
    "chat_bridge_agent_entity": "كيان الوكيل",
    "chat_bridge_caller_entity": "كيان المتصل",
    "chat_bridge_service_person_entity": "كيان موظف الخدمة",
    "chat_bridge_handoff_silence_timeout_seconds": "مهلة انتظار عودة البوت (ثواني)",
    "chat_bridge_handoff_return_message": "رسالة عودة البوت",
    "agent_training_llm": "LLM تدريب الوكيل",
    "agent_training_llm_help": "نموذج LLM المستخدم في ميزة «التعديل بالذكاء الاصطناعي». قابل للضبط على مستوى المستأجر/النظام من قبل المسؤولين العامين.",
    "agent_training_llm_timeout_seconds": "مهلة LLM للتدريب (ثوانٍ)",
    "agent_training_llm_timeout_seconds_help": "مهلة كل استدعاء LLM لوكيل التدريب/«التعديل بالذكاء الاصطناعي».",
    "agent_training_loop_timeout_seconds": "مهلة حلقة التدريب الإجمالية (ثوانٍ)",
    "agent_training_loop_timeout_seconds_help": "المهلة الإجمالية لتشغيل التدريب/«التعديل بالذكاء الاصطناعي» (جميع استدعاءات LLM والأدوات معًا).",
    "session_feedback_llm_provider": "LLM ملاحظات الجلسة",
    "session_feedback_llm_provider_help": "نموذج LLM المستخدم لتلخيص المكالمات وتقييم الرؤى بعد انتهاء الجلسة. اتركه فارغًا لتعطيل الملاحظات لهذا الوكيل.",
    "session_feedback_prompt": "موجز ملاحظات الجلسة",
    "session_feedback_prompt_help": "رأس الموجز الثابت (حتى «Trait Definitions:»). تُضاف تعريفات السمات والمخطط والنسخة ديناميكيًا. اتركه فارغًا للقيمة الافتراضية المدمجة.",
    "performance_assessment_prompt": "موجز تقييم الأداء",
    "performance_assessment_prompt_help": "موجز النظام لوكيل تقييم الأداء المستقل. معبأ مسبقًا بالقيمة الافتراضية المدمجة؛ عدّله للتخصيص.",
    "performance_assessment_history_hours": "ساعات السجل",
    "performance_assessment_history_hours_help": "ساعات المكالمات الأخيرة التي يراجعها وكيل التقييم.",
    "performance_assessment_stale_min_gap_minutes": "الحد الأدنى لفارض التشغيل التلقائي (دقائق)",
    "performance_assessment_stale_min_gap_minutes_help": "الحد الأدنى للدقائق بين عمليات تشغيل التقييم القديم التلقائي لهذا الوكيل. 0 يعطّل التشغيل التلقائي عند التحميل (يستمر المجدول وزر التشغيل اليدوي بالعمل).",
    "auto_reply_enabled": "الرد التلقائي مفعل",
    "session_timeout": "مهلة الجلسة (دقائق)",
    "telegram_parse_mode": "وضع تحليل Telegram",
    "telegram_disable_notification": "تعطيل إشعارات Telegram",
    "telegram_protect_content": "حماية محتوى Telegram",
    "whatsapp_template_namespace": "مساحة اسم نموذج WhatsApp",
    "whatsapp_message_type": "نوع رسالة WhatsApp",
    "voice_greeting": "تحية صوتية",
    "voice_timeout": "مهلة صوتية (ثوانٍ)",
    "webhook_url": "رابط Webhook",
    "webhook_secret": "سر Webhook",
    "webhook_events": "أحداث Webhook",
    "rocketchat_hook_register_interval": "فاصل تسجيل Webhook (ثوانٍ)",
    "rocketchat_integration_channel": "قناة التكامل",
    "consumer_api_enabled": "واجهة برمجة تطبيقات المستهلك مفعّلة",
    "consumer_api_agents_enabled": "نقطة نهاية الوكلاء مفعّلة",
    "consumer_api_call_logs_enabled": "نقطة نهاية سجلات المكالمات مفعّلة",
    "consumer_api_tools_enabled": "نقطة نهاية الأدوات مفعّلة",
    "consumer_api_knowledge_bases_enabled": "نقطة نهاية قواعد المعرفة مفعّلة",
    "consumer_api_tool_calls_enabled": "نقطة نهاية استدعاءات الأدوات مفعّلة",
    "consumer_api_dial_queue_enabled": "قائمة الاتصال — التحميل عبر API",
    "outbound_dialer_active": "نشط",
    "simultaneous_outbound_calls": "مكالمات صادرة متزامنة",
    "answer_timeout_seconds": "مهلة الرد (ثوانٍ)",
    "call_attempts": "محاولات الاتصال",
    "call_retry_interval_seconds": "فاصل إعادة المحاولة (ثوانٍ)",
    "call_retry_interval_randomization_seconds": "عشوائية فاصل إعادة المحاولة (ثوانٍ)",
    "caller_id_number": "رقم هوية المتصل",
    "caller_id_name": "اسم هوية المتصل",
    "outbound_sip_proxy_host": "مضيف وكيل SIP الصادر",
    "outbound_sip_proxy_port": "منفذ وكيل SIP الصادر",
    "outbound_sip_proxy_transport": "نقل وكيل SIP الصادر",
    "outbound_sip_username": "اسم مستخدم SIP الصادر",
    "outbound_sip_password": "كلمة مرور SIP الصادرة",
    "consumer_api_calls_include_transcripts": "المكالمات تتضمن النصوص",
    "consumer_api_rate_limit_window_seconds": "نافذة حد المعدل (ثوانٍ)",
    "consumer_api_rate_limit_max_requests": "الحد الأقصى للطلبات لكل نافذة",
    "consumer_api_rate_limit_concurrent": "الحد الأقصى للطلبات المتزامنة",
    "consumer_api_unauth_rate_limit_window_seconds": "نافذة حد المعدل غير المصادق عليه (ثوانٍ)",
    "consumer_api_unauth_rate_limit_max_requests": "الحد الأقصى للطلبات لكل نافذة غير مصادق عليها"
  },
  "attributeGroups": {
    "attachments": "الملفات المرفقة",
    "agent_collaboration": "تعاون الوكلاء",
    "stt_provider": "تكوين موفر STT",
    "tts_provider": "تكوين موفر TTS",
    "llm_provider": "تكوين موفر LLM",
    "vertex_ai": "حساب نظام Vertex AI",
    "tts_advanced": "إعدادات TTS المتقدمة",
    "tts_google": "إعدادات TTS من Google",
    "tts_openai": "إعدادات OpenAI",
    "core_agent": "تكوين الوكيل الأساسي",
    "tool_runner_health": "مراقبة صحة مشغل الأدوات",
    "virtual_interface": "تكوين الواجهة الافتراضية",
    "voice_analysis": "تحليل الصوت",
    "speaker_barge_in": "المقاطعة المشروطة بالمتكلم",
    "tool_processing": "تجربة مستخدم معالجة الأدوات",
    "session_timeout": "مهلة الجلسة",
    "messaging_instructions": "تعليمات المراسلة",
    "admin_permissions": "صلاحيات المدير",
    "audio_streaming": "بث الصوت",
    "vad": "كشف نهاية الكلام (VAD)",
    "barge_in": "مقاطعة TTS (Barge-in)",
    "rtp": "تكوين RTP",
    "utility_extensions": "الإضافات المساعدة",
    "audio_enhancement": "تحسين الصوت (APM)",
    "smtp_provider": "تكوين مزود SMTP",
    "email_template": "تكوين قوالب البريد الإلكتروني",
    "chat_bridging": "جسر الدردشة",
    "general": "تكوين عام",
    "session-timeout": "مهلة الجلسة",
    "bargein-config": "مقاطعة TTS (Barge-in)",
    "tool-processing": "معالجة الأدوات",
    "vertex-ai": "Google Vertex AI",
    "codec": "تحويل الترميز",
    "tool-runner": "تكوين مشغل الأدوات",
    "smtp": "تكوين SMTP (البريد الإلكتروني)",
    "chat-bridging": "جسر الدردشة",
    "audio-streaming": "بث الصوت",
    "vad-config": "كشف نهاية الكلام (VAD)",
    "rtp-config": "تكوين RTP",
    "utility-functions": "وظائف مساعدة",
    "audio-enhancement": "تحسين الصوت",
    "telegram": "إعدادات Telegram",
    "whatsapp": "إعدادات WhatsApp",
    "voice": "إعدادات الصوت",
    "voice-analysis": "تحليل الصوت",
    "webhook": "تكوين Webhook",
    "rocketchat": "إعدادات RocketChat",
    "permissions": "الصلاحيات الافتراضية",
    "consumer_api": "واجهة برمجة تطبيقات المستهلك",
    "kb_embedding": "تضمين قاعدة المعرفة",
    "kb_image_llm": "نموذج رؤية الصور لقاعدة المعرفة",
    "outboundDialer": "تكوين الاتصال الصادر",
    "execution_settings": "إعدادات التنفيذ"
  },
  "tool_tester": {
    "title": "مختبر الأدوات",
    "tool_runner": "مشغل الأدوات",
    "tool": "الأداة",
    "parameters": "المعاملات",
    "timeout": "مهلة زمنية",
    "populate": "تعبئة",
    "run_tool": "تشغيل الأداة",
    "running": "جار التشغيل...",
    "result": "النتيجة",
    "select_runner": "اختر مشغل أدوات...",
    "select_tool": "اختر أداة...",
    "select_runner_first": "اختر المشغل أولاً",
    "parameters_placeholder": '{"مفتاح": "قيمة"}',
    "parameters_help": "أدخل المعاملات ككائن JSON",
    "help_title": "كيفية الاستخدام",
    "help_text": "اختبر تنفيذ الأداة دون تشغيل جلسة محادثة كاملة.",
    "step1_title": "1. اختر المشغل",
    "step1_desc": "اختر مشغل أدوات متصل بالإنترنت.",
    "step2_title": "2. اختر الأداة",
    "step2_desc": "اختر الأداة المراد اختبارها.",
    "step3_title": "3. تعيين المعاملات",
    "step3_desc": "انقر على 'تعبئة' للحصول على معاملات نموذجية.",
    "step4_title": "4. تكوين المهلة",
    "step4_desc": "اضبط المهلة (الافتراضي: 60 ثانية).",
    "step5_title": "5. تشغيل الاختبار",
    "step5_desc": "انقر على 'تشغيل الأداة' للتنفيذ."
  },
  "dashboard": {
    "title": "لوحة التحكم",
    "time_series": "تحليلات السلسلة الزمنية",
    "today": "اليوم",
    "last_7_days": "آخر 7 أيام",
    "last_30_days": "آخر 30 يوماً",
    "this_month": "هذا الشهر",
    "last_month": "الشهر الماضي",
    "processed_calls": "المكالمات المعالجة",
    "tools_run": "الأدوات المشغلة",
    "total_call_time": "إجمالي وقت المكالمات",
    "tool_processing_time": "وقت معالجة الأدوات",
    "updated": "محدث",
    "tenant_scope": "نطاق المستأجر",
    "current_tenant": "الحالي",
    "all_tenants": "الكل",
    "system_health": "حالة النظام",
    "no_infrastructure": "لا توجد بنية تحتية مهيأة.",
    "recent_tool_logs": "آخر تنفيذات الأدوات",
    "no_recent_tool_logs": "لا توجد تنفيذات أدوات حديثة."
  },
  "agent": {
    "new": "وكيل جديد",
    "no_agents": "لم يتم العثور على وكلاء",
    "status": {
      "active": "نشط",
      "inactive": "غير نشط"
    }
  },
  "forms": {
    "tables": {
      "headers": {
        "attribute": "السمة",
        "value": "القيمة",
        "level": "المستوى",
        "action": "الإجراء"
      }
    },
    "agents": {
      "tabs": {
        "details": "التفاصيل",
        "configuration": "التكوين",
        "upstreamProviders": "مقدمو الخدمات الخارجية"
      },
      "labels": {
        "name": "الاسم",
        "description": "الوصف",
        "agentGroup": "مجموعة الوكلاء"
      },
      "placeholders": {
        "noGroup": "بدون مجموعة"
      },
      "errors": {
        "nameRequired": "اسم الوكيل مطلوب"
      },
      "loading": {
        "tools": "جار تحميل الأدوات...",
        "agents": "جار تحميل الوكلاء..."
      },
      "empty": {
        "noTools": "لا توجد أدوات متاحة",
        "noDelegateAgents": "لا يوجد وكلاء آخرون في هذا المستأجر"
      },
      "badge": {
        "builtin": "مدمج"
      },
      "alerts": {
        "saveFirst": "احفظ الوكيل أولاً لتكوين المزودين الخارجيين."
      },
      "otherConfiguration": "تكوين آخر"
    },
    "auth": {
      "login": { "title": "تسجيل الدخول بكلمة المرور" }
    },
    "outboundDialers": {
      "name": "الاسم",
      "originatingMediaServer": "خادم الوسائط المصدر",
      "virtualInterface": "الواجهة الافتراضية",
      "activitySchedule": "جدول النشاط",
      "activitySchedule.enabled": "نشط",
      "activitySchedule.start": "الفتح",
      "activitySchedule.end": "الإغلاق",
      "activitySchedule.day": "اليوم",
      "activitySchedule.invalidRange": "يجب أن يكون وقت البدء قبل وقت الانتهاء",
      "timezone": "المنطقة الزمنية",
      "anyCloudMediaServer": "أي خادم وسائط سحابي متاح",
      "weekday": {
        "sun": "الأحد",
        "mon": "الاثنين",
        "tue": "الثلاثاء",
        "wed": "الأربعاء",
        "thu": "الخميس",
        "fri": "الجمعة",
        "sat": "السبت"
      }
    }
  },
  "infrastructure": {
    ...enCommon.infrastructure,
    "media_servers": "خوادم الوسائط",
    "tool_runners": "مشغلي الأدوات",
    "new_server": "خادم جديد",
    "new_runner": "مشغل جديد",
    "new_media_server": "خادم وسائط جديد",
    "new_tool_runner": "مشغل أدوات جديد",
    "edit_media_server": "تحرير خادم الوسائط",
    "edit_tool_runner": "تحرير مشغل الأدوات",
    "api_key": "مفتاح API",
    "type": "النوع",
    "last_seen": "آخر ظهور",
    "never": "أبدًا",
    "on_prem": "On-Prem",
    "cloud": "سحابة",
    "copy_api_key": "نسخ مفتاح API",
    "api_key_copied": "تم نسخ مفتاح API إلى الحافظة",
    "api_key_copy_failed": "فشل نسخ مفتاح API",
    "no_media_servers": "لم يتم العثور على خوادم وسائط",
    "no_tool_runners": "لم يتم العثور على مشغلي أدوات",
    "connection_config": "تكوين الاتصال",
    "deployment_type": "نوع النشر",
    "on_premises_deployment": "نشر داخلي (On-Premises)",
    "on_prem_help": "حدد إذا كان الخادم سيتم نشره في البنية التحتية الخاصة بك.",
    "runner_on_prem_help": "حدد إذا كان مشغل الأدوات سيتم نشره في البنية التحتية الخاصة بك.",
    "create_server": "إنشاء خادم",
    "create_runner": "إنشاء مشغل",
    "creating": "جارٍ الإنشاء...",
    "saving": "جارٍ الحفظ...",
    "save_changes": "حفظ التغييرات",
    "details": "التفاصيل",
    "configuration": "التكوين",
    "regenerate_key": "إعادة توليد المفتاح",
    "regenerating": "جارٍ إعادة التوليد...",
    "regenerate_warning": "إعادة توليد مفتاح API سيبطل المفتاح القديم فورًا.",
    "regenerate_confirm": "هل أنت متأكد أنك تريد إعادة توليد مفتاح API؟ المفتاح القديم سيتوقف عن العمل فورًا.",
    "key_regenerated": "تم إعادة توليد مفتاح API بنجاح",
    "key_regenerate_failed": "فشل إعادة توليد مفتاح API",
    "server_created_title": "تم إنشاء خادم الوسائط",
    "runner_created_title": "تم إنشاء مشغل الأدوات",
    "success": "نجاح!",
    "server_created_desc": "تم إنشاء خادم الوسائط. يرجى حفظ مفتاح API أدناه - لن يتم عرضه مرة أخرى.",
    "runner_created_desc": "تم إنشاء مشغل الأدوات. يرجى حفظ مفتاح API أدناه - لن يتم عرضه مرة أخرى.",
    "server_id": "معرف الخادم",
    "runner_id": "معرف المشغل",
    "key_shown_once": "سيتم عرض مفتاح API هذا مرة واحدة فقط. يرجى حفظه بشكل آمن.",
    "config_title": "التكوين",
    "config_env_vars": "قم بتكوين الخادم الخاص بك باستخدام متغيرات البيئة التالية:",
    "runner_config_env_vars": "قم بتكوين مشغل الأدوات الخاص بك باستخدام متغيرات البيئة التالية:",
    "done": "تم",
    "auth_required": "المصادقة مطلوبة. يرجى تسجيل الدخول مرة أخرى.",
    "save_first_attributes": "احفظ خادم الوسائط أولاً لتكوين السمات.",
    "load_failed_media_server": "فشل تحميل خادم الوسائط",
    "create_failed_media_server": "فشل إنشاء خادم الوسائط",
    "update_failed_media_server": "فشل تحديث خادم الوسائط",
    "load_failed_tool_runner": "فشل تحميل مشغل الأدوات",
    "create_failed_tool_runner": "فشل إنشاء مشغل الأدوات",
    "update_failed_tool_runner": "فشل تحديث مشغل الأدوات",
    "delete_failed_media_server": "فشل حذف خادم الوسائط",
    "delete_failed_tool_runner": "فشل حذف مشغل الأدوات",
    "delete_failed_runner": "فشل حذف المشغل",
    "delete_runner_confirm": "هل أنت متأكد أنك تريد حذف المشغل \"{{name}}\"؟",
    "server_deleted": "تم حذف خادم الوسائط بنجاح",
    "runner_deleted": "تم حذف مشغل الأدوات بنجاح",
    "no_name": "بدون اسم",
    "health_check_url": "عنوان URL لفحص الصحة",
    "websocket_url": "عنوان WebSocket",
    "actions": "إجراءات",
    "edit": "تحرير",
    "delete": "حذف",
    "confirm_delete_server": "هل أنت متأكد أنك تريد حذف خادم الوسائط؟",
    "confirm_delete_runner": "هل أنت متأكد أنك تريد حذف مشغل الأدوات؟",
    "delete_server": "حذف الخادم",
    "delete_runner": "حذف المشغل",
    "server_name": "اسم الخادم",
    "runner_name": "اسم المشغل",
    "server_url": "عنوان الخادم",
    "runner_url": "عنوان المشغل",
    "status": "الحالة",
    "online": "متصل",
    "offline": "غير متصل",
    "version": "الإصدار",
    "active_calls": "المكالمات النشطة",
    "cpu_usage": "استخدام المعالج",
    "memory_usage": "استخدام الذاكرة",
    "uptime": "وقت التشغيل",
    "last_heartbeat": "آخر نبض",
    "no_data": "لا توجد بيانات",
    "refresh": "تحديث",
    "auto_refresh": "تحديث تلقائي",
    "auto_refresh_enabled": "التحديث التلقائي مفعّل",
    "auto_refresh_disabled": "التحديث التلقائي معطّل",
    "refresh_interval": "فاصل التحديث",
    "seconds": "ثوانٍ",
    "minutes": "دقائق",
    "hours": "ساعات",
    "days": "أيام",
    "media_server_connect": "تتصل خوادم الوسائط بـ AI Orchestrator باستخدام مفتاح API المعروض أعلاه. قم بتكوين عنوان الاتصال على خادم الوسائط عبر",
    "tool_runner_connect": "تتصل مشغلي الأدوات بـ AI Orchestrator باستخدام مفتاح API المعروض أعلاه. قم بتكوين عنوان الاتصال على مشغل الأدوات عبر",
    "env_var": "متغير بيئة.",
    "media_server_env_help": "سيتصل خادم الوسائط بـ AI Orchestrator باستخدام متغيرات البيئة. سيتم إنشاء مفتاح API وعرضه بعد الإنشاء.",
    "runner_env_help": "سيتصل مشغل الأدوات بـ AI Orchestrator باستخدام متغيرات البيئة. سيتم إنشاء مفتاح API وعرضه بعد الإنشاء.",
    "example": "مثال",
    "copy": "نسخ"
  },
  "toolRunner": {
    ...enCommon.toolRunner,
    "title": "مشغلي الأدوات",
    "new": "مشغل أدوات جديد",
    "edit": "تحرير مشغل الأدوات",
    "edit_title": "تحرير مشغل الأدوات",
    "basic_info": "معلومات أساسية",
    "api_key": "مفتاح API",
    "copy": "نسخ",
    "copy_success": "تم نسخ مفتاح API إلى الحافظة",
    "copy_failed": "فشل نسخ مفتاح API",
    "regenerate_key": "إعادة توليد المفتاح",
    "regenerating": "جارٍ إعادة التوليد...",
    "regenerate_warning": "إعادة توليد مفتاح API سيبطل المفتاح القديم فورًا.",
    "regenerate_confirm": "هل أنت متأكد أنك تريد إعادة توليد مفتاح API؟ المفتاح القديم سيتوقف عن العمل فورًا.",
    "key_regenerated": "تم إعادة توليد مفتاح API بنجاح",
    "key_regenerate_failed": "فشل إعادة توليد مفتاح API",
    "api_key_copied": "تم نسخ مفتاح API إلى الحافظة",
    "api_key_copy_failed": "فشل نسخ مفتاح API",
    "status_online": "متصل",
    "status_offline": "غير متصل",
    "status_pending": "قيد الانتظار",
    "status_error": "خطأ",
    "status_readonly": "يتم تحديث الحالة تلقائيًا بناءً على اتصال المشغل",
    "acceptConnections": "قبول الاتصالات",
    "acceptConnections_help": "السماح لهذا المشغل بقبول اتصالات تنفيذ الأدوات الجديدة",
    "deployment_type": "نوع النشر",
    "on_premises": "نشر داخلي (On-Premises)",
    "save_changes": "حفظ التغييرات",
    "saving": "جارٍ الحفظ...",
    "cancel": "إلغاء",
    "tools_panel_title": "الأدوات المتاحة في هذا المشغل",
    "no_tools": "لا توجد أدوات في هذا المشغل",
    "load_failed": "فشل تحميل مشغل الأدوات",
    "create_failed": "فشل إنشاء مشغل الأدوات",
    "update_failed": "فشل تحديث مشغل الأدوات",
    "delete_failed": "فشل حذف مشغل الأدوات",
    "runner_deleted": "تم حذف مشغل الأدوات بنجاح",
    "confirm_delete": "هل أنت متأكد أنك تريد حذف مشغل الأدوات؟",
    "delete": "حذف",
    "back_to_runners": "العودة إلى مشغلي الأدوات",
    "associated_tools": "الأدوات المرتبطة",
    "runner_tools": "أدوات المشغل",
    "available_tools": "الأدوات المتاحة",
    "items_count": "{{count}} عناصر",
    "built_in": "مدمج",
    "no_available_tools": "جميع الأدوات مرتبطة",
    "no_associated_tools": "لا توجد أدوات مرتبطة",
    "add_selected": "إضافة الأدوات المحددة",
    "remove_selected": "إزالة الأدوات المحددة",
    "selection_hint": "اضغط على Ctrl/Cmd لتحديد عناصر متعددة",
    "tools_updated": "تم تحديث ارتباطات الأدوات بنجاح",
    "error_load_tools": "فشل تحميل الأدوات",
    "error_save_tools": "فشل حفظ ارتباطات الأدوات"
  },
  "virtual_interface": {
    ...enCommon.virtual_interface,
    "title": "الواجهات الافتراضية",
    "new": "واجهة افتراضية جديدة",
    "edit": "تحرير الواجهة الافتراضية",
    "info_text": "تقوم الواجهات الافتراضية بتوصيل القنوات الخارجية (Telegram, WhatsApp, RocketChat, Voice) بوكلائك. تحدد كل واجهة معايير المطابقة لتوجيه الرسائل الواردة إلى الوكيل الصحيح.",
    "technology": "التقنية",
    "voice_sip": "Voice (SIP)",
    "active": "نشط",
    "inactive": "غير نشط",
    "match_criteria": "معايير المطابقة",
    "information": "معلومات",
    "save_first_attributes": "احفظ خادم الوسائط أولاً لتكوين السمات.",
    "waba_required": "معرف WABA مطلوب لواجهات WhatsApp.",
    "workspace_url_required": "عنوان مساحة العمل مطلوب لـ RocketChat",
    "bot_username_required": "اسم مستخدم البوت مطلوب لـ RocketChat",
    "bot_password_required": "كلمة مرور البوت مطلوبة لـ RocketChat",
    "invalid_rocketchat_config": "تكوين RocketChat غير صالح",
    "step1_basic": "الخطوة 1: معلومات أساسية",
    "step2_config": "الخطوة 2: التكوين",
    "configure_tech": "قم بتكوين إعدادات التكامل لـ {{technology}}.",
    "match_criteria_desc": "حدد كيفية مطابقة الرسائل الواردة لهذه الواجهة.",
    "step3_agent": "الخطوة 3: تعيين الوكيل",
    "select_agent": "اختر وكيلًا...",
    "no_agents_available": "لا توجد وكلاء متاحين. يرجى إنشاء وكيل أولاً.",
    "save_changes": "حفظ التغييرات",
    "saving": "جارٍ الحفظ...",
    "details": "التفاصيل",
    "configuration": "التكوين",
    "progress": "التقدم",
    "basic_information": "معلومات أساسية",
    "agent_assignment": "تعيين الوكيل",
    "configuration_attributes": "سمات التكوين",
    "review_create": "مراجعة وإنشاء",
    "review": "مراجعة",
    "configured": "تم التكوين",
    "edit_desc": "قم بتحرير تكوين الواجهة الافتراضية. ستتم مزامنة التغييرات تلقائيًا مع بوابات القنوات.",
    "telegram_chat_id": "معرف دردشة Telegram",
    "whatsapp_phone": "رقم هاتف WhatsApp",
    "caller_id": "معرف المتصل",
    "did_number": "رقم DID",
    "multi_value_help": "اضغط Enter أو الفاصلة أو Tab لإضافة كل قيمة. انقر على قيمة لتحريرها.",
    "telegram_chat_id_help": "عند التعيين، يمكن فقط للمحادثات في هذه القائمة التفاعل مع هذه الواجهة؛ اترك الحقل فارغًا للسماح للجميع.",
    "whatsapp_caller_id_help": "عند التعيين، يمكن فقط لأرقام الهواتف في هذه القائمة التفاعل مع هذه الواجهة؛ اترك الحقل فارغًا للسماح للجميع. يمكن إدخال الأرقام مع أو بدون علامة + في البداية.",
    "multi_value_remove": "إزالة",
    "sip_domain": "نطاق SIP",
    "webchat_info": "يتم مطابقة واجهات Webchat تلقائيًا حسب معرف الجلسة.",
    "rocketchat_info": "يتم مطابقة واجهات RocketChat تلقائيًا حسب مسار webhook. لا حاجة لمعايير مطابقة يدوية.",
    "agent_select": "اختر وكيلًا...",
    "agent_label": "الوكيل",
    "status_label": "الحالة",
    "hook_parameters": "معلمات Hook (JSON)",
    "rocketchat_config": "تكوين RocketChat",
    "workspace_url": "عنوان مساحة العمل",
    "workspace_url_label": "عنوان مساحة العمل",
    "workspace_url_help": "عنوان مساحة عمل RocketChat الخاصة بك",
    "bot_username": "اسم مستخدم البوت",
    "bot_username_label": "اسم مستخدم البوت",
    "bot_password": "كلمة مرور البوت",
    "bot_password_label": "كلمة مرور البوت",
    "bot_password_help": "كلمة المرور لحساب البوت",
    "webhook_url": "عنوان Webhook",
    "last_incoming_request": "آخر طلب وارد",
    "last_outbound_call": "آخر مكالمة صادرة",
    "last_webhook_register": "آخر تسجيل Webhook",
    "error_details": "تفاصيل الخطأ",
    "warning_change_tech": "سيؤدي تغيير التقنية إلى إعادة تعيين معايير المطابقة.",
    "never": "أبدًا",
    "success": "نجاح",
    "fail": "فشل",
    "whatsapp_phone_number_id": "Phone Number ID",
    "whatsapp_phone_number_id_help": "The Phone Number ID from your WhatsApp registration service onboarding.",
    "whatsapp_registration_section": "WhatsApp Registration",
    "display_phone_number": "Display Phone Number",
    "registration_id": "Registration ID",
    "last_refreshed": "Last refreshed",
    "refresh_registration": "Refresh Registration",
    "refreshing_registration": "Refreshing...",
    "registration_refreshed": "Registration refreshed",
    "registration_refresh_failed": "Registration refresh failed",
    "whatsapp_phone_number": "WhatsApp Number",
    "whatsapp_number_help": "Choose a number onboarded in the WhatsApp registration service for this tenant.",
    "select_whatsapp_number": "Select a number...",
    "loading_numbers": "Loading numbers...",
    "whatsapp_numbers_load_failed": "Failed to load WhatsApp numbers.",
    "no_whatsapp_numbers": "No WhatsApp numbers are available for this tenant. Onboard numbers in the WhatsApp registration service first.",
    "in_use": "in use",
    "number_in_use_warning": "This number is already connected to another interface. Connecting it here will move it to this interface; the other interface will stop receiving messages for this number.",
    "change_number": "Change Number",
    "change_number_title": "Change WhatsApp Number",
    "changing_number": "Changing...",
    "change_number_failed": "Failed to change the number.",
    "change_number_success": "Number changed.",
    "not_registered_hint": "This number is not registered yet. Click Refresh Registration to register it."
  },
  "virtual_interface_create": {
    "step4_title": "الخطوة 4: سمات التكوين",
    "step4_desc": "قم بتكوين إعدادات إضافية لهذه الواجهة الافتراضية. يمكن تغيير هذه الإعدادات لاحقًا.",
    "step4_info": "سيتم حفظ السمات بعد إنشاء الواجهة الافتراضية.",
    "step5_title": "الخطوة 5: مراجعة وإنشاء",
    "review_label": "مراجعة",
    "review_name": "الاسم",
    "review_technology": "التقنية",
    "review_agent": "الوكيل",
    "review_attributes": "السمات",
    "review_attributes_configured": "{{count}} تم تكوينها",
    "creating": "جارٍ الإنشاء...",
    "create_interface": "إنشاء الواجهة",
    "webhook_failed_title": "فشل تسجيل Webhook",
    "webhook_failed_desc": "فشل تسجيل WhatsApp Webhook Override في Meta. لم يتم إنشاء الواجهة الافتراضية.",
    "error_details_card": "تفاصيل الخطأ",
    "error_endpoint": "نقطة النهاية",
    "error_response_status": "حالة الاستجابة",
    "error_response_body": "جسم الاستجابة",
    "close": "إغلاق",
    "telegram_bot_token": "رمز بوت Telegram",
    "telegram_bot_token_help": "احصل عليه من @BotFather على Telegram. التنسيق: 123456789:ABCdef...",
    "whatsapp_api_token": "رمز API لـ WhatsApp",
    "whatsapp_phone_number_id": "معرف رقم الهاتف",
    "whatsapp_waba_id": "معرف WABA",
    "whatsapp_waba_id_help": "معرف حساب WhatsApp Business الخاص بك من إعدادات Meta Business.",
    "rocketchat_workspace_url_help": "عنوان مساحة عمل RocketChat الخاصة بك (مثل https://mycompany.rocket.chat)",
    "rocketchat_bot_username_help": "اسم مستخدم حساب البوت الذي تم إنشاؤه في RocketChat",
    "rocketchat_bot_password_help": "كلمة المرور لحساب البوت. سيتم تسجيل Webhook تلقائيًا عند الإنشاء.",
    "rocketchat_info_create": "سيتم تسجيل تكامل webhook تلقائيًا مع مساحة عمل RocketChat الخاصة بك عند إنشاء هذه الواجهة. سيرد البوت على @الإشارات في القنوات والرسائل المباشرة.",
    "match_chat_id_optional": "معرف دردشة Telegram (اختياري)",
    "match_chat_id_help": "اتركه فارغًا لمطابقة جميع الدردشات. استخدم للمجموعات/القنوات الخاصة. تم الحصول عليه من @userinfobot.",
    "match_whatsapp_help": "رقم هاتف WhatsApp للمطابقة (مع رمز البلد).",
    "match_caller_id_optional": "معرف المتصل (اختياري)",
    "match_did_optional": "رقم DID (اختياري)",
    "match_sip_optional": "نطاق SIP (اختياري)"
  },
  "session": {
    ...enCommon.session,
    "timeouts_title": "مهلات الجلسة",
    "timeouts_desc": "قم بتكوين سلوك مهلة الجلسة للقنوات الصوتية والنصية",
    "attribute": "السمة",
    "value": "القيمة",
    "level": "المستوى",
    "action": "الإجراء",
    "idle_timeout_voice": "مهلة الخمول (صوت)",
    "idle_timeout_voice_desc": "وقت الخمول قبل انتهاء الجلسة الصوتية",
    "idle_timeout_text": "مهلة الخمول (نص)",
    "idle_timeout_text_desc": "وقت الخمول قبل انتهاء الجلسة النصية",
    "absolute_timeout_voice": "المهلة المطلقة (صوت)",
    "absolute_timeout_voice_desc": "الحد الأقصى لمدة الجلسة الصوتية",
    "absolute_timeout_text": "المهلة المطلقة (نص)",
    "absolute_timeout_text_desc": "الحد الأقصى لمدة الجلسة النصية (0 = غير محدود)",
    "seconds": "ثوانٍ",
    "minutes": "دقائق",
    "timeout_behavior": "سلوك المهلة",
    "idle_timeout": "مهلة الخمول",
    "idle_timeout_explanation": "تنتهي الجلسة إذا كان المستخدم غير نشط للمدة المحددة.",
    "absolute_timeout": "المهلة المطلقة",
    "absolute_timeout_explanation": "تنتهي الجلسة بعد المدة القصوى بغض النظر عن النشاط.",
    "channel_types": "أنواع القنوات",
    "channel_types_explanation": "تستخدم القنوات الصوتية (SIP, WebRTC) مهلات صوتية. تستخدم القنوات النصية (Telegram, WhatsApp, Webchat) مهلات نصية.",
    "30_minutes": "30 دقيقة",
    "1_hour": "ساعة واحدة",
    "2_hours": "ساعتان",
    "3_hours": "3 ساعات",
    "4_hours": "4 ساعات",
    "5_hours": "5 ساعات",
    "6_hours": "6 ساعات",
    "12_hours": "12 ساعة",
    "18_hours": "18 ساعة",
    "24_hours": "24 ساعة",
    "36_hours": "36 ساعة",
    "48_hours": "48 ساعة",
    "72_hours": "72 ساعة",
    "infinite_no_timeout": "غير محدود (بدون مهلة)",
    "96_hours_4_days": "96 ساعة (4 أيام)",
    "168_hours_7_days": "168 ساعة (7 أيام)"
  },
  "system_attributes": {
    ...enCommon.system_attributes,
    "loading": "جارٍ تحميل سمات النظام...",
    "fetch_failed": "فشل جلب سمات النظام",
    "save_failed": "فشل حفظ سمات النظام",
    "chat_agent_title": "افتراضيات وكيل الدردشة",
    "chat_agent_desc": "التكوين الافتراضي لوكيل الدردشة للنظام",
    "tool_runner_title": "تكوين مشغل الأدوات",
    "tool_runner_desc": "إعدادات اتصال مشغل الأدوات العامة",
    "vertex_ai_title": "تكوين Google Vertex AI",
    "vertex_ai_desc": "بيانات اعتماد حساب الخدمة لـ Vertex AI (LLM و TTS)",
    "system_prompt": "موجه النظام",
    "barge_in_enabled": "المقاطعة مفعلة",
    "ping_interval": "فاصل Ping (ثوانٍ)",
    "absence_timeout": "مهلة الغياب (ثوانٍ)",
    "project_id": "معرف المشروع",
    "location": "الموقع",
    "sa_json": "JSON حساب الخدمة",
    "paste_sa_json": "الصق JSON حساب الخدمة هنا"
  },
  "knowledgeBases": {
    ...enCommon.knowledgeBases,
    "title": "قواعد المعرفة"
  },
  "vocabulary": {
    "title": "كتب المفردات",
    "add_book": "إضافة كتاب مفردات",
    "create": "إنشاء",
    "items": "العناصر",
    "phrase": "العبارة",
    "created": "تم الإنشاء",
    "updated": "تم التحديث",
    "empty": "لا توجد كتب مفردات",
    "delete_book_confirm": "حذف كتاب المفردات هذا؟ سيتم إزالة جميع العبارات.",
    "search_placeholder": "البحث عن العبارات...",
    "new_phrase": "عبارة جديدة...",
    "add_phrase": "إضافة",
    "import": "استيراد",
    "export": "تصدير CSV",
    "import_result": "تمت إضافة {added}، تكرارات: {duplicates}، تم تجاهل {dropped}",
    "delete_selected": "حذف المحدد",
    "delete_selected_confirm": "حذف العبارات المحددة؟",
    "load_failed": "فشل التحميل",
    "save_failed": "فشل الحفظ",
    "no_book": "(بدون)"
  }
};

const resources = {
  en: {
    translation: enCommon,
  },
  de: {
    translation: deCommon,
  },
  fr: {
    translation: frCommon,
  },
  he: {
    translation: heCommon,
  },
  ru: {
    translation: ruCommon,
  },
  ar: {
    translation: arCommon,
  },
};

// Get saved language from localStorage or default to English
const savedLanguage = typeof window !== 'undefined' && window.localStorage
  ? (window.localStorage.getItem('language') as string) || 'en'
  : 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
